/** 
* Utils for fx packages
* @namespace Utils
*/

class Utils {
	construtor(){}

	//static _temporaryIds = {};

	static get prefixID() {
		return "uuid-";//"UUID-";
	}
	
	static typeEqual(input, desiredType){
		return typeof input == desiredType;
	    //return Utils.type(input).toLowerCase() == desiredType;
	}

	static type(input){
		return typeof input;
		//let type = Object.prototype.toString.call(input);

	    //return (type.indexOf("[object") == -1) ? type : Object.prototype.toString.call(input).match(/^\[object\s(.*)\]$/)[1];
	}

    static version() {
        return Utils.getURLParam("version") || "";
    }

	static isVersionGreater(v2) {
        let v1 = Utils.version();

        if (!v1) return true;

		if (typeof v1 !== "string" || typeof v2 !== "string")
			return false;

		const clean = v => v.split("-")[0];
		const a = clean(v1).split(".").map(Number);
		const b = clean(v2).split(".").map(Number);
		const length = Math.max(a.length, b.length);

		for (let i = 0; i < length; i++) {
			const num1 = a[i] || 0;
			const num2 = b[i] || 0;

			if (num1 > num2)
				return true;

			if (num1 < num2)
				return false;
		}

		return false;
	}

	static newID(unique)
	{
		 // we use an incremental ID with date.now() and _id++ to be sure all ids are differents
		Utils._dateStart = unique ? Utils._dateStart || Date.now() : 1628936362305;;
	  	Utils._id = Utils._id || 0;
		return Utils.prefixID + (Utils._dateStart + Utils._id++).toString(36);
	}

	static temporaryId(temporary, final)
	{
		if (!Utils._temporaryIds)
			Utils._temporaryIds = {};

		if (final)
			Utils._temporaryIds[temporary] = final;
		else
			return Utils._temporaryIds[temporary] ? Utils._temporaryIds[temporary] : temporary;
	}

	
	
	static clone(obj)
	{
		let newObj = {};
		for (let property in obj)
			newObj[property] = obj[property];

		return newObj;
	}

	
    // Update all node children ids
    static refreshNodeIDs(node)
    {
        if (node)
        {
			if (node.id)
				node.id = Utils.newID();;

            for (let i = 0; i < node.children.length; i++)
				Utils.refreshNodeIDs(node.children[i]);
        } 
    }

    static extendObj (destination, source) {
	    let toString = Object.prototype.toString,
	        toStringCall = toString.call({});
	    for (let property in source) {
	        if (source[property] && toStringCall == toString.call(source[property])) {
	            destination[property] = destination[property] || {};
	            Utils.extendObj(destination[property], source[property]);
	        } else {
	            destination[property] = source[property];
	        }
	    }
	    return destination;
	}
	
	static getConstructor(path) {
		let parts = path.split("."),
			value = window,
			index;
		for (index = 0; index < parts.length; index++)
		{
			if (!(value = value[parts[index]]))
				break;
		}
		return {fcn : value, name : parts[index] };
	}

	static validConstructor(temp){
	   return (temp["init"] && Utils.typeEqual(temp["init"], 'function')  &&
	           temp["destroy"] && Utils.typeEqual(temp["destroy"], 'function') );
	}

	static pageLoaded() {
  		return document.readyState === "complete" || document.readyState === "interactive";
	}

	static normalizeCSSValue(val) {
		return  (!isNaN(parseFloat(val)) && isFinite(val))  ? (val + "px") : val;
	}

	static isID(val)
	{
		return val && typeof val == "string" && (val.indexOf(this.prefixID) == 0 || (val.match(/-/g) || []).length > 1);
        //return val && !Utils.isInt(val);
	}

	static isNumber(n) { return !isNaN(parseFloat(n)) && !isNaN(n - 0) }

	static isInt(n){ return (typeof n != "object") && !isNaN(n) && Number(n) === n && n % 1 === 0; }


    static isValidHttpUrl(string) {
        let url;
        
        if (typeof string != "string")
            return false;

        if (string.indexOf("data:image") == 0 || string.indexOf("blob:") == 0)
            return true;
        
        try {
            url = new URL(string);
        } catch (_) {
            return false;  
        }

        return url.protocol === "http:" || url.protocol === "https:";
    }

	static stripHtml(html)
	{
        if (!html)
            return "";
        
		var tmp = document.createElement("DIV");
		tmp.innerHTML = html;
		return tmp.textContent || tmp.innerText || "";
	}

	//---- URL parameters
	static getURLParam( name )
	{
		if (!Utils._urlparams)
			Utils._urlparams = new URLSearchParams(window.location.search);

		return Utils._urlparams.get( name );
	}

	static hasURLParam( name )
	{
		return Utils.getURLParam( name ) !== undefined && Utils.getURLParam( name ) !== null;
	}
	

	//Returns true if it is a DOM node
	static isDOMNode(o){
		return (
			typeof Node === "object" ? o instanceof Node : 
			o && typeof o === "object" && typeof o.nodeType === "number" && typeof o.nodeName==="string"
		);
	}
	
	//Returns true if it is a DOM element    
	static isDOMElement(o){
		return (
			typeof HTMLElement === "object" ? o instanceof HTMLElement : //DOM2
			o && typeof o === "object" && o !== null && o.nodeType === 1 && typeof o.nodeName==="string"
		);
	}


	static validateEmail(email) {
		const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(email).toLowerCase());
	}

	static getCssPropertyValues(domElement, property)
	{
		let found = [];
		
		if (domElement)
		{
			if (domElement.style && domElement.style[property])
				found.push(domElement.style[property]);
			
			for (let i = 0; i < domElement.children.length; i++)
			{
				let values = Utils.getCssPropertyValues( domElement.children[i], property )
				if (values.length > 0)
					found.push(...values);
			}
		}

		return found;
	}

	static _fixURL(url)
    {
        if (url.indexOf("https://") == 0 || url.indexOf("//") == 0)
            return url;

        return "//" + url;
    }

    static focusAndOpenKeyboard(el, timeout) {
        if(!timeout) {
          timeout = 100;
        }
        if(el) {
          // Align temp input element approximately where the input element is
          // so the cursor doesn't jump around
          var __tempEl__ = document.createElement('input');
          __tempEl__.style.position = 'absolute';
          __tempEl__.style.top = (el.offsetTop + 7) + 'px';
          __tempEl__.style.left = el.offsetLeft + 'px';
          __tempEl__.style.height = 0;
          __tempEl__.style.opacity = 0;
          // Put this temp element as a child of the page <body> and focus on it
          document.body.appendChild(__tempEl__);
          __tempEl__.focus();
      
          // The keyboard is open. Now do a delayed focus on the target element
          setTimeout(function() {
            el.focus();
            el.click();
            // Remove the temp element
            document.body.removeChild(__tempEl__);
          }, timeout);
        }
    }

    static stringify(val, depth, replacer, space) 
    {
        depth = isNaN(+depth) ? 1 : depth;
        function _build(key, val, depth, o, a) { // (JSON.stringify() has it's own rules, which we respect here by using it for property iteration)
            return !val || typeof val != 'object' ? val : (a=Array.isArray(val), JSON.stringify(val, function(k,v){ if (a || depth > 0) { if (replacer) v=replacer(k,v); if (!k) return (a=Array.isArray(v),val=v); !o && (o=a?[]:{}); o[k] = _build(k, v, a?depth:depth-1); } }), o||(a?[]:{}));
        }
        return JSON.stringify(_build('', val, depth), null, space);
    }

    /**
     * Compares two JSON objects and returns an object containing parameters that exist 
     * in both objects but have different values. The returned object contains only the 
     * values from the second object.
     *
     * @param {Object} obj1 - First JSON object
     * @param {Object} obj2 - Second JSON object
     * @returns {Object} Object containing the different values from obj2
     */
    static differences(obj1, obj2) {
        if (typeof obj1 !== 'object' || typeof obj2 !== 'object') {
            throw new Error('Both inputs must be objects');
        }

        const _differences = {};

        // Helper function to check if a value is a plain object
        const isPlainObject = (value) => {
            return value !== null && typeof value === 'object' && !Array.isArray(value);
        };

        // Helper function to check if values are equal
        const areValuesEqual = (val1, val2) => {
            if (Array.isArray(val1) && Array.isArray(val2)) {
                return JSON.stringify(val1) === JSON.stringify(val2);
            }
            return val1 === val2;
        };

        // Function to compare objects
        const compareObjects = (o1, o2) => {
            // Get all keys that exist in both objects
            const commonKeys = Object.keys(o1).filter(key => key in o2);

            commonKeys.forEach(key => {
                const value1 = o1[key];
                const value2 = o2[key];

                // If both values are objects, recurse
                if (isPlainObject(value1) && isPlainObject(value2)) {
                    const nestedDiffs = Utils.differences(value1, value2);
                    if (Object.keys(nestedDiffs).length > 0) {
                        _differences[key] = nestedDiffs;
                    }
                }
                // If values are different, add value from obj2 to _differences
                else if (!areValuesEqual(value1, value2)) {
                    _differences[key] = value2;
                }
            });
        };

        compareObjects(obj1, obj2);
        return _differences;
    }
	
	static ObjectEquals( a, b, enforce_properties_order, cyclic ) 
	{
		return a === b       // strick equality should be enough unless zero
		  && a !== 0         // because 0 === -0, requires test by _equals()
		  || _equals( a, b ) // handles not strictly equal or zero values
		;
		
		function _equals( a, b ) {
		  // a and b have already failed test for strict equality or are zero
		  
		  let s, l, p, x, y;
		
		  // null / undefined cases
		  if (!a && !b)
			return true;
		  // null / undefined cases
		  if ((!a && b) || (a && !b))
				return false;
		

		  // They should have the same toString() signature
		  if ( ( s = toString.call( a ) ) !== toString.call( b ) ) return false;
		  
		  switch( s ) {
			default: // Boolean, Date, String
			  return a.valueOf() === b.valueOf();
			
			case '[object Number]':
			  // Converts Number instances into primitive values
			  // This is required also for NaN test bellow
			  a = +a;
			  b = +b;
			  
			  return a ?         // a is Non-zero and Non-NaN
				  a === b
				:                // a is 0, -0 or NaN
				  a === a ?      // a is 0 or -O
				  1/a === 1/b    // 1/0 !== 1/-0 because Infinity !== -Infinity
				: b !== b        // NaN, the only Number not equal to itself!
			  ;
			// [object Number]
			
			case '[object RegExp]':
			  return a.source   == b.source
				&& a.global     == b.global
				&& a.ignoreCase == b.ignoreCase
				&& a.multiline  == b.multiline
				&& a.lastIndex  == b.lastIndex
			  ;
			// [object RegExp]
			
			case '[object Function]':
			  return false; // functions should be strictly equal because of closure context
			// [object Function]
			
			case '[object Array]':
			  if ( cyclic && ( x = reference_equals( a, b ) ) !== null ) return x; // intentionally duplicated bellow for [object Object]
			  
			  if ( ( l = a.length ) != b.length ) return false;
			  // Both have as many elements
			  
			  while ( l-- ) {
				if ( ( x = a[ l ] ) === ( y = b[ l ] ) && x !== 0 || _equals( x, y ) ) continue;
				
				return false;
			  }
			  
			  return true;
			// [object Array]
			
			case '[object Object]':
			  if ( cyclic && ( x = reference_equals( a, b ) ) !== null ) return x; // intentionally duplicated from above for [object Array]
			  
			  l = 0; // counter of own properties
			  
			  if ( enforce_properties_order ) {
				let properties = [];
				
				for ( p in a ) {
				  if ( a.hasOwnProperty( p ) ) {
					properties.push( p );
					
					if ( ( x = a[ p ] ) === ( y = b[ p ] ) && x !== 0 || _equals( x, y ) ) continue;
					
					return false;
				  }
				}
				
				// Check if 'b' has as the same properties as 'a' in the same order
				for ( p in b )
				  if ( b.hasOwnProperty( p ) && properties[ l++ ] != p )
					return false;
			  } else {
				for ( p in a ) {
				  if ( a.hasOwnProperty( p ) ) {
					++l;
					
					if ( ( x = a[ p ] ) === ( y = b[ p ] ) && x !== 0 || _equals( x, y ) ) continue;
					
					return false;
				  }
				}
				
				// Check if 'b' has as not more own properties than 'a'
				for ( p in b )
				  if ( b.hasOwnProperty( p ) && --l < 0 )
					return false;
			  }
			  
			  return true;
			// [object Object]
		  } // switch toString.call( a )
		} // _equals()
		
		/* -----------------------------------------------------------------------------------------
		   reference_equals( a, b )
		   
		   Helper function to compare object references on cyclic objects or arrays.
		   
		   Returns:
			 - null if a or b is not part of a cycle, adding them to object_references array
			 - true: same cycle found for a and b
			 - false: different cycle found for a and b
		   
		   On the first call of a specific invocation of equal(), replaces self with inner function
		   holding object_references array object in closure context.
		   
		   This allows to create a context only if and when an invocation of equal() compares
		   objects or arrays.
		*/
		function reference_equals( a, b ) {
		  let object_references = [];
		  
		  return ( reference_equals = _reference_equals )( a, b );
		  
		  function _reference_equals( a, b ) {
			let l = object_references.length;
			
			while ( l-- )
			  if ( object_references[ l-- ] === b )
				return object_references[ l ] === a;
			
			object_references.push( a, b );
			
			return null;
		  } // _reference_equals()
		} // reference_equals()
	  } // equals()

}


"use strict";
/**
 * @api {method} path title
 */
(function(){
	
	if (window.fx)
	{
		alert("fx already declared");
		return;
	}
	
	window.fx = {
		
		init : function() {
		
			this.log = new fx.Logger();
			this.browser = new fx.Browser();
			this.keyboard = new fx.Keyboard();
			this.ajax = new fx.Ajax();
			// TODO : do deeper tests with maxMedia & mediaToFree
			this.medialoader = new fx.MediaLoader();
			this.effectsEnabled = true;
            
            // disable double tap zoom on mobile
            if (this.browser.isMobile || this.browser.isTablet)
                document.ondblclick = function(e) { e.preventDefault(); }
            
			if (!fx._mainClass)
			{
				fx.throwError('No Main class found');
				return;
			}
			
			this._currentLang =  "fr";

			fx._mainInstance = new fx._mainClass();
			if (typeof fx._mainInstance.init == "function")
				fx._mainInstance.init();
			
			if (this._assetsToLoad)
			{
				for (let i = 0; i < this._assetsToLoad.length; i++)
					fx.asset(this._assetsToLoad[i]);

				this._assetsToLoad = null;
			}

			fx._mainInstance.onReady();

			// Force a fresh load when the page is restored from the browser's
			// back/forward cache (e.g. the user taps "Back"), so the app re-runs
			// with up-to-date data. Replaces the old `window.onunload` hack, which
			// relied on the deprecated `unload` event and disabled bfcache entirely.
			window.addEventListener("pageshow", function(event) {
				if (event.persisted)
					window.location.reload();
			});

		},
        sessionID(increment)
        {
            if (!this._sessionId)
                this._sessionId = Date.now().toString(16).slice(2);

            if (increment)
            {
                if (!this._sessionIdIndex)
                    this._sessionIdIndex = 0;

                this._sessionIdIndex++;
            }

            return this._sessionId + (increment ? "-" + this._sessionIdIndex : "");
        },
		currentLang(lang)
		{
			if (lang)
				this._currentLang = lang;
			
			return this._currentLang;
		},
		currentLocale()
		{
			switch(this._currentLang)
			{
				case "fr" : return "fr-FR";
				case "es" : return "es-ES";
				case "en" : return "en-GB";
				case "it" : return "it-IT";
				case "de" : return "de-DE";
			}

			return "fr-FR";
		},
		translations(lang, texts)
		{
			if (!this._lang)
				this._lang = {};

			if (!this._lang[lang])
				this._lang[lang] = {};

			this._lang[lang] = Object.assign(this._lang[lang], texts);
		},
		text : function(param)
		{
			let text;

			if (this._currentLang != "fr" && (!this._lang[this._currentLang] || !this._lang[this._currentLang][param]))
			{
				if (param && param != "$")
					this.log.info("Translation no found : " + param);
				text = param ? param : "";
			}
			else
			{
				text = this._lang[this._currentLang] ? this._lang[this._currentLang][param] : param;
			}

			// dynamic string
			if (arguments.length > 1)
			{
				let params = (arguments[1] instanceof Array) ? arguments[1] : Array.prototype.slice.call(arguments, 1);
				
				for(let i = 0; i < params.length; i++)
					text = text.replace("$", params[i]);
			}
			
			return text;	
		},
		asset : function(obj){
			
			this.assets = this.assets || {};

			if (!fx._mainInstance)
			{
				if (!this._assetsToLoad)
					this._assetsToLoad = [];
				this._assetsToLoad.push(obj);
				return;
			}
				
			if (Utils.typeEqual(obj, "string"))
			{
				let id = Utils.newID();
				this.assets[ id ] = new fx.Asset(obj, id);
				return this.assets[ id ];
			}
	
			for (let property in obj) {
				if (obj.hasOwnProperty(property)) 
				{
					//if (this.assets[property])
						this.assets[ property ] = new fx.Asset(obj[property], property);
					//else
					//	this.assets[ property ] = new fx.Asset(obj[property], property);
				}
			}
		},
		urls : function(obj){
			this.urls = this.urls || {};
			this.urls = Object.assign(this.urls, obj);
		},
		url : function(url){
			if (this.urls[window.location.hostname] && this.urls[window.location.hostname][url])
				return this.urls[window.location.hostname][url];
			return url;
		},
		ns : function(ns, val) {

			if (val && fx.Main && (val.prototype instanceof fx.Main))
			{
				/*if (fx._mainClass)
				{
					fx.throwError('Main class already defined. Class ' + fx._mainClass.name + ' will be used instead of ' + val.name);
					return;
				}
				else*/
					// last Main Class declared is used
					fx._mainClass = val;
			}

			let part = ns.split(".");
			let obj = window;
			for (let i = 0; i < part.length; i++)
			{
				if (val && i == part.length - 1)
				{
					if (val.constructor)
					{
						if (!obj[part[i]])
							Object.defineProperty( obj, part[i] , {value : {},  writable: false, enumerable: true  });
						
						Object.defineProperty( obj[part[i]], val.name , {value : val,  writable: false, enumerable: true  });
					}
					else
						Object.defineProperty( obj, part[i] , {value : val,  writable: false, enumerable: true  });
				}
				
				if (!obj[part[i]])
					Object.defineProperty( obj, part[i] , {value : {},  writable: false, enumerable: true  });
	
					obj = obj[part[i]];
			}
	
			return obj;
		},
		service : function(val, model) {
			
			this._services = this._services || {};

			if (typeof val == "string")
			{
				let name = val.toLowerCase();
				if (this._services[name])
				{
					if (typeof this._services[name] == "function")
					{
						if (!model)
							model = fx._mainInstance.model;
							
						this._services[name] = new this._services[name](model);
					}

					return this._services[name];
				}
				else
					fx.throwError("Service " + val + " doesn't exist");
			}
			else
			{
				if (typeof val != "function")
					fx.throwError('A service must be a class');
				else	
					this._services[val.name.toLowerCase()] = val;
			}
			
		},
		enableToolTip : function()
		{
			if ( !fx._toolTip )
				fx._toolTip = new fx.components.ToolTip();
		},
		get : function(name){
			if (name == "dom")
				return fx.dom;
			
			if (name == "ajax")
				return this.ajax;

			if (name == "assets")
				return this.assets;
			
			if (name == "model")
				return fx._mainInstance ? fx._mainInstance.model : null;

			if (name == "contextMenu" && fx.components.ContextMenu)
			{
				if ( !fx._contextMenu )
					fx._contextMenu = new fx.components.ContextMenu();

				return fx._contextMenu;
			}
			
			if (typeof fx[name] == "function")
				fx[name] = new fx[name]();

			return fx[name];
			
		},
		// allows to set constants accessible across the whole application 
		set : function(name, obj)
		{
			if (fx[name])
				fx[name] = obj;
			else
				Object.defineProperty( fx, name , {value : obj,  writable: true, enumerable: true  });
	
		},
		// instead of using console directly, let's use fx.console, so we avoid all cases 
		// when console is not defined (IE with javascript console closed for example)
		// and override this function in case we need to transfer all to some other log source.
		console : console || {log: () => {}, warn: () => {}, error: () => {} },
		throwError : function(msg) 
		{
			
			if (!console) return;
	
			let callstack = [];
			let isCallstackPopulated = false;
			try {
				i.dont.exist += 0; //doesn't exist- that's the point
			} catch (e) {
				if (e.stack) { //Firefox / chrome
					let lines = e.stack.split('\n');
					for (let i = 0, len = lines.length; i < len; i++) {
							callstack.push(lines[i]);
					}
					//Remove call to logStackTrace()
					callstack.shift();
					isCallstackPopulated = true;
				}
				else if (window.opera && e.message) { //Opera
					let lines = e.message.split('\n');
					for (let i = 0, len = lines.length; i < len; i++) {
						if (lines[i].match(/^\s*[A-Za-z0-9\-_\$]+\(/)) {
							let entry = lines[i];
							//Append next line also since it has the file info
							if (lines[i + 1]) {
								entry += " at " + lines[i + 1];
								i++;
							}
							callstack.push(entry);
						}
					}
					//Remove call to logStackTrace()
					callstack.shift();
					isCallstackPopulated = true;
				}
			}
			if (!isCallstackPopulated) { //IE and Safari
				let currentFunction = arguments.callee.caller;
				while (currentFunction) {
					let fn = currentFunction.toString();
					let fname = fn.substring(fn.indexOf("function") + 8, fn.indexOf("(")) || "anonymous";
					callstack.push(fname);
					currentFunction = currentFunction.caller;
				}
			}
			
			console.error("ERROR : " + msg + '\n' + callstack.splice(2).join('\n'));
	
		},
	};

	
	if (!Utils.pageLoaded())
		window.onload = window.fx.init.bind(fx);
	else
		window.fx.init();

})();


/** 
* Dom access based on JQUERY. If you want to use another library, just modify core of each function
* @namespace fx.dom
*/
fx.ns("fx", class dom {
    
    static find(selector, context){
        let elements = $(selector, context).get();
        return (elements.length == 0) ? null : ( (elements.length == 1) ? elements[0] : elements );

        /* Version with querySelector
         let _context = context;
        if (_context && (Utils.isDOMNode(_context) || Utils.isDOMElement(_context) ))
        {
            if (!_context.id)
                _context.id = Utils.newID(true);
            
            _context = "#" + _context.id;
        }
      
        let elements1 = $(selector, context).get();
        let result1 = (elements1.length == 0) ? null : ( (elements1.length == 1) ? elements1[0] : elements1 );

        let elements2 = Array.from(document.querySelectorAll((_context ? _context + " " : "") + selector));
        let result2 = (elements2.length == 0) ? null : ( (elements2.length == 1) ? elements2[0] : elements2 );

        if (result1 != result2)
        {
            console.log(selector, context);
        }

        return result2;
        */
    }

    static on(evt, fn, el )
    {
        $( fx.dom._selector(el) ).bind(evt, fn);
    }

    static off(evt, fn, el){

        $( fx.dom._selector(el) ).unbind(evt, fn);      
    }

    static trigger(evt, el){

        $( fx.dom._selector(el) ).unbind(evt);      
    }

    static css(el, props, recursively){
        for (let property in props) {
            if (props.hasOwnProperty(property)) {
                let val = props[property];
                if ("width,height,top,left,bottom,right,margin-top,margin-bottom,margin-left,margin-right,padding-top,padding-bottom,padding-left,padding-right,border-width,font-size".indexOf(property) != -1 && ("" + val).trim().endsWith("px") == false )
                    props[property] = Utils.normalizeCSSValue(("" + val).trim());
            }
        }

        if (recursively === true && typeof props == "string")
        {
            let value;
            while (el && !( value = $( fx.dom._selector(el) ).css(props) ) )
                el = el.parentNode;

            return value;
        }

        return $( fx.dom._selector(el) ).css(props);
    }

    static position(el){
    	return $( fx.dom._selector(el) ).position();
    }

    static addClass(el, className){
    	$( fx.dom._selector(el) ).addClass(className);
    }

    static removeClass(el, className){
    	$( fx.dom._selector(el) ).removeClass(className);
    }

    static toggleClass(el, className, val){
        $( fx.dom._selector(el) ).toggleClass(className, val);
    }

    static hasClass(el, className){
        //return $(element).hasClass(className);
        el = fx.dom._selector(el);
        if (typeof el == "string")
            el = fx.dom.find(el);

        return el && el.classList && el.classList.contains(className);
        //return ( (" " + element.className + " ").replace(/[\n\t]/g, " ").indexOf(className) > -1 ) 
    }

    static width(element){
    	return $(element ? fx.dom._selector(element) : window).width();
    }

    static height(element){
    	return $(element  ? fx.dom._selector(element) : window).height();
    }

    static outerWidth(element){
    	return $(element ? fx.dom._selector(element) : window).outerWidth();
    }

    static outerHeight(element){
    	return $(element ? fx.dom._selector(element) : window).outerHeight();
    }

    static offset(selector){
        return $( fx.dom._selector(selector) ).offset();
    }

    static remove(id) {
        $("#" + id).remove();
    }

    static ajax(options) {
        return $.ajax(options);
    }

    static stop( element, clearQueue, jumpToEnd )
    {
        $(element).stop(clearQueue, jumpToEnd);
    }

    static animate( element, properties , duration, easing, complete)
    {
        $(element).animate( properties , duration, easing, complete );
    }


    static parent(element, selector)
    {
        if (element)
        {
            if (selector instanceof fx.Component)
                selector = selector.node;

            if (element instanceof fx.Component)
                element = element.node;
                
            if (typeof selector == "object")
            {
                let parent = element;
                while (parent && parent != selector)
                    parent = parent.parentNode;
                
                return parent;
            }
            else
            {

                let found;

                while(element && !(found = $(element).is(selector)))
                    element = element.parentNode;
                
                return found ? element : null;
        
                /*let parents = fx.dom.parents(element, selector);
                if (parents.length > 0)
                    return parents[0];*/
            }
        }
        
        return null;
    }

    static parents(element, selector)
    {
        let parents = [];
        while (element && element.classList) 
        {
            if (element.classList.contains(selector.startsWith(".") ? selector.substr(1) : selector ))
                parents.unshift(element);
                
            element = element.parentNode;
        }
        return parents;
    }
    
    static _selector(el)
    {
        if (el instanceof fx.Component)
            el = "#" + el.id;
        else
        if (typeof el == "string" && el.indexOf(Utils.prefixID) == 0)
            el = "#" + el;

        return el;
    }


    static hasFocus(element)
    {
        if (typeof element == "string") //  selector
            element = fx.dom.find(element);
        
        if (element instanceof fx.Component)
            element = element.node;
        
        return document.activeElement === element
    }

    static focus(element)
    {
        if (typeof element == "string") //  selector
            element = fx.dom.find(element);
        
        if (element instanceof fx.Component)
            element = element.node;

        if (element && !(element instanceof Array))
            element.focus();
    }

    static text(node)
    {
        return $(node).text();
    }

    static turn(selector)
    {
        return $(selector);
    }

});
fx.ns("fx", class Logger {
    
    constructor()
    {
        this._mode = Utils.getURLParam("mode"); // TODO : code different modes (silent, verbose, strict)
        this._silentConsole =  {log: () => {}, warn: () => {}, error: () => {} };
    }

    get console()
    {
        if (console && this._mode == null)
            return console;
        else
            return this._silentConsole;
    }

    warning(message)
    {
        if (window.TrackJS && typeof TrackJS.track == "function")
            TrackJS.track(message);
        else
            this.console.warn(message);
    }

    info(message)
    {
        if (window.TrackJS && typeof TrackJS.track == "function")
            TrackJS.track(message);
        else
            this.console.log(message);
    }

    error(message)
    {
        if (window.TrackJS && typeof TrackJS.track == "function")
            TrackJS.track(message);
        else
            this.console.error(message);
    }

    track(str, init)
    {
        if (!this._start || init)
            this._start = new Date();

        this.console.log(str, new Date() - this._start);
    }
    

});
fx.ns("fx", class Disposable {

    constructor()
    {
        this._destroyed = false;
    }

    get destroyed()
    {
        return this._destroyed;
    }

    
    /*get className()
    {
		return Object.getPrototypeOf(this).constructor.name
    }*/

    get __objects()
    {
        if (!fx.get("objects"))
            fx.set("objects", {});

        return fx.get("objects");
    }

    register()
    {
        this.__objects[this.id] = this;
    }

    unregister()
    {
        if (this.__objects[this.id])
            delete this.__objects[this.id];
    }
    
    destroy()
    {
        this._destroyed = true;
        
        this.unregister();

        fx.Disposable.free(this);
    }

    /**
     * In javascript, garbadge collector deletes all objects not linked anymore to objects still in use.
     * In order to avoid memory easy leaks, all Disposable object will be automatically cleaned from all their "links" to other objects.
     * In order to not use too much of CPU for that process, we just create a list of object to free. And then every second we clean that list.
     * @param {Object} obj 
     */
    static free(obj)
    {
        if (obj)
        {
            if (fx.Disposable._freeTimer)
                clearTimeout(fx.Disposable._freeTimer);
            
            if (!fx.Disposable._freeList)
                fx.Disposable._freeList = [];
            
            fx.Disposable._freeList.push(obj);
            fx.Disposable._freeTimer = setTimeout(fx.Disposable.free, 1000);
        }
        else
        {
            if (fx.Disposable._freeList)
            {
                let obj;
                while (obj = fx.Disposable._freeList.pop())
                    for(var property in obj)
                        delete obj[property];// = null;   
            }

            fx.Disposable._freeTimer = null;
        }
    }

    
});
// TODO : rename it to EventEmmiter
// TODO : create a class Event 
fx.ns("fx", class EventDispatcher extends fx.Disposable {
	
	constructor()
	{
		super();

		this._events = {};
		this._binds = [];
		this._enabled = true;
		
		this._registeredEvents = [];
		this._internalbinds = [];
		// used only on mobile
		this._hammers = {};

		this._touchEvents = {	
			"click" : ["tap"], 
			/*"panstart" : [ "panstart", "mousedown"],
			"panmove" : [ "panmove", "mousemove"],
			"panend" : [ "panend", "mouseend"],*/
		}

		this._desktopEvents = {	
			"mousewheel" : ['mousewheel', 'wheel', 'DOMMouseScroll', 'MozMousePixelScroll'],
		}

		this._matchingEventsList = (fx.browser.isMobile || fx.browser.isTablet) ? this._touchEvents : this._desktopEvents;
	}

	disable(){
		this._enabled = false;
	}

	enable(){
		this._enabled = true;
	}

	get enabled()
	{
		return this._enabled;
	}

	get registeredEvents()
	{
		return this._registeredEvents;
	}

	

	// ---------------------------------------------- //


	on(event, handler, source)
	{	
		if (!this._binds)
			return;

		// no handler given
		if (!handler || typeof handler != "function")
			return new TypeError("Handler cannot be undefined or is not a function");

		// if source is not provided, it mean we listen on current object
		if (!source)
			source = this;

		// if we get an Array, we listen on each element of the array
		if (source instanceof Array)
		{
			for (let i = 0; i < source.length; i++)
				this.on(event, handler, source[i]);

			return;
		}
		
		if (source instanceof fx.Component && !source.node)
		{
			this._registeredEvents.push({event:event, handler:handler, source:source}); // How to do ?
		}
		else
		{
			// check if there is not already the same bind registred (same event, same callback, same source)
			let bind;
			for (let i = 0; i < this._binds.length; i++)
			{
				if (this._binds[i] && this._binds[i].handler == handler && this._binds[i].event == event && this._binds[i].source == source)
				{
					bind = this._binds[i];
					break;
				}
			}

			if (!bind) // we didn't find same bind registered, so we create one
			{
				bind = { 	event : event, 
							bind :  handler.bind(this), // we use .bind(this), so the handler is called in current object context
							handler : handler,
							source : source,
							node :  source.node ? source.node : source };

				this._binds.push( bind );
			}

			let events = this._matchingEvents(event);

			for (let i = 0; i < events.length; i++)
			{
				if (this._isMobileEvent(events[i]))
					this._addMobileEvent(events[i], bind);
				else
                    if (bind.node && typeof bind.node.addEventListener == "function")
					    bind.node.addEventListener(events[i], bind.bind);
			}
				
		}

		return this;
	}

	_addMobileEvent(event, bind)
	{
		if (!bind.source.id)
			bind.source.id = Utils.newID();

		let data = this._hammers[bind.source.id];

		if (!data)
		{
			//data = {hammer : new Hammer.Manager(bind.node) };
            data = {hammer : new AlloyFinger(bind.node, {}) };
			this._hammers[bind.source.id] = data;
		}	
		
        //if (event.indexOf("swipe,tap,pan,pinch,press,rotate,touchStart,touchMove,touchEnd,touchCancel,multipointStart,multipointEnd,tap,doubleTap,longTap,singleTap,rotate,pinch,pressMove,swipe,") == -1)
        //{
        //    bind.node.addEventListener(event, bind.bind);
        //}
        //else
        //{
            data._mobileEvent = this._mobileEvent.bind(this, bind);
            data.hammer.on(event, data._mobileEvent );
        //}

		/*if (event.indexOf("swipe") != -1)
		{
			if( !data.hammer.get('swipe') )
				data.hammer.add(new Hammer.Swipe());
		}
		else
		if (event.indexOf("tap") != -1)
		{
			if( !data.hammer.get('tap') )
				data.hammer.add(new Hammer.Tap({threshold:fx.browser.isSafari ? 5 :15})); 
		}
		else
		if (event.indexOf("pan") != -1)
		{
			if( !data.hammer.get('pan') )
				data.hammer.add(new Hammer.Pan({ threshold: 0, pointers: 0 }));//.recognizeWith([element.hammer.get('tap')]);
		}
		else
		if (event.indexOf("pinch") != -1)
		{
			if( !data.hammer.get('pinch') )
				data.hammer.add(new Hammer.Pinch()).recognizeWith([data.hammer.get('pan')]);
		}
		else
		if (event.indexOf("press") != -1)
		{
			if( !data.hammer.get('press') )
				data.hammer.add(new Hammer.Press({threshold:20})).recognizeWith([data.hammer.get('pan')]);
		}
		else
		if (event.indexOf("rotate") != -1)
		{
			if( !data.hammer.get('rotate') )
				data.hammer.add(new Hammer.Rotate());
		}
		else
		{
			bind.node.addEventListener(event, bind.bind);
			return;
		}
	
		data._mobileEvent = this._mobileEvent.bind(this, bind);

		data.hammer.on(event, data._mobileEvent );*/
	}

    _removeMobileEvent(event, bind)
	{
		let data = this._hammers[bind.source.id];
		if (data && data.hammer)
			data.hammer.off(event, bind.bind);
	}

	_isMobileEvent(event)
    {
        return !fx.browser.isDesktop && ["swipe","tap","pan","pinch","press","rotate","touchStart","touchMove","touchEnd","touchCancel","multipointStart","multipointEnd","tap","doubleTap","longTap","singleTap","rotate","pinch","pressMove","swipe"].find(event) != null;
    }
	

	_mobileEvent(bind, e)
	{
		bind.bind(this._convertEvent(e), bind.source);

		if (this._hammers[bind.source.id])
			delete this._hammers[bind.source.id]._mobileEvent;
	}

	_convertEvent(event)
    {
        if (event)
        {
            let touches = event.touches;
            if (touches.length == 0) 
                touches = event.changedTouches;
            if (touches.length == 0)  
                touches = event.targetTouches;
            
            //event.pageX = event.touches[0].pageX;
            //event.pageY = event.touches[0].pageY;
            if (touches)
                event.center = {x : touches[0].pageX , y : touches[0].pageY };
        }
        /*else coming from HammerJS
        if (event && event.center)
        {
            event.pageX = event.center.x;
            event.pageY = event.center.y;
        }
        else
        if (event && event.gesture && event.gesture.srcEvent)
        {
            event.pageX = event.gesture.srcEvent.pageX;
            event.pageY = event.gesture.srcEvent.pageY;
		}*/
		
		//event.target = event.srcEvent.target;

        return event;
    }

	
	off(event, handler, source)
	{
		if (!this._binds)
			return;

		// no handler given
		if (!handler || typeof handler != "function")
			return fx.log.error("Handler cannot be undefined or is not a function");

		// if source is not provided, it mean we listen on current object
		if (!source)
			source = this;

		// if we get an Array, we listen on each element of the array
		if (source instanceof Array)
		{
			for (let i = 0; i < source.length; i++)
				this.off(event, handler, source[i]);

			return;
		}
		
		if (source instanceof fx.Component && !source.node)
		{
			return;
		}
		else
		{
			
			for (let i =0; i < this._binds.length; i++)
			{
				if (this._binds[i] && this._binds[i].handler == handler  && this._binds[i].event == event && this._binds[i].source == source)
				{
					let events = this._matchingEvents(event);
					for (let j = 0; j < events.length; j++)
					{
						if (this._isMobileEvent(events[j]))
							this._removeMobileEvent(event, this._binds[i]);
						else
							this._binds[i].node.removeEventListener(events[j], this._binds[i].bind);
					}
					
					this._binds[i] = null;
				}					
			}
		
		}
		
		return this;
	}
	
	trigger(event, data)
	{	
		if (!this._binds)
			return;
			
		if (this instanceof fx.Component && this.node) // in case fx.Component 
		{
			// if data is not given
			if (!data)
			{
				// and event is given as an object: {type:"updated", ... }
				if (event.type)
				{
					data = {};
					if (event.detail)
						data = event.detail;
					else
						for (let property in event)
						{
							if (property != "type")
								data[property] = event[property];
						}

					event = event.type;
				}
			}

			// in case we want event to propagate like a DOM event (from child to parents)
			if (data && data.propagate)
				data.source = this;

			let events = this._matchingEvents(event);
			for (let i = 0; i < events.length; i++)
				this.node.dispatchEvent(  new CustomEvent(events[i], {  bubbles: data && data.propagate, detail: data }) );
		}
		else
		{
			if (!data)
				this.dispatchEvent( event );
			else
				this.dispatchEvent( {type : event, detail : data} );
				
		}
			
		

				

		return this;
	}

	triggerDelay(event, data, delay)
	{
		// if event is given as an object
		if (!delay)
		{
			if (event.type)
			{
				if (typeof data == "number")
					delay = data;

				data = {};
				for (let property in event)
				{
					if (property != "type")
						data[property] = event[property];
				}
				event = event.type;
			}
		}

		if (delay === undefined)
			delay = 0;

		// TODO : add this bind to some array in order to delete it at the end
		setTimeout(this.trigger.bind(this, event, data), delay);
	}


	bind(callback)
	{
		// TODO : add this bind to some OTHER array in order to delete it at the end

		let bind = callback.bind(this);
		this._internalbinds.push( bind )
		return bind;
	}

	/**
	 * Call the given function with the given delay.
	 * If delay is called again with the same function, and delay is not over yet, the delay is resetted so the function is called only once after the new given delay.
	 * @param {function} handler 
	 * @param {Int} delay : if delay is equal to null, and a delay was already called, it will be canceled.
	 */
	delay(handler, delay)
	{
		
		let bind = this._internalbinds.find({handler : handler});
		if (bind)
		{
			clearTimeout(bind.timer);	

			if (delay !== null)
				bind.timer = setTimeout( bind.bind, (delay === undefined) ? 0 : delay);
		}
		else
		if (delay !== null)
		{
			bind = handler.bind(this);
			this._internalbinds.push( {handler : handler, bind : bind, timer : setTimeout( bind, (delay === undefined) ? 0 : delay) } );
		}
			
		return bind ? bind.timer : null;
	}

	/**
	 * Calls a function  at regular intervals
	 * To stop it, just call with same function and delay set to 0
	 * @param {function} handler 
	 * @param {Int} delay 
	 */
	repeat(handler, delay)
	{
		let bind = this._internalbinds.find({handler : handler});
		if (bind)
		{
			clearInterval(bind.timer);	

			if (delay !== null)
				bind.timer = setInterval( bind.bind, (delay === undefined) ? 0 : delay);
		}
		else
		if (delay !== null)
		{
			bind = handler.bind(this);
			this._internalbinds.push( {handler : handler, bind : bind, timer : setInterval( bind, (delay === undefined) ? 0 : delay) } );
		}
			
		return bind ? bind.timer : null;
	}


	// ------------------------ COMPATIBILITY TO DOM EVENTs --------------------- //

	// We use here same name that in Javascript DOM in order to make all events compatible
	addEventListener(e, callback)
	{
		this._subscribe(e, callback);
	}

	removeEventListener(e, callback)
	{
		this._unsubscribe(e, callback);
	}

	dispatchEvent(e)
	{
		this._publish(e);
	}


	// ----------------------------- PRIVATE -----------------------//

	_subscribe(e, callback)
	{
		if (!this._events) return;

		this._events[e] = this._events[e] || [];
		this._events[e].push( callback );
	}

	_unsubscribe(e, callback)
	{
		if (!this._events) return;

		let event = typeof e == "string" ? e : e.type;
		
		if (this._events[event])
		{
			for (let index = 0; index < this._events[event].length; index++)
			{
				if (this._events[event][index] === callback)
				{
					this._events[event].splice(index, 1);
					break;
				}
			}
		}
	
	}

	_publish(e, data)
	{
		if (!this._events) return;

		if (!this._enabled) return;

		if (Utils.typeEqual(e, "string"))
			e = {type : e, detail : data};

		//let result;
		if (this._events[e.type])
		{
			let events = this._events[e.type].slice(0); // so if this._events[e.type] changed while looping ( .off() ), this loop is not impacted
			for (let index = 0; index < events.length; index++)
			{
				if (events[index] && typeof events[index] == "function")
				{
					try 
					{
						events[index](e, this);
					}
					catch(error)
        			{
						fx.log.error(error);
					}
				}

				//result = result || (events[index] && events[index](e, this) );
				if (e.handled || (e.detail && e.detail.event instanceof fx.Event && e.detail.event.handled))
					break;
			}
		}
		
		//return result;
	}

	
	

	destroy()
	{
		super.destroy();

		this.disable();

		if (this._binds)
		{
			for (let i =0; i < this._binds.length; i++)
				if (this._binds[i])
					this.off(this._binds[i].event, this._binds[i].handler, this._binds[i].source);
		}

		if (this._internalbinds)
		{
			let bind;
			while (bind = this._internalbinds.pop())
			{
				bind.handler = null;
				bind.bind = null;
				clearTimeout(bind.timer);
				bind.timer = null;
			}
		}

		if (this._hammers)
		{
			for (let id in this._hammers) 
			{
				let data = this._hammers[id];
				if (data.hammer)
					data.hammer.destroy()

				delete this._hammers[id];
			}
		}
	}


	_matchingEvents(event)
	{
		return this._matchingEventsList[event] || [event];
	}
});
//fx.ns("fx", class DataHandler extends fx.EventDispatcher {
fx.ns("fx", class DataHandler extends fx.EventDispatcher {

    constructor(data)
    {
        super();

		this._listenedData = [];

		this._autoDelete = true;

		this._initialized = false;

		this.data = data;
	
	}
	
	get initialized(){
		return this._initialized;
	}

    get filter()
	{
		return this._filter;
	}

	set filter(val)
	{
		if (this._filter)
			this.off("updated", this._filterUpdated, this._filter)

		this._filter = val;

		if (this._filter)
		{
			this._filter.data = this._data;
			this.on("updated", this._filterUpdated, this._filter)
		}
		
		if (this.initialized)
			this.onDataUpdated(new fx.Action("update"));
    }
    
    get data()
	{
		if (this._filter)
			return this._filter.data;
		else
			return this._data;
	}

	
	set data(val)
	{
		//if (val && !( val instanceof fx.Model) && typeof val == "object") // TODO : To improve so we can just give any kind of data to a dataHandler (String, Boolean, Array, Object)
		//	val = new fx.Model(val);

		if (val == this._data)
			return;

		if (this._data instanceof fx.Model)
		{
			this.off("updated", this._dataUpdated, this._data);
			this.off("event", this._dataEvent, this._data);
		}

		this._data = val;

		if (this._data && this._data instanceof fx.Model)
		{
			this.on("updated", this._dataUpdated, this._data);
			this.on("event", this._dataEvent, this._data);
		}

		if (this._data && this._filter)
		{
			this._filter.data = this._data;
			this.on("updated", this._filterUpdated, this._filter)
		}

		if (this.initialized && this.data instanceof fx.Model) 
			this.onDataUpdated(new fx.Action("init", null, this.data));	
	}

    /**
	 * Disable/enable automatic deletion of component when model is deleted
	 */
	get autoDelete()
	{
		return this._autoDelete;
	}

	set autoDelete(val)
	{
		this._autoDelete = val;
    }

     /**
	 * To Override when need to apply specific update on data change
	 * @param {fx.Action} action 
	 */
	onDataUpdated(action)
	{
		
    }

    onDataEvent(event) {};

    /**
	 * To override if you want to know that a [sub]child was updated
	 * @param {fx.Action} action 
	 */
	onChildUpdated(action)
	{

	}
	
	init()
	{
		this._initialized = true;
	}

    listenUpdates( data, listen )
	{
		listen = (listen === undefined) ? true : listen;
		
		if (listen)
		{
			if (this._listenedData.indexOf( data ) == -1)
			{
				this._listenedData.push( data );
                
                if (!this.data || !(this.data instanceof fx.Model) || !this._hasValue( data ) /*this.data.hasValue( data )*/ )
				{
					this.on("updated", this._dataUpdated, data);
					if (data && !data.isChildOf( this.data ) )
						this.on("event", this._dataEvent, data);
				}
			}
		}
		else
		{
			let index = this._listenedData.indexOf( data );
			if (index != -1)
			{
				if (!this.data || !(this.data instanceof fx.Model) || !this._hasValue( data ) /*this.data.hasValue( data )*/ )
				{
					this.off("updated", this._dataUpdated, this._listenedData[index]);
					if (data && !data.isChildOf( this.data ) )
						this.off("event", this._dataEvent, this._listenedData[index]);
				}
				this._listenedData.splice(index, 1);
			}
		}
    }

    _hasValue(data)
    {
        return Object.keys(this.data)
                    .filter( (key) => !key.startsWith("_"))
                    .filter( (key) => this.data[key] == data)
                    .length > 0;
    }

    _dataUpdated(e)
	{
		if (this.destroyed || !this._listenedData || !e.action)
			return;

		if (e.action.model == this._data || this._listenedData.indexOf( e.action.model ) != -1)
		{
			if (this.filter && e.action.model instanceof fx.ModelArray)
				this.filter.refresh();
				
			if (e.action.type == "delete" && e.action.model == this._data && this.autoDelete)
				this.hideDestroy();
			else
			if (e.action.updates.length > 0 || e.action.tag)
				this.onDataUpdated(e.action);
		}
		else
			this.onChildUpdated(e.action);
	}
	
	hideDestroy()
	{
		this.destroy();
	}

    _dataEvent(e)
	{
		this.onDataEvent(e.detail.event);
    }
    
    _filterUpdated(e)
	{
		this.onDataUpdated(new fx.Action("update"));
	}
    

});
/**
* A service allows :
* - to access remote server
* - store/read/delete local data (localStorage)
* - store/read/delete cookies
* 
* A service is ready (ready == true) only when it's data property is set
**/
fx.ns("fx", class Service extends fx.EventDispatcher{

	constructor()
	{
		super();

		this._ajax = fx.get("ajax");
		
		this._handlers = [];
	}

	get endpoint()
	{
		return this._endpoint;
	}

	set endpoint(val)
	{
		this._endpoint = val;
	}

	get requestDefaultParams()
	{
		return null;
	}

	/**************************** AJAX *********************/
	get(url, data, callback, options) 
	{
		if (typeof url == "object")
		{
			options = callback;
			callback = data;
			data = url;
			url = data.url || this.endpoint;
		}

		return this._ajaxCall( url, "GET", callback, data, options);
	}

	post(url, data, callback, options) 
	{
		if (typeof url == "object")
		{
			options = callback;
			callback = data;
			data = url;
			url = data.url || this.endpoint;
		}

		return this._ajaxCall( url, "POST", callback, data, options);
	}

	put(url, data, callback, options) 
	{	
		if (typeof url == "object")
		{
			options = callback;
			callback = data;
			data = url;
			url = data.url || this.endpoint
		}

		return this._ajaxCall( url, "PUT", callback, data, options);
	}

	delete(url, data, callback, options) 
	{
		if (typeof url == "object")
		{
			options = callback;
			callback = data;
			data = url;
			url = data.url || this.endpoint
		}
		
		return this._ajaxCall( url, "DELETE", callback, data, options);
	}

	abort(request)
	{
		this._ajax.abort(request);
	}

	_ajaxCall( url, method, callback, data, options )
	{
		// TODO : use _getBind ?
		/*let bind = callback.bind(this);
		this._handlers.push( bind );*/

		if (!url)
			throw new Error( "No endpoint/url given" );

		if (!(data instanceof FormData) && this.requestDefaultParams)
			data = Object.assign({}, this.requestDefaultParams, data);

		let request = Object.assign({}, options, { method: method, url : url, callback: this._getBind(callback), data : data });
		
		return this._ajax.request( request );
	}

	/**************************** LOCAL STORAGE *********************/
	
	storeData(id, data) 
	{
		if (Utils.typeEqual(data, "object"))
			data = JSON.stringify(data); // use Model.json ?

		try{
			localStorage.setItem(id, data);
		}
		catch(e){
			if(e instanceof DOMException)
				fx.log.warning("cookies are disabled");	// send warning instead of error if user have disabled cache
			else
				throw e;
		}
	}

	removeData(id) 
	{
		try{
			localStorage.removeItem(id);
		}
		catch(e){
			//if(e instanceof DOMException)
				//fx.log.warning("cookies are disabled"); // send warning instead of error if user have disabled cache
			//else
				//throw e;
		}
	}

	readData(id) 
	{
		var data = {};
		try{
			data = localStorage.getItem(id);
		}
		catch(e){
			if(e instanceof DOMException)
				fx.log.warning("cookies are disabled"); // send warning instead of error if user have disabled cache
			else
				throw e;
		}
		return JSON.parse(data);
	}

	/**************************** COOKIES *********************/
	readCookie(name)
	{
        let value = Cookies.get(name);
        return (value != "undefined") ? value : undefined;
	}

	/**
	 * Stores a cookie
	 * @param {*} name cookie name
	 * @param {*} value string or number representing value of cookie
	 * @param {*} expire Number of days cookie will be stored
	 */
	writeCookie(name, value, expire)
	{
		Cookies.set(name, value, { expires: expire ? expire : 365 });
	}

	deleteCookie(name)
	{
		Cookies.remove(name);
	}

	/**************************** BINDS *********************/
	_getBind(callback)
	{
		if (!callback) return null;
		
		let bind;
		for (let i = 0; i < this._handlers.length; i++)
		{
			if (this._handlers[i].callback == callback)
			{
				bind = this._handlers[i].bind;
				break;
			}
		}

		if (!bind)
		{
			bind = callback.bind(this);
			this._handlers.push({ callback : callback, bind : bind});
		}

		return bind;
	}

	destroy()
	{
		super.destroy();

		let handler;
		while(handler = this._handlers.pop())
		{
			delete handler.callback;
			delete handler.bind;
		}

		this._handlers = null;

		//this._ajax = null;
		//this._handlers = null;
		//this._endpoint  = null;
	}
	
	


});
fx.ns("fx", class Ajax extends fx.EventDispatcher {
    
    constructor()
    {
        super();

        this.NEXTID = 0;
        this.MAX_TRIES = 3;
        this.DELAY_RETRY = 1000;
        this.DELAY_TIMEOUT = 60000; // 1mn
        this.DELAY_TIMEOUT_MAX = 120000; // 2mn
        this.DELAY_MAX = 1200000; // 20mn
        this.requests = {};
        this.onDoneHandler = this._onDone.bind(this);
        this.onFailedHandler = this._onFailed.bind(this);
        this.retryRequestHandler = this._retryRequest.bind(this);

        this._binds = {};
    }

    request(options, request, parentRequest)
    {
       if (options && options.data && typeof options.data == 'object' && !(options.data instanceof FormData) && !options.data.connectionid && fx.get("connectionid"))
            options.data.connectionid = fx.get("connectionid");

        if (!request) {
            request = { tries: 1, 
                        maxTries : options.maxTries !== undefined ? options.maxTries : this.MAX_TRIES,
                        url:options.url, 
                        data:options.data, 
                        method : options.method || "POST", 
                        callback: options.callback, 
                        id:this.NEXTID, 
                        dataType : options.dataType  || "json",
                        processData: (options.processData !== undefined) ? options.processData : true, 
                        contentType: (options.contentType !== undefined) ? options.contentType : 'application/x-www-form-urlencoded; charset=UTF-8', 
                        parentRequest: parentRequest, 
                        sync : options.sync,
                        progressCallBack : options.progressCallBack,
                        timeout : options.timeout === 0 ? this.DELAY_MAX : ((options.timeout !== undefined) ? options.timeout : this.DELAY_TIMEOUT) };

            request.headers = {};

            if (options && options.headers)
                request.headers = Object.assign({}, options.headers);

            if (fx.get("global-request-header"))
                request.headers[fx.get("global-request-header").key] = fx.get("global-request-header").value;

            this.requests[this.NEXTID++] = request;
        }

        if (!(request.data instanceof FormData))
        {
            request.data = request.data || {};

            if (typeof request.data == 'object' && !request.data.uuid)
                request.data.uuid = Date.now() + "-" + Math.random().toString(16).slice(2); // uuid is used to identify in a unique way a request (if it's done again after error)
            
            if (Utils.getURLParam("debug"))
                request.data.debug = Utils.getURLParam("debug");
        }

        let _progressHandler = this._progress.bind(this, request);

        request.xhr = fx.get("dom").ajax({  url:fx.url(request.url),
                                            dataType: request.dataType,  
                                            type:request.method, 
                                            timeout:request.timeout,  
                                            processData : request.processData,
                                            contentType: request.contentType, 
                                            cache:false,  
                                            data:request.data, 
                                            async : !request.sync, 
                                            headers : request.headers,
                                            xhr: function()
                                            {
                                                var xhr = new window.XMLHttpRequest();
                                                //Upload progress
                                                xhr.upload.addEventListener("progress", _progressHandler, false);
                                                //Download progress
                                                xhr.addEventListener("progress", _progressHandler, false);
                                                   
                                                return xhr;
                                            },
                                        })
                                    .done( this.onDoneHandler )
                                    .fail( this.onFailedHandler );


        
        request.xhr._requestid = request.id;
     
        return request;
    }

    abort(request)
    {
        if (this.requests[request.id] && request.xhr)
        {
            request.xhr.abort();
            this._clean(request);
        }
    }

     _progress(request, evt)
    {
        if (evt.lengthComputable) {
            //var percentComplete = evt.loaded / evt.total * 100;
            if (request.progressCallBack)
                request.progressCallBack(evt.loaded , evt.total);
        }
    }


    
    /*hasRequests()
    {
        let has = false;
        for (let key in this.requests)
        {
            has = true;
            break;
        };
        return has;
    }*/
    
    _onDone(data, textStatus, xhr)
    {
        let request = this.requests[xhr._requestid];

        if (data && (data.error || data.success === false))
        {
            if (data.handled)
            {
                if (request.callback)
                    request.callback({error:true, details : data, request : this._jsonRequest(request)});

                this._clean(request);
            }
            else
                this._manageError(request, data);
        }
        else
        {
            if (request.callback)
                request.callback( data ) ;
            this._clean(request);
        }
    }

    _onFailed(xhr, textStatus, errorThrown )
    {
        let request = this.requests[xhr._requestid];

        this._manageError(request, errorThrown);
    }

 
    _manageError(request, details)
    {
        if (!request) return;

        if (request.tries < request.maxTries && details != "abort")
        {
            request.tries++;
            request.toRetry = true;
            request.timeout = request.timeout ? Math.min(this.DELAY_TIMEOUT_MAX, request.timeout + this.DELAY_TIMEOUT) : request.timeout;
            setTimeout( this.retryRequestHandler ,  this.DELAY_RETRY);
        }
        else
        {
            if (request.callback)
                request.callback({error:true, details : details, request :this._jsonRequest(request)});
            this._clean(request);
        }
    };

    _retryRequest()
    {
        for (let key in this.requests)
        {
            let r = this.requests[key];
            if (r.toRetry)
            {
                r.toRetry = false;
                this.request(null, r );
            }
        }
    };



    _jsonRequest(request)
    {
        return {
            url:fx.url(request.url),  
            dataType: request.dataType,  
            type:request.method, 
            timeout:request.timeout,  
            processData : request.processData,
            contentType: request.contentType, 
            data: request.data, 
            async : !request.sync,
        }
    }

    _clean(request)
    {
        delete(this.requests[request.id]);
        delete(request.data);
        if (request.callback)
            delete(request.callback);
        delete(request.url);
        delete(request.id);
    }
});

fx.ns("fx", class ErrorHandling extends fx.Service {

    constructor()
    {
        super();

        this._startApplicationTimeStamp = new Date();
        window.onerror = this._onError.bind(this);
    }

    get timestamp()
    {
        return (new Date() - this._startApplicationTimeStamp);
    }

    _onError(msg, url, line, column, error)
    {
        this.trigger("global-error", { msg : msg, url : url, line : line, column : column, error : error});
    }

    

});
fx.ns("fx", class Action {

    constructor(type, data, model, tag, history)
    {
        this._id = fx.sessionID(true) ;
        this._type = type;
        this._data = data;
        this._model = model;
        this._tag = tag;
        this._history = history;
        
        this._json = {};
        this._previous = {};
        this._properties = [];
        this._timestamp = new Date();
        this._index = 0;
        this._forSaving = false;

        this._stack = "";

        if (fx.get("debugging"))
            this._setStack();
    }

    get id()
    {
        return this._id;
    }

    get type()
    {
        return this._type;
    }

    get tag()
    {
        return this._tag;
    }

    get data()
    {
        return this._data;
    }

    set data(val)
    {
        this._data = val;
    }

    get index()
    {
        return this._index;
    }

    set index(val)
    {
        this._index = val;
    }

    get model()
    {
        return this._model;
    }

    set json(val)
    {
        this._json = val;
    }

    get json()
    {
        return this._json;
    }

    set previous(val)
    {
        this._previous = val;
    }

    get previous()
    {
        return this._previous;
    }

    set history(val)
    {
        this._history = val;
    }

    get history()
    {
        return this._history;
    }

    set properties(val)
    {
        this._properties = val;
    }

    get properties()
    {
        return this._properties;
    }

    get timestamp()
    {
        return this._timestamp;
    }

    set timestamp(val)
    {
        this._timestamp = val;
    }

    get forSaving()
    {
        return this._forSaving;
    }

    set forSaving(val)
    {
        this._forSaving = val;
    }
    
    get stack()
    {
        return this._stack;
    }

    get updates()
    {
        let updates = [];

        if (this.type == "update" && this.previous && this.data)
        {
            if (Object.keys(this.previous).length == Object.keys(this.data).length)
            {
                for (let prop in this.previous)
                {
                    if (this.previous[prop] != this.data[prop])
                    {
                        let update = {};
                        update[prop] = this.data[prop];
                        updates.push(update);
                    }
                }
            }
        }
        else
            updates.push(this.data);

        return updates;
    }

    clone()
    {
        let action = new Action();
		for (let property in this)
        {
            if (this[property])
            {
                if (this[property] instanceof Date)
                    action[property] = this[property];
                else
                if (this[property] instanceof Array)
                    action[property] = this[property].slice();
                else
                if (this[property] instanceof fx.Model)
                    action[property] = this[property];
                else
                if (typeof this[property] == "object")
                    action[property] =  Object.assign(Object.create(Object.getPrototypeOf(this[property])), this[property]);
                else
                    action[property] = this[property];
            }
        }

        return action;

        
    }
    
    impacts()
    {
        
        /*if (this.type == "init")
            return true;*/

        let impacts = false;
        for (let i = 0; i < arguments.length; i++)
        {
            if ( this.properties.indexOf(arguments[i]) != -1)
            {
                impacts = true;
                break;
            }
        }

        return impacts;
        
    }

    impactsOnly()
    {
        if (this.properties.length == 0)
            return false;

        let impacts = 0;
        for (let i = 0; i < arguments.length; i++)
        {
            if ( this.properties.indexOf(arguments[i]) != -1)
                impacts++;
        }

        return impacts == this.properties.length;
    }

    undo()
    {
        this.model.undo( this );
    }

    redo()
    {
        this.model.redo( this );
    }


    // --------------------------- //

    _setStack()
    {
        try {
            this._stack = new Error().stack;
        }
        catch(e)
        {
            this._stack =  e.stack;
        }
    }

});

// filter actions
// extract only need data
fx.ns("fx", class Event  extends fx.Disposable {

    constructor(type, data, model)
    {
        super();
        
        this._type = type;
        this._data = data;
        this._model = model;
        this._handled = false;
    }

    get type()
    {
        return this._type;
    }

    get data()
    {
        return this._data;
    }

    get detail()
    {
        return this._data;
    }

    get model()
    {
        return this._model;
    }

    get handled()
    {
        return this._handled;
    }

    cancel()
    {
        this.stopPropagation();
        if (this.data.stopPropagation)
            this.data.stopPropagation()
        
        if (this.data.preventDefault)
            this.data.preventDefault()
    }
    
    stopPropagation()
    {
        this._handled = true;
    }

});
fx.ns("fx", class History extends fx.EventDispatcher{

    constructor(model, nbActionsStored)
    {
        super();

        if (!model instanceof fx.Model)
        {
            fx.throwError("Model constructor must be an instance of Model or ModelArray")
            return;
        }

        this._model = model;

        this._actions = [];
        this._position = -1;
        this._timestampBetweenActions = 1000;
        this._timestampActionsInGroup = 250;
        this._maxActionsStored = (nbActionsStored !== undefined) ? nbActionsStored : 10; 

        this.on("updated", this._onDataUpdated, this._model);

        this._startTimeStamp = new Date();

        // so far, no need to track events
        //this.on("event", this._onDataEvent, this._model);
    
        // in order to avoid any cleaning at start of application
        this.disable();
    }


    get model()
    {
        return this._model;
    }

    get timestamp()
    {
        return this._timestampBetweenActions;
    }

    get timestampActionsInGroup()
    {
        return this._timestampActionsInGroup;
    }


    get position()
    {
        return this._position;
    }

    set position(val)
    {
        this._position = val;
        this.trigger("updated");
    }

    get actions()
    {
        return this._actions;
    }

    get canUndo()
    {
        return this._actions.length > 0 && this._position >= 0;
    }

    get canRedo()
    {
        return this._actions.length > 0 && this._position < this._actions.length - 1;
    }

    get currentAction()
    {
        return this._actions[this._position];
    }

    get maxActionsStored()
    {
        return this._maxActionsStored;
    }

    set maxActionsStored(val)
    {
        this._maxActionsStored = val;
    }

    disable()
    {
        this._enabled = false;
    }

    enable()
    {
        this._enabled = true;
    }

    clear()
    {
        this._actions = [];
        this.position = -1;
    }

    start()
    {
        this.delay(this.enable, 250);
    }

    undo()
    {
        if (!this.canUndo) return;

        this._lastTimeStamp = new Date();

        for (let i = this.currentAction.actions.length-1; i >=0; i--)
            this.currentAction.actions[i] && this.currentAction.actions[i].undo();
    
        this.position = this.position - 1;

        
    }

    redo()
    {
        if (!this.canRedo) return;

        this._lastTimeStamp = new Date();
        
        this.position = this.position + 1;
        
        for (let i = 0; i < this.currentAction.actions.length; i++)
            this.currentAction.actions[i] && this.currentAction.actions[i].redo();

        
    }

    // raisonner en groupe d'actions
    _onDataUpdated(e)
    {
        if (!this._enabled) return;
        
        if (!e) return;
        
        // we don't count any action generated at start
        if ((new Date()) - this._startTimeStamp < 2000)
            return;

        let action = e.action;

        if (!action || action.history)
            return;

        // we don't count any action generated by last undo/redo
        if ((new Date()) - this._lastTimeStamp < 100)
            return;

        if (!this.valid(action))
            return;

        // means we undone some updates, and started to work
        // so let remove next actions
        this._actions.splice(this._position + 1);

        let newAction = action.clone();
   
        newAction.history = true;
        
        // need to check last newAction, and see if it's on same component
        // and check if timestamp if very close
        // and then only merge newAction with this one
        //let lastAction = this._actions.last();
        let lastGroup = this._actions.last();

        let lastAction = lastGroup ? lastGroup.actions.last() : null;
    
        if (this.needMerge(lastAction, newAction, lastGroup))
        {
            lastAction.data = Object.assign({}, lastAction.data, newAction.data);
            lastAction.previous = Object.assign({}, newAction.previous, lastAction.previous);
            lastAction.properties = lastAction.properties.concat(newAction.properties).unique()
            lastAction.timestamp = newAction.timestamp;
        }
        else
        if (lastGroup && lastAction &&
                (   ( (newAction.timestamp - lastAction.timestamp) < this.timestampActionsInGroup) 
                /*|| 
                    (lastGroup.actions.last().model == (newAction.data || newAction.model) && (newAction.type == "delete" || newAction.type == "removeItem")) */) 
                 )
            lastGroup.actions.push( newAction );
        else
        {
            lastGroup = { actions : [newAction] };
            this._actions.push( lastGroup ); // new group

            if (this._maxHistoryActionsStored && this._actions.length > this._maxHistoryActionsStored)
                this._actions.shift();
        }
    
        this.position = this._actions.length - 1;

        return lastGroup;
    }

    needMerge(lastAction, action, lastGroup)
    {
        return lastAction && action.type == "update" && lastAction.type == "update" && lastAction.model == action.model && (action.timestamp - lastAction.timestamp) < this.timestamp;
    }

    valid(action)
    {
        if (!this.enabled)
            return false;

        if (action.type == "update" && Utils.ObjectEquals(action.previous, action.data))
            return false;

        return action.type != "init";
    }

    

});


/**
 * fx.Model is the base class for any data that would be used in a graphical component.
 * By using objects encapsulated in an fx.Model class (or in any inherited class), graphical component will be updated automatically when data is updated.
 * Any object mutation will create an action that will be propagated through all parent up to the top most object.
 * This allow to be able to monitor any data update at any level of the application. 
 * It allows also to make different graphical component communicate easily (not need of a global EventEmitter or of some cascading events / callbacks)
 * 
 * It inherits from fx.Service, so it has access to all functions to get data from remote sources (AJAX), or local sources (Cookies, LocalStorage, ...).
 * 
 * It mains functions :
 * 
 * - update(name, data) :   A model can not be updated directly. All it's properties are ready only.
 *                              This function is the lone way to update a model property.
 *                              All ui components encapsulating this model will be updated if model is updated (render() function will be called, or update() for fx.Component )
 *                              Reserved names : "delete", "addItem", "empty", "insertItem"
 * 
 *                              name can be omitted, =Example : 
 *                                  > this.data.update({height:100, width:50, left:170});
 *                                  > this.data.update("resize", {height:100, width:50});
 * 
 *	                            If model handles the mutation, and action is created with all details, and an event is dispatch from this model.
 *                              This event will be dispatched from parent to parent, up to the top.
 *                              Any fx.Component ensapsulating this model will be notified and updated.
 * 
 *  - prop(name, value) : add a property that will not propagate it's updates.
 *   
 * In case it's an array :
 * 
 * - getItemAt(index)
 * - length
 * 
 * 
 */
fx.ns("fx", class Model extends fx.Service {
    
    constructor(data, options, classesMap)
    {
        super();

        // properties array is used to store all data coming from remote model
        // we will use this property to extract those data when it comes to send
        // anything to server.
        this._properties = [];
        this._propertiesNotBinded = [];
        
        this._parentModel = null;
        this._parentProperty = null;
        this._queueEvents = [];
        this._modified = null;

        this._storedParentModelUpdates = [];

        //this._dispatchParentHandler = this._dispatchParent.bind(this);
        
        this._saver = (options && options.saver) ? new options.saver(this) : null;
        
        this.on("updated", this._onUpdated );
        this.on("event", this._onDataEvent );

        this.init(data, classesMap);   


        // When a model is created, it's still not linked to main model
        // so we store "create" event until it's connected.
        if (Utils.isID(this.id)) // created manually
            this._storedParentModelUpdates.push({type:"updated", action : new fx.Action("create", null, this)});
        
        // Let's enable history here
        if (options && options.history)
            this.history = new options.history(this);
            
            
    }

    /**************************** GETTERS ****************************/

    /**
     * In order to save a model, you have to assign it a saver. See fx.ModelSaver to see an example of remote CRUD saver.
     * By default fx.ModelSaver is used when save() function is called.
     */
    get saver()
    {
        return this._saver;
    }

    set saver(val)
    {
        if (typeof val == "function")
            this._saver = new val(this);
        else
            this._saver = val;
    }

   
    
    get modified()
    {
        // if _modified was never set, we use saver data to know if model was updated
        return (this.saver ? this.saver.lastUpdates.length > 0 : this._modified);
    }

    set modified(val)
    {
        this._modified = val;
    }

    /**
     * Returns Model class. It's either defined by property "_m", if not we just use class name.
     */
    get modelClass()
    {
        return this._m || Object.getPrototypeOf(this).constructor.name
    }

    /**
     * Override this getter in order to add param to save ajax call
     */
    get saveParams()
    {   
        return {};
    }

    /**
     * This getter has to be overrided when Model needs some defaults values (for example values not sent by database of not set)
     */
    get defaults()
    {
        return {};
    }

    get propertiesNotStorable()
    {
        return [];
    }

    get storable()
    {
        return true;
    }

    get parent()
    {
        if (this._parentModel instanceof fx.ModelArray)
            return this._parentModel.parentModel;
        
        return this.parentModel;
    }

    get parentModel()
    {
        return this._parentModel;
    }

    set parentModel(val)
    {
        this._parentModel = val;
        this._dispatchStoredParentModelEvents();
    }

    get parentProperty()
    {
        return this._parentProperty;
    }

    set parentProperty(val)
    {
        this._parentProperty = val;
    }
    
    get localized()
    {
        return false;
    }
    
    /**************************** EVENTS TO OVERRIDE ****************************/

     /**
     * Override this function if you want to be notified everytime model and it's childs are updated.
     * You must always call parent function in order to get parent notified also.
     * @param {fx.Action} action fx.Action object with all details about what update.
     */
    onUpdated(action)
    {
       
    }

    /**
     * Override this function if you want to be notified everytime an event is dispatch on model.
     * 
     * @param {object} e event
     */
    onDataEvent(e)
    {
        
    }

    // TODO : if photo was deleted while uploading, and save is called, save everything before this action only. Next save will save the rest
    // because photoid is still not received, and delete on backoffice won't be possible.
    save(options)
	{
        if (!options)
            options = {};
            
        if (!options.url)
            options.url = this.endpoint;
        
        if (this.saver)
            this.saver.save(options);
    }
    
    /**
     * Override this function is you want to add some special behaviour when model is saved
     * @param {Object} data 
     */
	onSaved(data)
	{
    }

    

    /**************************** PUBLIC FUNCTIONS ****************************/

     /**
     * Returns a JSON version of the Model. Used mostly for Ajax requests
     */
    JSON(keepClass)
    {   
        if (this._properties)
        {
            let json = {};
            let propertiesNotStorable = keepClass ? this.propertiesNotStorable : this.propertiesNotStorable.concat(["_m"]);
            for (let i = 0; i < this._properties.length; i++)
            {
                if (propertiesNotStorable.indexOf(this._properties[i]) == -1) 
                    json[ this._properties[i] ] = (this[ this._properties[i] ] instanceof fx.Model) ? this[ this._properties[i] ].JSON(keepClass) : this[ this._properties[i] ];
            }
        
            return json;
        }
    }

    init(data, classesMap)
    {
        if (!data) 
            data = {};

        // first we remove all already set properties (binded and not)
        for(let i = 0; i < this._properties.length; i++)
            delete this[this._properties[i]];

        for(let i = 0; i < this._propertiesNotBinded.length; i++)
            delete this[this._propertiesNotBinded[i]];

        this._properties = [];
        this._propertiesNotBinded = [];
        
        // in case data has no id, let's create one (in fx, every element has to have an ID)
        // and if not type given in raw model throught "_m" property, let's set class name.
        
        let props = {   
                        id : data.id || Utils.newID(), 
                        _m : data._m || this.modelClass 
                    };

        this._map( Object.assign({}, props, this.defaults, data), classesMap );
        
        if (!this._m)
            this._setProperty("_m", this.modelClass);

        this.trigger({type:"updated", action : new fx.Action("init", this, this)});
    }

   
    /**
     * Dispatch an event wich will be propagated from parent to parent. Usefull when you want to make component using same model or on same model hierarchy communicate together.
     * @param {string} event event tag
     * @param {Object} parameters sent with event
     * @param {Number} delay in miliseconds before to send event
     */
    event(type, data, delay)
    {
        this.triggerDelay({type:"event", event : new fx.Event(type,  data, this) }, delay);
    }
   
    /**
     * If name given and data given, and data doesn't match any model property, let's disptach to parent unhandled
     * @param {string} name  given as a tag for the mutation. Usefull when you want to optimize you graphical update, with this tag you can decide to update only a specific part. And since mutation action will be propagated to parents, parents can use this tag in order to start some other mutations.
     * @param {object} params object with each property and value
     */
    update(tag, data)
    {
        let history = false;
        if (tag instanceof fx.Action)
        {
            let action = tag;
            // undo
            if (data === true)
                data = Utils.clone(action.previous);
            else // redo
                data = Utils.clone(action.data);
            
            tag = action.tag;
            
            history = true;
        }
        else
        {
            // Check parameter
            if (!data)
            {
                /*if (typeof tag != "object")
                    throw new Error("Wrong parameter in mutate() function");*/
                
                if (tag && typeof tag == "object")
                {
                    data = tag;
                    tag = "";
                }
            }
            else
            {
                if (typeof tag == "object" && typeof data == "object" && data.history !== undefined)
                {
                    history = data.history;
                    data = tag;
                    tag = "";
                }
                else
                if (typeof tag != "string" || typeof data != "object")
                    throw new Error("Wrong parameters in update() function");
            }
        }

        let handled = false;
        
        // let's first see if data match any property in actual model
        // otherwise let call parent mutate function
        let previous = {};
        let properties = [];
        //let same = true;
        for(let property in data)
        {
            
            // if same value, we continue
            //if (data[property] == this[property])
            //    continue;

            // store previous value, will be needed for rollback
            
            previous[property] = this[property];

            //same = same && (previous[property] == data[property]);
            this._setProperty(property, data[property] );

            properties.push(property);

            handled = true;
        }
    
        if (handled || tag)
        {
            let action = new fx.Action("update", data, this, tag);
            action.properties = properties;
            action.previous = previous;
            action.json = this.JSON();
            action.history = history;
            //action.same = same;
            
            this.trigger({type:"updated", action : action});
        }
      
        
    }

    undo(action)
    {
        if (action.type == "create")
            this.delete(true);
        else
        if (action.type == "delete")
        {
            this.trigger({type:"updated", action : new fx.Action("create", null, this, null, true)});
            this._deleted = false;
        }
        else
            this.update(action, true);
    }

    redo(action)
    {
        if (action.type == "create")
        {
            this.trigger({type:"updated", action : new fx.Action("create", null, this, null, true)});
            this._deleted = false;
        }
        else
        if (action.type == "delete")
            this.delete(true);
        else
            this.update(action, false);
    }


    /**
     * When deleting a model, there is 3 cases :
     * - model is part of an array, so we need to remove it from parent array
     * - model is not part of an array, so if it has a parent model, we just set null to it's parent corresponding property.
     * - model has not parent
     */
    delete(history)
    {
        // let's delete properties
        for(let i = 0; i < this._propertiesNotBinded.length; i++)
            delete this[this._propertiesNotBinded[i]];

        this._deleted = true;
        this.trigger({type:"updated", action : new fx.Action("delete", null, this, null, history)});
    }

    // to override 
    clean()
    {

    }

    get deleted()
    {
        return this._deleted;
    }

    /**
     * Check if model contain the given value (go through all properties, and find if one of them is equal to the given value)
     * @param {Object} value 
     */
    hasValue(value)
    {
        let keys = Object.keys(this), has = false;
        for (let i = 0; i < keys.length; i++)
        {
            if (/*!keys[i].startsWith("_") &&*/ this[keys[i]] == value)
            {
                has = true;
                break;
            }
        }
        
        return has;
        //return Object.values( this ).indexOf( value ) != -1;
    }

    /**
     * Adds a property to the model that will not trigger any update event.
     * This function is to be used when we need to link model to an object that is not part of it's properties.
     * This property won't be considered as part of model properties, so it won't be sent to backoffice for saving.
     * @param {String} name 
     * @param {Object} value 
     */
    prop(name, value)
    {
        // if property already exist, we don't add it.
        if (this._properties.indexOf(name) != -1) 
            return;

        if (this._propertiesNotBinded.indexOf(name) == -1)
            this._propertiesNotBinded.push(name);

        if (value === undefined)
            delete(this[name]);
        else
            this[name] = value;
    }

    /**
     * Adds a property to the model that will trigger any update event
     * @param {String} name 
     * @param {*} value 
     */
    set(name, value)
    {
        this._setProperty(name, this._createModel( value, name ));   
    }


    isChildOf(parent)
    {
        let isChildOf = false;
        let element = this;
        while (!isChildOf && element)
        {
            isChildOf = (element == parent);
            element = element.parent;
        }
        return isChildOf;   
    }

    /**************************** PRIVATE FUNCTIONS ****************************/
   
    _map(data, classesMap)
    {
        let properties = Object.keys( data );

        for (let i = 0 ; i < properties.length; i++)
        {
            let property = properties[i];
            
            if (property == "_parentModel" || property == "_m" || data[property] instanceof fx.Component)
                continue;
            
            this._setProperty(property, this._createModel( data[property], property, classesMap )  );   
        }
    }

    /**
     * Creates and returns an fx.Model instance of the given data, and set this model as it's parent model.
     */
    _createModel(data, property, classesMap)
    {
        let obj;

        if (data === null || typeof data != "object")
            obj = data;
        else
        if (data instanceof fx.Model)
            obj = data;
        else
        if (data["_m"] && models[ data["_m"]  ] ) 
        {
            let className = data["_m"];
            if (classesMap && classesMap[data["_m"]])
                className = classesMap[data["_m"]];
            
            obj = new models[ className ]( data );
        }
            
        else
        if (data instanceof Array)
            obj = new fx.ModelArray( data, classesMap );
        else
        if (data != null && typeof data == "object")
            obj = new fx.Model( data );

        if (obj instanceof fx.Model)
        {
            obj.parentModel = this;
            obj.parentProperty = property;
        }

        return obj;
    }

    /**
     * Create a read only property on model, and set it with given value.
     */
    _setProperty(key, value)
    {
        // we define this property only once
        if (!this.hasOwnProperty(key))
        {
            if (this._properties.indexOf(key) == -1)
                this._properties.push(key);

            Object.defineProperty(this, key, {
                                                get : function() { return this["_" + key]; }, 
                                                set : function(value) { 

                                                    if (!this.hasOwnProperty(key))
                                                    {
                                                        fx.log.error("Direct mutation on non existing property : " + key);
                                                    }
                                                    else
                                                    {
                                                        if (this["_" + key] == value)
                                                            return;

                                                        let previous = {};
                                                        previous[key] = this["_" + key];
                                                        this["_" + key] = value;

                                                        // in case update is made directly, we disptach an action to let know update happened
                                                        let data = {};
                                                        data[key] = value;
                                                        let action = new fx.Action("update", data, this);
                                                        action.properties.push(key);
                                                        action.previous = previous;
                                                        action.json = this.JSON();
                                            
                                                        this.trigger({type:"updated", action : action});
                                                    
                                                    }
                                                },
                                                enumerable : true,
                                                configurable : true
                                            }); 
        } 
        else 
        if(this._propertiesNotBinded.indexOf(key) != -1) // created with prop
            this[key] = value
        
        // we set the property
        this["_" + key] = value;
    }

    _onUpdated(e)
    {
       if (!e) return;
       
        // use to know if page was updated
        if ((e.action.type == "create" && e.action.model && e.action.model.constructor !== fx.Model) || e.action.type == "update" || e.action.type == "delete")
            this.modified = true;


        this.onUpdated(e.action);

        // actions are propagated until we reach the top model
        if (this.parentModel)
            this._dispatchParent(e);
        else
        if (!this.saver)
            this._storedParentModelUpdates.push( e );
            
        if (this.saver)
            this.saver.handle(e.action);
        
         // in case of delete we cut the link with parent (in order to avoid any memory leak)
         if (e.action && e.action.type == "delete" && this == e.action.model)
            this.parentModel = null;
    }

    _onDataEvent(e)
    {
        this.onDataEvent(e.detail.event);

        /*if (this.saver)
            this.saver.event(e.detail.event);*/

        if (!e.detail.event.handled)
            this._dispatchParent(e);
    }

    _dispatchParent(e)
    {
        if (this.parentModel)
            this.parentModel.trigger(e);
    }

    _dispatchStoredParentModelEvents()
    {
        if (this.parentModel)
        {
            let update;
            while( update = this._storedParentModelUpdates.shift())
                this.parentModel.trigger(update);
        }
    }

 
    // TODO : Is it usefull to make Model destroyable ?
    //destroy()
    //{
    //    super.destroy();
    //    this._saver.destroy();
    //}


});
/**
 * fx.ModelArray is a Model thay contains an array of objects
 */
fx.ns("fx", class ModelArray extends fx.Model {

    constructor(data, classesMap)
    {
        super(data, {}, classesMap);
    }

    /**************************** GETTERS ****************************/

    get sendActions()
	{
		return {update : false, create : false, delete : false};
    }
    
    get length()
    {
        return this._array.length;
    }

    get last()
    {
        return this._array[ this._array.length - 1];
    }

    set internalSort( callback )
    {
        this._internalSort = callback ;
        if (this._array)
            this._applyInternalSort();
    }

   
    /**************************** OVERRIDES & PUBLIC FUNCTIONS ****************************/

    JSON(keepClass)
    {
        let json = [];
        for (let i = 0; i < this._array.length; i++)
            json.push( this._array[i] instanceof fx.Model ? this._array[i].JSON(keepClass) : this._array[i])
        
        return json;
    }

    toArray()
    {
        return this._array.concat();
    }

    getItemAt(index)
    {
        return this._array[index];
    }

    slice(start, end)
    {
        return this._array.slice(start, end);
    }

    indexOf(item)
    {
        return this._array.indexOf(item);
    }

    sort(fnc)
    {
        this._array.sort( fnc );
    }
    

    // TODO : on all removeItem[s][all] check case of item (need to call .delete() or not ?)
    removeItems(items, history)
    {
        for (let i = 0; i < items.length; i++)
            this.removeItem( items[i], history );
    }

    removeItem(item, history)
    {
        let index = this._array.indexOf( item );
        if (index != -1)
        {
            let previous = this.JSON();

            this._array.splice(index, 1);

            let action = new fx.Action("removeItem", item, this);
            action.item = item;
            action.previous = previous;
            action.index = index;
            action.json = this.JSON();
            action.history = history;
            this.trigger({type:"updated", action : action});
        }
        else
            fx.log.error("removeItem : item not found, " + item);
    }

    removeItemAt(index, history)
    {
        if (index >= 0 && index <= this.length)
        {
            let previous = this.JSON();

            this._array.splice(index, 1);

            let action = new fx.Action("removeItemAt", index, this);
            action.index = index;
            action.previous = previous;
            action.index = index;
            action.json = this.JSON();
            action.history = history;
            this.trigger({type:"updated", action : action});
        } 
        //else
        //    fx.console.log("removeItemAt : index out of range", index);

        
    }

    removeAll(silent, history)
    {
        if (this._array.length == 0)
            return;

        let previous = this._array.slice(); // trick to create a copy

        let item;
        while (item = this._array.pop() || this._array.length > 0)
        {
            if (!silent && item instanceof fx.Model)
                item.delete();
        }
        
        if (!silent)
        {
            let action = new fx.Action("removeAll", null, this);
            action.previous = previous;
            action.json = [];
            action.history = history;
            this.trigger({type:"updated", action : action});
        }
    }

    /**
     * Add new item
     * @param {*} item : items or array of items to be added
     * @param {*} unique : item is unique, so if it already exist don't add it
     * @param {*} silent : it set to true, don't trigger any event
     * @param {*} history : if set to true, used for history
     * @param {*} all : if set to true means no more items will be added after that (needed for exemple on VerticalGridDynamic to know that it can be update instantanetly instead of waiting for next items)
     */
    addItem(item, unique, silent, history, all)
    {
        unique = !(unique === false);

        let previous = this.JSON();

        let items = ( item instanceof Array || item instanceof fx.ModelArray) ? item : [item];
            
        //let added = false;
        let addedItems = [];
        let itemModel;
        for(let i = 0; i < items.length; i++)
        {
            let elt = items instanceof fx.ModelArray ? items.getItemAt(i) : items[i];

            if (!unique || (elt.hasOwnProperty("id") ? !this._array.find({id : elt.id}) : (this._array.indexOf(elt) == -1) ) )
            {
                itemModel = elt instanceof fx.Model ? elt : this._createModel(elt);
                this._connect(itemModel, true);
                addedItems.push(itemModel);
                this._array.push( itemModel);
                //added = true;
            }
        }
            
        if (!silent)
        //if (added) We send an action event if not element was added because in cases when no result, component need to be refreshed
        {   
            //let action = new fx.Action("addItem", item, this);
            let action = new fx.Action("addItem", item, this);
            action.items = addedItems;
            action.previous = previous;
            action.json = [];
            action.history = history;
            action.all = all;
            this.trigger({type:"updated", action : action});
        }

        return item;
    }

    addItemAt(index, item, history)
    {
        if (index >= 0 /*&& index <= this.length*/)
        {
            if (index >= this.length)
                index = this.length;
            
            let previous = this.JSON();

            let items = ( item instanceof Array || item instanceof fx.ModelArray) ? item : [item];
            let addedItems = [];
            
            for(let i = 0; i < items.length; i++)
            {
                let itemModel = items instanceof fx.ModelArray ? items.getItemAt(i) : this._createModel(items[i]);
                this._connect(itemModel, true);
                addedItems.push(itemModel);
                this._array.splice(index, 0, itemModel );
            }
                

            let action = new fx.Action("addItemAt", item, this);
            action.items = addedItems;
            action.index = index;
            action.previous = previous;
            action.json = [];
            action.history = history;
            this.trigger({type:"updated", action : action});
        }
            
    }

    moveItemAt(index, item, history)
    {
        if (index >=0 && index < this.length && this.indexOf(item) != -1)
        {
            let previous = this.JSON();

            let oldindex = this._array.indexOf(item);
            this._array.move( oldindex, index);

            let action = new fx.Action("moveItemAt", {item:item, index : index}, this);
            action.item = item;
            action.previous = previous;
            action.json = this.JSON();
            action.history = history;
            this.trigger({type:"updated", action : action});
        }
    }

    moveItem(item, reference, side,history)
    {
        side = side || "right";

        if (!item || reference === undefined)
            return;
        
        let previous = this.toArray();

        if (Utils.isInt(reference))
        {
            this._array.move( this._array.indexOf(item), reference);
        }
        else
        if (side == "right")
        {
           let oldindex = this._array.indexOf(item);
           let newindex = this._array.indexOf(reference);

           if (oldindex > newindex)
                newindex++;

           this._array.move( oldindex, newindex);
        }
        else // "before"
        {
           let oldindex = this._array.indexOf(item);
           let newindex = this._array.indexOf(reference);

           if (oldindex < newindex)
                newindex--;

           this._array.move( oldindex, newindex);
        }
        
        let action = new fx.Action("moveItem", {item:item, reference:reference, side:side}, this);
        action.item = reference;
        action.side = side;
        action.previous = previous;
        action.json = this.JSON();
        action.history = history;
        this.trigger({type:"updated", action : action});
      
    }
	
    contains(item)
    {
        return this._array.indexOf( item ) != -1;
    }

    indexOf(item)
    {
        return this._array.indexOf( item );
    }

    find(properties, returnArray)
    {
        return this._array.find(properties, returnArray);
    }

    filter(callback)
    {
        return this._array.filter(callback);
    }

    map(callback)
    {
        return this._array.map(callback);
    }

    sort(callback)
    {
        return this._array.sort(callback);
    }

    every(callback)
    {
        return this._array.every(callback);
    }

    concat(item)
    {
        return this.addItem(item);
    }

    init(data, classesMap)
    {
        // we store here the array of data
        if (!this._array || this._array.length > 0)
            this._array = [];

        if (!data) return;

        for (let i = 0; i < data.length; i++)
        {
            let model = this._createModel(data[i], "", classesMap);
            this._array.push( model );
            this._connect(model, true);
        }

        this._applyInternalSort();

        this.trigger({type:"updated", action : new fx.Action("init", this, this)});
    }


    undo(action)
    {
        switch(action.type)
        {
            case "removeItem":
                action.model.addItemAt(action.index, action.item, true);
                break;

            case "addItem" :
                if (action.data instanceof fx.Model)
                    action.data.delete(true);
                break;

            case "addItemAt" :
                //TODO
                if (action.data instanceof fx.Model)
                    action.data.delete(true);
                break;

            case "moveItem" :
                action.model.moveItemAt(action.previous.indexOf( action.item ), action.item, true);
                //action.model.moveItem(action.data, action.item, action.side, true);
                break;

            case "removeAll" :
                    action.model.addItem(action.previous, false, false, true);
                break;
        } 
    }

    redo(action)
    {
        switch(action.type)
        {
            case "removeItem":
                action.item.delete(true);
                break;

            case "addItem":
                action.model.addItem(action.data, undefined, undefined, true);
                break;

            case "addItemAt" :
                //TODO
                action.model.addItemAt(action.index, action.data, true);
                break;

            case "moveItem" :
                action.model.moveItem(action.data, action.item, action.side, true);
                break;

            case "removeAll" :
                action.model.removeAll(false, true);
                break;
        } 
    }

    /**
     * Reserved add, delete, empty, insert(after, before, reference)
     **/ 
    update(name, data) // DISABLED
    {
    }

    /**
     * To override if needed to sort or update data before being displayed
     */
    refresh()
    {
     
    }

    /**************************** PRIVATE FUNCTIONS ****************************/

    _connect(data, on)
    {
        if (data instanceof fx.Model)
            data.parentModel = on ? this : null;
    }

    _onUpdated(e)
    {
        // we spy here on delete action, so we can delete element from array
        if (e.action.type == "delete" && e.action.model.parentModel == this)
        {
            if (this.contains(e.action.model))
                this.removeItem( e.action.model, e.action.history );
        }

        this._applyInternalSort();
        //else
        super._onUpdated(e);
    }


    _applyInternalSort()
    {
        if (this._internalSort)
            this._array.sort( this._internalSort );
    }
    
   
});

/**
 * This class is like an Interface to follow in order to code a saver for a model.
 */
fx.ns("fx", class ModelSaver extends fx.Service {

    constructor(model)
    {
        super();

        this._model = model;
        this._saving = false;

        this._lastUpdates = [];
    }

    /**
     * Return model to save
     */
    get model()
    {
         return this._model;
    }

    /**
     * Returns true is saving is going on, false if save already done.
     */
    get saving()
    {
        return this._saving;
    }

    /**
     * Returns last updates since last save
     */
    get lastUpdates()
    {
        return this._lastUpdates;
    }

    /**
     * Override this function if you want to filter actions to save.
     * @param {fx.Action} action 
     */
    handle(action)
    {
        if (!this.enabled) return;
        
        if (action.model && !action.model.storable)
            return;

        action = action.clone();

        try {
            // filter properties not storable
            if (action.type == "update")
            {

                if (action.model && action.data)
                {
                    let propertiesNotStorable = action.model.propertiesNotStorable.concat(["_m"]);
                        
                    for(let i = 0; i < propertiesNotStorable.length; i++)
                    {
                        let index = action.properties.indexOf( propertiesNotStorable[i] );
                        if (index != -1)
                        {
                            action.properties.removeAt(index);
                        
                            delete action.data[propertiesNotStorable[i]];
                            delete action.previous[propertiesNotStorable[i]];
                            delete action.json[propertiesNotStorable[i]];
                        }
                    }

                    if ( Object.keys(action.data).length == 0)
                            return;
                    
                }

                // if element was already updated, let's just update last update action
                let lastUpdateAction = this._lastUpdates.find({ model : action.model, type : "update", forSaving : false});

                if (lastUpdateAction)
                {
                    lastUpdateAction.data = Object.assign({}, lastUpdateAction.data, action.data);
                    lastUpdateAction.previous = Object.assign({}, action.previous, lastUpdateAction.previous);
                    lastUpdateAction.properties = lastUpdateAction.properties.concat(action.properties).unique();

                    return;
                }
            }
        
        } catch(e) {
            fx.log.error(e);
        }
        
        this._lastUpdates.push( action );
    }

    /**
     * Override this function to implement saving (remote, local, etc...) 
     * By default this function just empties lastUpdates and calls _saved()
     * @param {Object} options 
     */
    save(options)
	{
        this._saving = true;
    }

    /**
     * When your model is saved, call this function in order in order to set properly saving property and let model know saving is finished.
     * @param {data} data 
     */
	onSaved(data)
	{
        this._saving = false;
        
        this.model.onSaved(data);	
    }

});
// TODO
// TODO
// TODO
/**
 * This model saver collects only Create, Update and Delete actions from models defined in models packages.
 * And sends those actions to server by post ajax request.
 * save function has to be called with object defining url for ajax request. Example : this.save({url : "https://www.myserver.com/api"})
 * A post call is done is 2 parameters :
 * - action = "save" 
 * - updates : array of json objects will all data about each update (CREATE, UPDATE, DELETE)
 */
fx.ns("fx", class CrudSaver extends fx.ModelSaver {

    constructor(model, MAXUPDATES)
    {
        super(model);

        this._MAX_UPDATES = MAXUPDATES ? MAXUPDATES : 200;
    }

    // TODO : record events for debugging 
    /*event(event)
    {
        event.type
    }*/

    handle(action)
    {
        // if model was not defined in models package, we don't save it
        if (!action.model || action.model._m == "Model" || !action.model._m)
            return;

        // COMMENTED TO CHECK IF IT CREATES PROBLEM OF DUPLICATED PICTURES
         // if element is deleted, but create is in list of update, let's remove create action
        /*if (action.type == "delete" && !action.history)
        {
            let createAction = this.lastUpdates.find({ model : action.model, type : "create", forSaving : false});
            if (createAction)
            {
                this.lastUpdates.remove(createAction);
                return;
            }
        }
        else
        if (action.type == "create" && !action.history) // if element is created (because of undo) and was delete before, we cancel action and remove delete one
        {
            let deleteAction = this.lastUpdates.find({ model : action.model, type : "delete", forSaving : false});
            if (deleteAction)
            {
                this.lastUpdates.remove(deleteAction);
                return;
            }
        }
        else*/
        

        // For saving, we store only those actions : update / create / delete
        if ( action.type == "update" ||  action.type == "create" || action.type == "delete" )
            super.handle(action);

    }

    cancel()
    {
        if (this._currentCall)
        {
            this._currentCall.xhr.abort();
            this._currentCall = null;
        }
    }

    reset(full)
    {
        this._saving = false;

        if (full)
            this._lastUpdates = [];
        else
        {
            for (let i = 0; i < this.lastUpdates.length; i++)
                this.lastUpdates[i].forSaving = false;
        }
    }

    /**
     * Override this function to implement saving of your model.
     * @param {Object} options 
     * options.force : send all updates
     * options.updates : process request even if no updates
     */
    save(options)
	{
        if (!options)
            options = {};

        if (this._saving && !options.force)
            return;

        this._saving = true;

        let updates = this.prepareUpdatesForSending();

        if (updates.length == 0 && options && (!options.force && !options.updates))
        {
            this.delay(this.onSaved);   
        }
        else
        {   
            let data = {};

            if (this.model.saveParams)
                Object.assign(data, this.model.saveParams);

            if (options.params)
                Object.assign(data, options.params);

            data.updates = updates;

            options.maxTries = 1;
            options.timeout = 0;
            
            data.version = "2"; // version 2 get back object with actions, ids, and error

            this._currentCall = this.post( options.url, {data : JSON.stringify( data ) }, this._onSaved, options );
        }
    
    }
    
    _onSaved(data)
    {
        if (data.error && typeof data.details != "string")
        {
            data = data.details;
            data.error = true;
        }

        this.onSaved(data);
    }

	onSaved(data)
	{
        this._saving = false;
        this._currentCall = null;
        
        if (!data) data = {};

        if (this.lastUpdates.length > 0 && data.ids && Object.keys(data.ids).length > 0)
        {
            for (let i = 0; i < this.lastUpdates.length; i++)
            {
                if ( this.lastUpdates[i].model && data.ids[ this.lastUpdates[i].model.id ] )
                    this.lastUpdates[i].model.id = data.ids[ this.lastUpdates[i].model.id ];
            }
        }

        // we remove all updates that were processed
        if (data.actions)
            this._lastUpdates = this.lastUpdates.filter(function(action){ return !data.actions.contains(action.id); });

        for (let i = 0; i < this.lastUpdates.length; i++)
            this.lastUpdates[i].forSaving = false;
        
        this.model.onSaved(data);
    }

    /**
     * 
     * @param {*} rescue : if true, sends back all updates so they will be saved locally
     * @returns 
     */
    prepareUpdatesForSending(rescue)
    {
        let updates = [];

        for (let i = 0; i < this.lastUpdates.length && (rescue || i < this._MAX_UPDATES); i++)
        {
            let action = this.lastUpdates[i];

            // if update and temporary id, wait
            // action.model.id
            
            if (!action.forSaving || rescue)
            {
                let update = {  type    : action.type, 
                                _m      : action.model._m, 
                                id      : action.model.id,
                                tag     : action.tag,
                                data    : (action.type == "delete") ? undefined : ((action.type == "update") ? action.data : action.model.JSON()),
                                actionid : action.id
                            };

                if (fx.get("debugging"))
                {
                    update.timestamp = action.timestamp; // debugging purpose
                    update.stack   = action.stack; // debugging purpose
                }

                if(action.model.localized)
                    update.id_lang = action.model.id_lang;

                updates.push( update );

                if (!rescue)
                   action.forSaving = true;
            }
        }

        return updates;
    }

});
// TODO
// TODO
fx.ns("fx", class KeyboardEvent extends fx.Event {

    constructor(type, originalEvent)
    {
        super(type);

        this._originalEvent = originalEvent;
    }

  
    get originalEvent()
    {
        return this._originalEvent;
    }

    cancel()
    {
        this.preventDefault();
        this.stopPropagation();
    }

    preventDefault()
    {
        if (this._originalEvent)
            this._originalEvent.preventDefault();
    }

    stopPropagation()
    {
        if (this._originalEvent)
            this._originalEvent.stopPropagation();

        super.stopPropagation();
    }

});
/**
 * This class handled keyword events
 * It's crossbrowser (max + windows)
 * It dispatches readable events like "CTRL+A", "RIGHT", "SPACE", "0", etc...
 * It come with original event, so it's possible to call preventDefault/StopPropagation
 **/

fx.ns("fx", class Keyboard extends fx.EventDispatcher {
    
    constructor()
    {
        super();

        this.on("keydown", this._onKeyDown, window);
        this.on("keyup", this._onKeyUp, window);
       
        this._keyCodes = {
            48 : "0",
            49 : "1",
            50 : "2",
            51 : "3",
            52 : "4",
            53 : "5",
            54 : "6",
            55 : "7",
            56 : "8",
            57 : "9",
            65 : "A",
            66 : "B",
            67 : "C",
            68 : "D",
            69 : "E",
            70 : "F",
            71 : "G",
            72 : "H",
            73 : "I",
            74 : "J",
            75 : "K",
            76 : "L",
            77 : "M",
            78 : "N",
            79 : "O",
            80 : "P",
            81 : "Q",
            82 : "R",
            83 : "S",
            84 : "T",
            85 : "U",
            86 : "V",
            87 : "W",
            88 : "X",
            89 : "Y",
            90 : "Z",
            9  : "TAB",
            13 : "ENTER",
            17 : "CTRL",
            16 : "SHIFT",
            18 : "ALT",
            8  : "BACKSPACE",
            27 : "ESCAPE",
            33 : "PAGEUP",
            34 : "PAGEDOWN",
            32 : "SPACE",
            35 : "END",
            36 : "HOME",
            37 : "LEFT",
            38 : "UP",
            39 : "RIGHT",
            40 : "DOWN",
            45 : "INSERT",
            46 : "DELETE",
            20 : "CAPSLOCK",
        };
    }

    isSpecialKey(e)
    {
        return (e.keyCode >= 8 && e.keyCode <= 46 && e.keyCode != 32) || e.metaKey || e.ctrlKey;
    }

    _onKeyDown(e)
    {
        this._handleEvent(e , "DOWN");
    }

    _onKeyUp(e)
    {
        this._handleEvent(e , "UP");
    }
            
    _handleEvent(e, direction)
    {
        if (this._keyCodes[e.keyCode] != "ESCAPE" &&
            (   fx.dom.parent(e.target, "input") ||
                fx.dom.parent(e.target, "textarea") ||
                fx.dom.parent(e.target, "div[contenteditable=true]") ) )
        return;

        let eventCode = "";
        
        if (e.ctrlKey || e.metaKey)
            eventCode += "CTRL";
            
        if (e.shiftKey)
        {
            if (e.ctrlKey || e.metaKey)
                eventCode += "+";

            eventCode += "SHIFT";
        }
        
        if (direction == "UP" || (this._keyCodes[e.keyCode] != "CTRL" && this._keyCodes[e.keyCode] != "SHIFT"))
            eventCode += (eventCode == "" ? "" :  "+" ) + this._keyCodes[e.keyCode];

        if (eventCode)
        {
            if (direction == "UP")
                this.trigger( new fx.KeyboardEvent(eventCode, e) );

            this.trigger( new fx.KeyboardEvent(eventCode + "-" + direction, e) );
        }
    }


    /*_onKeyUp(e)
    {
        
    }*/

});
fx.ns("fx", class Asset extends fx.Model 
{
	constructor(data, assetName)
	{
		super(); 

		this._name = assetName || "";
		this._content = data;
		
		if (this._content && this._content.indexOf("<svg") != -1)
			this.type = "svg";
		else
			this._type = "image";
	}

	get name()
	{
		return this._name;
	}

	get type()
	{
		return this._type;
	}

	set type(val)
	{
		return this._type = val;
	}

	get content()
	{
		return this._content;
	}

	render(className, tooltip)
	{
		if (!this._content)
			return;
			
		className = className || "asset";

		let html = '';
		if (this._type == "svg")
		{
			// add className
			let firstTabClosing = this._content.indexOf(">");
			let classPosition = this._content.indexOf("class");

			if (classPosition != -1 && firstTabClosing > classPosition) // class tag present, so we inject className
				html = this._content.splice(this._content.indexOf('"', classPosition) + 1, 0, className + " " + this._name);
			else // no class attribute, so we create a new one
				html = this._content.splice(firstTabClosing, 0, ' class="' + className + " " + this._name + '"');

			if (tooltip)
			{
				let firstTabClosing = html.indexOf(">");
				html = html.splice(firstTabClosing, 0, ' title="' + tooltip + '"');
			}
		}
		else
		//if (type == "png" || type == "jpg" || type == "gif" || type == "base64")
			html += '<img class="' + className + '" src="' + this._content + '" title="' + (tooltip ? tooltip : "")  + '">';

		return html;
	}
});
fx.ns("fx", class Filter extends fx.EventDispatcher {

	constructor()
	{
		super();

		this._changed = false;
		this.transformedData = "";
	}

	get changed()
	{
		return this._changed;
	}
 
	get data()
	{
		if (this._changed)
		{
			this.transformedData = this.exec();
			this._changed = false;
		}

		return this.transformedData;
	}

	set data(val)
	{
		if (this.rawData)
		{
			if (this.rawData instanceof fx.Model)
				this.off("updated", this.refresh, this.rawData);
		}

		if (val)
		{
			if (val != this.rawData)
				this._changed = true;

			this.rawData = val;

			if (this.rawData instanceof fx.Model)
				this.on("updated", this.refresh, this.rawData);
		}
	}

	refresh()
	{
		this._changed = true;
	}

	exec()
	{
		return this.rawData;
	}

});

/**
 * Creates a new router
 * @example fx.router(["ui.View1", "ui.View2", ...]);
 * @method router
 * @memberof fx.router
 */
fx.ns("fx", class Router extends fx.EventDispatcher{

	constructor()
	{
        super();

		this.switchEffect;
		this.currentView;
		this.associations = {};
		this.views = [];
		this._showViewHandler;

		this._navigation = [];
	}

	get previousView()
	{
		if (this._navigation.length - 2 >= 0)
			return this._navigation[this._navigation.length - 2].viewName;
		else
			return "";
	}

	init(appViews, effectIn, effectOut, model)
	{
		this.switchEffectIn = effectIn;
		this.switchEffectOut = effectOut;
		this.model = model;
		
		if (appViews)
		{
			for (let index = 0; index < appViews.length; index++)
			{
				let view = appViews[index];
				this.setView(view);

				/*let constructor = view;

				if (Utils.typeEqual(view, 'string'))
					constructor = Utils.getConstructor(constructor).fcn;
				else
				{
					fx.throwError('Application views parameter must be an array of Strings listing all main views');
					return;
				}

				if (!Utils.typeEqual(constructor, 'function'))
				{
					fx.throwError('View ' + view + ' can\'t be instanciated');
					return;
				}

				

				this.views.push( {viewName : viewName, name : view, instance : null, constructor : constructor} );*/
			}
		}
	}

	setView(view)
	{
		let constructor = view;

		if (Utils.typeEqual(view, 'string'))
			constructor = Utils.getConstructor(constructor).fcn;
		else
		{
			fx.throwError('Application views parameter must be an array of Strings listing all main views');
			return;
		}

		if (!Utils.typeEqual(constructor, 'function'))
		{
			fx.throwError('View ' + view + ' can\'t be instanciated');
			return;
		}

		let name = view;
		if (name.indexOf(".") != -1)
		{
			let parts = name.split(".");
			name = parts[parts.length-1];
		}

		let viewObj = this.views.find({name : name});
		if (viewObj)
		{
			viewObj.view = view;
			viewObj.constructor = constructor;
			viewObj.instance = null;
		}
		else
			this.views.push( {name : name, view : view, instance : null, constructor : constructor} );
	}

	switchTo(viewName, data , noHistory, direction)
    {
		if (this._locked) return;
		/*if (typeof remove !== "boolean")
			remove = false;*/
			
		if (this.currentView && (this.currentView == this.getView(viewName) || viewName == this._nextView))
        {
            this._nextView = "";
			return;
        }

		/*if (!Utils.typeEqual(callback, "function"))
			callback = null;*/

		
		// hide current view
		if (this.currentView && this.currentView.instance)
		{
			this._showViewHandler = this._showView.bind(this, viewName, data, direction)
			if (this.currentView.instance) // fix trackjs crash
            {
                this.currentView.instance.hideEffect = (direction == "previous") ? this.currentView.instance.__showEffect : this.currentView.instance.__hideEffect;
                
				this.currentView.instance.hide(this._showViewHandler);
                this._nextView = viewName;
            }
		}
		else
			this._showView(viewName, data, direction);

		if (!noHistory)
			this._navigation.push({viewName : viewName, data : data});
	}

   

	remove(viewName) 
	{
		let view = this.getView(viewName);
		if ( !view) return;

		//this.views.splice(this.views.indexOf(view), 1);


		if (view == this.currentView && this.views.length > 0)
			this.switchTo( this.views[0] );
		
		if (view && view.instance)
		{
			view.instance.destroy();
			view.instance = null;
		}

	}

	navigateToURL(url, newWindow){

		if (this.currentView && this.currentView.instance && !newWindow)
			this.currentView.instance.hide();

		try // IE 11 Problem
		{
			if (newWindow)
			{
				let win = window.open(url, '_blank');
				win.focus();
			}
			else
				window.location.assign( url );
		}
		catch(e)
		{
			window.location.href = url;
		}

	}

	// let's follow user navigation, and get back to previous view 
	back()
	{
		if (this._navigation.length == 0)
			window.history.back();
		else
		{
			this._navigation.pop();
			let view = this._navigation[this._navigation.length - 1];
			if(view)
				this.switchTo(view.viewName, view.data, true);
			else
				window.history.back();
		}
	}

	lock()
	{
		this._locked = true;

		if (this.currentView && this.currentView.instance) // fix trackjs crash
			this.currentView.instance.hide();
	}

	associate(event, view){
		if (this.associations[event])
			this.dissociate(event);

		let handler = this.switchTo.bind(this, view);
		fx.get("events").on(event,  handler);
		this.associations[event] = handler;
	}

	dissociate(event){
		let handler = this.associations[event];
		fx.get("events").off(event, handler );
		delete this.associations[event];
	}

	getView(name)
	{
		return this.views.find({name : name});

		/*return this.views.filter( function(view) { 
			if (view.name.indexOf(".") != -1)
			{
				let parts = view.name.split(".");
				return view.name == viewName || parts[parts.length-1] == viewName;
			}
			else
				return view.name == viewName;
		})[0];*/
	}

	_showView(viewName, data, direction)
	{	
		if (this.currentView && this.currentView.instance && this.currentView.instance.destroyOnSwitch)
		{
			this.currentView.instance.destroy();
			this.currentView.instance = null;
		}
		
		// get view
		let view = Utils.typeEqual( viewName, "string" ) ? this.getView(viewName) : viewName;
		// instanciate it if not yet
		if (!view)
		{
			fx.throwError('Impossible to switch to view ' + viewName + '. It was not found on registed views');
			return;
		}

        try 
        {
            if (!view.instance)
            {
                view.instance = new view.constructor();
                if (data || !view.instance.data)
                    view.instance.data = data ? data : this.model;

                view.name = viewName;
                view.instance.showEffect = (view.instance.showEffect !== undefined) ? view.instance.showEffect : (view.instance.effect !== undefined ? view.instance.effect : this.switchEffectIn);
                view.instance.hideEffect = (view.instance.hideEffect !== undefined) ? view.instance.hideEffect : (view.instance.effect !== undefined ? view.instance.effect : this.switchEffectOut);
                this._setShowHideEffects(view);

                view.instance.showEffect = (direction == "previous") ? view.instance.__hideEffect : view.instance.__showEffect;

                view.instance.viewport("fullscreen");
                view.instance.init();
            }
            else
            {
                if (data !== undefined && data !== null)
                    view.instance.data = data;

                // show view
                view.instance.show(true);
            }
        }
        catch(e) 
        {
            
        }


		/*if (remove && this.currentView)
			this.currentView.instance.destroy();*/
			

		this.currentView = view;

		//if (callback) callback()

		this._showViewHandler = null;

        this.trigger("view-changed", viewName);
		
	}

    _setShowHideEffects(view)
    {
        if (!view.instance.__showEffect)
            view.instance.__showEffect = view.instance.showEffect;

        if(!view.instance.__hideEffect)
            view.instance.__hideEffect = view.instance.hideEffect;
    }
	/*_locationHashChangedHandler = this._locationHashChanged.bind(this);
	window.location.hash = "#" + this._extractName(view.name);
		window.removeEventListener("hashchange", _locationHashChangedHandler, false);
		setTimeout(function(){
			window.addEventListener("hashchange", _locationHashChangedHandler, false);
		}, 250);
		
	_locationHashChanged : function(){
		if (location.hash)
		{
			let hash = location.hash.substring(1);
			let view = this.getView(hash);
			if (view)
				this.switchTo(view);
		}
	},
	_extractName : function(name){
		if (name.indexOf(".") != -1)
		{
			let parts = name.split(".");
			name = parts[parts.length-1];
		}
		return name;
	}*/
});
fx.ns("fx", class Browser 
{
    constructor()
    {
        this._bowser = bowser.getParser( window.navigator.userAgent);

        let browser = this._bowser.getBrowserName().toLowerCase();
        /*if (this.isChrome)
            browser = "chrome";
        else
        if (this.isIE)
            browser = "internet";
        else
        if (this.isFireFox)
            browser = "firefox";
        else
        if (this.isSafari)
            browser = "safari";
        else
        if (this.isOpera)
            browser = "opera";*/

        fx.dom.addClass("body", browser);
        if (document && document.body)
        {
            document.body.setAttribute("os", this.OSName.toLowerCase() );
            document.body.setAttribute("device", this.touchEnabled ? "touch" : "desktop" );
        }
    }

    get isChrome()
    {
        return this._bowser.isBrowser('Chrome');
    }

    get isIE()
    {
        return this._bowser.isBrowser('Internet Explorer');    }

    get isFireFox()
    {
        return this._bowser.isBrowser('Firefox');
    }

    get isSafari()
    {
        return this._bowser.isBrowser('Safari');
    }

    get isOpera()
    {
        return this._bowser.isBrowser('Opera');
    }

    get OSName()
    {
        return this._bowser.getOSName();
    }

    get isMac()
    {
        return this.OSName.toLowerCase() == "macos";
    }

    get device()
    {
        return this._bowser.getPlatformType(true);
    }

    get isDesktop()
    {
        return !this.isMobile && !this.isTablet;
    }

    get isDesktop()
    {
        return !this.isMobile && !this.isTablet;
    }

    get isMobile()
    {
        let a = navigator.userAgent||navigator.vendor||window.opera;
        return (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)));

    }

    get isTablet()
    {
        return this.touchEnabled && fx.graphics.screenSize().width >= 700;
        /*return this.touchEnabled ||
                (this.isIOS && fx.graphics.screenSize().width >= 500) || 
                /ipad|tablet/i.test(navigator.userAgent) || 
                (this.isMobile && fx.graphics.screenSize().width >= 500);*/
    }

    get isIOS() 
    {
        if (/iPad|iPhone|iPod/.test(navigator.platform)) {
          return true;
        } else {
          return navigator.maxTouchPoints &&
            navigator.maxTouchPoints > 2 &&
            /MacIntel/.test(navigator.platform);
        }
    }

    get isTouchDevice() 
    {
        return !(/Win32/.test(navigator.platform)) && this.touchEnabled;
    }

    get touchEnabled()
    {
        return ('ontouchstart' in window) /* ||
           (navigator.maxTouchPoints > 0) ||
           (navigator.msMaxTouchPoints > 0)*/;
    }

    get urlPathParts()
    {
        return window.location.pathname.split("/").slice(2);
    }

    hashParameter(name, value, erase)
    {
        if (!this._hasParameters)
        {
            let parameters= window.location.hash.substr(1).split("&");
            this._hasParameters = {};
            for (let i = 0; i < parameters.length; i++)
            {
                let parameter = parameters[i].split("=");
                this._hasParameters[parameter[0]] = parameter[1];
            }
        }

        if (value)
        {
            if (erase)
                this._hasParameters = {};

            this._hasParameters[name] = value;

            let parameters = "#";
            for (let prop in this._hasParameters)
            {
                parameters += prop + "=" + this._hasParameters[prop] + "&"
            }

            parameters = parameters.slice(0, -1);

            parent.location.hash = parameters;
        }
        else
        if (name === false)
        {
            parent.location.hash = "";
        }

        return this._hasParameters[name];
    }
    

});
fx.ns("fx", class ImageLoader extends fx.EventDispatcher{

    constructor()
    {
        super();

        //this._onLoadHandler = this._onLoad.bind(this);
        //this._onErrorHandler = this._onError.bind(this);
    }


    get blob()
    {
        return this._img ? this._img.src : null;
    }

    get width()
    {
        return this._img ? this._img.width : 0;
    }

    get height()
    {
        return this._img ? this._img.height : 0;
    }

    load(url)
    {
        if (!this._img)
            this._img = new Image();

        //this._img.onload = this._onLoadHandler;
        //this._img.onerror = this._onErrorHandler;

        this.on(Image.LOADED, this._onLoad, this._img);
        this.on(Image.ERROR, this._onError, this._img);
        this.on(Image.PROGRESS, this._onProgress, this._img);

        //this._img.src = url;
        this._img.load(url);

        this.trigger("loadstart");
    }


    _onLoad()
    {
        this.trigger(Image.LOADED);
    }

    _onError()
    {
        this.trigger(Image.ERROR);
    }

    _onProgress(e)
    {
        this.trigger(Image.PROGRESS, e.detail);
    }

    destroy()
    {
        super.destroy();

        //this._img.onload = null;
        //this._img.onerror = null;
        //this._onLoadHandler = null
        //this._onErrorHandler = null;
        this._img = null;
    }


});
/**
 * TODO : rotation of a media should not result in a new blob
 */
fx.ns("fx", class Media extends fx.Model {

    constructor(data)
    {
        super(data);

        this._image = null;
        this._mediaWidth = 0;
        this._mediaHeight = 0;

        this._usedCount = 0;

        this._cache = {};
    }

    get image()
    {
        return this._image;
    }

    get loadLight()
    {
        return this._loadLight;
    }

    get usage()
    {
        return this._usedCount;
    }

    get mediaWidth()
    {
        return this._mediaWidth || this.width;
    }

    get mediaHeight()
    {
        return this._mediaHeight || this.height;
    }

    // TODO : override
    getUrl()
    {
        return this.url;
    }

    getThumb()
    {
        return this.thumb;
    }

    isLoaded(effect)
    {
        let cache = this.getCache(effect);
        return cache && !cache.loading;
    }

    isLoading(effect)
    {
        let cache = this.getCache(effect);
        return cache && cache.loading;
    }

     // preload picture in cache
    load(effect, light)
    {
        if(this.isLoading(effect))
        {
            this.trigger({type:"loading", media : this});
            return;
        }
            
        if (this.getCache(effect))
        {
            this.trigger({type:"complete", media : this});
        }
        else
        {
            this._loadLight = light;
            
            if(this.blob && !effect)
            {
                this.setCache(this.blob, effect);
            
                this.trigger({type:"complete", media : this, effect : effect});
            }
            else
            if (!this.getUrl(effect))
            {
                this.setCache(this.getUrl(""), effect);
            }
            else
            {
                this._image = new Image();
                this._image.crossOrigin = "anonymous";
                this._image._effect = effect;
                
                this._listen(true);

                this._image.url( this.getUrl(effect) );
                //this._image.load( this.getUrl(effect) ); in order to get progress, we can use load. TODO : experiment

                this.setCache(this.getUrl(effect), effect, true); // loading
            }
        }
    }

    unload()
    {
        for(let effect in this._cache)
        {
            if (effect && this.getCache(effect))
                (window.URL || window.webkitURL).revokeObjectURL( this.getCache(effect).data );

            this.setCache(null, effect);
        }

        if (this._image && typeof this._image.destroy == "function")
            this._image.destroy();

        this._image = null;
    }


    refresh()
    {
        this.unload();
    }

    // clean from any temporary object : base64, image, file, etc... and use urls
    clean()
    {
        try 
        {
            // TODO : clean all of that
            if (this.file)
                this.prop("file", undefined);

            if (this.base64)
                this.prop("base64", undefined);

            if (this.blob)
            {
                (window.URL || window.webkitURL).revokeObjectURL(this.blob);
                this.prop("blob", undefined);
            }
                
            /*if (this.memory && this.memory.src)
            {
                (window.URL || window.webkitURL).revokeObjectURL(this.memory.src);
                this.prop("memory", undefined);
            }*/

            for(let effect in this._cache)
            {
                try 
                {
                    // effect blobs only : the base one is this.blob, revoked just above, and it may
                    // still be displayed elsewhere (gallery, other components)
                    if (effect && this.getCache(effect))
                        (window.URL || window.webkitURL).revokeObjectURL(this.getCache(effect).data );
                }
                catch(e)
                {
                    fx.log.info(e);
                }
                  
                this.setCache(this.getUrl(effect) || null, effect);
            }
            
        }
        catch(e)
        {
            fx.log.info(e);
        }
    }

    destroy()
    {
        super.destroy();

        this._listen(false);

        this.unload();
        
        if (this._image)
            this._image.destroy();

        this._image = null;
        this.file = null;
        this._usedCount = 0;
    }

    // find preloaded picture, or load it in cache first
    //fetch(rotation, callback, effect)
    fetch(callback, effect)
    {
        let image = this.getCache(effect)

        // the cache entry may have been removed in between (clean/unload) : nothing to render.
        // the caller has to know, it must not consider the media as rendered.
        if (!image)
            return false;

        callback({url : image.data, width : image.width, height : image.height, media : this});

        return true;
    }

    using(val)
    {
        if (val)
            this._usedCount++;
        else
            this._usedCount--;
    }

    getCache(effect)
    {
        if (!effect) effect = "";
        return this._cache[effect] ? this._cache[effect] : null;
    }

    setCache(data, effect, loading, width, height)
    {
        if (!effect) effect = "";

        if (data == null)
            delete this._cache[effect];
        else
            this._cache[effect] = { data : data, loading : !!loading, width : width || this.width, height : height || this.height};
    }

    
    _listen(value)
    {
        if (!this._image) return;

        if (value)
        {
            this.on(Image.LOAD_START, this._onLoadStart, this._image);
            this.on(Image.LOADED, this._onLoadComplete, this._image);
            this.on(Image.PROGRESS, this._onLoadProgress, this._image);
            this.on(Image.ERROR, this._onLoadError, this._image);
            this.on(Image.MEMORY_PROBLEM, this._onLoadError, this._image);
        }
        else
        {
            this.off(Image.LOAD_START, this._onLoadStart, this._image);
            this.off(Image.LOADED, this._onLoadComplete, this._image);
            this.off(Image.PROGRESS, this._onLoadProgress, this._image);
            this.off(Image.ERROR, this._onLoadError, this._image);
            this.off(Image.MEMORY_PROBLEM, this._onLoadError, this._image);

        }
    }

    _onLoadStart()
    {
        this.trigger({type:"start", media : this, effect : this._image._effect});
    }

    _onLoadComplete()
    {
        //this._mediaWidth = this._image.width;
        //this._mediaHeight = this._image.height;

        if (!this._image) return;
        
        this.setCache(this._image.blob || this._image.src, this._image._effect, false, this._image.width, this._image.height);
            
        this.trigger({type:"complete", media : this, effect : this._image ? this._image._effect : ""});
    
        this._listen(false);
    }

    _onLoadProgress(e)
    {
        console.log("Progress " + this.id + " : " + e.loaded / e.total * 100)
        this.trigger({type:"progress", detail : {loaded : e.loaded, total : e.total, percentage : e.loaded / e.total * 100 }, media : this, effect : this._image ? this._image._effect : ""});
    }

    _onLoadError()
    {
        this.unload(true);
        this.trigger({type:"error", media : this, effect : this._image ? this._image._effect : ""});

        this._listen(false);
    }
    
    
});
/**
 * Service used to load Medias : it's a clever queue
 * It loads media one after the other.
 * But it can stop loading one media which is loading, and start loading another one
 * It's design to fit the use of a standard application. 
 * Customer scroll, element are displayed, images are being loaded.
 * If he keeps scrolling, we will try to load next images and not wait for the previous ones to be loaded first.
 */
fx.ns("fx", class MediaLoader extends fx.EventDispatcher {

    constructor(parameters)
    {
        super();
        
        this._maxMedia = parameters && parameters.maxMedia ? parameters.maxMedia : 50;
        //this._mediaToFree = parameters && parameters.mediaToFree ? parameters.mediaToFree : 5;
        this._maxMediaLoading = parameters && parameters.maxMediaLoading ? parameters.maxMediaLoading : 3;

        this._queue = [];
        this._currentMedias = [];
        //this._loadedMedias = [];
    }

    get loading()
    {
        return this._queue.length > 0;
    }

    load(media, effect, light) 
    {
        let obj = this._currentMedias.find({media : media, effect : effect});

        if (obj) return;
        
        obj = this._queue.find({media : media, effect : effect});

        let index = obj ? this._queue.indexOf(obj) : -1;

        if (index == -1)
        {
            this._queue.push({media : media, effect : effect, light : light});
            this._process();
        }
        else // if already existing, we only put it at the end so it will be loaded first
        {    
            this._queue.push(this._queue.splice(index, 1)[0]);
        }
    }

    unload(media, effect)
    {
        this.stop( media, effect );

        media.unload();
    }



    _process()
    {
        if (this._queue.length > 0)
        {
            if (this._currentMedias.length < this._maxMediaLoading)
            {
                if (!this._currentMedias.find({media : this._queue.last.media, effect : this._queue.last.effect}))
                {
                    let obj = this._queue.pop();

                    this._currentMedias.push( obj );

                    this._listen(obj.media, true);

                    obj.media.load(obj.effect, obj.light);
                }   
            }
        }

        //this.delay(this._checkMemory, 1000);
    }


    stop(media, effect)
    {
        this._listen(media, false);

        // check currentMedias first
        let obj = this._currentMedias.find({media : media, effect : effect});

        if (obj)
        {
            this._currentMedias.remove(obj);
            this._queue.remove(obj);
            //this._loadedMedias.remove(obj);
        }
    
        this._process();
    }

    _complete(e) 
    {
        let obj = this._currentMedias.find({media : e.media, effect : e.effect});

        if (obj)
            this._currentMedias.remove( obj );

        this._listen(e.media, false);
        
        /*obj = this._loadedMedias.find({media : e.media, effect : e.effect});
        if (!obj)
            this._loadedMedias.push({media : e.media, effect : e.effect});*/
        
        this._process();
    }

    _error(e) 
    {
        let obj = this._currentMedias.find({media : e.media, effect : e.effect});

        if (obj)
            this._currentMedias.remove( obj );

        this._listen(e.media, false);

        this._process();
    }


    _listen(media, listen)
    {
        if (listen)
        {
            this.on("complete", this._complete, media);
            this.on("error", this._error, media);
        }
        else
        {
            this.off("complete", this._complete, media);
            this.off("error", this._error, media);
        }
    }
    // ---- Memory management : media are loaded in Blob. 
    // So we manage to never overpass a maximum number of Blobs loaded at the same time
    // in order to not have any memory problem

    /*_checkMemory()
    {
        this._checkMemoryTimer = null;

        if (this._loadedMedias.length > this._maxMedia)
        {
            let notUsedMedia = this._loadedMedias.filter(obj => obj.media.usage == 0);
            
            // we free some not used medias
            for (let i = 0; i < this._mediaToFree && i < notUsedMedia.length; i++)
                this.unload(notUsedMedia[i].media, notUsedMedia[i].effect);
        }
    }*/

    
});

fx.ns("fx", class graphics {

    static canvasContext(create)
    {
        if (create)
            fx.graphics._context = null;

        if (!fx.graphics._context)
        {
            fx.graphics._context = {};
            fx.graphics._context.canvas = document.createElement('canvas');
            fx.graphics._context.ctx = fx.graphics._context.canvas.getContext('2d');
        }
        else
            fx.graphics._context.ctx.clearRect(0, 0, fx.graphics._context.canvas.width, fx.graphics._context.canvas.height);

        return fx.graphics._context;
    }

    static screenSize()
    {
        return  {
            width : fx.dom.width(window),
            height : fx.dom.height(window),
        };
    }

    static imageToDataUri(img, width, height, type, quality, fromX, fromY)
    {
        if (!quality) quality = 1;
        if (!type) type = 'image/jpeg';

        (fromX) || (fromX = 0);
        (fromY) || (fromY = 0);

        let canvasContext = fx.graphics.canvasContext(true);
        let canvas = canvasContext.canvas,
            ctx = canvasContext.ctx;

        canvas.width = width;
        canvas.height = height;

        ctx.drawImage(img, fromX, fromY, width, height);

        let str = "";
        try {
            str = canvas.toDataURL(type, quality);
        }
        catch(e)
        {
            fx.log.error(e);
        }

        canvas = null;
        ctx = null;
        return str;
    }

    static imageToData(img, width, height)
    {
        let canvasContext = fx.graphics.canvasContext(true);
        let canvas = canvasContext.canvas,
            ctx = canvasContext.ctx;

        canvas.width = width;
        canvas.height = height;

        ctx.drawImage(img, 0, 0, width, height);

        let imageData;
        try {
            imageData = ctx.getImageData(0, 0, width, height);
        }
        catch(e){}

        canvas = null;
        ctx = null;
        return imageData;
    }

    static canvasToBlob(image, width, height, type, callback, rotate, quality)
    {
        if (!type) type = 'image/jpeg';

        if (image.img instanceof Image)
            image = image.img;

        let canvasContext = fx.graphics.canvasContext();
        let canvas = canvasContext.canvas,
            ctx = canvasContext.ctx;

        if (rotate)
        {
            if(rotate == 90 || rotate == 270) 
            {
                canvas.width = height;
                canvas.height = width;
            } else 
            {
                canvas.width = width;
                canvas.height = height;
            }

            ctx.translate(canvas.width/2,canvas.height/2);
            
            
            ctx.rotate(rotate*Math.PI/180);
            ctx.drawImage(image,-width/2,-height/2, width, height);

        }
        else
        {
            if ( image.width > image.height)
                height = image.height / image.width * width;
            else
                width = image.width / image.height * height;
        
            canvas.width = width;
            canvas.height = height;

            ctx.drawImage(image, 0, 0, width, height);
        }

        canvas.toBlob(callback, type, quality || 1);
    }

    static getImageDimension(file, callback, freeMemory)
    {
        let img = new Image();

        img.onload = function() {
            callback(img, img.width, img.height);
            if (freeMemory)
            {
                if (typeof file != "string")
                    URL.revokeObjectURL(img.src);
                img = null;
            }
        };
    
        img.src = (typeof file == "string") ? file : URL.createObjectURL(file);
    }

    
    static averageColorFromBase64(imgEl, returnColorObject, width, height)
    {
          var blockSize = 5, // only visit every 5 pixels
              defaultRGB = {r:0,g:0,b:0}, // for non-supporting envs
              canvas = document.createElement('canvas'),
              context = canvas.getContext && canvas.getContext('2d'),
              data,
              i = -4,
              length,
              rgb = {r:0,g:0,b:0},
              count = 0;

          if (!context) 
              return defaultRGB;
          
          if (width && height)
          {
              canvas.width = width;
              canvas.height = height; 
              context.drawImage(imgEl, 0, 0, width, height);
          }
          else
          {
              height = canvas.height = imgEl.naturalHeight || imgEl.offsetHeight || imgEl.height;
              width = canvas.width = imgEl.naturalWidth || imgEl.offsetWidth || imgEl.width;
              context.drawImage(imgEl, 0, 0);
          }
          
          try {
              data = context.getImageData(0, 0, width, height);
          } catch(e) {
              /* security error, img on diff domain */
              return defaultRGB;
          }

          length = data.data.length;

          while ( (i += blockSize * 4) < length ) {
              ++count;
              rgb.r += data.data[i];
              rgb.g += data.data[i+1];
              rgb.b += data.data[i+2];
          }

          // ~~ used to floor values
          rgb.r = ~~(rgb.r/count);
          rgb.g = ~~(rgb.g/count);
          rgb.b = ~~(rgb.b/count);

          //return rgb;
          let color = tinycolor(rgb)
          return returnColorObject ? color : color.toRgbString();
    }

    static getImageLuminance(imgEl, width, height)
    {
          let blockSize = 5, // only visit every 5 pixels
              defaultRGB = 1, // for non-supporting envs
              canvas = document.createElement('canvas'),
              context = canvas.getContext && canvas.getContext('2d'),
              data,
              i = -4,
              length,
              count = 0,
              dark = 0;

        try 
        {
            if (!context) 
                return defaultRGB;

            if (width && height)
            {
                canvas.width = width;
                canvas.height = height; 
                context.drawImage(imgEl, 0, 0, width, height);
            }
            else
            {
                height = canvas.height = imgEl.naturalHeight || imgEl.offsetHeight || imgEl.height;
                width = canvas.width = imgEl.naturalWidth || imgEl.offsetWidth || imgEl.width;
                context.drawImage(imgEl, 0, 0);
            }

            data = context.getImageData(0, 0, width, height);

            length = data.data.length;
            //let colors = [];
            while ( (i += blockSize * 4) < length ) 
            {
                count++;
                let rgb = [data.data[i], data.data[i+1], data.data[i]+2];
              //  colors.push(rgb);
                let brightness = fx.graphics.getBrigthness(rgb);
                
                if(brightness < 20)
                    dark+=3;
                else
                if(brightness < 50)
                    dark+=2;
                else
                if(brightness < 100)
                    dark+=1;
            }

            /*let palette = quantize(colors, 10).palette();

            console.log( palette ) ;*/

            return dark / count;

        }  catch(e)  {
            return defaultRGB;
        }
    }

    // TODO : check that S L for a function
    // 
    /*
Good solution :  https://awik.io/determine-color-bright-dark-using-javascript/
hsp = Math.sqrt(
    0.299 * (r * r) +
    0.587 * (g * g) +
    0.114 * (b * b)
    );


  
    static rgbToHsl(r, g, b){
        r /= 255, g /= 255, b /= 255;
        var max = Math.max(r, g, b), min = Math.min(r, g, b);
        var h, s, l = (max + min) / 2;
    
        if(max == min){
            h = s = 0; // achromatic
        }else{
            var d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch(max){
                case r: h = (g - b) / d + (g < b ? 6 : 0); break;
                case g: h = (b - r) / d + 2; break;
                case b: h = (r - g) / d + 4; break;
            }
            h /= 6;
        }
    
        return [h, s, l];
    }  */

    static getBrigthness(rgb) {
        return (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
    }

    static getLuminance(rgb) {
        //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        var RsRGB, GsRGB, BsRGB, R, G, B;
        RsRGB = rgb.r/255;
        GsRGB = rgb.g/255;
        BsRGB = rgb.b/255;

        if (RsRGB <= 0.03928) {R = RsRGB / 12.92;} else {R = Math.pow(((RsRGB + 0.055) / 1.055), 2.4);}
        if (GsRGB <= 0.03928) {G = GsRGB / 12.92;} else {G = Math.pow(((GsRGB + 0.055) / 1.055), 2.4);}
        if (BsRGB <= 0.03928) {B = BsRGB / 12.92;} else {B = Math.pow(((BsRGB + 0.055) / 1.055), 2.4);}
        return Number( ((0.2126 * R) + (0.7152 * G) + (0.0722 * B)).toFixed(2));
    }

    static getColorAlpha(color)
    {
        if (color && color.indexOf("rgba") != -1)
          return color.replace(/^.*,(.+)\)/,'$1');
      else
          return undefined;
    }

    static globalToLocal( elt, globalX, globalY ){
        // Get the position of the context element.
        //let position = fx.graphics.offset( elt );
        //let position = $(elt).offset();
        if (elt instanceof fx.Component)
            elt = elt.node;

        let position = fx.graphics.offset( elt );
        // Return the X/Y in the local context.
        return({
            x: Math.floor( globalX - position.left ),
            y: Math.floor( globalY - position.top )
        });
    }

    static localToGlobal( elt, localX, localY ){
        // Get the position of the context element.
        if (elt instanceof fx.Component)
            elt = elt.node;

        let position = fx.graphics.offset( elt );
        //let position = context.offset();
        // Return the X/Y in the local context.
        return({
            x: Math.floor( localX + position.left ),
            y: Math.floor( localY + position.top )
        });
    }

    static offset(elt) 
    {
        if (elt instanceof fx.Component)
            elt = elt.node;
        
        let rect = elt.getBoundingClientRect(), bodyElt = document.body;
        return {
            top: rect.top + bodyElt .scrollTop,
            left: rect.left + bodyElt .scrollLeft
        }
    }

    static getTextWidthDOM(textContainer, parent) {

        if (!parent)
            parent = textContainer.parentNode;

        let span = document.createElement("div");
        //span.style.font = fx.dom.css(textContainer, "font-weight", true) + " " + fx.dom.css(textContainer, "font-style", true) + " " + fx.dom.css(textContainer, "font-size", true) + " " + fx.dom.css(textContainer, "font-family", true);
        span.style.fontSize = fx.dom.css(textContainer, "font-size", true);
        span.style.fontWeight = fx.dom.css(textContainer, "font-weight", true);
        span.style.fontFamily = fx.dom.css(textContainer, "font-family", true);
        span.style.fontStyle = fx.dom.css(textContainer, "font-style", true);
        span.style.lineHeight = fx.dom.css(textContainer, "line-height", true); // search recursively
        span.style.float = "left";
        span.style.whiteSpace = "nowrap";
        span.style.visibility = "hidden";
        span.style.position = "absolute";
        span.style.width = "auto";
        span.style.height = "auto";
        span.innerHTML = textContainer.innerHTML;
        parent.appendChild( span );

        //let w = fx.dom.width( span);        
        //let h = fx.dom.height( span);
        //let size = { width : span.clientWidth + 1, height : span.clientHeight };
        let width = span.clientWidth;

        parent.removeChild( span );

        return width;

    }

    static getSelectionContainerElement () 
    {
        let range, sel, container;
        if (document.selection && document.selection.createRange) {
            // IE case
            range = document.selection.createRange();
            return range.parentElement();
        } else if (window.getSelection) {
            sel = window.getSelection();
            if (sel.getRangeAt) {
                if (sel.rangeCount > 0) {
                    range = sel.getRangeAt(0);
                }
            } else {
                // Old WebKit selection object has no getRangeAt, so
                // create a range from other selection properties
                range = document.createRange();
                range.setStart(sel.anchorNode, sel.anchorOffset);
                range.setEnd(sel.focusNode, sel.focusOffset);

                // Handle the case when the selection was selected backwards (from the end to the start in the document)
                if (range.collapsed !== sel.isCollapsed) {
                    range.setStart(sel.focusNode, sel.focusOffset);
                    range.setEnd(sel.anchorNode, sel.anchorOffset);
                }
            }

            if (range) {
                container = range.commonAncestorContainer;

                // Check if the container is a text node and return its parent if so
                return container.nodeType === 3 ? container.parentNode : container;
            }   
        }
    }

    static selectText(element) 
    {
        if (!element)
            element = fx.graphics.getSelectionContainerElement();

        if (window.getSelection) { // All browsers, except IE <=8
            window.getSelection().selectAllChildren(element);
        } 
        else 
        if (document.body.createTextRange) { // IE <=8
            let range = document.body.createTextRange();
            range.moveToElementText(element);
            range.select();
        }
    }

    static  deselectText()
    {
        if (window.getSelection) { // All browsers, except IE <=8
            window.getSelection().removeAllRanges();
        } 
        else 
        if (document.selection) { // IE <=8
            document.selection.empty();
            }
    }

    static elementsFromPoint(x,y, count) {

        let elements = [];

        x = parseInt(x);
        y = parseInt(y);

        if (!Utils.isInt(x) || !Utils.isInt(y))
            return elements;

        if (document.elementsFromPoint) // Chrome
            elements = document.elementsFromPoint(x, y);
        else
        if (document.msElementsFromPoint){ // IE
            elements = document.msElementsFromPoint(x, y);
        }
        else
        if (document.elementFromPoint)
        {
            let previousPointerEvents = [], current, i, d;
            
            // get all elements via elementFromPoint, and remove them from hit-testing in order
            while ((current = document.elementFromPoint(x, y)) && elements.indexOf(current) === -1 && current != null && count >= 0) {

                // push the element and its current style
                elements.push(current);
                previousPointerEvents.push({
                    value: current.style.getPropertyValue('pointer-events'),
                    priority: current.style.getPropertyPriority('pointer-events')
                });

                // add "pointer-events: none", to get to the underlying element
                current.style.setProperty('pointer-events', 'none', 'important');

                count--;
            }

            // restore the previous pointer-events values
            for (i = previousPointerEvents.length; d = previousPointerEvents[--i];) {
                elements[i].style.setProperty('pointer-events', d.value ? d.value : '', d.priority);
            }
        }
        else
        if (document.msElementsFromRect && document.msElementsFromRect(x, y, 1, 1)){ // IE
            let nodes = document.msElementsFromRect(x, y, 1, 1)
            for(let i = nodes.length; i--; elements.unshift(nodes[i]));
        }

         // case when msElementsFromPoint return object
         if (!(elements instanceof Array))
         {
            let tmp = [];
            for (var key in elements)
                if (elements.hasOwnProperty(key))
                    tmp.push(elements[key]);
                
            elements = tmp;
         }

        return elements;

    }

    static underElements(event)
    {
        let elements = [];

        let x = parseInt(event.center ? event.center.x : event.pageX);
        let y = parseInt(event.center ? event.center.y : event.pageY);

        if (Number.isInteger(x) &&  Number.isInteger(y))
        {
            if (document.elementsFromPoint) // Chrome
                elements = document.elementsFromPoint(x, y);
            else
            if (document.elementFromPoint)
            {
                let previousPointerEvents = [], current, i, d;

                // get all elements via elementFromPoint, and remove them from hit-testing in order
                while ((current = document.elementFromPoint(x, y)) && elements.indexOf(current) === -1 && current != null) {

                    // push the element and its current style
                    elements.push(current);
                    previousPointerEvents.push({
                        value: current.style.getPropertyValue('pointer-events'),
                        priority: current.style.getPropertyPriority('pointer-events')
                    });

                    // add "pointer-events: none", to get to the underlying element
                    current.style.setProperty('pointer-events', 'none', 'important');

                    if (fx.dom.parent(current, ".BaseComponent"))
                        break;
                }

                // restore the previous pointer-events values
                for (i = previousPointerEvents.length; d = previousPointerEvents[--i];) {
                    elements[i].style.setProperty('pointer-events', d.value ? d.value : '', d.priority);
                }
            }
            else
            if (document.msElementsFromRect && document.msElementsFromRect(x, y, 1, 1)){ // IE
                let nodes = document.msElementsFromRect(x, y, 1, 1)
                for(let i = nodes.length; i--; elements.unshift(nodes[i]));
            }
        }
        return elements;
    }

    static getBoundingRect(rect, angle)
    {
        let radVal = Number(angle) * Math.PI / 180;
        let radVal2 = (90- Number(angle)) * Math.PI / 180;

        let x, y, x1, y1, x2, y2, x3, y3;
        x = Number(rect.x);
        y = Number(rect.y);
        x1 = -Math.sin(radVal) * Number(rect.height) + Number(rect.x);
        y1 = Math.cos(radVal) * Number(rect.height) + Number(rect.y);
        x2 = Math.cos(radVal) * Number(rect.width) + x1;
        y2 = Math.sin(radVal) * Number(rect.width) + y1;
        x3 = Math.sin(radVal2) * Number(rect.width) + x;
        y3 = Math.cos(radVal2) * Number(rect.width) + y;

        let newX = Math.min(x, x1, x2, x3);
        let newY = Math.min(y, y1, y2, y3);

        let width = Number(rect.height) * Math.abs( Math.sin( radVal) ) + Number(rect.width) * Math.abs( Math.cos( radVal ) );
        let height = Number(rect.height) * Math.abs( Math.cos( radVal ) ) + Number(rect.width) * Math.abs( Math.sin( radVal ) );

        return {x : Math.round(newX), y : Math.round(newY), width : Math.round(width), height : Math.round(height)};
    }

    static rotate(cx, cy, x, y, angle)
    {
        let radians = (Math.PI / 180) * angle,
                cos = Math.cos(radians),
                sin = Math.sin(radians),
                nx = (cos * (x - cx)) - (sin * (y - cy)) + cx,
                ny = (sin * (x - cx)) + (cos * (y - cy)) + cy;
        return [nx, ny];
    }

    static getRotationAngle(x1 , y1, x2,y2)
    {
        return Math.atan2(y2 - y1, x2 - x1) * 180 / Math.PI;
    }

    static  getRotationDegrees( element )
    {
        let obj = $(element);
        let angle;
        let matrix = obj.css("-webkit-transform") ||
                     obj.css("-moz-transform")    ||
                     obj.css("-ms-transform")     ||
                     obj.css("-o-transform")      ||
                     obj.css("transform");

        if (matrix !== 'none') 
        {
            let values = matrix.split('(')[1].split(')')[0].split(',');
            let a = values[0];
            let b = values[1];
            angle = Number(Math.atan2(b, a) * (180/Math.PI));
        } 
        else 
        { 
            angle = 0; 
        }

        return (angle < 0) ? angle + 360 : angle;
    }


    static getTranslate(item, useStyle, useZoom) 
    {
        let position = {x:0, y:0};
         
        if (item)
        {
            if (item instanceof fx.Component)
                item = item.node;

            let transArr = [];

            if (useStyle)
            {
                let mat = item.style.transform.match(/translate\((.+)\)$/);
                position.x  = parseFloat(mat[1].split(", ")[0]);
                position.y = parseFloat(mat[1].split(", ")[1]);
            }
            else
            {
                if (!window.getComputedStyle) return;
                let style     = getComputedStyle(item),
                    transform = style.transform || style.webkitTransform || style.mozTransform || style.msTransform;

                if (transform)
                {
                    let mat       = transform.match(/^matrix3d\((.+)\)$/);
                    if (mat) return parseFloat(mat[1].split(', ')[13]);

                    mat = transform.match(/^matrix\((.+)\)$/);
                    mat ? transArr.push(parseFloat(mat[1].split(', ')[4])) : transArr.push(0);
                    mat ? transArr.push(parseFloat(mat[1].split(', ')[5])) : transArr.push(0);
                    position.x = transArr[0];
                    position.y = transArr[1];
                }
            }
        }

        if (useZoom)
        {
            let zoom;
            while (item && item.isHTMLElement())
            {
                zoom = item.getStyle("zoom");
            
                if (!isNaN(parseFloat(zoom))) // zoom is a number
                {
                    position.x *= zoom;
                    position.y *= zoom;
                }

                if (item == document.body)
                    break;
                else
                    item = item.parentNode;
            }
        }
    
        return position;
        
    }

    static getScale(element)
    {
        if (element instanceof fx.Component)
            element = element.node;
            
        return !element ? 0 : element.getBoundingClientRect().width / element.offsetWidth;   
    }

    static getLineHeight(el) 
    {
        const cs = window.getComputedStyle(el);
        const lh = cs.lineHeight;
        if (lh === 'normal') {
        // fallback raisonnable si "normal"
        return parseFloat(cs.fontSize) * 1.2;
        }
        return parseFloat(lh);
    }


    static scrollbarWidth() {

        // Creating invisible container
        const outer = document.createElement('div');
        outer.style.visibility = 'hidden';
        outer.style.overflow = 'scroll'; // forcing scrollbar to appear
        outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
        document.body.appendChild(outer);
      
        // Creating inner element and placing it in the container
        const inner = document.createElement('div');
        outer.appendChild(inner);
      
        // Calculating difference between container's full width and the child width
        const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);
      
        // Removing temporary elements from the DOM
        outer.parentNode.removeChild(outer);
      
        return scrollbarWidth;
      
      }
      

      static fullScreen(elt)
      {
        if (!elt) return;
        
        if (elt instanceof fx.Component)
            elt = elt.node;

        if (elt.requestFullScreen) {
            elt.requestFullScreen();
        } else if (elt.mozRequestFullScreen) {
            elt.mozRequestFullScreen();
        } else if (elt.webkitRequestFullScreen) {
            elt.webkitRequestFullScreen();
        }
      }
   

});
/**
 * Component is base class for any graphical component.
 * It creates dom element based on render() function.
 * It manages all events (dom and custom) on this element, and call render() function every time data is updated.
 * It allows manipulating graphical representation thanks to wrappers (with, height, x, y, addClass, etc...).
 */
// TODO : Component should inherits from Events
fx.ns("fx", class Component extends fx.DataHandler {

	constructor(data, tag)
	{
		super(data);

		this._tag = tag || "div";

        this._childs = [];
		
		this._parent;
        this._effect = undefined;
		
        this._visible = false;
		this._animating = false;
		this._enabled = false;
		
		this._node;
		this._viewport = {};
		this._id = Utils.newID();
        
		this._realWidth;
		this._realHeight;
		this._realPosition = {top:0, let:0};


		this._visibleAtStart = true;
		this._pointerEvents = true;
		this._registeredClasses = [];
		this._registeredAttributes = [];
		this._updateDisplayAsked = true;

		this._className = "";

		this._needRender = false;
		this._nbChildsRender = 0;

		this._contextMenu = false;

		this._currentPopup = null;

		this._destroyOnSwitch = false;

		this.destroyHandler = this.destroy.bind(this);	
		
		this._createdTimeStamp = new Date();

        this._popups = [];
	}
	
	// ----------------------- GETTERS / SETTERS ---------------------- //
	
	/**
	 * Component unique id (same id on DOM)
	 */
	get id(){ 
		return this._id;
	}

	set id(val)
	{
		this._id = val;
		if (this._node)
			this._node.setAttribute("id", this.id );
	}

	/**
	 * Shows/Hide a component
	 */
	get visible()
	{
		return this._visible;
	}

	set visible(val)
	{
		if (!this.initialized)
			this.visibleAtStart = val;
		else
		{
			//this._visible = val;

			if (val)
				this.show();
			else
				this.hide();
		}
	}

	get globalyVisible()
	{
		let visible = this.css("opacity") == 1 && this.css("visibility") == "visible";
		let parent = this.parent;
		while (visible && parent)
		{
			visible = visible && parent.css("opacity") == 1 && parent.css("visibility") == "visible";
			parent = parent.parent;
		}
		
		return visible;
	}

	/**
	 * Enable/disables a component (mouse events)
	 */
	get enabled()
	{
		return this._enabled;
	}

	set enabled(val)
	{
		if (val)
			this.enable();
		else
			this.disable();
	}

	/**
	 * Set component visible/not visible at start.
	 * By default component are visible when created thr first time.
	 */
	get visibleAtStart(){
		return this._visibleAtStart;
	}

	set visibleAtStart(val)
	{
		this._visibleAtStart = val;
		
		//if (!val)
		//	this.disable();

		if (this.initialized)
			this.visible = val;
	}


	/**
	 * If set to true and used as view in router, this component will be destroy after switching to new view
	 */
	get destroyOnSwitch()
	{
		return this._destroyOnSwitch;
	}

	set destroyOnSwitch(val)
	{
		this._destroyOnSwitch = val;
	}

	/**
	 * Enable/disables pointers event on component
	 */
	get pointerEvents()
	{
		return this._pointerEvents;
	}

	set pointerEvents(val){
		this._pointerEvents = val;

		if (this.initialized)
			this.css({"pointer-events" : val ? "all" : "none"});
	}

	/**
	 * True while component is animated (fx.animate)
	 */
	get animating(){
		return this._animating;
	}

	set animating(val){
		this._animating = val;
	}

	/**
	 * Component's Class name in DOM
	 */
	get className(){
		return Object.getPrototypeOf(this).constructor.name + (this._className ? (" " + this._className) : "");
	}

	set className(val)
	{
		this._className = val;
	}
	
	/**
	 * Component's class names in DOM (in DOM component has class name of all his parents)
	 */
	get classNames(){
		
		let classNames = [];
		let element = this;
		while(Object.getPrototypeOf(element))
		{
			element = Object.getPrototypeOf(element)
			if (element.constructor.name != "Object")
				classNames.push(element.constructor.name);

			if (element.constructor.name == "Component")
				break;
		}
		return classNames;
	}

	/**
	 * Absolution calculated position
	 */
	get realPosition(){
		return this._realPosition;
	}

	/**
	 * Effect name from fx.animate
	 */
	get effect()
	{
		return this._effect;
	}

	set effect(name)
	{
		if (name && !fx.animate[name])
			fx.throwError("Effect " + name + " does not exisit in fx.animate");
		else
			this._effect = name ? name : "";
	}

	get showEffect()
	{
		return this._showEffect;
	}

	set showEffect(name)
	{
		if (name && !fx.animate[name])
			fx.throwError("Effect " + name + " does not exisit in fx.animate");
		else
			this._showEffect = name ? name : "";
	}

	get hideEffect()
	{
		return this._hideEffect;
	}

	set hideEffect(name)
	{
		if (name && !fx.animate[name])
			fx.throwError("Effect " + name + " does not exisit in fx.animate");
		else
			this._hideEffect = name ? name : "";
	}

	/**
	 * DOM node to which this component is linked
	 */
	get node(){
		return this._node;
	}
	
	/**
	 * Calculated width
	 */
	get realWidth(){
		return this._realWidth && !isNaN(parseInt(this._realWidth)) ? this._realWidth : this.measuredWidth(null,true);
	}
	
	/**
	 * Calculated height
	 */
	get realHeight(){
		return this._realHeight && !isNaN(parseInt(this._realHeight))? this._realHeight : this.measuredHeight();
	}

	/**
	 * Calculated Y (top) absolute position
	 */
	get y()
	{
		return parseFloat(this.realPosition ? this.realPosition.top : this.top());	
	}

	set y(val)
	{
		this.top(val);
	}
	
	/**
	 * Calculated X (left) absolute position
	 */
	get x()
	{
		return parseFloat(this.realPosition ? this.realPosition.left : this.left());	
	}

	set x(val)
	{
		this.left(val);
	}
	
		/**
	 * Return scroll top value
	 */
	get scrollTop()
	{
		return this.node ? this.node.scrollTop : 0;
	}

	/**
	 * Sets scroll top value
	 */
	set scrollTop(val)
	{
		if (this.node)
			this.node.scrollTop = val;
	}

	/**
	 * Return scroll left value
	 */
	get scrollLeft()
	{
		return this.node ? this.node.scrollLeft : 0;
	}

	/**
	 * Sets scroll top value
	 */
	set scrollLeft(val)
	{
		if (this.node)
			this.node.scrollLeft = val;
	}

	get toolTip()
	{
		return this._toolTip;
	}

	set toolTip(val)
	{
		this._toolTip = val;

		//this._setToolTipAttribute();
	}

	get toolTypeStyle()
	{
		return this._toolTypeStyle;
	}

	set toolTypeStyle(val)
	{
		this._toolTypeStyle = val;
	}

	get contentHTML()
	{
		return this.node ? this.node.outerHTML : "";
	}

	get innerHTML()
	{
		return this.node ? this.node.innerHTML : "";
	}

	/*_setToolTipAttribute()
	{
		if (this.initialized)
			this.attr("toolTip", typeof this.toolTip == "function" ?  this.toolTip() : this.toolTip);
	}*/
	/**
	 * Override this function in order to customize context Menu on this component.
	 * This function has to return an array of object. Each object has to have a "label" property and a "code" property.
	 * "label" property will be displayed in Menu, and "code" property will be sent in event handler onContextMenu
	 * 
	 * Example :
	 * contextMenu(e)
	 * {
	 * 		return [
	 *             	{label : "Edit", code : "edit"},
	 *             	{label : "Enable", code : "visible"},
	 * 				{label : "Duplicate", code : "duplicate"}
	 * 		];
	 * }
	 * 
	 * onContextMenu(item)
	 * {
	 * 		console.log(item);
	 * }
	 * 
	 */
	contextMenu(e)
	{
		return this._contextMenu;
	}

	/*set contextMenu(val)
	{
		this._contextMenu = val;
	}*/


	/**
	 * Return parent component
	 */
	get parent()
	{
		return this._parent;
	}
	

	/**
	 * Override this function in order to create component childs.
	 */
	create() {}

	/**
	 * Override this function if you need some components to be created only after create() function was called.
	 */
	postCreate() {}

	/**
	 * Override this function in order to create component width HTML. Every time component data is update, this HTML is refreshed
	 */
	render() {}

	/**
	 * Override this function if you need to perform any action when component is ready for the first time (childs created, displayed, resized, positionned)
	 */
	onReady() {}

	
	/**
	 * The first time data is set, this function is called with action.type == "init" so you can set your component.
	 * Then every time data is updated, this function is called with an action containing properties which were updated.
	 * @param {fx.Action} action 
	 */
	onDataUpdated(action)
	{
		super.onDataUpdated(action);

		this.update();
	}

	/**
	 * Events are sent throught model and can be caught in any component where model is present.
	 * Event are bubbling from bottom to top.
	 * @param {fx.Event} event 
	 */
	onDataEvent(event)
	{
		super.onDataEvent(event);
	}

	/**
	 * Override this function if you need to perform any action after component is resized & positionned
	 */
	onDisplayUpdated() {}

	/**
	 * To override in order to get the item clicked on ContextMenu
	 */
	onContextMenu(item)
	{
		
	}
	
	/**
	 * This function create the component and adds it either to it's parent, if it's has not parent component is added to document.body.
	 */
	init()
	{
		if (this.initialized)
		{
			this.initialize();

			//if (!this._needRender)
			//{
			//	for( let i = 0; i < this._childs.length; i++)
			//		this.addChild( this._childs[i] , this._childs[i].viewport);

				this.resize();
				this.position();

				this.trigger("__apply-register-events");

				this.onReady();
			//}
			
		}
		else
		{
			this.initialize();

			this.create();

			this.postCreate();
			this._checkRenderAndCreate();

			this.resize();
			this.position();
			
			super.init();

			this._initChildren();

			this.trigger("__apply-register-events");
			
			this._applyCSS();

			//this._setToolTipAttribute();

			this._setVisilibityAtStart();
			
			this._setContextMenu();
			
			//this.delay(this.onDisplayUpdated, 10);
			
			this.onReady();

			if (this.data && !this._needRender)
				this.onDataUpdated(new fx.Action("init", null, this.data));
		}

		this._setState();

		this.trigger("component-initialized");
	}

	/**
	 * Call this function to disable component and display waiting animation.
	 * It's usefull when loading data is needed, and takes some time for example.
	 * @param {Boolean} val : if true, displays waiting state, otherwiser removes it
	 * @param {String} text : text displayed during waiting state
	 * @param {Boolean} style : possible values : 
	 * 							- "light" : light opacity
	 * 							- "dark" (default): heavy opacity
	 */
	loading(val, text, style)
	{
		if (val)
        {
			if (this._loading)
			{
				if (this._loaderComponentText)
					this._loaderComponentText.text = text;

				return;
			}

			if (!this._loaderComponent)
			{
				if (fx.assets.loader)
				{
					this._loaderComponent = new fx.components.Box();

					if (text)
					{
						this._loaderComponentInner = new fx.components.VBox({className:"inner"});
						this._loaderComponentInner.addChild(new fx.components.Image(fx.assets.loader), {width : 50, height : 50});

						this._loaderComponentText = new fx.components.Text(text);
						this._loaderComponentInner.addChild(this._loaderComponentText);

						this._loaderComponent.addChild(this._loaderComponentInner, {/*width:"150",height:80,*/  top:"center", left:"center"});
					}
					else
					{
						this._loaderComponent.addChild(new fx.components.Image(fx.assets.loader), {width:50, height:50, top:"center", left:"center"} );
					}
						
				}
				else
					this._loaderComponent.addChild(new fx.components.Text(text ? text : "Chargement..."), {width:50, height:50, top:"center", left:"center"} );
					
				this.addClass("__loading");
				this._loaderComponent.addClass("loading");
				if (style)
					this._loaderComponent.addClass(style);
			}
                
			let childs = this.getChilds();
			//this._loadingOpacity = {};
			if (childs)
				for (let i = 0; i < childs.length; i++)
				//{
					//this._loadingOpacity[childs[i].id] = childs[i].css("opacity");
					//childs[i].css("opacity", 0.1);
					childs[i].addClass("_loading");
				//}
					
			
			//this.disable();

            this.addChild(this._loaderComponent, {width:"100%", height:"100%"});
        }
        else
        {
			if (!this._loading)
				return;

			let childs = this.getChilds();
			if (childs)
				for (let i = 0; i < childs.length; i++)
				//{
					/*if (this._loadingOpacity && this._loadingOpacity[childs[i].id] )
						childs[i].css("opacity", this._loadingOpacity[childs[i].id]);
					else
						childs[i].css("opacity", "");*/
						childs[i].removeClass("_loading");
				//}
					
			this.delay(this._removeLoading, 1000);

            if (this._loaderComponent)
            {
				this.removeChild(this._loaderComponent);
				
                this._loaderComponent.destroy();
                this._loaderComponent = null;
                this._loaderComponentInner = null;
            }

			//this.enable();
		}
		
		this._loading = val;

		this._updateLoadingScale();
	}

	_removeLoading()
	{
		this.removeClass("__loading");
	}
	
	_updateLoadingScale()
	{
		if (this._loaderComponent && this.node)
		{
			let scale = 1/fx.graphics.getScale(this.node);
			if (scale != 1)
				this.css(this._loaderComponent.find(".inner"), {"transform" : "scale(" + scale + ")"});

            if (this._loaderComponentInner)
            {
                this._loaderComponentInner.top( (this._loaderComponent.realHeight/scale - this._loaderComponentInner.realHeight) / 2 * scale  );
                this._loaderComponentInner.left( (this._loaderComponent.realWidth/scale - this._loaderComponentInner.realWidth) / 2 * scale);
            }
		}
	}

	/**
	 * Call this function in order to force component to resize and re-position.
	 */
	updateDisplay(onlyIfAsked)
	{
		if (!this.initialized) return;

		if (onlyIfAsked && !this._updateDisplayAsked)
			return;

		if (!this.visible)
		{
			this._updateDisplayAsked = true;
			return;
		}
	
		this.resize();
		this.position();

		for (let i = 0; i < this._childs.length; i++)
			this._childs[i].updateDisplay();
		
		this._updateDisplayAsked = false;

		this._updateLoadingScale();

		//this.delay(this.onDisplayUpdated, 10);
		this.onDisplayUpdated();
	}

	/**
	 * Onverride  this function to destroy all what you created.
	 * All properties are automaticall destroyed, and all event handler are removed automatically.
	 */
	destroy()	
	{
		super.destroy();
		
		// we disable the component
		this.disable();
		
        if (this._currentPopup)
        {
            this._currentPopup.close();
            this._currentPopup = null;
        }
            

		// let's remove and destroy all childs
		this.removeAllChild(true);

		// if it has a parent, let's call parent removeChild so it's remove from childs and from screen
		if (this.parent)
			this.parent.removeChild( this, false );
		else
			fx.dom.remove(this.id);
		
		fx.get("contextMenu").unregister(this);
		
	}
	
	/**
	 * Return child component with given id
	 * @param {String} id 
	 */
	getChild(id) 
	{
		for (let index = 0; index < this._childs.length; index++)
		{
			if (this._childs[index].id == id)
				return this._childs[index];
		}

		return null;
	}

	getChildFromUI(element)
	{
		if (!element)
			return null;

		let obj = fx.get("objects")[element.id];

		if (obj)
		{
			let parent = obj.parent;
			while(parent)
			{
				if (parent == this)
					return obj;

				parent = parent.parent;
			}
		}

		return null;
	}

	getChildIndex(child) 
	{
		let indexOfChild;
		for (let index = 0; index < this._childs.length; index++)
		{
			if (this._childs[index].id == child.id)
			{
				indexOfChild = index;
				break;
			}
		}
		return indexOfChild;
	}

	/**
	 * Return child component containing given data
	 * @param {Object} data 
	 */
	getChildFromData(data)
	{
		for (let index = 0; index < this._childs.length; index++)
		{
			if (this._childs[index].data == data)
				return this._childs[index];
		}
		return null;
	}
	
	/**
	 * Return all child components
	 */
	getChilds()
	{
		return this._childs || [];
	}

	/**
	 * Return true if given child is as child of component.
	 * @param {fx.Component} child 
	 */
	hasChild(child){
		let has = false;
		if (child instanceof fx.Component)
		{
			for (let index = 0; index < this._childs.length; index++)
				has = has || this._childs[index].id == child.id;
		}
		return has;
	}
	
	/**
	 * Add a child to component. Child will be set with given viewport (width, height, left/right, top/bottom).
	 * [optional] effect will be applied to child.
	 * [optional] index : child will be added at given index. If ommited, child will be added at the end.
	 * @param {fx.Component} child 
	 * @param {Object} viewport 
	 * @param {String} effect 
	 * @param {int} index 
	 */
	addChild(child, viewport, effect, index)
	{
		if (!(child instanceof fx.Component))
			throw new Error('fx.Component.addChild(child) : child must be an instance of fx.Component');
		else
		if (window[child.id])
			fx.throwError("Child " + child.classNames[0] + " was already added ");
		else
		{
			child._parent = this;
		
			if (index !== undefined)
			{
				child._index = index;
				this._childs.splice(index, 0, child);
			}
			else
				this._childs.push(child);

			if (viewport)
				child.viewport(viewport);

			if (effect)
				child.effect = effect;

			if (this.initialized)
			{
				child.init();
				child.updateDisplay();

				//this._applyRegisteredEvents();
			}
				

			return child;
		}
	}
	
	/**
	 * Remove child from component.
	 * [optional] destoy : if true, child is destroyed
	 * @param {fx.Component} child 
	 * @param {Boolean} destroy 
	 */
	removeChild(child, destroy)
	{
		if (destroy)
			child.destroy();

		let index = this._childs.indexOf(child);

		if (index != -1)
		{
			fx.dom.remove(child.id);
			this._childs.splice(index, 1);
		}

		return this;
	}
	
	/**
	 * Removes all childs from component
	 * [optional] destoy : if true, all childs are destroyed
	 * @param {boolean} destroy 
	 */
	removeAllChild(destroy)
	{
		if (this._childs)
		{
			let childs = this._childs.slice(0);
			for (let index = 0; index < childs.length; index++)
			{
				if (destroy)
					childs[index].destroy();
				else
					fx.dom.remove(childs[index].id);
			}
		}
		
		this._childs = [];
		return this;
	}
	
	/**
	 * Move child1 to before position in DOM
	 * @param {fx.Component} child1 
	 * @param {fx.Component} child2 
	 */
	moveChildBefore( child1, child2 )
	{
		let index = this._childs.indexOf(child1);
		let newIndex = this._childs.indexOf(child2);
		
		// TODO : check this part
		this._childs.move( index, newIndex);

		this.node.insertBefore( child1.node, child2.node);
	}

	/**
	 * Move child1 to after position in DOM
	 * @param {fx.Component} child1 
	 * @param {fx.Component} child2 
	 */
	moveChildAfter(child1, child2) 
	{
		let index = this._childs.indexOf(child1);
		let newIndex = this._childs.indexOf(child2);
		
		// TODO : check this part
		this._childs.move( index, newIndex+1);

		this.node.insertBefore( child1.node, child2.nextSibling);
	}

	/**
	 * Shows or hide component
	 * if val is not given, toggle component visibility.
	 * if val is give, and set to true, component is shown.
	 * @param {Boolean} val 
	 */
	toggle(val)
	{	
		if (val === undefined)
			val = !this.visible;

		if (val)
			this.show();
		else
			this.hide();
	}
	
	/**
	 * Shows component
	 * callback is called when component is visible
	 * effect : component is showed with given effect (fx.animate)
	 * @param {Function} callback 
	 * @param {String} effect 
	 */
	show(callback, effect)
	{
		if (!this.initialized || this.visible)
		{
			this._visibleAtStart = true;
			if (callback && typeof callback == "function") callback();
			return;
		}

		this._visible = true;

		if (typeof callback == "string")
		{
			effect = callback;
			callback = null;
		}

		if (fx.effectsEnabled && ( effect !== undefined || this._effect !== undefined || this._showEffect !== undefined) && fx.animate && fx.animate[effect ? effect : (this._showEffect ? this._showEffect : this._effect)])
		{
			fx.animate[effect ? effect : (this._showEffect ? this._showEffect : this._effect)]["show"](this, (typeof callback == "function") ? callback : null);
			
			if (this.pointerEvents)
				this.css({"pointer-events" : ""});
		}
		else
		{
			let css = {"opacity": 1, "visibility" : "visible"};

			if (this.pointerEvents)
				css.pointerEvents = "";

			this.css(css);
		
			if (typeof callback == "function") callback();

			this.updateDisplay(true);
		}

		this.enable();
		
		if (this.data &&  this.data instanceof fx.ModelArray)
           this.data.refresh();
	}
	
	/**
	 * Hides component
	 * callback is called when component is hidden
	 * effect : component is hidden with given effect (fx.animate)
	 * force : tries to hide component event if alreay hidden
	 * @param {Function} callback 
	 * @param {String} effect 
	 * @param {Boolean,} force
	 */
	hide(callback, effect, force)
	{
		if (!this.initialized || (!this.visible && !force))
		{
			this._visibleAtStart = false;
			if (callback && typeof callback == "function") callback();
			return;
		}

		this._visible = false;
		
		if (typeof callback == "string")
		{
			effect = callback;
			callback = null;
		}

		if (fx.effectsEnabled && !force && fx.animate[effect ? effect : (this._hideEffect ? this._hideEffect : this._effect)])
		{
			fx.animate[effect ? effect : (this._hideEffect ? this._hideEffect : this._effect)]["hide"](this, (typeof callback == "function") ? callback : null);

			if (this.pointerEvents)
				this.css({"pointer-events" : "none !important"});
		}
		else
		{
			let css = {"opacity": 0, "visibility" : "hidden"};

			if (this.pointerEvents)
				css.pointerEvents = "none !important";

			this.css(css);
		
			if (typeof callback == "function") callback();
		}

		//if (this.enabled)
			this.disable();
	}


	hideDestroy()
	{
		this.hide( this.destroyHandler);
	}
	
	
	/**
	 * Refresh component HTML if created with render function
	 */
	update(force)
	{
		if (this.initialized && this.node && (this._needRender || force))
		{
			// we use delay here, so if too many updates happen at same time, component is refreshed only once
			this.delay(this._update, 10);
			/*this.node.innerHTML = this.render();
			this._refreshHandlers();
			this.updateDisplay();*/
		}
	}

	_update()
	{
		if (this.initialized && this.node)
		{
			this.node.innerHTML = this.render();
			this._refreshHandlers();
			this.updateDisplay();
		}
	}

	/**
	 * Return position in dom of given element, or if not element given it return Component position in DOM.
	 * @param {HTMLElement} element 
	 */	
	childPosition(element) {
		return fx.dom.position( element ? this.find(element) : this.node );
	}
	
	/**
	 * Enable mouse events on component
	 */
	enable(){

		if (/*this.enabled ||*/ !this.initialized)
		{
			this._toEnable =  true;
			return;
		}

		this.removeClass("disabled");

		this._enabled = true;

		return this;
	}
	
	/**
	 * Disable mouse events on component
	 */
	disable(){

		if (/*!this.enabled ||*/ !this.initialized)
		{
			this._toDisable =  true;
			return;
		}

		this.addClass("disabled");

		this._enabled = false;

		return this;
	}
	
	
	/**
	 * Resize component according to viewport property
	 */
	resize()
	{
		// let's calculate _realWidth and _realHeight
		this._realWidth;
		this._realHeight;
		
		if (this._viewport.width !== undefined)
		{
			if (this._viewport.width == "fill")
			{
				let totalWidth = 0;

				if (this.css("position") == "absolute")
				{
					let left = 0;
					if (typeof this._viewport.left == "string" && this._viewport.left.endsWith("%"))
						left = this.parent.realWidth * parseFloat(this._viewport.left)/100;
					else
						left = parseFloat( this._viewport.left )

					totalWidth = left;
				}
				else
				{
					let childs = this.parent.getChilds();
					
					for (let i = 0; i < childs.length; i++)
					{
						if (childs[i].visible && childs[i].id != this.id)
							totalWidth += childs[i].realWidth;
					}
				}

				this._realWidth = (this.parent ? this.parent.realWidth : fx.dom.width(window)) - totalWidth;
			}
			else
			if (typeof this._viewport.width == "string" && this._viewport.width.endsWith("%"))
			{
				if (typeof this._viewport.left == "string")
				{
					if (this._viewport.left.endsWith("%"))
						this._realWidth = (this.parent ? this.parent.realWidth : fx.dom.width(window) ) * (parseFloat(this._viewport.width) / 100) -  (this.parent ? this.parent.realWidth : fx.dom.width(window) ) * (parseFloat(this._viewport.left) / 100);
					else
					if (this._viewport.left == "center")
						this._realWidth = (this.parent ? this.parent.realWidth : fx.dom.width(window) ) * (parseFloat(this._viewport.width) / 100);					
					else
						this._realWidth = (this.parent ? this.parent.realWidth : fx.dom.width(window) ) * (parseFloat(this._viewport.width) / 100) - parseFloat(this._viewport.left ? this._viewport.left : 0);					
				}
				else
					this._realWidth = (this.parent ? this.parent.realWidth : fx.dom.width(window) ) * (parseFloat(this._viewport.width) / 100) - parseFloat(this._viewport.left ? this._viewport.left : 0);					
			}
			else
			if (this._viewport.width == "max-content") // max-content, etc...
				this._realWidth = this._viewport.width;
			else
			if (this._viewport.left !== undefined && this._viewport.right !== undefined)
			{
				let parentWidth = (this.parent ? this.parent.realWidth : fx.dom.widht(window));
				let left = ( typeof this._viewport.left == "string" && this._viewport.left.endsWith("%")) ? ( (parseFloat(this._viewport.left) / 100) * parentWidth ) : this._viewport.left;
				let right = ( typeof this._viewport.right == "string" &&  this._viewport.right.endsWith("%")) ? ( (parseFloat(this._viewport.right) / 100) * parentWidth ) : this._viewport.right;
				this._realWidth = parentWidth - left - right;
			}
			else
			if (this._viewport.width == "auto") // max-content, etc...
				this._realWidth = "";
			else
				this._realWidth = parseFloat( this._viewport.width );
		}
		else 
		{
			this._realWidth = undefined;
			this.toFinishResize = true;
		}

		if (this._viewport.height !== undefined)
		{
			if (this._viewport.height == "fill")
			{
				//this.toFinishResize = true;
				//this._realHeight =  undefined;//(this.parent ? this.parent.realHeight : fx.dom.height(window) ) * (parseFloat(this._viewport.height) / 100)

				let totalHeight = 0;
				
				if (this.css("position") == "absolute")
				{
					// same as the width "fill" below : read the asked top from the viewport, not from the computed
					// style. With a CSS transition on the component (.layoutGrid, .coversGrid) the computed top still
					// reports the previous position right after top() was called, and the height would be computed
					// against a top that is about to change.
					let top = 0;
					if (typeof this._viewport.top == "string" && this._viewport.top.endsWith("%"))
						top = this.parent.realHeight * parseFloat(this._viewport.top)/100;
					else
						top = parseFloat( this._viewport.top );

					totalHeight = isNaN(top) ? (parseFloat( this.css("top") ) || 0) : top;
				}
				else
				{
					let childs = this.parent.getChilds();
				
					for (let i = 0; i < childs.length; i++)
					{
						if (childs[i].visible && childs[i].id != this.id)
							totalHeight += childs[i].measuredHeight();
					}
				}

				this._realHeight = (this.parent ? this.parent.realHeight : fx.dom.height(window)) - totalHeight;
			}
			else
			if (typeof this._viewport.height == "string" &&  this._viewport.height.endsWith("%") )
			{
				if (typeof this._viewport.top == "string" && this._viewport.top.endsWith("%"))
					this._realHeight =  (this.parent ? this.parent.realHeight : fx.dom.height(window) ) * (parseFloat(this._viewport.height) / 100)  - (this.parent ? this.parent.realHeight : fx.dom.height(window) ) * (parseFloat(this._viewport.top) / 100) ;
				else
					this._realHeight =  (this.parent ? this.parent.realHeight : fx.dom.height(window) ) * (parseFloat(this._viewport.height) / 100)  - parseFloat(this._viewport.top ? this._viewport.top : 0);
			}
			else
			if (this._viewport.height == "max-content")
				this._realHeight = this._viewport.height;
			else
			if (this._viewport.top && this._viewport.bottom )
			{
				let parentHeight = (this.parent ? this.parent.realHeight : fx.dom.height(window));
				let top = ( typeof this._viewport.top == "string" && this._viewport.top.endsWith("%")) ? ( (parseFloat(this._viewport.top) / 100) * parentHeight ) : this._viewport.top;
				let bottom = ( typeof this._viewport.bottom == "string" &&  this._viewport.bottom.endsWith("%")) ? ( (parseFloat(this._viewport.bottom) / 100) * parentHeight ) : this._viewport.bottom;
				this._realHeight = parentHeight - top - bottom;
			}
			else
			if (this._viewport.height == "auto")
				this._realHeight = "";
			else
				this._realHeight = parseFloat( this._viewport.height );
		}
		else 
		{
			this._realHeight = undefined;
			this.toFinishResize = true;
		}
	
		
		this.css({ width : this._realWidth, height : this._realHeight !== undefined ? this._realHeight : "auto"});

		return this;
	}

	
		
	/**
	 * A "fill" size is computed from the component position (parent size minus top / left), so moving the
	 * component must recompute it : otherwise a grid moved from top 115 to top 175 keeps the height it had at
	 * 115 and overflows its parent, which hides its scrollbar.
	 */
	_resizeIfFill()
	{
		if (this._viewport && (this._viewport.height == "fill" || this._viewport.width == "fill") && this.node && this.initialized)
			this.resize();
	}

	/**
	 * Position component according to viewport property
	 */
	position()
	{
		this._realPosition = {};
		
		if ( this._viewport.top === undefined && this._viewport.left  === undefined && this._viewport.bottom  === undefined && this._viewport.right  === undefined ) // no position
		{
			this._realPosition.top = 0;
			this._realPosition.left = 0;
		}
		
		if ( this._viewport.top == "center" || this._viewport.left == "center" || this._viewport.bottom == "center" || this._viewport.right == "center")
		{
			if (this._viewport.left == "center" || this._viewport.right == "center")
				this._realPosition.left = ((this.parent ? this.parent.realWidth : fx.dom.width(window) ) - this.realWidth) / 2;
			
			
			if (this._viewport.top == "center" || this._viewport.bottom == "center")
				this._realPosition.top = ((this.parent ? this.parent.realHeight : fx.dom.height(window) ) - this.realHeight) / 2;
		}

		if (typeof this._viewport.left == "string" && this._viewport.left.endsWith("%"))
			this._realPosition.left = (this.parent ? this.parent.realWidth : fx.dom.width(window) ) * (parseFloat(this._viewport.left) / 100);
		
		if (typeof this._viewport.right == "string"  && this._viewport.right.endsWith("%"))
			this._realPosition.right = (this.parent ? this.parent.realWidth : fx.dom.width(window) ) * (parseFloat(this._viewport.right) / 100);

		if (typeof this._viewport.top == "string"  && this._viewport.top.endsWith("%"))
			this._realPosition.top = (this.parent ? this.parent.realHeight : fx.dom.height(window) ) * (parseFloat(this._viewport.top) / 100);

		if (typeof this._viewport.bottom == "string"  && this._viewport.bottom.endsWith("%"))
			this._realPosition.bottom = (this.parent ? this.parent.realHeight : fx.dom.height(window) ) * (parseFloat(this._viewport.bottom) / 100);

		if (Utils.isNumber(this._viewport.left))
		{
			this._realPosition.left = this._viewport.left;
			this._realPosition.right = "unset";
		}
		else
		if (Utils.isNumber(this._viewport.right))
		{
			this._realPosition.right = this._viewport.right;
			this._realPosition.left = "unset";
		}

		if (Utils.isNumber(this._viewport.top))
		{
			this._realPosition.top = this._viewport.top;
			this._realPosition.bottom = "unset";
		}
		else
		if (Utils.isNumber(this._viewport.bottom))
		{
			this._realPosition.bottom = this._viewport.bottom;
			this._realPosition.top = "unset";
		}
		

		this.css(this._realPosition)
		
		return this;
	}

	
	/**
	 * Set or get viewport property of component. Viewport property contains size of component (with/height) and it's position (top/bottom, left/top)
	 * Size and position can be set with integers or with strings, example : {width:100, height:"auto", top:"center", left:"15%"}
	 * Size, and position can be percentages, example : {width : "100%", height:"50%", top:"10%", left:"50%"}
	 * Size possible values :
	 * - percentage : size will be a percentage of parent size
	 * - absolute value
	 * - "auto" : size is calculated from component content
	 * - "fullscreen" : size will equal to screen size
	 * 
	 * Position possible values :
	 * - percentage : size will be a percentage of parent size
	 * - absolute value
	 * - "center" : component will be center according to it's parent size
	 * 
	 * You can use right and bottom to align component on right side of bottom side.
	 * 
	 * You can avoid providing absolute values in pixels.
	 * 
	 * @param {Object} val 
	 * @param {Boolean} applyOnly 
	 */
	viewport(val, applyOnly){

		if (val){

			if (val == "fullscreen")
				this._viewport = {top:"0px", left:"0px", width:"100%", height:"100%"}
			else
			{
				this._viewport = {};
				for (let prop in val)
				{
					if ("left,right,top,bottom,width,height".indexOf(prop) != -1)
						this._viewport[prop] = val[prop];
					else
						fx.log.info(" This viewport property wasn't regognized : " + prop);
				}
				
				if (!this._viewport["width"])
					this._viewport["width"] = "auto";
				
				if (!this._viewport["height"])
					this._viewport["height"] = "auto";
			}
			
			if (!applyOnly && this.node && this.initialized)
				this.updateDisplay();
				
			return this;
		}
		else 
			return this._viewport;
	}
	
	/**
	 * Sets/gets viewport.top value
	 * @param {String} val 
	 * @param {bool} animate 
	 */
	top(val, animate){

		if (val !== undefined)
		{
			if (animate)
				this._applyAnimate();

			this._viewport.top = val;
			this.position(true);
			this._resizeIfFill();
			return this;
		}
		
		return this._viewport.top;
	}
	
	/**
	 * Sets/gets viewport.left value
	 * @param {String} val 
	 * @param {bool} animate 
	 */
	left(val, animate){

		if (val !== undefined)
		{
			if (animate)
				this._applyAnimate();
				
			this._viewport.left = val;
			this.position(true);
			this._resizeIfFill();
			return this;
		}
		
		return this._viewport.left;   
	}

	/**
	 * Moves component position. Top and left can be absolute values, or strings ("center")
	 * @param {String} left 
	 * @param {String} top 
	 */
	move(left, top)
	{
		this._viewport.left = left;
		this._viewport.top = top;
		this.position(true);
		this._resizeIfFill();
	}
	
	/**
	 * Sets/gets viewport.right value
	 * @param {String} val 
	 * @param {bool} animate 
	 */
	right(val, animate) {

		if (val !== undefined)
		{
			if (animate)
				this._applyAnimate();

			this._viewport.right = val;
			this.position(true);
			this._resizeIfFill();
			return this;
		}
		
		return this._viewport.right;
	}
	
	/**
	 * Sets/gets viewport.bottom value
	 * @param {String} val 
	 * @param {bool} animate 
	 */
	bottom(val, animate) {

		if (val !== undefined)
		{
			if (animate)
				this._applyAnimate();

			this._viewport.bottom = val;
			this.position(true);
			this._resizeIfFill();
			return this;
		}
		
		return this._viewport.bottom;
	}
	
	/**
	 * Sets/gets viewport.twidthop value
	 * @param {String} val 
	 * @param {bool} animate 
	 */
	width(val, animate) {

		if (val !== undefined)
		{
			if (animate)
				this._applyAnimate();

			this._viewport.width = val;
			this.resize();

			this.trigger("resized");
			return this;
		}
		
		return this._viewport.width;	
	}
	
	/**
	 * Sets/gets viewport.height value
	 * @param {String} val 
	 * @param {bool} animate 
	 */
	height(val, animate) {

		if (val !== undefined)
		{
			if (animate)
				this._applyAnimate();
			
			this._viewport.height = val;
			this.resize();

			this.trigger("resized");
			return this;
		}
		
		return this._viewport.height;
	}
	
	/**
	 * Return given component of current measured width (with border and margin)
	 * @param {fx.Component} child 
	 */
	measuredWidth(child, padding){
		child = child || this.node;
		return fx.dom.width(child)
				+ ( (child == window) ? 0 : (
					  parseFloat(fx.dom.css(child, "border-left-width"))
					+ parseFloat(fx.dom.css(child, "border-right-width"))
					+ parseFloat(fx.dom.css(child, "margin-right") )
					+ parseFloat(fx.dom.css(child, "margin-left") )
					+ (padding ? (
						parseFloat(fx.dom.css(child, "padding-left") )
						+ parseFloat(fx.dom.css(child, "padding-right") )
					) : 0)
					
				 ) );
	}
	
	/**
	 * Return given component of current measured height (with border and margin)
	 * @param {fx.Component} child 
	 */
	measuredHeight(child, innerOnly){
		if (child === false)
		{
			innerOnly = true
			child = this.node
		}
		else
			child = child || this.node;

		return fx.dom.height(child) 
				+ (innerOnly ? 0 : ( ( (child == window) ? 0 : (
										parseFloat(fx.dom.css(child , "border-top-width"))
										+ parseFloat(fx.dom.css(child , "border-bottom-width")) 
										+ parseFloat(fx.dom.css(child, "margin-top") )
										+ parseFloat(fx.dom.css(child, "margin-bottom") )
										+ parseFloat(fx.dom.css(child, "padding-top") )
										+ parseFloat(fx.dom.css(child, "padding-bottom") )
									) ) ) );
	}

	

	/**
	 * Adds a class to given element, or to component
	 * If element given, it can be a DOM element or a fx.Component
	 * @param {Element} element 
	 * @param {String} className 
	 */
	addClass(element, className) {

		if (!className)
		{
			if (!element) return;

			className = element;
			element = this.node;

			if (!this.initialized && this._registeredClasses)
				this._registeredClasses.push(className);
		}
		//else
		//	element = this.find(element);

		fx.dom.addClass(element, className);
	}
	
	/**
	 * Removes a class from given element, or to component
	 * If element given, it can be a DOM element or a fx.Component
	 * @param {Element} element 
	 * @param {String} className 
	 */
	removeClass(element, className) {

		if (!className)
		{
			if (!element) return;

			className = element;
			element = this.node;
		}
		//else
		//	element = this.find(element);

		fx.dom.removeClass(element, className);
	}
	
	/**
	 * Checks if given element, or current component contains given class
	 * If element given, it can be a DOM element or a fx.Component
	 * @param {Element} element 
	 * @param {String} className 
	 */
	hasClass(element, className) {

		if (!className)
		{
			className = element;
			element = this.node;
		}
		//else
		//	element = this.find(element);

		return fx.dom.hasClass(element, className);
	}
	
	/**
	 * Adds or removes class from given element, or current component 
	 * If element given, it can be a DOM element or a fx.Component
	 * @param {Element} element 
	 * @param {String} className 
	 */
	toggleClass(element, className, val) {
		if (val === undefined)
		{
			val = className;
			className = element;
			element = this.node;
		}
		//else
		//	element = this.find(element);

		fx.dom.toggleClass(element, className, val);
	}

	/**
	 * Trick to start a CSS animation. Call this function with name of class containing animation.
	 * @param {String} name 
	 */
	launchCSSAnimation(name)
	{
		// trick to force animation to start
		this.removeClass(name);
		void this.node.offsetWidth;
		this.addClass(name);
	}

	/**
	 * Gets/Sets an attribute from component DOM node
	 * @param {String} attribute 
	 * @param {String} value 
	 */
	attr(attribute, value)
	{
		if (value !== undefined)
		{
			if (!this._node)
				this._registeredAttributes.push({name : attribute, value : value});
			else
				this._node.setAttribute(attribute, value );
			
			return this;
		}		
		else
			return this._node ? this._node.getAttribute(attribute) : null;
	}
	
	/**
	 * Set focus component DOM node
	 */
	focus(options)
	{
		if (this._node)
			this._node.focus(options);
	}
	
	/**
	 * Gets/Sets css properties from given element or current component.
	 * Example :
	 * let comp = new fx.Component();
	 * console.log( comp.css("background-color") );
	 * comp.css("background-color", "red");
	 * comp.css({background-color" : "red"});
	 * console.log( comp.css(document.body) , "color" );
	 * comp.css(document.body , {"color" : "red"} );
	 * @param {Element} element 
	 * @param {Object} properties 
	 */
	css(element, properties) 
	{
		if (!this._cssToApply)
				this._cssToApply = {};

		if (properties === undefined)
		{
			properties = element;
			element = this.node;

			if (!this.initialized)
			{
				if ( typeof properties != "string")
				{
					Object.assign(this._cssToApply, properties);
					return;
				}
				else
				{
					if (this._cssToApply && this._cssToApply[properties])
						return this._cssToApply[properties];
				}
			}
				
		}
		else if (typeof element == "string" && (typeof properties != "object" || properties === null))
		{
			let prop = {};
			prop[element] = properties;
			properties = prop;
			element = this.node;

			if (!this.initialized)
			{
				Object.assign(this._cssToApply, properties);
				return;
			}
		}
		else 
			element = this.find(element);
		
		return fx.dom.css(element, properties);
	}
	
	/**
	 * Find dom node in component matching with given selector.
	 * Only one HTMLEmement component is returned.
	 * @param {Element} selector 
	 */
	find(selector) 
	{
		let element;
		if (selector === null)
			element = null;

		// if dom element given, if it's child of component we return it, otherwise we return null
		if (Utils.isDOMNode(selector) || Utils.isDOMElement(selector))
			element = (fx.dom.parent(selector, this.node)) ? selector : null;
		else
		if (Utils.isID(selector)) // id
			element = window[selector];
		else
			element = fx.dom.find(selector, this.node);

		// we tag any element returned by find
		if (element) 
		{
			element["_data-selector-" + this.id] = selector;

			if (element instanceof Array)
			{
				for (let i = 0; i < element.length; i++)
					element[i]["_data-selector-" + this.id] = selector + ":eq(" + i + ")";
			}
		}
			
		
		return element;
	}


	popup(popup, options)
    {
        //if (this._currentPopup)
        //    this._currentPopup.close();

        if (options && options.closeCurrent && this._currentPopup)
        {
            this._currentPopup.close();
            this._currentPopup = null;
        }
        
        if (this._currentPopup)
            this._popups.push( this._currentPopup );

        this._currentPopup = popup;
    
        if (this._currentPopup)
        {
			this._currentPopup.viewport("fullscreen");	

			this._currentPopup.options = options;
				
            this._currentPopup.init();
            
            this._currentPopup.show(true);

			this.on("closed", this._onPopupClosed, this._currentPopup);
		}
		
		return this._currentPopup;
    }

	resetScroll()
	{
		if (this.node)
            this.node.scrollTop = 0;
	}

	_onPopupClosed()
	{
        this._currentPopup = this._popups.pop();
		this.trigger("popup-closed");
	}


	//------------------------------- PRIVATE ---------------------------//

	
	_initChildren()
	{
		for (let i = 0; i < this._childs.length; i++)
			if (!this._childs[i].initialized)
				this._childs[i].init();
	}

	_applyRegisteredEvents()
	{
		if (!this.initialized) return;
		
		let handled = [];
		for (let i = 0; i < this._registeredEvents.length; i++)
		{
			let registeredEvent = this._registeredEvents[i];
			if (registeredEvent.source.node)
			{
				this.on(registeredEvent.event, registeredEvent.handler, registeredEvent.source);
				handled.push( registeredEvent);
			}
		}

		let event;
		while (event = handled.pop())
			this._registeredEvents.remove(event);
	}

	_onApplyRegisterEvents()
	{
		if (!this.initialized) return;

		this._applyRegisteredEvents();

		if (this.parent)
			this.parent.trigger("__apply-register-events");
	}

	_applyCSS()
	{
		if (this._cssToApply)
		{
			this.css(this._cssToApply);
			this._cssToApply = null;
		}
	}

	_setVisilibityAtStart()
	{
		if (this.visibleAtStart)
			this.show(null, null);
		else
			this.hide(null, null, true);
	}
	
	_setContextMenu()
	{
		if (this.contextMenu())
		{
			fx.get("contextMenu").register(this);
			this.on("menu-action", this._onContextMenuAction);
		}
	}

	on(event, handler, source)
	{	
		super.on(event, handler, source);

		if (source instanceof fx.Component && !source.node && source.parent != this)
			super.on("__apply-register-events", this._onApplyRegisterEvents, source)
	}

	off(event, handler, source)
	{
		super.off(event, handler, source);

		if (source instanceof fx.Component && !source.node && source.parent != this)
			super.off("__apply-register-events", this._onApplyRegisterEvents, source)
	}

	initialize()
	{
		super.register();
		
		if (!this._node)
		{
			this._node = document.createElement(this._tag);
			this._node.setAttribute("id", this.id );
			this._node.setAttribute("class", this.classNames.join(" ") + " " + (this._className ? this._className : "") + " " + this._registeredClasses.join(" ") );
			for (let i = 0; i < this._registeredAttributes.length; i++)
				this._node.setAttribute(this._registeredAttributes[i].name, this._registeredAttributes[i].value);

			if (!this.visibleAtStart)
				fx.dom.css(this.node, { "opacity":0, "visibility" :"hidden", "pointer-events":"none"});	
		}

		let html = this.render();
		
		if (html !== undefined)
		{
			this._needRender = true;
			this._node.innerHTML = html;
			this._nbChildsRender = this._node.children.length;
		}
		

		let parentContainer = this.parent ? this.parent.node /*window.document.getElementById( this.parent.id )*/ : window.document.body; // window[ this.parent.id]

		if ( !parentContainer )
		{
			fx.log.info(this.classNames[0] + "#" + this._id + " can not be added. Possible cause : super.init() not called in parent, addChild() has no effect.");
			return;
		}
		else
		{
			if (this._index !== undefined && this._index < Math.max(0,parentContainer.children.length))
				parentContainer.insertBefore(this._node, parentContainer.children[this._index]);
			else
				parentContainer.appendChild(this._node);
		}

		if (this._className && !this.hasClass(this._className))
			this.addClass(this._className);

		if (!this.parent && !this.initialized)
			this.on("resize", this.windowResized, window);

		//if (this.parent)
			//this.parent.trigger("__component-added");

		//this.on("__apply-register-events", this._onApplyRegisterEvents)

		this.on("__apply-register-events", this._onApplyRegisterEvents)
	}

	getDelay(value)
	{
		if (this._createdTimeStamp === undefined)
			return value;
			
		let delay = new Date() - this._createdTimeStamp;
		if ( delay > value)
			return 0;

		return Math.max(value, delay);
	}

	_checkRenderAndCreate()
	{
		if (this._nbChildsRender > 0 && this._node.children.length > this._nbChildsRender)
		{
			this._needRender = false;
			fx.log.warning("fx.Component must override render() or create() but not both. If both overrided, render will be called only the at initialization.");
		}
	}
	
	_setState()
	{
		if (this._toDisable)
			this.disable();
		else
		if (this._toEnable)
			this.enable();
	}
	
	_applyAnimate()
	{
		fx.dom.css(this.node, {"transition" : "all 0.4s"});
		this.delay( this._animateFinished , 500);
		
	}

	_animateFinished()
	{
		fx.dom.css(this.node, {"transition" : "none"}); 

		if (this.parent)
			this.parent.updateDisplay();
	}
	
	_onContextMenuAction(e)
	{
		//this.onContextMenu(e.detail);
		this.onContextMenu(e);
	}

	windowResized (e)
	{
		this.delay(this.updateDisplay, 10);
	}

	_refreshHandlers()
	{
		// loop on all properties, find handler (created from find())
		// check if they are DOM object, and find the one not linked anymore to DOM
		// then refresh them
		// - remove event handler
		// - get new handler
		// - add event handler

		for(var property in this)
		{
			let handler = this[property];
			
			if ( Utils.isDOMNode(handler) || Utils.isDOMElement(handler) )
			{
				if ( !fx.dom.parent(handler, document.body) )
				{
					let selector = handler["_data-selector-" + this.id];
					let newHandler = this.find(selector);
					this[property] = newHandler;
					for (let i = 0; i < this._binds.length; i++)
					{
						if (this._binds[i] && this._binds[i].source == handler)
						{
							this.on(this._binds[i].event, this._binds[i].handler, this[property] );
							this.off(this._binds[i].event, this._binds[i].handler, this._binds[i].source );
						}
					}
				}
			}
		}

		// do the same for all handler in this._binds
		for (let i = 0; i < this._binds.length; i++)
		{
			if (this._binds[i])
			{
				if (Utils.isDOMNode(this._binds[i].source) || Utils.isDOMElement(this._binds[i].source) )
				{
					if ( !fx.dom.parent(this._binds[i].source, document.body) )
					{
						let selector = this._binds[i].source["_data-selector-" + this.id];
						if (selector)
						{
							let newHandler = this.find(selector);
							this.on(this._binds[i].event, this._binds[i].handler, newHandler );
							this.off(this._binds[i].event, this._binds[i].handler, this._binds[i].source );
						}
					}
				}
			}
		}
	}

});
// https://mymth.github.io/vanillajs-datepicker/
!function(){"use strict";function e(e){return e[e.length-1]}function t(e,...t){return t.forEach((t=>{e.includes(t)||e.push(t)})),e}function i(e,t){return e?e.split(t):[]}function s(e,t,i){return(void 0===t||e>=t)&&(void 0===i||e<=i)}function n(e,t,i){return e<t?t:e>i?i:e}function a(e,t,i={},s=0,n=""){n+=`<${Object.keys(i).reduce(((e,t)=>{let n=i[t];return"function"==typeof n&&(n=n(s)),`${e} ${t}="${n}"`}),e)}></${e}>`;const r=s+1;return r<t?a(e,t,i,r,n):n}function r(e){return e.replace(/>\s+/g,">").replace(/\s+</,"<")}function o(e){return new Date(e).setHours(0,0,0,0)}function d(){return(new Date).setHours(0,0,0,0)}function c(...e){switch(e.length){case 0:return d();case 1:return o(e[0])}const t=new Date(0);return t.setFullYear(...e),t.setHours(0,0,0,0)}function l(e,t){const i=new Date(e);return i.setDate(i.getDate()+t)}function h(e,t){const i=new Date(e),s=i.getMonth()+t;let n=s%12;n<0&&(n+=12);const a=i.setMonth(s);return i.getMonth()!==n?i.setDate(0):a}function u(e,t){const i=new Date(e),s=i.getMonth(),n=i.setFullYear(i.getFullYear()+t);return 1===s&&2===i.getMonth()?i.setDate(0):n}function f(e,t){return(e-t+7)%7}function p(e,t,i=0){const s=new Date(e).getDay();return l(e,f(t,i)-f(s,i))}function m(e,t){return Math.round((e-t)/6048e5)+1}function w(e){const t=p(e,4,1);return m(t,p(new Date(t).setMonth(0,4),4,1))}function g(e,t){const i=p(new Date(e).setMonth(0,1),t,t),s=p(e,t,t),n=m(s,i);if(n<53)return n;return s===p(new Date(e).setDate(32),t,t)?1:n}function y(e){return g(e,0)}function D(e){return g(e,6)}function k(e,t){const i=new Date(e).getFullYear();return Math.floor(i/t)*t}function b(e,t,i){if(1!==t&&2!==t)return e;const s=new Date(e);return 1===t?i?s.setMonth(s.getMonth()+1,0):s.setDate(1):i?s.setFullYear(s.getFullYear()+1,0,0):s.setMonth(0,1),s.setHours(0,0,0,0)}const v=/dd?|DD?|mm?|MM?|yy?(?:yy)?/,x=/[\s!-/:-@[-`{-~年月日]+/;let M={};const O={y:(e,t)=>new Date(e).setFullYear(parseInt(t,10)),m(e,t,i){const s=new Date(e);let n=parseInt(t,10)-1;if(isNaN(n)){if(!t)return NaN;const e=t.toLowerCase(),s=t=>t.toLowerCase().startsWith(e);if(n=i.monthsShort.findIndex(s),n<0&&(n=i.months.findIndex(s)),n<0)return NaN}return s.setMonth(n),s.getMonth()!==N(n)?s.setDate(0):s.getTime()},d:(e,t)=>new Date(e).setDate(parseInt(t,10))},S={d:e=>e.getDate(),dd:e=>C(e.getDate(),2),D:(e,t)=>t.daysShort[e.getDay()],DD:(e,t)=>t.days[e.getDay()],m:e=>e.getMonth()+1,mm:e=>C(e.getMonth()+1,2),M:(e,t)=>t.monthsShort[e.getMonth()],MM:(e,t)=>t.months[e.getMonth()],y:e=>e.getFullYear(),yy:e=>C(e.getFullYear(),2).slice(-2),yyyy:e=>C(e.getFullYear(),4)};function N(e){return e>-1?e%12:N(e+12)}function C(e,t){return e.toString().padStart(t,"0")}function F(t){if("string"!=typeof t)throw new Error("Invalid date format.");if(t in M)return M[t];const i=t.split(v),s=t.match(new RegExp(v,"g"));if(0===i.length||!s)throw new Error("Invalid date format.");const n=s.map((e=>S[e])),a=Object.keys(O).reduce(((e,t)=>(s.find((e=>"D"!==e[0]&&e[0].toLowerCase()===t))&&e.push(t),e)),[]);return M[t]={parser(e,t){const i=e.split(x).reduce(((e,t,i)=>{if(t.length>0&&s[i]){const n=s[i][0];"M"===n?e.m=t:"D"!==n&&(e[n]=t)}return e}),{});return a.reduce(((e,s)=>{const n=O[s](e,i[s],t);return isNaN(n)?e:n}),d())},formatter:(t,s)=>n.reduce(((e,n,a)=>e+`${i[a]}${n(t,s)}`),"")+e(i)}}function V(e,t,i){if(e instanceof Date||"number"==typeof e){const t=o(e);return isNaN(t)?void 0:t}if(e){if("today"===e)return d();if(t&&t.toValue){const s=t.toValue(e,t,i);return isNaN(s)?void 0:o(s)}return F(t).parser(e,i)}}function B(e,t,i){if(isNaN(e)||!e&&0!==e)return"";const s="number"==typeof e?new Date(e):e;return t.toDisplay?t.toDisplay(s,t,i):F(t).formatter(s,i)}const E=document.createRange();function A(e){return E.createContextualFragment(e)}function L(e){return e.parentElement||(e.parentNode instanceof ShadowRoot?e.parentNode.host:void 0)}function Y(e){return e.getRootNode().activeElement===e}function W(e){"none"!==e.style.display&&(e.style.display&&(e.dataset.styleDisplay=e.style.display),e.style.display="none")}function _(e){"none"===e.style.display&&(e.dataset.styleDisplay?(e.style.display=e.dataset.styleDisplay,delete e.dataset.styleDisplay):e.style.display="")}function K(e){e.firstChild&&(e.removeChild(e.firstChild),K(e))}const R=new WeakMap,{addEventListener:j,removeEventListener:T}=EventTarget.prototype;function H(e,t){let i=R.get(e);i||(i=[],R.set(e,i)),t.forEach((e=>{j.call(...e),i.push(e)}))}function $(e){let t=R.get(e);t&&(t.forEach((e=>{T.call(...e)})),R.delete(e))}if(!Event.prototype.composedPath){const e=(t,i=[])=>{let s;return i.push(t),t.parentNode?s=t.parentNode:t.host?s=t.host:t.defaultView&&(s=t.defaultView),s?e(s,i):i};Event.prototype.composedPath=function(){return e(this.target)}}function I(e,t,i){const[s,...n]=e;return t(s)?s:s!==i&&"HTML"!==s.tagName&&0!==n.length?I(n,t,i):void 0}function P(e,t){const i="function"==typeof t?t:e=>e instanceof Element&&e.matches(t);return I(e.composedPath(),i,e.currentTarget)}const J={en:{days:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],daysShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],daysMin:["Su","Mo","Tu","We","Th","Fr","Sa"],months:["January","February","March","April","May","June","July","August","September","October","November","December"],monthsShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],today:"Today",clear:"Clear",titleFormat:"MM y"}},U={autohide:!1,beforeShowDay:null,beforeShowDecade:null,beforeShowMonth:null,beforeShowYear:null,clearButton:!1,dateDelimiter:",",datesDisabled:[],daysOfWeekDisabled:[],daysOfWeekHighlighted:[],defaultViewDate:void 0,disableTouchKeyboard:!1,enableOnReadonly:!0,format:"mm/dd/yyyy",language:"en",maxDate:null,maxNumberOfDates:1,maxView:3,minDate:null,nextArrow:"»",orientation:"auto",pickLevel:0,prevArrow:"«",showDaysOfWeek:!0,showOnClick:!0,showOnFocus:!0,startView:0,title:"",todayButton:!1,todayButtonMode:0,todayHighlight:!1,updateOnBlur:!0,weekNumbers:0,weekStart:0},{language:q,format:z,weekStart:X}=U;function G(e,i){return e.length<6&&i>=0&&i<7?t(e,i):e}function Q(e,t){switch(4===e?6===t?3:!t+1:e){case 1:return w;case 2:return y;case 3:return D}}function Z(e,t,i){return t.weekStart=e,t.weekEnd=(e+6)%7,4===i&&(t.getWeekNumber=Q(4,e)),e}function ee(e,t,i,s){const n=V(e,t,i);return void 0!==n?n:s}function te(e,t,i=3){const s=parseInt(e,10);return s>=0&&s<=i?s:t}function ie(e,t,i,s=void 0){t in e&&(i in e||(e[i]=s?s(e[t]):e[t]),delete e[t])}function se(e,i){const s=Object.assign({},e),n={},a=i.constructor.locales,r=!!i.rangeSideIndex;let{datesDisabled:o,format:d,language:l,locale:h,maxDate:u,maxView:f,minDate:p,pickLevel:m,startView:w,weekNumbers:g,weekStart:y}=i.config||{};if(ie(s,"calendarWeeks","weekNumbers",(e=>e?1:0)),ie(s,"clearBtn","clearButton"),ie(s,"todayBtn","todayButton"),ie(s,"todayBtnMode","todayButtonMode"),s.language){let e;if(s.language!==l&&(a[s.language]?e=s.language:(e=s.language.split("-")[0],a[e]||(e=!1))),delete s.language,e){l=n.language=e;const t=h||a[q];h=Object.assign({format:z,weekStart:X},a[q]),l!==q&&Object.assign(h,a[l]),n.locale=h,d===t.format&&(d=n.format=h.format),y===t.weekStart&&(y=Z(h.weekStart,n,g))}}if(s.format){const e="function"==typeof s.format.toDisplay,t="function"==typeof s.format.toValue,i=v.test(s.format);(e&&t||i)&&(d=n.format=s.format),delete s.format}let D=m;"pickLevel"in s&&(D=te(s.pickLevel,m,2),delete s.pickLevel),D!==m&&(D>m&&("minDate"in s||(s.minDate=p),"maxDate"in s||(s.maxDate=u)),o&&!s.datesDisabled&&(s.datesDisabled=[]),m=n.pickLevel=D);let k=p,x=u;if("minDate"in s){const e=c(0,0,1);k=null===s.minDate?e:ee(s.minDate,d,h,k),k!==e&&(k=b(k,m,!1)),delete s.minDate}if("maxDate"in s&&(x=null===s.maxDate?void 0:ee(s.maxDate,d,h,x),void 0!==x&&(x=b(x,m,!0)),delete s.maxDate),x<k?(p=n.minDate=x,u=n.maxDate=k):(p!==k&&(p=n.minDate=k),u!==x&&(u=n.maxDate=x)),s.datesDisabled){const e=s.datesDisabled;if("function"==typeof e)n.datesDisabled=null,n.checkDisabled=(t,i)=>e(new Date(t),i,r);else{const i=n.datesDisabled=e.reduce(((e,i)=>{const s=V(i,d,h);return void 0!==s?t(e,b(s,m,r)):e}),[]);n.checkDisabled=e=>i.includes(e)}delete s.datesDisabled}if("defaultViewDate"in s){const e=V(s.defaultViewDate,d,h);void 0!==e&&(n.defaultViewDate=e),delete s.defaultViewDate}if("weekStart"in s){const e=Number(s.weekStart)%7;isNaN(e)||(y=Z(e,n,g)),delete s.weekStart}if(s.daysOfWeekDisabled&&(n.daysOfWeekDisabled=s.daysOfWeekDisabled.reduce(G,[]),delete s.daysOfWeekDisabled),s.daysOfWeekHighlighted&&(n.daysOfWeekHighlighted=s.daysOfWeekHighlighted.reduce(G,[]),delete s.daysOfWeekHighlighted),"weekNumbers"in s){let e=s.weekNumbers;if(e){const t="function"==typeof e?(t,i)=>e(new Date(t),i):Q(e=parseInt(e,10),y);t&&(g=n.weekNumbers=e,n.getWeekNumber=t)}else g=n.weekNumbers=0,n.getWeekNumber=null;delete s.weekNumbers}if("maxNumberOfDates"in s){const e=parseInt(s.maxNumberOfDates,10);e>=0&&(n.maxNumberOfDates=e,n.multidate=1!==e),delete s.maxNumberOfDates}s.dateDelimiter&&(n.dateDelimiter=String(s.dateDelimiter),delete s.dateDelimiter);let M=f;"maxView"in s&&(M=te(s.maxView,f),delete s.maxView),M=m>M?m:M,M!==f&&(f=n.maxView=M);let O=w;if("startView"in s&&(O=te(s.startView,O),delete s.startView),O<m?O=m:O>f&&(O=f),O!==w&&(n.startView=O),s.prevArrow){const e=A(s.prevArrow);e.childNodes.length>0&&(n.prevArrow=e.childNodes),delete s.prevArrow}if(s.nextArrow){const e=A(s.nextArrow);e.childNodes.length>0&&(n.nextArrow=e.childNodes),delete s.nextArrow}if("disableTouchKeyboard"in s&&(n.disableTouchKeyboard="ontouchstart"in document&&!!s.disableTouchKeyboard,delete s.disableTouchKeyboard),s.orientation){const e=s.orientation.toLowerCase().split(/\s+/g);n.orientation={x:e.find((e=>"left"===e||"right"===e))||"auto",y:e.find((e=>"top"===e||"bottom"===e))||"auto"},delete s.orientation}if("todayButtonMode"in s){switch(s.todayButtonMode){case 0:case 1:n.todayButtonMode=s.todayButtonMode}delete s.todayButtonMode}return Object.entries(s).forEach((([e,t])=>{void 0!==t&&e in U&&(n[e]=t)})),n}const ne={show:{key:"ArrowDown"},hide:null,toggle:{key:"Escape"},prevButton:{key:"ArrowLeft",ctrlOrMetaKey:!0},nextButton:{key:"ArrowRight",ctrlOrMetaKey:!0},viewSwitch:{key:"ArrowUp",ctrlOrMetaKey:!0},clearButton:{key:"Backspace",ctrlOrMetaKey:!0},todayButton:{key:".",ctrlOrMetaKey:!0},exitEditMode:{key:"ArrowDown",ctrlOrMetaKey:!0}};const ae=e=>e.map((e=>`<button type="button" class="%buttonClass% ${e}" tabindex="-1"></button>`)).join(""),re=r(`<div class="datepicker">\n  <div class="datepicker-picker">\n    <div class="datepicker-header">\n      <div class="datepicker-title"></div>\n      <div class="datepicker-controls">\n        ${ae(["prev-button prev-btn","view-switch","next-button next-btn"])}\n      </div>\n    </div>\n    <div class="datepicker-main"></div>\n    <div class="datepicker-footer">\n      <div class="datepicker-controls">\n        ${ae(["today-button today-btn","clear-button clear-btn"])}\n      </div>\n    </div>\n  </div>\n</div>`),oe=r(`<div class="days">\n  <div class="days-of-week">${a("span",7,{class:"dow"})}</div>\n  <div class="datepicker-grid">${a("span",42)}</div>\n</div>`),de=r(`<div class="week-numbers calendar-weeks">\n  <div class="days-of-week"><span class="dow"></span></div>\n  <div class="weeks">${a("span",6,{class:"week"})}</div>\n</div>`);class ce{constructor(e,t){Object.assign(this,t,{picker:e,element:A('<div class="datepicker-view"></div>').firstChild,selected:[],isRangeEnd:!!e.datepicker.rangeSideIndex}),this.init(this.picker.datepicker.config)}init(e){"pickLevel"in e&&(this.isMinView=this.id===e.pickLevel),this.setOptions(e),this.updateFocus(),this.updateSelection()}prepareForRender(e,t,i){this.disabled=[];const s=this.picker;s.setViewSwitchLabel(e),s.setPrevButtonDisabled(t),s.setNextButtonDisabled(i)}setDisabled(e,i){i.add("disabled"),t(this.disabled,e)}performBeforeHook(e,t){let i=this.beforeShow(new Date(t));switch(typeof i){case"boolean":i={enabled:i};break;case"string":i={classes:i}}if(i){const s=e.classList;if(!1===i.enabled&&this.setDisabled(t,s),i.classes){const e=i.classes.split(/\s+/);s.add(...e),e.includes("disabled")&&this.setDisabled(t,s)}i.content&&function(e,t){K(e),t instanceof DocumentFragment?e.appendChild(t):"string"==typeof t?e.appendChild(A(t)):"function"==typeof t.forEach&&t.forEach((t=>{e.appendChild(t)}))}(e,i.content)}}renderCell(e,t,i,s,{selected:n,range:a},r,o=[]){e.textContent=t,this.isMinView&&(e.dataset.date=s);const d=e.classList;if(e.className=`datepicker-cell ${this.cellClass}`,i<this.first?d.add("prev"):i>this.last&&d.add("next"),d.add(...o),(r||this.checkDisabled(s,this.id))&&this.setDisabled(s,d),a){const[e,t]=a;i>e&&i<t&&d.add("range"),i===e&&d.add("range-start"),i===t&&d.add("range-end")}n.includes(i)&&d.add("selected"),i===this.focused&&d.add("focused"),this.beforeShow&&this.performBeforeHook(e,s)}refreshCell(e,t,i,[s,n]){const a=e.classList;a.remove("range","range-start","range-end","selected","focused"),t>s&&t<n&&a.add("range"),t===s&&a.add("range-start"),t===n&&a.add("range-end"),i.includes(t)&&a.add("selected"),t===this.focused&&a.add("focused")}changeFocusedCell(e){this.grid.querySelectorAll(".focused").forEach((e=>{e.classList.remove("focused")})),this.grid.children[e].classList.add("focused")}}class le extends ce{constructor(e){super(e,{id:0,name:"days",cellClass:"day"})}init(e,t=!0){if(t){const e=A(oe).firstChild;this.dow=e.firstChild,this.grid=e.lastChild,this.element.appendChild(e)}super.init(e)}setOptions(e){let t;if("minDate"in e&&(this.minDate=e.minDate),"maxDate"in e&&(this.maxDate=e.maxDate),e.checkDisabled&&(this.checkDisabled=e.checkDisabled),e.daysOfWeekDisabled&&(this.daysOfWeekDisabled=e.daysOfWeekDisabled,t=!0),e.daysOfWeekHighlighted&&(this.daysOfWeekHighlighted=e.daysOfWeekHighlighted),"todayHighlight"in e&&(this.todayHighlight=e.todayHighlight),"weekStart"in e&&(this.weekStart=e.weekStart,this.weekEnd=e.weekEnd,t=!0),e.locale){const i=this.locale=e.locale;this.dayNames=i.daysMin,this.switchLabelFormat=i.titleFormat,t=!0}if("beforeShowDay"in e&&(this.beforeShow="function"==typeof e.beforeShowDay?e.beforeShowDay:void 0),"weekNumbers"in e)if(e.weekNumbers&&!this.weekNumbers){const e=A(de).firstChild;this.weekNumbers={element:e,dow:e.firstChild,weeks:e.lastChild},this.element.insertBefore(e,this.element.firstChild)}else this.weekNumbers&&!e.weekNumbers&&(this.element.removeChild(this.weekNumbers.element),this.weekNumbers=null);"getWeekNumber"in e&&(this.getWeekNumber=e.getWeekNumber),"showDaysOfWeek"in e&&(e.showDaysOfWeek?(_(this.dow),this.weekNumbers&&_(this.weekNumbers.dow)):(W(this.dow),this.weekNumbers&&W(this.weekNumbers.dow))),t&&Array.from(this.dow.children).forEach(((e,t)=>{const i=(this.weekStart+t)%7;e.textContent=this.dayNames[i],e.className=this.daysOfWeekDisabled.includes(i)?"dow disabled":"dow"}))}updateFocus(){const e=new Date(this.picker.viewDate),t=e.getFullYear(),i=e.getMonth(),s=c(t,i,1),n=p(s,this.weekStart,this.weekStart);this.first=s,this.last=c(t,i+1,0),this.start=n,this.focused=this.picker.viewDate}updateSelection(){const{dates:e,rangepicker:t}=this.picker.datepicker;this.selected=e,t&&(this.range=t.dates)}render(){if(this.today=this.todayHighlight?d():void 0,this.prepareForRender(B(this.focused,this.switchLabelFormat,this.locale),this.first<=this.minDate,this.last>=this.maxDate),this.weekNumbers){const e=this.weekStart,t=p(this.first,e,e);Array.from(this.weekNumbers.weeks.children).forEach(((i,s)=>{const n=l(t,7*s);i.textContent=this.getWeekNumber(n,e),s>3&&i.classList[n>this.last?"add":"remove"]("next")}))}Array.from(this.grid.children).forEach(((e,t)=>{const i=l(this.start,t),s=new Date(i),n=s.getDay(),a=[];this.today===i&&a.push("today"),this.daysOfWeekHighlighted.includes(n)&&a.push("highlighted"),this.renderCell(e,s.getDate(),i,i,this,i<this.minDate||i>this.maxDate||this.daysOfWeekDisabled.includes(n),a)}))}refresh(){const e=this.range||[];Array.from(this.grid.children).forEach((t=>{this.refreshCell(t,Number(t.dataset.date),this.selected,e)}))}refreshFocus(){this.changeFocusedCell(Math.round((this.focused-this.start)/864e5))}}function he(e,t){if(!e||!e[0]||!e[1])return;const[[i,s],[n,a]]=e;return i>t||n<t?void 0:[i===t?s:-1,n===t?a:12]}class ue extends ce{constructor(e){super(e,{id:1,name:"months",cellClass:"month"})}init(e,t=!0){t&&(this.grid=this.element,this.element.classList.add("months","datepicker-grid"),this.grid.appendChild(A(a("span",12,{"data-month":e=>e}))),this.first=0,this.last=11),super.init(e)}setOptions(e){if(e.locale&&(this.monthNames=e.locale.monthsShort),"minDate"in e)if(void 0===e.minDate)this.minYear=this.minMonth=this.minDate=void 0;else{const t=new Date(e.minDate);this.minYear=t.getFullYear(),this.minMonth=t.getMonth(),this.minDate=t.setDate(1)}if("maxDate"in e)if(void 0===e.maxDate)this.maxYear=this.maxMonth=this.maxDate=void 0;else{const t=new Date(e.maxDate);this.maxYear=t.getFullYear(),this.maxMonth=t.getMonth(),this.maxDate=c(this.maxYear,this.maxMonth+1,0)}e.checkDisabled&&(this.checkDisabled=this.isMinView||null===e.datesDisabled?e.checkDisabled:()=>!1),"beforeShowMonth"in e&&(this.beforeShow="function"==typeof e.beforeShowMonth?e.beforeShowMonth:void 0)}updateFocus(){const e=new Date(this.picker.viewDate);this.year=e.getFullYear(),this.focused=e.getMonth()}updateSelection(){const{dates:e,rangepicker:i}=this.picker.datepicker;this.selected=e.reduce(((e,i)=>{const s=new Date(i),n=s.getFullYear(),a=s.getMonth();return void 0===e[n]?e[n]=[a]:t(e[n],a),e}),{}),i&&i.dates&&(this.range=i.dates.map((e=>{const t=new Date(e);return isNaN(t)?void 0:[t.getFullYear(),t.getMonth()]})))}render(){this.prepareForRender(this.year,this.year<=this.minYear,this.year>=this.maxYear);const e=this.selected[this.year]||[],t=this.year<this.minYear||this.year>this.maxYear,i=this.year===this.minYear,s=this.year===this.maxYear,n=he(this.range,this.year);Array.from(this.grid.children).forEach(((a,r)=>{const o=b(new Date(this.year,r,1),1,this.isRangeEnd);this.renderCell(a,this.monthNames[r],r,o,{selected:e,range:n},t||i&&r<this.minMonth||s&&r>this.maxMonth)}))}refresh(){const e=this.selected[this.year]||[],t=he(this.range,this.year)||[];Array.from(this.grid.children).forEach(((i,s)=>{this.refreshCell(i,s,e,t)}))}refreshFocus(){this.changeFocusedCell(this.focused)}}class fe extends ce{constructor(e,t){super(e,t)}init(e,t=!0){var i;t&&(this.navStep=10*this.step,this.beforeShowOption=`beforeShow${i=this.cellClass,[...i].reduce(((e,t,i)=>e+(i?t:t.toUpperCase())),"")}`,this.grid=this.element,this.element.classList.add(this.name,"datepicker-grid"),this.grid.appendChild(A(a("span",12)))),super.init(e)}setOptions(e){if("minDate"in e&&(void 0===e.minDate?this.minYear=this.minDate=void 0:(this.minYear=k(e.minDate,this.step),this.minDate=c(this.minYear,0,1))),"maxDate"in e&&(void 0===e.maxDate?this.maxYear=this.maxDate=void 0:(this.maxYear=k(e.maxDate,this.step),this.maxDate=c(this.maxYear,11,31))),e.checkDisabled&&(this.checkDisabled=this.isMinView||null===e.datesDisabled?e.checkDisabled:()=>!1),this.beforeShowOption in e){const t=e[this.beforeShowOption];this.beforeShow="function"==typeof t?t:void 0}}updateFocus(){const e=new Date(this.picker.viewDate),t=k(e,this.navStep),i=t+9*this.step;this.first=t,this.last=i,this.start=t-this.step,this.focused=k(e,this.step)}updateSelection(){const{dates:e,rangepicker:i}=this.picker.datepicker;this.selected=e.reduce(((e,i)=>t(e,k(i,this.step))),[]),i&&i.dates&&(this.range=i.dates.map((e=>{if(void 0!==e)return k(e,this.step)})))}render(){this.prepareForRender(`${this.first}-${this.last}`,this.first<=this.minYear,this.last>=this.maxYear),Array.from(this.grid.children).forEach(((e,t)=>{const i=this.start+t*this.step,s=b(new Date(i,0,1),2,this.isRangeEnd);e.dataset.year=i,this.renderCell(e,i,i,s,this,i<this.minYear||i>this.maxYear)}))}refresh(){const e=this.range||[];Array.from(this.grid.children).forEach((t=>{this.refreshCell(t,Number(t.textContent),this.selected,e)}))}refreshFocus(){this.changeFocusedCell(Math.round((this.focused-this.start)/this.step))}}function pe(e,t){const i={bubbles:!0,cancelable:!0,detail:{date:e.getDate(),viewDate:new Date(e.picker.viewDate),viewId:e.picker.currentView.id,datepicker:e}};e.element.dispatchEvent(new CustomEvent(t,i))}function me(e,t){const{config:i,picker:s}=e,{currentView:a,viewDate:r}=s;let o;switch(a.id){case 0:o=h(r,t);break;case 1:o=u(r,t);break;default:o=u(r,t*a.navStep)}o=n(o,i.minDate,i.maxDate),s.changeFocus(o).render()}function we(e){const t=e.picker.currentView.id;t!==e.config.maxView&&e.picker.changeView(t+1).render()}function ge(e){e.setDate({clear:!0})}function ye(e){const t=d();1===e.config.todayButtonMode?e.setDate(t,{forceRefresh:!0,viewDate:t}):e.setFocusedDate(t,!0)}function De(e){const t=()=>{e.config.updateOnBlur?e.update({revert:!0}):e.refresh("input"),e.hide()},i=e.element;Y(i)?i.addEventListener("blur",t,{once:!0}):t()}function ke(e,t){const i=e.picker,s=new Date(i.viewDate),n=i.currentView.id,a=1===n?h(s,t-s.getMonth()):u(s,t-s.getFullYear());i.changeFocus(a).changeView(n-1).render()}function be(e){we(e)}function ve(e){me(e,-1)}function xe(e){me(e,1)}function Me(e,t){const i=P(t,".datepicker-cell");if(!i||i.classList.contains("disabled"))return;const{id:s,isMinView:n}=e.picker.currentView,a=i.dataset;n?e.setDate(Number(a.date)):ke(e,Number(1===s?a.month:a.year))}function Oe(e){e.preventDefault()}const Se=["left","top","right","bottom"].reduce(((e,t)=>(e[t]=`datepicker-orient-${t}`,e)),{}),Ne=e=>e?`${e}px`:e;function Ce(e,t){if("title"in t&&(t.title?(e.controls.title.textContent=t.title,_(e.controls.title)):(e.controls.title.textContent="",W(e.controls.title))),t.prevArrow){const i=e.controls.prevButton;K(i),t.prevArrow.forEach((e=>{i.appendChild(e.cloneNode(!0))}))}if(t.nextArrow){const i=e.controls.nextButton;K(i),t.nextArrow.forEach((e=>{i.appendChild(e.cloneNode(!0))}))}if(t.locale&&(e.controls.todayButton.textContent=t.locale.today,e.controls.clearButton.textContent=t.locale.clear),"todayButton"in t&&(t.todayButton?_(e.controls.todayButton):W(e.controls.todayButton)),"minDate"in t||"maxDate"in t){const{minDate:t,maxDate:i}=e.datepicker.config;e.controls.todayButton.disabled=!s(d(),t,i)}"clearButton"in t&&(t.clearButton?_(e.controls.clearButton):W(e.controls.clearButton))}function Fe(t){const{dates:i,config:s,rangeSideIndex:a}=t;return n(i.length>0?e(i):b(s.defaultViewDate,s.pickLevel,a),s.minDate,s.maxDate)}function Ve(e,t){"_oldViewDate"in e||t===e.viewDate||(e._oldViewDate=e.viewDate),e.viewDate=t;const{id:i,year:s,first:n,last:a}=e.currentView,r=new Date(t).getFullYear();switch(i){case 0:return t<n||t>a;case 1:return r!==s;default:return r<n||r>a}}function Be(e){return window.getComputedStyle(e).direction}function Ee(e){const t=L(e);if(t!==document.body&&t)return"visible"!==window.getComputedStyle(t).overflow?t:Ee(t)}class Ae{constructor(e){const{config:t,inputField:i}=this.datepicker=e,s=re.replace(/%buttonClass%/g,t.buttonClass),n=this.element=A(s).firstChild,[a,r,o]=n.firstChild.children,d=a.firstElementChild,[c,l,h]=a.lastElementChild.children,[u,f]=o.firstChild.children,p={title:d,prevButton:c,viewSwitch:l,nextButton:h,todayButton:u,clearButton:f};this.main=r,this.controls=p;const m=i?"dropdown":"inline";n.classList.add(`datepicker-${m}`),Ce(this,t),this.viewDate=Fe(e),H(e,[[n,"mousedown",Oe],[r,"click",Me.bind(null,e)],[p.viewSwitch,"click",be.bind(null,e)],[p.prevButton,"click",ve.bind(null,e)],[p.nextButton,"click",xe.bind(null,e)],[p.todayButton,"click",ye.bind(null,e)],[p.clearButton,"click",ge.bind(null,e)]]),this.views=[new le(this),new ue(this),new fe(this,{id:2,name:"years",cellClass:"year",step:1}),new fe(this,{id:3,name:"decades",cellClass:"decade",step:10})],this.currentView=this.views[t.startView],this.currentView.render(),this.main.appendChild(this.currentView.element),t.container?t.container.appendChild(this.element):i.after(this.element)}setOptions(e){Ce(this,e),this.views.forEach((t=>{t.init(e,!1)})),this.currentView.render()}detach(){this.element.remove()}show(){if(this.active)return;const{datepicker:e,element:t}=this,i=e.inputField;if(i){const s=Be(i);s!==Be(L(t))?t.dir=s:t.dir&&t.removeAttribute("dir"),this.place(),t.classList.add("active"),e.config.disableTouchKeyboard&&i.blur()}else t.classList.add("active");this.active=!0,pe(e,"show")}hide(){this.active&&(this.datepicker.exitEditMode(),this.element.classList.remove("active"),this.active=!1,pe(this.datepicker,"hide"))}place(){const{classList:e,style:t}=this.element;t.display="block";const{width:i,height:s}=this.element.getBoundingClientRect(),n=this.element.offsetParent;t.display="";const{config:a,inputField:r}=this.datepicker,{left:o,top:d,right:c,bottom:l,width:h,height:u}=r.getBoundingClientRect();let{x:f,y:p}=a.orientation,m=o,w=d;if(n!==document.body&&n){const e=n.getBoundingClientRect();m-=e.left-n.scrollLeft,w-=e.top-n.scrollTop}else m+=window.scrollX,w+=window.scrollY;const g=Ee(r);let y=0,D=0,{clientWidth:k,clientHeight:b}=document.documentElement;if(g){const e=g.getBoundingClientRect();e.top>0&&(D=e.top),e.left>0&&(y=e.left),e.right<k&&(k=e.right),e.bottom<b&&(b=e.bottom)}let v=0;"auto"===f&&(o<y?(f="left",v=y-o):o+i>k?(f="right",k<c&&(v=k-c)):f="rtl"===Be(r)?c-i<y?"left":"right":"left"),"right"===f&&(m+=h-i),m+=v,"auto"===p&&(p=d-s>D&&l+s>b?"top":"bottom"),"top"===p?w-=s:w+=u,e.remove(...Object.values(Se)),e.add(Se[f],Se[p]),t.left=Ne(m),t.top=Ne(w)}setViewSwitchLabel(e){this.controls.viewSwitch.textContent=e}setPrevButtonDisabled(e){this.controls.prevButton.disabled=e}setNextButtonDisabled(e){this.controls.nextButton.disabled=e}changeView(e){const t=this.currentView;return e!==t.id&&(this._oldView||(this._oldView=t),this.currentView=this.views[e],this._renderMethod="render"),this}changeFocus(e){return this._renderMethod=Ve(this,e)?"render":"refreshFocus",this.views.forEach((e=>{e.updateFocus()})),this}update(e=void 0){const t=void 0===e?Fe(this.datepicker):e;return this._renderMethod=Ve(this,t)?"render":"refresh",this.views.forEach((e=>{e.updateFocus(),e.updateSelection()})),this}render(e=!0){const{currentView:t,datepicker:i,_oldView:s}=this,n=new Date(this._oldViewDate),a=e&&this._renderMethod||"render";if(delete this._oldView,delete this._oldViewDate,delete this._renderMethod,t[a](),s&&(this.main.replaceChild(t.element,s.element),pe(i,"changeView")),!isNaN(n)){const e=new Date(this.viewDate);e.getFullYear()!==n.getFullYear()&&pe(i,"changeYear"),e.getMonth()!==n.getMonth()&&pe(i,"changeMonth")}}}function Le(e,t,i,n,a,r){if(s(e,a,r)){if(n(e)){return Le(t(e,i),t,i,n,a,r)}return e}}function Ye(e,t,i){const s=e.picker,n=s.currentView,a=n.step||1;let r,o=s.viewDate;switch(n.id){case 0:o=l(o,i?7*t:t),r=l;break;case 1:o=h(o,i?4*t:t),r=h;break;default:o=u(o,t*(i?4:1)*a),r=u}o=Le(o,r,t<0?-a:a,(e=>n.disabled.includes(e)),n.minDate,n.maxDate),void 0!==o&&s.changeFocus(o).render()}function We(e,t){const{config:i,picker:s,editMode:n}=e,a=s.active,{key:r,altKey:o,shiftKey:d}=t,c=t.ctrlKey||t.metaKey,l=()=>{t.preventDefault(),t.stopPropagation()};if("Tab"===r)return void De(e);if("Enter"===r){if(a)if(n)e.exitEditMode({update:!0,autohide:i.autohide});else{const t=s.currentView;t.isMinView?e.setDate(s.viewDate):(s.changeView(t.id-1).render(),l())}else e.update();return}const h=i.shortcutKeys,u={key:r,ctrlOrMetaKey:c,altKey:o,shiftKey:d},f=Object.keys(h).find((e=>{const t=h[e];return!Object.keys(t).find((e=>t[e]!==u[e]))}));if(f){let t;if("toggle"===f?t=f:n?"exitEditMode"===f&&(t=f):a?"hide"===f?t=f:"prevButton"===f?t=[me,[e,-1]]:"nextButton"===f?t=[me,[e,1]]:"viewSwitch"===f?t=[we,[e]]:i.clearButton&&"clearButton"===f?t=[ge,[e]]:i.todayButton&&"todayButton"===f&&(t=[ye,[e]]):"show"===f&&(t=f),t)return Array.isArray(t)?t[0].apply(null,t[1]):e[t](),void l()}if(!a||n)return;const p=(i,s)=>{d||c||o?e.enterEditMode():(Ye(e,i,s),t.preventDefault())};"ArrowLeft"===r?p(-1,!1):"ArrowRight"===r?p(1,!1):"ArrowUp"===r?p(-1,!0):"ArrowDown"===r?p(1,!0):("Backspace"===r||"Delete"===r||r&&1===r.length&&!c)&&e.enterEditMode()}function _e(e){e.config.showOnFocus&&!e._showing&&e.show()}function Ke(e,t){const i=t.target;(e.picker.active||e.config.showOnClick)&&(i._active=Y(i),i._clicking=setTimeout((()=>{delete i._active,delete i._clicking}),2e3))}function Re(e,t){const i=t.target;i._clicking&&(clearTimeout(i._clicking),delete i._clicking,i._active&&e.enterEditMode(),delete i._active,e.config.showOnClick&&e.show())}function je(e,t){t.clipboardData.types.includes("text/plain")&&e.enterEditMode()}function Te(e,t){const{element:i,picker:s}=e;if(!s.active&&!Y(i))return;const n=s.element;P(t,(e=>e===i||e===n))||De(e)}function He(e,t){return e.map((e=>B(e,t.format,t.locale))).join(t.dateDelimiter)}function $e(e,t,i=!1){if(0===t.length)return i?[]:void 0;const{config:n,dates:a,rangeSideIndex:r}=e,{pickLevel:o,maxNumberOfDates:d}=n;let c=t.reduce(((e,t)=>{let i=V(t,n.format,n.locale);return void 0===i||(i=b(i,o,r),!s(i,n.minDate,n.maxDate)||e.includes(i)||n.checkDisabled(i,o)||!(o>0)&&n.daysOfWeekDisabled.includes(new Date(i).getDay())||e.push(i)),e}),[]);return 0!==c.length?(n.multidate&&!i&&(c=c.reduce(((e,t)=>(a.includes(t)||e.push(t),e)),a.filter((e=>!c.includes(e))))),d&&c.length>d?c.slice(-1*d):c):void 0}function Ie(e,t=3,i=!0,s=void 0){const{config:n,picker:a,inputField:r}=e;if(2&t){const e=a.active?n.pickLevel:n.startView;a.update(s).changeView(e).render(i)}1&t&&r&&(r.value=He(e.dates,n))}function Pe(e,t,i){const s=e.config;let{clear:n,render:a,autohide:r,revert:o,forceRefresh:d,viewDate:c}=i;void 0===a&&(a=!0),a?void 0===r&&(r=s.autohide):r=d=!1,c=V(c,s.format,s.locale);const l=$e(e,t,n);(l||o)&&(l&&l.toString()!==e.dates.toString()?(e.dates=l,Ie(e,a?3:1,!0,c),pe(e,"changeDate")):Ie(e,d?3:1,!0,c),r&&e.hide())}function Je(e,t){return t?i=>B(i,t,e.config.locale):e=>new Date(e)}class Ue{constructor(e,t={},s=void 0){e.datepicker=this,this.element=e,this.dates=[];const n=this.config=Object.assign({buttonClass:t.buttonClass&&String(t.buttonClass)||"button",container:null,defaultViewDate:d(),maxDate:void 0,minDate:void 0},se(U,this));let a;if("INPUT"===e.tagName?(a=this.inputField=e,a.classList.add("datepicker-input"),t.container&&(n.container=t.container instanceof HTMLElement?t.container:document.querySelector(t.container))):n.container=e,s){const e=s.inputs.indexOf(a),t=s.datepickers;if(e<0||e>1||!Array.isArray(t))throw Error("Invalid rangepicker object.");t[e]=this,this.rangepicker=s,this.rangeSideIndex=e}this._options=t,Object.assign(n,se(t,this)),n.shortcutKeys=function(e){return Object.keys(ne).reduce(((t,i)=>{const s=void 0===e[i]?ne[i]:e[i],n=s&&s.key;if(!n||"string"!=typeof n)return t;const a={key:n,ctrlOrMetaKey:!!(s.ctrlOrMetaKey||s.ctrlKey||s.metaKey)};return n.length>1&&(a.altKey=!!s.altKey,a.shiftKey=!!s.shiftKey),t[i]=a,t}),{})}(t.shortcutKeys||{});const r=i(e.value||e.dataset.date,n.dateDelimiter);delete e.dataset.date;const o=$e(this,r);o&&o.length>0&&(this.dates=o),a&&(a.value=He(this.dates,n));const c=this.picker=new Ae(this),l=[e,"keydown",We.bind(null,this)];a?H(this,[l,[a,"focus",_e.bind(null,this)],[a,"mousedown",Ke.bind(null,this)],[a,"click",Re.bind(null,this)],[a,"paste",je.bind(null,this)],[document,"mousedown",Te.bind(null,this)],[window,"resize",c.place.bind(c)]]):(H(this,[l]),this.show())}static formatDate(e,t,i){return B(e,t,i&&J[i]||J.en)}static parseDate(e,t,i){return V(e,t,i&&J[i]||J.en)}static get locales(){return J}get active(){return!(!this.picker||!this.picker.active)}get pickerElement(){return this.picker?this.picker.element:void 0}setOptions(e){const t=se(e,this);Object.assign(this._options,e),Object.assign(this.config,t),this.picker.setOptions(t),Ie(this,3)}show(){if(this.inputField){const{config:e,inputField:t}=this;if(t.disabled||t.readOnly&&!e.enableOnReadonly)return;Y(t)||e.disableTouchKeyboard||(this._showing=!0,t.focus(),delete this._showing)}this.picker.show()}hide(){this.inputField&&(this.picker.hide(),this.picker.update().changeView(this.config.startView).render())}toggle(){this.picker.active?this.inputField&&this.picker.hide():this.show()}destroy(){this.hide(),$(this),this.picker.detach();const e=this.element;return e.classList.remove("datepicker-input"),delete e.datepicker,this}getDate(e=void 0){const t=Je(this,e);return this.config.multidate?this.dates.map(t):this.dates.length>0?t(this.dates[0]):void 0}setDate(...t){const i=[...t],s={},n=e(t);!n||"object"!=typeof n||Array.isArray(n)||n instanceof Date||Object.assign(s,i.pop());Pe(this,Array.isArray(i[0])?i[0]:i,s)}update(e=void 0){if(!this.inputField)return;const t=Object.assign(e||{},{clear:!0,render:!0,viewDate:void 0});Pe(this,i(this.inputField.value,this.config.dateDelimiter),t)}getFocusedDate(e=void 0){return Je(this,e)(this.picker.viewDate)}setFocusedDate(e,t=!1){const{config:i,picker:s,active:n,rangeSideIndex:a}=this,r=i.pickLevel,o=V(e,i.format,i.locale);void 0!==o&&(s.changeFocus(b(o,r,a)),n&&t&&s.changeView(r),s.render())}refresh(e=void 0,t=!1){let i;e&&"string"!=typeof e&&(t=e,e=void 0),i="picker"===e?2:"input"===e?1:3,Ie(this,i,!t)}enterEditMode(){const e=this.inputField;e&&!e.readOnly&&this.picker.active&&!this.editMode&&(this.editMode=!0,e.classList.add("in-edit"))}exitEditMode(e=void 0){if(!this.inputField||!this.editMode)return;const t=Object.assign({update:!1},e);delete this.editMode,this.inputField.classList.remove("in-edit"),t.update&&this.update(t)}}function qe(e){const t=Object.assign({},e);return delete t.inputs,delete t.allowOneSidedRange,delete t.maxNumberOfDates,t}function ze(e,t){if(e._updating)return;e._updating=!0;const i=t.target;if(void 0===i.datepicker)return;const s=e.datepickers,[n,a]=s,r={render:!1},o=e.inputs.indexOf(i),d=0===o?1:0,c=s[o].dates[0],l=s[d].dates[0];void 0!==c&&void 0!==l?0===o&&c>l?(n.setDate(l,r),a.setDate(c,r)):1===o&&c<l&&(n.setDate(c,r),a.setDate(l,r)):e.allowOneSidedRange||void 0===c&&void 0===l||(r.clear=!0,s[d].setDate(s[o].dates,r)),s.forEach((e=>{e.picker.update().render()})),delete e._updating}window.Datepicker=Ue,window.DateRangePicker=class{constructor(e,t={}){let i=Array.isArray(t.inputs)?t.inputs:Array.from(e.querySelectorAll("input"));if(i.length<2)return;e.rangepicker=this,this.element=e,this.inputs=i=i.slice(0,2),Object.freeze(i),this.allowOneSidedRange=!!t.allowOneSidedRange;const s=ze.bind(null,this),n=qe(t),a=this.datepickers=[];i.forEach((e=>{!function(e,t,i,s){H(e,[[i,"changeDate",t]]),new Ue(i,s,e)}(this,s,e,n)})),Object.freeze(a),Object.defineProperty(this,"dates",{get:()=>a.map((e=>e.dates[0]))}),a[0].dates.length>0?ze(this,{target:i[0]}):a[1].dates.length>0&&ze(this,{target:i[1]})}setOptions(e){this.allowOneSidedRange=!!e.allowOneSidedRange;const t=qe(e);this.datepickers.forEach((e=>{e.setOptions(t)}))}destroy(){this.datepickers.forEach((e=>{e.destroy()})),$(this),delete this.element.rangepicker}getDates(e=void 0){const t=e?t=>B(t,e,this.datepickers[0].config.locale):e=>new Date(e);return this.dates.map((e=>void 0===e?e:t(e)))}setDates(e,t){const{datepickers:[i,s],inputs:[n,a],dates:[r,o]}=this;this._updating=!0,i.setDate(e),s.setDate(t),delete this._updating,s.dates[0]!==o?ze(this,{target:a}):i.dates[0]!==r&&ze(this,{target:n})}}}();
/**
 * French translation for bootstrap-datepicker
 * Nico Mollet <nico.mollet@gmail.com>
 */
(function () {
  Datepicker.locales.fr = {
    days: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
    daysShort: ["Dim.", "Lun.", "Mar.", "Mer.", "Jeu.", "Ven.", "Sam."],
    daysMin: ["DIM", "LUN", "MAR", "MER", "JEU", "VEN", "SAM"],
    months: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
    monthsShort: ["Janv.", "Févr.", "Mars", "Avril", "Mai", "Juin", "Juil.", "Août", "Sept.", "Oct.", "Nov.", "Déc."],
    today: "Aujourd'hui",
    monthsTitle: "Mois",
    clear: "Effacer",
    weekStart: 1,
    format: "dd/mm/yyyy"
  };
}());

/**
 * German translation for bootstrap-datepicker
 * Sam Zurcher <sam@orelias.ch>
 */
(function () {
  Datepicker.locales.de = {
    days: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
    daysShort: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
    daysMin: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
    months: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
    monthsShort: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
    today: "Heute",
    monthsTitle: "Monate",
    clear: "Löschen",
    weekStart: 1,
    format: "dd.mm.yyyy"
  };
}());

/**
 * Spanish translation for bootstrap-datepicker
 * Bruno Bonamin <bruno.bonamin@gmail.com>
 */
(function () {
  Datepicker.locales.es = {
    days: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
    daysShort: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
    daysMin: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"],
    months: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
    monthsShort: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
    today: "Hoy",
    monthsTitle: "Meses",
    clear: "Borrar",
    weekStart: 1,
    format: "dd/mm/yyyy"
  };
}());

/**
 * Italian translation for bootstrap-datepicker
 * Enrico Rubboli <rubboli@gmail.com>
 */
(function () {
  Datepicker.locales.it = {
    days: ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"],
    daysShort: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
    daysMin: ["Do", "Lu", "Ma", "Me", "Gi", "Ve", "Sa"],
    months: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
    monthsShort: ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"],
    today: "Oggi",
    monthsTitle: "Mesi",
    clear: "Cancella",
    weekStart: 1,
    format: "dd/mm/yyyy"
  };
}());
fx.ns("fx", class Main extends fx.EventDispatcher {
    
    constructor()
    {
        super();

        this._currentPopup = null;
        this._steps = null;
        this._popups = []
        
        this.router = new fx.Router();

        this.on("beforeunload", this.onLeave, window);
        this.on("online", this.onLine, window);
        this.on("offline", this.onOffline, window);
    }

    onReady()
    {
        this.router.init(this.views, this.switchEffectIn, this.switchEffectOut, this.model);

        if (!this.model)
            this.model = new fx.Model({});

        if (this.backgroundClass)
        {
            this._backgroundInstance = new this.backgroundClass();
            this._backgroundInstance.data = this.model;
            this._backgroundInstance.viewport("fullscreen");
            this._backgroundInstance.init();
            this.on("view-changed", this._onViewChanged, this.router);
        }
        
        this.model.event( "start" );
    }

    ajaxGlobalParameter(name, key)
    {
        let param = fx.dom.find('meta[name="' + name + '"]');
		if (param)
			fx.set("global-request-header", {key : key, value : param.getAttribute('content')});
    }

    _onViewChanged(event)
    {
        if(this._backgroundInstance && typeof this._backgroundInstance.onViewChanged == "function")
            this._backgroundInstance.onViewChanged(event.detail)

        let nextView = this.router.getView(event.detail);
        if (nextView && nextView.instance)
            this.on("view-scrolled", this._onViewScrolled, nextView.instance);
    }

    _onViewScrolled(event)
    {
        if(this._backgroundInstance && typeof this._backgroundInstance.onViewScrolled == "function")
            this._backgroundInstance.onViewScrolled(event.detail)
    }

    switchTo(view, data)
    {
       
        if (this._steps)
            this._steps = null;

        this._switchTo(view, data);
    }

    _switchTo(viewName, data, noHistory, direction)
    {
        if (this.router.currentView && this.router.currentView.instance)
            this.off("view-scrolled", this._onViewScrolled, this.router.currentView.instance);

        this.router.switchTo(viewName, data , noHistory, direction);
    }

    setView(view)
    {
        this.views.push(view);
        this.router.setView(view);
    }

    get currentViewComponent()
    {
        return this.router && this.router.currentView ? this.router.currentView.instance : null;
    }

    get currentView()
    {
        return this.router && this.router.currentView ? this.router.currentView.name : "";
    }

    get previousView()
	{
		return this.router ? this.router.previousView : "";
	}


    remove(view)
    {
        this.router.remove(view);
    }

    back()
    {
        this.router.back();
    }

    lock()
    {
        this.router.lock();
    }

    navigateToURL(url, newWindow)
    {
        this.router.navigateToURL(url, newWindow);
    }

    navigateBack()
    {
        this.off("beforeunload", this.onLeave, window);

        let currentAdress = window.location.toString().split('#')[0];   

        window.history.back();

        // in order to navigate until new adress
        let nextAdress = window.location.toString().split('#')[0];

        //if (nextAdress == currentAdress)
        //    this.delay(this.navigateBack, 250);
        
    }

    reloadPage()
    {
        window.location.reload();
    }

    get hasPopup()
    {
        return !!this._currentPopup;
    }

    get currentPopup()
    {
        return this._currentPopup;
    }

    popup(popup)
    {
        if (this._currentPopup)
        {
            if (!popup)
                this._currentPopup.close();
            else
                this._popups.push(this._currentPopup);
        }
            

        this._currentPopup = popup;
    
        if (this._currentPopup)
        {
            this._currentPopup.viewport("fullscreen");
            this._currentPopup.init();
            
            this._currentPopup.show(true);

            this.on("closed", this.onPopupClosed, this._currentPopup);
        }
    }

    onPopupClosed()
    {
        this._currentPopup = this._popups.pop();
    }
   
    
    /****************************** EVENTS TO OVERRIDE **************************/
    /**
     * This function is called everytime an update is done on model.
     * @param {fx.Action} action action object will all details about update.
     */
    onDataUpdated(action)
    {

    }

    /**
     * This function is called everytime an event is sent somewhere in model.
     * @param {fx.Event} e event
     */
    onDataEvent(e)
    {
        
    }
    

    onLeave(e)
    {
        if (e.cancel)
        {
            if(!e) e = window.event;

            e.cancelBubble = true;
            e.returnValue = fx.text("Votre album n'a pas été sauvegardé. Etes-vous sûre de vouloir quitter cette page ?"); //This is displayed on the dialog
            
            if (e.stopPropagation) e.stopPropagation();
            if (e.preventDefault) e.preventDefault();

            return e.returnValue = fx.text("ATTENTION : en quittant sans sauvegarder vous risquez de perdre un partie de votre travail. Veuillez utiliser le bouton QUITTER pour quitter en sauvegardant votre travail.");
        }
    }

    onLine()
    {
        if (this.model)
            this.model.event("online");
    }

    onOffline()
    {
        if (this.model)
            this.model.event("offline");
    }

    get model()
    {
        return this._model;
    }

    set model(val)
    {
        if (!val)
            fx.throwError("Model cannot be null or undefined");
        else
        if (this._model)
            fx.throwError("Model already set on Main application");
        else
        {
            this._model = val;
            this.on("event", this._onDataEvent, this._model);
            this.on("updated", this._onDataUpdated, this._model);
        }
    }

    get views()
    {
        return this._views;
    }

    set views(val)
    {
        if ( val instanceof Array)
            this._views = val;   
        else
            fx.throwError("views parameter must be an array of String");
        
    }


    get switchEffect()
    {
        return this._switchEffect;
    }

    set switchEffect(val)
    {
        this._switchEffect = val;
    }

    get switchEffectIn()
    {
        return this._switchEffectIn || this._switchEffect;
    }

    set switchEffectIn(val)
    {
        this._switchEffectIn = val;
    }

    get switchEffectOut()
    {
        return this._switchEffectOut || this._switchEffect;
    }

    set switchEffectOut(val)
    {
        this._switchEffectOut = val;
    }

    // Creates steps with list of views. Navigation is available ony with "next-step" and "previous-step" events.
    // steps list is disabled as soon as router is switch directly to a view
    // views can be passed as an array, or list of view names
    // exemple :
    // this.steps("PhotoChoice", "Spash", "Editor");
    // this.steps(["PhotoChoice", "Spash", "Editor"]);
    steps()
    {
        let steps = arguments;
        if (arguments[0] instanceof Array)
            steps = arguments[0];

        this._steps = {startingView : this.currentView, views :[]};
        for(let i = 0; i < steps.length; i++)
        {
            if (!steps[i]) continue;

            let step = {view : steps[i].view || steps[i], skipPrevious : steps[i].skipPrevious, skipNext : steps[i].skipNext};
            
            if (typeof step.view == "string" && this.router.getView(step.view))
                this._steps.views.push(step);
            else
                fx.log.info(step.view + " not found");
        }

        if (this._steps.views.length > 0)
            this._switchTo(this._steps.views[0].view);
    }

    isInSteps()
    {
        return !!this._steps;
    }

    nextStep()
    {
        if (!this._steps)
            return;

        let view = this._steps.views.find({view : this.currentView });

        if (!view)
            return;
        else
        {
            let index = this._steps.views.indexOf(view);

            while (index < this._steps.views.length - 1 && this._steps.views[++index].skipNext);

            if (index <= this._steps.views.length - 1)
                this._switchTo(this._steps.views[index].view, null, null, "next");
        }
        
    }

    previousStep()
    {
        if (!this._steps)
        {
            this.model.event("back");
            return;
        }
            
        let view = this._steps.views.find({view : this.currentView });
        
        if (!view)
            return;
        else
        {
            let index = this._steps.views.indexOf(view);

            if (index <= 0) // we get out of steps
            {
                if (!this._steps.startingView)
                    this.navigateBack();
                else
                {
                    this._switchTo(this._steps.startingView, null, null, "previous");
                    this._steps = null;
                }
            }
            else
            {
                while(this._steps.views[--index] && this._steps.views[index].skipPrevious && index >= 0);
                
                if (index >= 0)
                    this._switchTo(this._steps.views[index].view, null, null, "previous");
                else
                {
                    if (!this._steps.startingView)
                        this.navigateBack();
                    else
                    {
                        this._switchTo(this._steps.startingView, null, null, "previous");
                        this._steps = null;
                    }
                }
            }
                
        }
        
    }

     /********************************** PRIVATE FUNCTIONS ************************/

    _onDataEvent(e)
    {
        let stepJumpPrefix = "step-";

        if (this._steps && e.detail.event.type.indexOf(stepJumpPrefix) == 0)
        {
            let viewName = e.detail.event.type.substring(stepJumpPrefix.length);
            let view = this._steps.views.find({view : viewName});
            if (view)
            {
                this._switchTo(view.view);
                return;
            }
        }

        this.onDataEvent(e.detail.event);
        
        switch(e.detail.event.type)
        {
            case "next-step" : 
                this.nextStep();
                break;

            case "previous-step" : 
                this.previousStep();
                break;

        }
    
    }

    _onDataUpdated(e)
    {
        if (e)
            this.onDataUpdated(e.action);
    }

});
(function(){
	/**
	 * Overrides of Array.prototype.find in order to search for one item from it's properties instead of using a function.
	 * Example :
	 * let array = [{id : 1, value : 55}, {id : 2, value : 55}, {id : 3, value : 84}];
	 * let elt = array.find({id : 2}); // return second element of array with property id equal to 2 : {id : 2, value : 55}
	 * let elt = array.find({value : 55});  // return only the first element of array with property value equal to 55 : {id : 1, value : 55}
	 * let elts = array.find({value : 55}, true);  // return an array containing all elements with property value equal to 55 : [{id : 1, value : 55}, {id : 2, value : 55}]
	 */
	let proxy = Array.prototype.find;
	Array.prototype.find = function()
	{
		if (typeof arguments[0] == "function")
			return proxy.apply(this, arguments);
		else
		{
			let data = arguments[0];
			let unique = (arguments[1] === undefined);
			let results = [];
			for (let i = 0; i < this.length; i++)
		    {
		    	let element = this[i];
		    	let all = true;
		    	for (let key in data)
		    		all = all && (element[key] == data[key]);
		    	
				if (all)
				{
					if (unique)
						return element;
					else
						results.push(element);
				}
		        	
			}
			
		    return unique ? null : results;
		}
	};

    Array.prototype.contains = function(item)
	{
		return this.indexOf(item) != -1;
	}

	Array.prototype.add = function(item, unique)
	{
		if (!unique || this.indexOf(item) == -1)
			this.push(item)
	}

	Array.prototype.getItemAt = function(i)
	{
		return this[i];
	};

	Array.prototype.removeAt = function(index)
	{
		if (index != -1)
			this.splice(index, 1);
	};

	// return array with all possible combinations of array elements
	Array.prototype.combinations = function()
	{
		return new Array(1 << this.length).fill().map(
			(e1, i) => this.filter((e2, j) => i & 1 << j))
							  .filter((a) => a.length > 0)
							  .sort( (a, b) => (a.length < b.length ? -1 : (a.length > b.length ? 1 : 0)));
	}

	if (!Array.prototype.last){
			Array.prototype.last = function(){
					return this[this.length - 1];
			};
	};

	Array.prototype.removeAll = function() {
		while(this.length > 0) {
			this.pop();
		}
	};

	Array.prototype.remove = function(field, value)
	{
		if (!value)
		{
			if (typeof field == "object")
			{
				let index = this.indexOf(field);
				if (index != -1)
					this.splice(index, 1);

				return (index != -1);
			}
			else
			{
				value = field;
				field = "id";

				let ret = this.splice(this.findIndex(function(item) {
					return item[field] === value;
				}), 1);

				return ret.length > 0;
			}
			
		}
		else
		{
			let index = 0;
			for (index = 0; index < this.length; index++)
			{
				if (this[index][field] == value)
					break;
			}

			if (index < this.length)
			{
				this.splice(index, 1);
				return true;
			}
			else
				return false;
		}
	};


	Array.prototype.move = function(old_index, new_index) 
	{
    	if (new_index >= this.length) {
        	let k = new_index - this.length + 1;
        	while (k--) {
            	this.push(undefined);
        	}
    	}
    	this.splice(new_index, 0, this.splice(old_index, 1)[0]);
	};


	Array.prototype.hasOnlyUnique = function()
	{
		// TODO : recode with .every(fnc)
		for (let i = 0; i < this.length; i++)
		{
			let item = this[i];
			let occurences = [];
			for (let j = 0; j < this.length; j++)
		    {
		    	let element = this[j];
		    	let all = true;
		    	for (let key in item)
		    		all = all && (element[key] == item[key]);
		    	
		        if (all)
					occurences.push( element );
		    }
			if (occurences.length > 1)
				return false;
		}
		return true;
	};


	Object.defineProperty(Array.prototype, 'unique', {
		enumerable: false,
		configurable: false,
		writable: false,
		value: function() {
			var a = this.concat();
			for(var i=0; i<a.length; ++i) {
				for(var j=i+1; j<a.length; ++j) {
					if(a[i] === a[j])
						a.splice(j--, 1);
				}
			}
	
			return a;
		}
	});

	if (!Array.prototype.includes) 
	{
		Object.defineProperty(Array.prototype, "includes", {
		  enumerable: false,
		  value: function(obj) {
			  var newArr = this.filter(function(el) {
				return el === obj;
			  });
			  return newArr.length > 0;
			}
		});
	}

	Array.prototype.flat||Object.defineProperty(Array.prototype,"flat",{configurable:!0,value:function r(){var t=isNaN(arguments[0])?1:Number(arguments[0]);return t?Array.prototype.reduce.call(this,function(a,e){return Array.isArray(e)?a.push.apply(a,r.call(e,t-1)):a.push(e),a},[]):Array.prototype.slice.call(this)},writable:!0}),Array.prototype.flatMap||Object.defineProperty(Array.prototype,"flatMap",{configurable:!0,value:function(r){return Array.prototype.map.apply(this,arguments).flat()},writable:!0});

	/************ Compare 2 arrays */

	
	if(Array.prototype.equals)
		console.warn("Overriding existing Array.prototype.equals. Possible causes: New API defines the method, there's a framework conflict or you've got double inclusions in your code.");
	// attach the .equals method to Array's prototype to call it on any array
	Array.prototype.equals = function (array) {
	// if the other array is a falsy value, return
	if (!array)
		return false;

	// compare lengths - can save a lot of time 
	if (this.length != array.length)
		return false;

	for (let i = 0, l=this.length; i < l; i++) {
		// Check if we have nested arrays
		if (this[i] instanceof Array && array[i] instanceof Array) {
			// recurse into the nested arrays
			if (!equals(this[i], array[i]))
				return false;
		}
		/**REQUIRES OBJECT COMPARE**/
		else if (this[i] instanceof Object && array[i] instanceof Object) {
			// recurse into another objects
			if (!equals(this[i], array[i]))
				return false;
			}
		else if (this[i] != array[i]) {
			// Warning - two different object instances will never be equal: {x:20} != {x:20}
			return false;   
		}           
	}       
	return true;
	}
	// Hide method from for-in loops
	Object.defineProperty(Array.prototype, "equals", {enumerable: false});


	function equals(object1, object2)
	{
		//For the first loop, we only check for types
		for (propName in object1) {
			//Check for inherited methods and properties - like .equals itself
			//https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/hasOwnProperty
			//Return false if the return value is different
			if (object1.hasOwnProperty(propName) != object2.hasOwnProperty(propName)) {
				return false;
			}
			//Check instance type
			else if (typeof object1[propName] != typeof object2[propName]) {
				//Different types => not equal
				return false;
			}
		}
		//Now a deeper check using other objects property names
		for(propName in object2) {
			//We must check instances anyway, there may be a property that only exists in object2
				//I wonder, if remembering the checked values from the first loop would be faster or not 
			if (object1.hasOwnProperty(propName) != object2.hasOwnProperty(propName)) {
				return false;
			}
			else if (typeof object1[propName] != typeof object2[propName]) {
				return false;
			}
			//If the property is inherited, do not check any more (it must be equa if both objects inherit it)
			if(!object1.hasOwnProperty(propName))
			  continue;
	
			//Now the detail check and recursion
	
			//This returns the script back to the array comparing
			/**REQUIRES Array.equals**/
			if (object1[propName] instanceof Array && object2[propName] instanceof Array) {
					   // recurse into the nested arrays
			   if (equals(!object1[propName], (object2[propName])))
							return false;
			}
			else if (object1[propName] instanceof Object && object2[propName] instanceof Object) {
					   // recurse into another objects
			   if (equals(!object1[propName], (object2[propName])))
							return false;
			}
			//Normal value comparison for strings and numbers
			else if(object1[propName] != object2[propName]) {
			   return false;
			}
		}
		//If everything passed, let's say YES
		return true;
	}


    Array.prototype.difference = function(arr, compareKey = null) 
    {
        if (!Array.isArray(arr)) {
            throw new Error('Both inputs must be arrays');
        }
    
        if (compareKey) {
            // Compare using specific key
            return this.filter(item1 => 
                !arr.some(item2 => item1[compareKey] === item2[compareKey])
            );
        } else {
            // Compare using deep equality
            return this.filter(item1 => 
                !arr.some(item2 => 
                    JSON.stringify(item1) === JSON.stringify(item2)
                )
            );
        }
    }
	
})();
fx.ns("fx.extends", class BlobLoader {

    constructor()
    {
        this._loadcallback;
        this._loadurl;
        this._xmlHTTP;
        this._completedPercentage;
        this._events = new fx.EventDispatcher(),
        this._onXMLHttpLoadedHandler = this._onXMLHttpLoaded.bind(this);
        this._onXMLHttpProgressHandler = this._onXMLHttpProgress.bind(this);
        this._onXMLHttpLoadStartHandler = this._onXMLHttpLoadStart.bind(this);
        this._onXMLHttpLoadEndHandler = this._onXMLHttpLoadEnd.bind(this);
        this._onXMLHttpErrorHandler = this._onXMLHttpError.bind(this);
        this._onReadyStateChangeHandler = this._onReadyStateChange.bind(this);
    }
   
    // -- PUBLIC FUNCTIONS


    get blob()
    {
        return this._blob;
    }

    on(event, callback)
    {
        this._events.on(event, callback);
    }

    off(event, callback)
    {
        this._events.off(event, callback);
    }


    load( url, callback) 
    {
        this.src = url;

        this._loadcallback = callback;
        this._loadurl = url;
    
        this._xmlHTTP = new XMLHttpRequest();
        this._xmlHTTP.onload = this._onXMLHttpLoadedHandler;
        this._xmlHTTP.onprogress = this._onXMLHttpProgressHandler;
        this._xmlHTTP.onloadstart = this._onXMLHttpLoadStartHandler;
        this._xmlHTTP.onloadend = this._onXMLHttpLoadEndHandler;
        this._xmlHTTP.onerror = this._onXMLHttpErrorHandler;
        this._xmlHTTP.onreadystatechange = this._onReadyStateChangeHandler;

        this._completedPercentage = 0;

        try
        {
            this._xmlHTTP.open('GET', this._loadurl, true);
            this._xmlHTTP.responseType = 'arraybuffer';
            this._xmlHTTP.send();
        }
        catch(e)
        {
            this._events.trigger(Image.ERROR);
            this._xmlHTTP = null;
        }

        return this._xmlHTTP;
    }

    destroy()
    {
        this.stop();
        if (this._blob)
            (window.URL || window.webkitURL).revokeObjectURL( this._blob );
        this._blob = null;
    }

    stop()
    {
        if (this._xmlHTTP)
        {
            this._xmlHTTP.onload = null;
            this._xmlHTTP.onprogress = null;
            this._xmlHTTP.onloadstart = null;
            this._xmlHTTP.onloadend = null;
            this._xmlHTTP.onerror = null;
            this._xmlHTTP.onreadystatechange = null;
            this._xmlHTTP.abort();

            this._clean();
        }
            
    }


    // --- PRIVATES FUNCTIONS

    _clean()
    {
        this._loadcallback = null;
        this._loadurl = null;
        this._xmlHTTP = null;
    }

    _onXMLHttpLoaded( e ) 
    {
        if (!this._xmlHTTP) 
            return;

        let h = this._xmlHTTP.getAllResponseHeaders(),
            m = h.match( /^Content-Type\:\s*(.*?)$/mi),
            mimeType;

        if (m && m[ 1 ])
            mimeType = m[ 1 ];
        else
            mimeType = 'image/jpg';
        
        try
        {
            let blob = new Blob( [ this._xmlHTTP.response ], { type: mimeType } );
            
            this._blob = (window.URL || window.webkitURL).createObjectURL( blob );

            if ( this._loadcallback ) this._loadcallback();

            this._events.trigger(Image.LOADED);

        }
        catch(e) // Unsufficient memory
        {
            this._events.trigger(Image.MEMORY_PROBLEM);
        }

        this._clean();
    };

    _onXMLHttpProgress( e ) 
    {
        if ( e.lengthComputable ) 
        {
            let actualProgress = parseInt(( e.loaded / e.total ) * 100);
            if (actualProgress != this._completedPercentage) 
            {
                this._completedPercentage = actualProgress;
                this._events.trigger({type:Image.PROGRESS, data :{loaded : e.loaded, total : e.total, percentage : this._completedPercentage} });
            }
        }
    };

    _onXMLHttpLoadStart() 
    {
        this._completedPercentage = 0;
        this._events.trigger(Image.LOAD_START);
    }

    _onXMLHttpLoadEnd() 
    {
        this._completedPercentage = 100;
        this._events.trigger(Image.LOAD_END);
    
    };

    _onXMLHttpError()
    {
        this._events.trigger(Image.ERROR);
        
        this._clean();
    }

    _onReadyStateChange(oEvent) 
    {
        if (this._xmlHTTP.readyState === 4) 
        {
            if (this._xmlHTTP.status === 404 || this._xmlHTTP.status === 500) 
            {
                this._events.trigger({type : Image.ERROR, data : this._loadurl});
                this._clean();
            }
        }
    }

   
});

(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define([], function() {factory(root);});
    } else factory(root);
// node.js has always supported base64 conversions, while browsers that support
// web workers support base64 too, but you may never know.
})(typeof exports !== "undefined" ? exports : this, function(root) {
    if (root.atob) {
        // Some browsers' implementation of atob doesn't support whitespaces
        // in the encoded string (notably, IE). This wraps the native atob
        // in a function that strips the whitespaces.
        // The original function can be retrieved in atob.original
        try {
            root.atob(" ");
        } catch(e) {
            root.atob = (function(atob) {
                var func = function(string) {
                    return atob(String(string).replace(/[\t\n\f\r ]+/g, ""));
                };
                func.original = atob;
                return func;
            })(root.atob);
        }
        return;
    }

        // base64 character set, plus padding character (=)
    var b64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
        // Regular expression to check formal correctness of base64 encoded strings
        b64re = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/;

    root.btoa = function(string) {
        string = String(string);
        var bitmap, a, b, c,
            result = "", i = 0,
            rest = string.length % 3; // To determine the final padding

        for (; i < string.length;) {
            if ((a = string.charCodeAt(i++)) > 255
                    || (b = string.charCodeAt(i++)) > 255
                    || (c = string.charCodeAt(i++)) > 255)
                throw new TypeError("Failed to execute 'btoa' on 'Window': The string to be encoded contains characters outside of the Latin1 range.");

            bitmap = (a << 16) | (b << 8) | c;
            result += b64.charAt(bitmap >> 18 & 63) + b64.charAt(bitmap >> 12 & 63)
                    + b64.charAt(bitmap >> 6 & 63) + b64.charAt(bitmap & 63);
        }

        // If there's need of padding, replace the last 'A's with equal signs
        return rest ? result.slice(0, rest - 3) + "===".substring(rest) : result;
    };

    root.atob = function(string) {
        // atob can work with strings with whitespaces, even inside the encoded part,
        // but only \t, \n, \f, \r and ' ', which can be stripped.
        string = String(string).replace(/[\t\n\f\r ]+/g, "");
        if (!b64re.test(string))
            throw new TypeError("Failed to execute 'atob' on 'Window': The string to be decoded is not correctly encoded.");

        // Adding the padding if missing, for semplicity
        string += "==".slice(2 - (string.length & 3));
        var bitmap, result = "", r1, r2, i = 0;
        for (; i < string.length;) {
            bitmap = b64.indexOf(string.charAt(i++)) << 18 | b64.indexOf(string.charAt(i++)) << 12
                    | (r1 = b64.indexOf(string.charAt(i++))) << 6 | (r2 = b64.indexOf(string.charAt(i++)));

            result += r1 === 64 ? String.fromCharCode(bitmap >> 16 & 255)
                    : r2 === 64 ? String.fromCharCode(bitmap >> 16 & 255, bitmap >> 8 & 255)
                    : String.fromCharCode(bitmap >> 16 & 255, bitmap >> 8 & 255, bitmap & 255);
        }
        return result;
    };
});

if (!HTMLCanvasElement.prototype.toBlob) {
    Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
      value: function (callback, type, quality) {
        var canvas = this;
        setTimeout(function() {
  
          var binStr = atob( canvas.toDataURL(type, quality).split(',')[1] ),
              len = binStr.length,
              arr = new Uint8Array(len);
  
          for (var i = 0; i < len; i++ ) {
            arr[i] = binStr.charCodeAt(i);
          }
  
          callback( new Blob( [arr], {type: type || 'image/png'} ) );
  
        });
      }
    });
  }
// in order to avoid problem on IE
if (!window.console)
    window.console = { log : function(){} };

Date.prototype.toSQL = function()
{
    let month = (this.getMonth() + 1);
    let day = this.getDate();
    let hours = this.getHours();
    let minutes = this.getMinutes();
    let secondes = this.getSeconds();
    return this.getFullYear() + "-" + ((month > 9) ? month : ("0" + month)) + "-" + ((day > 9) ? day : ("0" + day)) + " " + ((hours > 9) ? hours : ("0" + hours)) + ":" + ((minutes > 9) ? minutes : ("0" + minutes)) + ":" + ((secondes > 9) ? secondes : ("0" + secondes));
};

Date.prototype.getUnixTime = function() { return this.getTime()/1000|0 };


Date.fromSQL = function(sqlDate)
{
    if (typeof sqlDate != "string")
        return sqlDate;
    
    let t = sqlDate.split(/[- :]/);
    return new Date(Date.UTC(t[0], t[1] - 1, t[2], t[3], t[4], t[5]));
};

Date.prototype.toString = function()
{
    return Date.normalize(this.getDate())  + "/" + Date.normalize(this.getMonth()+1) + "/" + this.getFullYear() + " " + Date.normalize(this.getHours()-1) + ":" + Date.normalize(this.getMinutes()) + ":" + Date.normalize(this.getSeconds());
};

Date.monthNames = [ "Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre" ];

Date.currentMonth = function(date)
{
    if (!date)
        date = new Date();
    return Date.monthNames[ date.getMonth() ];
};

Date.currentYear = function(date)
{
    if (!date)
        date = new Date();
    return date.getFullYear()
};

Date.normalize = function(num)
{
    return ((Number(num) > 9) ? num : "0" + num);
};

Date.notSameDay = function(timestamp1, timestamp2)
{
  let date1 =  new Date(parseInt(timestamp1) * 1000);
  let date2 =  new Date(parseInt(timestamp2) * 1000);
  return   date1.getFullYear() != date2.getFullYear()
        || date1.getMonth() != date2.getMonth()
        || date1.getDate() != date2.getDate();
}

Date.differentYear = function(timestamp1, timestamp2)
{
  let date1 =  new Date(parseInt(timestamp1) * 1000);
  let date2 =  new Date(parseInt(timestamp2) * 1000);
  return   date1.getFullYear() != date2.getFullYear();
}

Date.unixTimeToDate = function(UNIX_timestamp, showDate, showMonth, showYear, showHours, showMinutes, showSeconds)
{
  let a = new Date(UNIX_timestamp * 1000);
  let months = ['Janvier','Fevrier','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'];
  let year = a.getFullYear();
  let month = months[a.getMonth()];
  let date = a.getDate();
  let hour = Date.normalize(a.getHours());
  let min = Date.normalize(a.getMinutes());
  //let sec = a.getSeconds();
  let time = (showDate ? date : '') + ' ' + (showMonth ? month : '') + ' ' + (showYear ? year : '') + ' ' + (showHours ? hour : '') + (showMinutes ? (':' + min) : '') + (showSeconds ? (':' + a.getSeconds()) : '') ;
  return time;
};

Date.prototype.pretty = function(locale)
{
  const options = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  };

  let str = this.toLocaleDateString(locale, options);

  return str.charAt(0).toUpperCase() + str.slice(1);
};



 Date.generateMonthGrid = function(date) 
{
    let grid = [];
    const year = date.getFullYear();
    const month = date.getMonth();

    // Get the first day of the month
    const firstDayOfMonth = new Date(year, month, 0);
    // Get the day of the week for the first day (0 for Sunday, 6 for Saturday)
    const startDay = firstDayOfMonth.getDay();

    // Get the last day of the month
    const lastDayOfMonth = new Date(year, month + 1, 0);
    const daysInMonth = lastDayOfMonth.getDate();

    let dayCounter = 1;
    let prevMonthDayCounter = new Date(year, month, 0).getDate() - startDay + 1; // Days from previous month

    // Determine total number of rows (weeks)
    const totalDays = startDay + daysInMonth;
    const numRows = Math.ceil(totalDays / 7);

    for (let i = 0; i < numRows; i++) {
        const week = [];
        for (let j = 0; j < 7; j++) {
            let currentDay;
            if (i === 0 && j < startDay) {
                // Days from the previous month
                currentDay = new Date(year, month - 1, prevMonthDayCounter++);
            } else if (dayCounter <= daysInMonth) {
                // Days of the current month
                currentDay = new Date(year, month, dayCounter++);
            } else {
                // Days from the next month
                currentDay = new Date(year, month + 1, dayCounter++ - daysInMonth);
            }
            week.push(currentDay);
        }
        grid.push(week);
    }

    return grid;
};
(function(){

    var proxy = Element.prototype.getBoundingClientRect;
    
    Element.prototype.getBoundingClientRect = function () {
        let element = this;
        let rect = proxy.call(element)
      
        let zoom;
        while (element && element.isHTMLElement())
        {
            zoom = element.getStyle("zoom");
            if (zoom != 1)
                break;
            else
                element = element.parentNode;
        }
    
        if (zoom)
        {
            rect.width = rect.width * zoom;
            rect.height = rect.height * zoom;
            rect.x = rect.x * zoom;
            rect.y = rect.y * zoom;
        }
    
        return rect;
      };

    Element.prototype.getStyle = function ( styleProp) 
    {
        var value, defaultView = (this.ownerDocument || document).defaultView;
        // W3C standard way:
        if (defaultView && defaultView.getComputedStyle) {
            // sanitize property name to css notation
            // (hyphen separated words eg. font-Size)
            styleProp = styleProp.replace(/([A-Z])/g, "-$1").toLowerCase();
            return defaultView.getComputedStyle(this, null).getPropertyValue(styleProp);
        } else if (this.currentStyle) { // IE
            // sanitize property name to camelCase
            styleProp = styleProp.replace(/\-(\w)/g, function(str, letter) {
                return letter.toUpperCase();
        });
        value = this.currentStyle[styleProp];
        // convert other units to pixels on IE
        if (/^\d+(em|pt|%|ex)?$/i.test(value)) { 
            return (function(value) {
                var oldLeft = this.style.left, oldRsLeft = this.runtimeStyle.left;
                this.runtimeStyle.left = this.currentStyle.left;
                this.style.left = value || 0;
                value = this.style.pixelLeft + "px";
                this.style.left = oldLeft;
                this.runtimeStyle.left = oldRsLeft;
                return value;
            })(value);
        }
        return value;
    }
}
    
})();


!function(){
    /* Exif 0x0112	Orientation
     1 = Horizontal (normal)
     2 = Mirror horizontal
     3 = Rotate 180
     4 = Mirror vertical
     5 = Mirror horizontal and rotate 270 CW
     6 = Rotate 90 CW
     7 = Mirror horizontal and rotate 90 CW
     8 = Rotate 270 CW
     */
    window.Exif = {
        getDateTaken : function(exif)
        {
            let date = "";

            if (exif)
            {
                exif = (typeof exif.getAll == "function") ?  exif.getAll().Exif : exif;

                //exif = exif.getAll().Exif;

                let data = exif ? exif.DateTimeOriginal : null;

                //let data = exif.get('DateTimeOriginal');
                if (!data && exif && exif.DateTimeDigitized)
                    data = exif.DateTimeDigitized; //exif.get('DateTimeDigitized');

                if (!data && exif && exif.DateTime)
                    data = exif.DateTime;//exif.get('DateTime');

                if (typeof data == "string")
                {
                    let parts = data.split(" ");
                    if (parts[0] && parts[1])
                    {
                        let dateParts = parts[0].split(":"); 
                        let timeParts = parts[1].split(":"); 
                        date = new Date(parseInt(dateParts[0]), parseInt(dateParts[1]) - 1, parseInt(dateParts[2]), parseInt(timeParts[0]), parseInt(timeParts[1]), parseInt(timeParts[2]) );
                    }
                }  
            }

            //if (!date)
            //    date = new Date();

            return date;
        },
        getOrientationAngle : function(exif)
        {
          if (!exif)
            return 0;
          else
          {
              let orientation = (typeof exif.get == "function") ?  exif.get('Orientation') : exif["Orientation"];
              switch(orientation)
              {
                  case 6 :
                      orientation = 90;
                      break;
                  case 8 :
                      orientation = 270;
                      break;
                  case 3 :
                      orientation = 180;
                      break;
                  default:
                      orientation = 0;
              }
              return orientation;
          }
        },
        getCoordinates : function(exif)
        {
          if (!exif)
            return 0;
          else
          {
            var coordinates = {
                latitude: undefined,
                longitude: undefined
            };

            if( exif["GPSLatitudeRef"] || exif[0x8825]){
                
                let latitudeRef = exif["GPSLatitudeRef"] || exif[0x8825][1];  // latitude direction (N,W,S,E)                
                let latitude = exif["GPSLatitude"] || exif[0x8825][2];
                let longitudeRef =exif["GPSLongitudeRef"] ||  exif[0x8825][3]; // longitude direction (N,W,S,E)
                let longitude = exif["GPSLongitude"] || exif[0x8825][4];

                if (longitude && longitudeRef && latitude && latitudeRef){
                    var dd_lat = latitude[0] + (latitude[1]/60) + (latitude[2]/3600); // convert latitude to a decimal number
                    if (latitudeRef == "S" || latitudeRef == "W") {
                        dd_lat = dd_lat * -1; 
                    }
                    var dd_lon = longitude[0] + (longitude[1]/60) + (longitude[2]/3600); // convert longitude to a decimal number
                    if (longitudeRef == "S" || longitudeRef == "W") {
                        dd_lon = dd_lon * -1; 
                    }
                    coordinates = {
                        latitude: dd_lat,
                        longitude: dd_lon
                    };
                }
            }
            return coordinates;
          }
        }
    };

}();

// nothing for now
/**
 * Hack in support for Function.name for browsers that don't support it.
 * IE, I'm looking at you.
**/

if(Function.prototype.name === undefined){
    Object.defineProperty(Function.prototype, 'name', {
        get:function(){
            if(!this.__name)
                this.__name = this.toString().split('(', 1)[0].split(' ')[1];
            return this.__name;
        }
    });
}
/**
 * Override of Image component in order to support download with progress event with XMLHTTPRequest 2
 */
(function(){

    // EVENTS
    Image.LOADED = "loaded";
    Image.PROGRESS = "progress";
    Image.LOAD_START = "loadstart";
    Image.LOAD_END = "loadend";
    Image.ERROR = "loaderror";
    Image.MEMORY_PROBLEM = "memory";

    Image.prototype.on = function(event, callback, target){
        this.events().on(event, callback, target);
    };

    Image.prototype.off = function(event, callback, target){
        this.events().off(event, callback);
    };

    Image.prototype.trigger = function(event){
        this.events().trigger(event);
    };

    Image.prototype.events = function(){
        if (!this._events)
            this._events = new fx.EventDispatcher();

        return this._events;
    };

    // when using url, no progress
    Image.prototype.url = function( url ) 
    {
        this.dispatchEvent(new Event(Image.LOAD_START));
        this.onload = this.onLoaded;
        this.onerror = this.onError;
        this.src = url;
    }

    Image.prototype.onLoaded = function()
    {
        this.onload = null;
        this.onerror = null;

        if (this.width == 0 || this.height == 0)
            this.dispatchEvent(new Event(Image.ERROR));
        else
            this.dispatchEvent(new Event(Image.LOADED));
    }

    Image.prototype.onError = function()
    {
        this.onload = null;
        this.onerror = null;

        this.dispatchEvent(new Event(Image.ERROR));
    }

    // when using load, progress is available
    Image.prototype.load = function( url, callback) 
    {
        this.callback = callback;
        this.url = url;

        if (this.url && (this.url.indexOf("data:image") == 0)) // base64 images loaded directly
        {
            //this.trigger(Image.LOAD_START);
            this.dispatchEvent(new Event(Image.LOAD_START));

            this.onData64LoadedHandler = onData64Loaded.bind(this);
            this.addEventListener("load", this.onData64LoadedHandler);

            this.src = this.url;

            return null;
        }
        else
        {
            this.xmlHTTP = new XMLHttpRequest();

            this.onXMLHttpLoadedHandler = onXMLHttpLoaded.bind(this)
            this.xmlHTTP.onload = this.onXMLHttpLoadedHandler;

            this.onXMLHttpProgressHanlder = onXMLHttpProgress.bind(this);
            this.xmlHTTP.onprogress = this.onXMLHttpProgressHanlder;

            this.onXMLHttpLoadStartHandler = onXMLHttpLoadStart.bind(this);
            this.xmlHTTP.onloadstart = this.onXMLHttpLoadStartHandler

            this.onXMLHttpLoadEndHandler = onXMLHttpLoadEnd.bind(this);
            this.xmlHTTP.onloadend = this.onXMLHttpLoadEndHandler;

            this.onXMLHttpErrorHandler = onXMLHttpError.bind(this);
            this.xmlHTTP.onerror = this.onXMLHttpErrorHandler;

            this.onReadyStateChangeHandler = onReadyStateChange.bind(this);
            this.xmlHTTP.onreadystatechange = this.onReadyStateChangeHandler;

            this.completedPercentage = 0;

            try
            {
                this.xmlHTTP.open('GET', this.url, true);
                this.xmlHTTP.responseType = 'arraybuffer';
                this.xmlHTTP.send();
            }
            catch(e)
            {
                //this.trigger(Image.ERROR);
                this.dispatchEvent(new Event(Image.ERROR));
                this.xmlHTTP = null;
            }

            return this.xmlHTTP;
        }

    };

    Image.prototype.destroy = function()
    {
        this.stop();

        if (this.src)
            (window.URL || window.webkitURL).revokeObjectURL( this.src );

        this.blob = null;
        this._events = null;
    };

    Image.prototype.stop = function()
    {
        if (this.xmlHTTP)
            this.xmlHTTP.abort();

        this._clean();    
    };

    Image.prototype._clean = function()
    {
        this.onData64LoadedHandler = null;
        this.onXMLHttpLoadedHandler = null;
        this.onXMLHttpProgressHanlder = null;
        this.onXMLHttpLoadStartHandler = null;
        this.onXMLHttpLoadEndHandler = null;
        this.onXMLHttpErrorHandler = null;
        this.onReadyStateChangeHandler = null;
        

        if (this.xmlHTTP)
        {
            this.xmlHTTP.onload = null;
            this.xmlHTTP.onprogress = null;
            this.xmlHTTP.onloadstart = null;
            this.xmlHTTP.onloadend = null;
            this.xmlHTTP.onerror = null;
            this.xmlHTTP.onreadystatechange = null;
            this.xmlHTTP = null;
        }

        this.callback = null;
        this.url = null;

    }

    function onXMLHttpLoaded( e ) 
    {
        if (!this.xmlHTTP) return;
        let h = this.xmlHTTP.getAllResponseHeaders(),
            m = h.match( /^Content-Type\:\s*(.*?)$/mi),
            mimeType;
        if (m && m[ 1 ])
            mimeType = m[ 1 ];
        else
            mimeType = 'image/jpg';
        
        try
        {
            let blob = new Blob( [ this.xmlHTTP.response ], { type: mimeType } );
            //this.onload = onXMLHttpSrcLoaded.bind(this);
            this.blob = this.src = (window.URL || window.webkitURL).createObjectURL( blob );
            onXMLHttpSrcLoaded.call(this);
        }
        catch(e) // Unsufficient memory
        {
            //this.trigger(Image.ERROR);
            //this.trigger(Image.MEMORY_PROBLEM);

            this.dispatchEvent(new Event(Image.ERROR));
            this.dispatchEvent(new Event(Image.MEMORY_PROBLEM));
            
            this._clean();
            //this.addEventListener("load", onXMLHttpSrcLoaded.bind(this));
            //this.src = url;
        }
    };

    function onXMLHttpSrcLoaded()
    {
        if ( this.callback ) this.callback.call(this, this );

        //this.trigger(Image.LOADED);
        this.dispatchEvent(new Event(Image.LOADED));

        this._clean();
    };

    function onXMLHttpProgress( e ) 
    {
        if ( e.lengthComputable ) 
        {
            let actualProgress = parseInt(( e.loaded / e.total ) * 100);
            if (actualProgress != this.completedPercentage) 
            {
                this.completedPercentage = actualProgress;
                //this.trigger({type:Image.PROGRESS, data : {loaded : e.loaded, total : e.total, percentage : this.completedPercentage } });
                this.dispatchEvent(new ProgressEvent("progress", {lengthComputable : e.lengthComputable, loaded : e.loaded, total : e.total}));
                //this.dispatchEvent(new Event("progress", {lengthComputable : e.lengthComputable, loaded : e.loaded, total : e.total}));
            }
        }
    };

    function onXMLHttpLoadStart() 
    {
        this.completedPercentage = 0;
        //this.trigger(Image.LOAD_START);
        this.dispatchEvent(new Event(Image.LOAD_START));
    }

    function onXMLHttpLoadEnd() 
    {
        this.completedPercentage = 100;
        //this.trigger(Image.LOAD_END);
        this.dispatchEvent(new Event(Image.LOAD_END));

        this._clean();
    };

    function onXMLHttpError()
    {
        //this.trigger(Image.ERROR);
        this.dispatchEvent(new Event(Image.ERROR));
        
        this._clean();
    }

    function onReadyStateChange(oEvent) 
    {
        if (this.xmlHTTP.readyState === 4) 
        {
            if (this.xmlHTTP.status === 404 || this.xmlHTTP.status === 500) 
            {
                //this.trigger({type:Image.ERROR, data:this.url});
                this.dispatchEvent(new Event(Image.ERROR));
                this.xmlHTTP = null;
            }
        }
    }

    function onData64Loaded() 
    {
        this.completedPercentage = 100;
        //this.trigger(Image.LOAD_END);
        //this.trigger(Image.LOADED);

        this.dispatchEvent(new Event(Image.LOAD_END));
        this.dispatchEvent(new Event(Image.LOADED));


        if ( this.callback ) this.callback.call(this, this );
        
        this._clean();
    }





})();


//https://github.com/facebookarchive/fixed-data-table/blob/master/src/vendor_upstream/dom/normalizeWheel.js


function normalizeWheel(/*object*/ event) /*object*/ {

    // Reasonable defaults
    let PIXEL_STEP  = 10;
    let LINE_HEIGHT = 40;
    let PAGE_HEIGHT = 800;


  let sX = 0, sY = 0,       // spinX, spinY
      pX = 0, pY = 0;       // pixelX, pixelY

  // Legacy
  if ('detail'      in event) { sY = event.detail; }
  if ('wheelDelta'  in event) { sY = -event.wheelDelta / 120; }
  if ('wheelDeltaY' in event) { sY = -event.wheelDeltaY / 120; }
  if ('wheelDeltaX' in event) { sX = -event.wheelDeltaX / 120; }

  // side scrolling on FF with DOMMouseScroll
  if ( 'axis' in event && event.axis === event.HORIZONTAL_AXIS ) {
    sX = sY;
    sY = 0;
  }

  pX = sX * PIXEL_STEP;
  pY = sY * PIXEL_STEP;

  if ('deltaY' in event) { pY = event.deltaY; }
  if ('deltaX' in event) { pX = event.deltaX; }

  if ((pX || pY) && event.deltaMode) {
    if (event.deltaMode == 1) {          // delta in LINE units
      pX *= LINE_HEIGHT;
      pY *= LINE_HEIGHT;
    } else {                             // delta in PAGE units
      pX *= PAGE_HEIGHT;
      pY *= PAGE_HEIGHT;
    }
  }

  // Fall-back if spin cannot be determined
  if (pX && !sX) { sX = (pX < 1) ? -1 : 1; }
  if (pY && !sY) { sY = (pY < 1) ? -1 : 1; }

  return { spinX  : sX,
           spinY  : sY,
           pixelX : pX,
           pixelY : pY };
}

/**
 * Returns a number that is the neirest multiple.
 * Exemple :
 * 12.multipleOf( 5 ) => 10
 * 14.multipleOf( 5 ) => 15
 */
Number.prototype.multipleOf = function(multiple)
{
    let floor = Math.floor(this / multiple) * multiple;
    let delta = this - floor;
    delta =  (delta < (multiple / 2)) ? 0 : multiple;
    return floor + delta;
};
(function(){
    let proxy = Object.prototype.toString;
    Object.prototype.toString = function()
        { 
            if (this instanceof fx.Disposable)
            {
                if (this.name !== undefined && typeof this.name == "string")
                    return this.name;
                
                if (this.label !== undefined && typeof this.label == "string")
                    return this.label;
            }

            return proxy.call(this); 
        };


        // polufill Object.assign https://gist.github.com/spiralx/68cf40d7010d829340cb
        if (!Object.assign) {
            Object.assign = function assign(target, source) {
                'use strict';
                if (target === undefined || target === null) {
                  throw new TypeError('Cannot convert first argument to object');
                }
          
                var to = Object(target);
                for (var i = 1; i < arguments.length; i++) {
                  var nextSource = arguments[i];
                  if (nextSource === undefined || nextSource === null) {
                    continue;
                  }
                  nextSource = Object(nextSource);
          
                  var keysArray = Object.keys(Object(nextSource));
                  for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
                    var nextKey = keysArray[nextIndex];
                    var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                    if (desc !== undefined && desc.enumerable) {
                      to[nextKey] = nextSource[nextKey];
                    }
                  }
                }
                return to;
            }

            Object.defineProperty(Object, 'assign', {enumerable: false});
        }

       
        Object.prototype.isHTMLElement = function()
        {
            return (
                typeof HTMLElement === "object" ? this instanceof HTMLElement : //DOM2
                this && typeof this === "object" && this !== null && this.nodeType === 1 && typeof this.nodeName==="string"
            );
        };

        Object.defineProperty(Object.prototype, 'isHTMLElement', {enumerable: false});   


})();
Point.prototype.multipleOf = function(multiple)
{
    this.x = this.x.multipleOf(multiple);
    this.y = this.y.multipleOf(multiple);
};
// Polyfill addEventListener / removeEventListener / dispatchEvent IE
//https://gist.githubusercontent.com/jonathantneal/3748027/raw/d262ccf278902705d61658a2fc5cd60409846b98/eventListener.polyfill.js

!window.addEventListener && (function (WindowPrototype, DocumentPrototype, ElementPrototype, addEventListener, removeEventListener, dispatchEvent, registry) {
	WindowPrototype[addEventListener] = DocumentPrototype[addEventListener] = ElementPrototype[addEventListener] = function (type, listener) {
		let target = this;

		registry.unshift([target, type, listener, function (event) {
			event.currentTarget = target;
			event.preventDefault = function () { event.returnValue = false };
			event.stopPropagation = function () { event.cancelBubble = true };
			event.target = event.srcElement || target;

			listener.call(target, event);
		}]);

		this.attachEvent("on" + type, registry[0][3]);
	};

	WindowPrototype[removeEventListener] = DocumentPrototype[removeEventListener] = ElementPrototype[removeEventListener] = function (type, listener) {
		for (let index = 0, register; register = registry[index]; ++index) {
			if (register[0] == this && register[1] == type && register[2] == listener) {
				return this.detachEvent("on" + type, registry.splice(index, 1)[0][3]);
			}
		}
	};

	WindowPrototype[dispatchEvent] = DocumentPrototype[dispatchEvent] = ElementPrototype[dispatchEvent] = function (eventObject) {
		return this.fireEvent("on" + eventObject.type, eventObject);
	};
})(Window.prototype, HTMLDocument.prototype, Element.prototype, "addEventListener", "removeEventListener", "dispatchEvent", []);

//--- HashChangeEvent Polyfill : https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onhashchange
if (!window.HashChangeEvent)(function(){
	let lastURL = document.URL;
	window.addEventListener("hashchange", function(event){
	  Object.defineProperty(event, "oldURL", {enumerable:true,configurable:true,value:lastURL});
	  Object.defineProperty(event, "newURL", {enumerable:true,configurable:true,value:document.URL});
	  lastURL = document.URL;
	});
}());


//--- Promise Polyfill

(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(factory());
}(this, (function () { 'use strict';

/**
 * @this {Promise}
 */
function finallyConstructor(callback) {
  let constructor = this.constructor;
  return this.then(
    function(value) {
      // @ts-ignore
      return constructor.resolve(callback()).then(function() {
        return value;
      });
    },
    function(reason) {
      // @ts-ignore
      return constructor.resolve(callback()).then(function() {
        // @ts-ignore
        return constructor.reject(reason);
      });
    }
  );
}

// Store setTimeout reference so promise-polyfill will be unaffected by
// other code modifying setTimeout (like sinon.useFakeTimers())
let setTimeoutFunc = setTimeout;

function isArray(x) {
  return Boolean(x && typeof x.length !== 'undefined');
}

function noop() {}

// Polyfill for Function.prototype.bind
function bind(fn, thisArg) {
  return function() {
    fn.apply(thisArg, arguments);
  };
}

/**
 * @constructor
 * @param {Function} fn
 */
function Promise(fn) {
  if (!(this instanceof Promise))
    throw new TypeError('Promises must be constructed via new');
  if (typeof fn !== 'function') throw new TypeError('not a function');
  /** @type {!number} */
  this._state = 0;
  /** @type {!boolean} */
  this._handled = false;
  /** @type {Promise|undefined} */
  this._value = undefined;
  /** @type {!Array<!Function>} */
  this._deferreds = [];

  doResolve(fn, this);
}

function handle(self, deferred) {
  while (self._state === 3) {
    self = self._value;
  }
  if (self._state === 0) {
    self._deferreds.push(deferred);
    return;
  }
  self._handled = true;
  Promise._immediateFn(function() {
    let cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
      return;
    }
    let ret;
    try {
      ret = cb(self._value);
    } catch (e) {
      reject(deferred.promise, e);
      return;
    }
    resolve(deferred.promise, ret);
  });
}

function resolve(self, newValue) {
  try {
    // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
    if (newValue === self)
      throw new TypeError('A promise cannot be resolved with itself.');
    if (
      newValue &&
      (typeof newValue === 'object' || typeof newValue === 'function')
    ) {
      let then = newValue.then;
      if (newValue instanceof Promise) {
        self._state = 3;
        self._value = newValue;
        finale(self);
        return;
      } else if (typeof then === 'function') {
        doResolve(bind(then, newValue), self);
        return;
      }
    }
    self._state = 1;
    self._value = newValue;
    finale(self);
  } catch (e) {
    reject(self, e);
  }
}

function reject(self, newValue) {
  self._state = 2;
  self._value = newValue;
  finale(self);
}

function finale(self) {
  if (self._state === 2 && self._deferreds.length === 0) {
    Promise._immediateFn(function() {
      if (!self._handled) {
        Promise._unhandledRejectionFn(self._value);
      }
    });
  }

  for (let i = 0, len = self._deferreds.length; i < len; i++) {
    handle(self, self._deferreds[i]);
  }
  self._deferreds = null;
}

/**
 * @constructor
 */
function Handler(onFulfilled, onRejected, promise) {
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, self) {
  let done = false;
  try {
    fn(
      function(value) {
        if (done) return;
        done = true;
        resolve(self, value);
      },
      function(reason) {
        if (done) return;
        done = true;
        reject(self, reason);
      }
    );
  } catch (ex) {
    if (done) return;
    done = true;
    reject(self, ex);
  }
}

Promise.prototype['catch'] = function(onRejected) {
  return this.then(null, onRejected);
};

Promise.prototype.then = function(onFulfilled, onRejected) {
  // @ts-ignore
  let prom = new this.constructor(noop);

  handle(this, new Handler(onFulfilled, onRejected, prom));
  return prom;
};

Promise.prototype['finally'] = finallyConstructor;

Promise.all = function(arr) {
  return new Promise(function(resolve, reject) {
    if (!isArray(arr)) {
      return reject(new TypeError('Promise.all accepts an array'));
    }

    let args = Array.prototype.slice.call(arr);
    if (args.length === 0) return resolve([]);
    let remaining = args.length;

    function res(i, val) {
      try {
        if (val && (typeof val === 'object' || typeof val === 'function')) {
          let then = val.then;
          if (typeof then === 'function') {
            then.call(
              val,
              function(val) {
                res(i, val);
              },
              reject
            );
            return;
          }
        }
        args[i] = val;
        if (--remaining === 0) {
          resolve(args);
        }
      } catch (ex) {
        reject(ex);
      }
    }

    for (let i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.resolve = function(value) {
  if (value && typeof value === 'object' && value.constructor === Promise) {
    return value;
  }

  return new Promise(function(resolve) {
    resolve(value);
  });
};

Promise.reject = function(value) {
  return new Promise(function(resolve, reject) {
    reject(value);
  });
};

Promise.race = function(arr) {
  return new Promise(function(resolve, reject) {
    if (!isArray(arr)) {
      return reject(new TypeError('Promise.race accepts an array'));
    }

    for (let i = 0, len = arr.length; i < len; i++) {
      Promise.resolve(arr[i]).then(resolve, reject);
    }
  });
};

// Use polyfill for setImmediate for performance gains
Promise._immediateFn =
  // @ts-ignore
  (typeof setImmediate === 'function' &&
    function(fn) {
      // @ts-ignore
      setImmediate(fn);
    }) ||
  function(fn) {
    setTimeoutFunc(fn, 0);
  };

Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
  if (typeof console !== 'undefined' && console) {
    console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
  }
};

/** @suppress {undefinedlets} */
let globalNS = (function() {
  // the only reliable means to get the global object is
  // `Function('return this')()`
  // However, this causes CSP violations in Chrome apps.
  if (typeof self !== 'undefined') {
    return self;
  }
  if (typeof window !== 'undefined') {
    return window;
  }
  if (typeof global !== 'undefined') {
    return global;
  }
  throw new Error('unable to locate global object');
})();

if (!('Promise' in globalNS)) {
  globalNS['Promise'] = Promise;
} else if (!globalNS.Promise.prototype['finally']) {
  globalNS.Promise.prototype['finally'] = finallyConstructor;
}

})));
/*\
|*|
|*|  Polyfill which enables the passage of arbitrary arguments to the
|*|  callback functions of JavaScript timers (HTML5 standard syntax).
|*|
|*|  https://developer.mozilla.org/en-US/docs/DOM/window.setInterval
|*|
|*|  Syntax:
|*|  var timeoutID = window.setTimeout(func, delay[, arg1, arg2, ...]);
|*|  var timeoutID = window.setTimeout(code, delay);
|*|  var intervalID = window.setInterval(func, delay[, arg1, arg2, ...]);
|*|  var intervalID = window.setInterval(code, delay);
|*|
\*/

(function() {
    setTimeout(function(arg1) {
      if (arg1 === 'test') {
        // feature test is passed, no need for polyfill
        return;
      }
      var __nativeST__ = window.setTimeout;
      window.setTimeout = function(vCallback, nDelay /*, argumentToPass1, argumentToPass2, etc. */ ) {
        var aArgs = Array.prototype.slice.call(arguments, 2);
        return __nativeST__(vCallback instanceof Function ? function() {
          vCallback.apply(null, aArgs);
        } : vCallback, nDelay);
      };
    }, 0, 'test');
  
    var interval = setInterval(function(arg1) {
      clearInterval(interval);
      if (arg1 === 'test') {
        // feature test is passed, no need for polyfill
        return;
      }
      var __nativeSI__ = window.setInterval;
      window.setInterval = function(vCallback, nDelay /*, argumentToPass1, argumentToPass2, etc. */ ) {
        var aArgs = Array.prototype.slice.call(arguments, 2);
        return __nativeSI__(vCallback instanceof Function ? function() {
          vCallback.apply(null, aArgs);
        } : vCallback, nDelay);
      };
    }, 0, 'test');
  }());
if (!String.prototype.splice) {
    /**
     * {JSDoc}
     *
     * The splice() method changes the content of a string by removing a range of
     * characters and/or adding new characters.
     *
     * @this {String}
     * @param {number} start Index at which to start changing the string.
     * @param {number} delCount An integer indicating the number of old chars to remove.
     * @param {string} newSubStr The String that is spliced in.
     * @return {string} A new string with the spliced substring.
     */
    String.prototype.splice = function(start, delCount, newSubStr) {
        return this.slice(0, start) + newSubStr + this.slice(start + Math.abs(delCount));
    };
}

if (!String.prototype.startsWith) {
  String.prototype.startsWith = function(searchString, position){
    return this.substr(position || 0, searchString.length) === searchString;
    };
}

if (!String.prototype.endsWith) {
    String.prototype.endsWith = function(searchString, position) {
      let subjectString = this.toString();
      if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
        position = subjectString.length;
      }
      position -= searchString.length;
      let lastIndex = subjectString.lastIndexOf(searchString, position);
      return lastIndex !== -1 && lastIndex === position;
    };
  }


  if (!String.prototype.toSnakeCase) {
    String.prototype.toSnakeCase = function() {
      let upperChars = this.match(/([A-Z])/g);
      if (! upperChars) {
          return this;
      }

      let str = this.toString();
      for (let i = 0, n = upperChars.length; i < n; i++) {
          str = str.replace(new RegExp(upperChars[i]), '_' + upperChars[i].toLowerCase());
      }

      if (str.slice(0, 1) === '_') {
          str = str.slice(1);
      }

      return str;
  };
}

  Object.defineProperty(String.prototype, 'capitalize', {
    value: function() {
      return this.charAt(0).toUpperCase() + this.slice(1);
    },
    enumerable: false
  });

  
  Object.defineProperty(String.prototype, 'isEmpty', {
    value: function() {
         return !this || this.trim().length === 0;
    },
    enumerable: false
  });
// Get next named element id
SVG.eid = function(name) {
    return Utils.newID();//'Svgjs' + capitalize(name) + (SVG.did++)
};

SVG.extend(SVG.Base, {
    positionOf : function(child) {
        let  parent = child.parentNode;
        return Array.prototype.indexOf.call(parent.children, child);
    }
});
/**
 * Manage the XHR requests :
 * - some XHR requests are used for downloading/uploading assets
 * - some XHR requests are used for communicating with server (save, update, etc...)
 * Modern browser allow up to 6 simultaneous XHR connections
 * So, in order to not have the communication with the server locked till all the download/upload is done,
 * we reserve 4 connections for uploading/downloading and 2 for communication
 */


fx.ns("fx.extends", function XHRManager(quality)
{
    let activeAssetsConnections = 0,
        waitingAssetsConnections = [],
        fullQuality = quality,
        xhrs = {},
        closing = false,
        MAXCONNECTIONS = 3,
        MAXASSETSCONNECTIONS = 3,
        NEXTID = 1000,
        events = fx.EventDispatcher();

    return {
        on : function(event, callback){
            events.on(event, callback);
        },
        off : function(event, callback){
            events.off(event, callback);
        },
        closing : function(){
            return closing;
        },
        loadImage : function(element, isblob, callback)
        {   
            if (isblob)
                element.image = new fx.extends.BlobLoader();
            else
                element.image = new Image();
            
            element.loading = true;
            element.loaded = false;
            
            if (!element.image || !element.image.load || typeof element.image["load"] != 'function')
            {
                callback();
                return;
            }

            loadurl.XHRID = NEXTID++;
            
            let url = this.getURL(element);

            if (activeAssetsConnections < MAXASSETSCONNECTIONS)
            {
                activeAssetsConnections++;

                element.image.on(Image.MEMORY_PROBLEM, function(){
                    events.trigger(Image.MEMORY_PROBLEM);

                    delete( xhrs[this.XHRID] );
                });

                element.image.on(Image.ERROR, function(){
                    activeAssetsConnections--;
                    loadWaitingAssets();

                    delete( xhrs[this.XHRID] );
                });

                let xhr = element.image.load(url,
                    function(){
                    activeAssetsConnections--;
                    loadWaitingAssets();
                    callback();

                    delete( xhrs[this.XHRID] );
                });

                if (xhr)
                    xhrs[element.image.XHRID] = xhr;
            }
            else
            {
                waitingAssetsConnections.push({image:element.image, url:url, callback:callback});
            }
        },
        getURL : function(element)
        {
            return ( (!element.ressource & !fullQuality ) ? element.light_url : element.url );
        },
        loadWaitingAssets()
        {
            if ( waitingAssetsConnections.length > 0 )
            {
                let asset = waitingAssetsConnections.splice(0,1)[0];

                asset.image.XHRID = NEXTID++;

                activeAssetsConnections++;

                asset.image.on(Image.ERROR, function(){
                    activeAssetsConnections--;
                    loadWaitingAssets();

                    delete( xhrs[this.XHRID] );
                });

                let xhr = asset.image.load(asset.url, function(){
                    activeAssetsConnections--;
                    loadWaitingAssets();
                    asset.callback();

                    delete( xhrs[this.XHRID] );
                });

                if (xhr)
                    xhrs[asset.image.XHRID] = xhr;
            }
        },
        clear : function()
        {
            MAXASSETSCONNECTIONS = -1;

            for (let id in xhrs)
            {
                let xhr = xhrs[id];
                if (xhr)
                    xhr.abort();
            }

            closing = true;
        },
    }
        
});




/** 
* Animations for fx
* @namespace fx.animate
* Every component animation is defined here
*/
fx.animate = {};
/** 
* Animations for fx
* @namespace fx.animate
* Every component animation is defined here
*/
fx.animate.fadeSequence = (function(){

	let showSpeed = 0.4,
		hideSpeed = 0.25,
		showDelayFactor = 500,
		hideDelayFactor = 500,
		dom = fx.get("dom");
 
	return {
		show : function(component, callback){
			
			let childs = component.getChilds();

			component.animating = true;

			// let's disable transition
			dom.css(component.node, {"transition": "none"});
			for (let index = 0; index < childs.length; index++)
				dom.css(childs[index].node, {"transition": "none"});

			// let's hide element without transition
			dom.css(component.node,  {opacity : 0});

			for (let index = 0; index < childs.length; index++)
				dom.css(childs[index].node, {opacity : 0});

			// let's enable transition
			dom.css(component.node, {"transition": "none"});
			for (let index = 0; index < childs.length; index++)
				dom.css(childs[index].node, {"transition": null});
			
			dom.css(component.node, {"transition":"all " + showSpeed + "s "});
			let delay = showSpeed;
			for (let index = 0; index < childs.length; index++)
			{
				delay += showSpeed;
				dom.css(childs[index].node, {"transition": "all " + showSpeed + "s " + delay + "s"});
			}

			setTimeout(function(){
				
				dom.css(component.node,  {opacity : 1});

				for (let index = 0; index < childs.length; index++)
					dom.css(childs[index].node, {opacity : 1});			
				
				component.animating = false;
				component.enable();
				component.updateDisplay(true);

				if (callback)
					setTimeout(callback, delay * showDelayFactor);
					

			}, 100);
		},
		hide : function(component, callback){
			
			let childs = component.getChilds();

			// let's disable transition
			dom.css(component.node, {"transition" : "none"});
			for (let index = 0; index < childs.length; index++)
				dom.css(childs[index].node, {"transition": "none"});
			
			// let's hide element without transition
			dom.css(component.node,  {opacity : 1});
			for (let index = 0; index < childs.length; index++)
				dom.css(childs[index].node,  {opacity : 1});

			// let's enable transition
			dom.css(component.node, {"transition": "none"});
			for (let index = 0; index < childs.length; index++)
				dom.css(childs[index].node, {"transition": "none"});
			
			// let's enable transition
			let delay = 0;
			for (let index = 0; index < childs.length; index++)
			{
				dom.css(childs[index].node, {"transition": "all " + hideSpeed +"s " + (delay ? (delay + "s") : "")});
				delay += hideSpeed;
			}

			dom.css(component.node, {"transition": "all " + hideSpeed + "s "  + (delay ? (delay + "s") : "")});

			delay += hideSpeed;

			setTimeout(function(){

				for (let index = 0; index < childs.length; index++)
					dom.css(childs[index].node, {opacity : 0});		
				
				dom.css(component.node,  {opacity : 0});
				component.disable();

				if (callback)
					setTimeout(callback, delay * hideDelayFactor)

			}, 100);
		}
	};

})();
fx.animate.fade = (function(){

	let easing = "cubic-bezier(0.455, 0.03, 0.515, 0.955)",
		showSpeed = 0.6, // speed to show an element
		hideSpeed = 0.25, // speed to show an element
		defaultTimeout = 10,
		dom = fx.get("dom");
		

	function getTransition(speed)
	{
		return "opacity " + " " + speed + "s " + easing;
	}

	return {
		show : function(component, callback){
			
			// let's disable transition
			dom.css(component.node, {"transition": "none", opacity : 0, "visibility" : "visible"});
			
			component.animating = true;
			
			setTimeout(function(){
				// let's enable transition
				dom.css(component.node, {transition : getTransition(showSpeed), opacity : 1});
				
				setTimeout( function(){
					dom.css(component.node, {"transition" : "none"});
					
					component.animating = false;
					component.enable();
					component.updateDisplay(true);
					
					if (callback)
						callback();

				}, showSpeed * 1000);


			}, defaultTimeout);
		},
		hide : function(component, callback){
			
			let zindex = component.css( "z-index");
			// let's disable transition
			dom.css(component.node, {"transition": "none", opacity : 1, "visibility" : "visible", "z-index" : 10});
			
			setTimeout(function(){
				// let's enable transition
				dom.css(component.node, {transition : getTransition(hideSpeed)});

				setTimeout(function(){

					dom.css(component.node, { opacity : 0});
					
					setTimeout( function(){
						
						dom.css(component.node, {"transition" : "none", "visibility" : "hidden"});
						component.css( "z-index", zindex);
						component.disable();
						
						if (callback)
							callback();

					}, 1 * hideSpeed * 500);

				}, defaultTimeout);
			}, defaultTimeout);
		}
	};

})();
fx.animate.hslidein = (function(){

	let showSpeed = 0.5, // speed to show an element
        hideSpeed = 0.25, // speed to show an element
		defaultTimeout = 10,
        offset = 0;
		//timers = [];
	
	function timers(component)
	{
		if (!component)
			return [];

		if (!component.__animationTimers)
			component.__animationTimers = [];

		return component.__animationTimers;
	}
	function cleanTimers(component)
	{
		let _timers = timers(component), timer;
		while(timer = _timers.pop())
			clearTimeout(timer);
	}
	
	return {
		show : function(component, callback)
		{	
			cleanTimers(component);

			offset = -(component.realWidth * 0.5);

			component.animating = true;
			let zindex = component.hasClass("disabled") ? 0 : component.css( "z-index");
			component.css({transition : "none", transform : "translateX(" + offset + "px)", opacity : 0, "visibility" : "hidden", "z-index" : 10});
			component.updateDisplay(true); // put here to avoid some weird offest behaviour with PhotoChoices (desktop)

			timers(component).push(setTimeout(function(){

				component.css({transition : "all " + showSpeed + "s cubic-bezier(0.5, 1, 0.89, 1)", opacity : 1, "visibility": "visible", transform : "translateX(0px)"});
				
				timers(component).push(setTimeout( function(){

					component.css( {"transition" : "none", "z-index" : zindex});
					
					component.animating = false;
					component.enable();
					//component.updateDisplay(true);

					if (callback)
						callback();

				}, showSpeed * 1000));


			}, defaultTimeout) );
		
		},
		hide : function(component, callback)
		{	
			cleanTimers(component);

			offset = -(component.realWidth * 0.50);

			component.animating = true;
            component.css({transition : "none", transform : "translateX(0px)", opacity : 1, "visibility" : "visible"});
			

				timers(component).push(setTimeout(function(){

					component.css({transition : "all " + hideSpeed + "s cubic-bezier(0.11, 0, 0.5, 0)", opacity : 0, transform : "translateX(" + offset + "px)"});
					
					timers(component).push(setTimeout( function(){
						
						component.css( {"transition" : "none", "visibility" : "hidden"});
						component.disable();
						component.animating = false;
						
						if (callback)
							callback();

					}, hideSpeed * 1000));

				}, defaultTimeout));
			//}, defaultTimeout);
		}
	};

})();
fx.animate.hslideout = (function(){

	let showSpeed = 0.5, // speed to show an element
        hideSpeed = 0.25, // speed to hide an element
		defaultTimeout = 10,
        offset = 0,
		timers = [];

	function cleanTimers()
	{
		let timer;
		while(timer = timers.pop());
			clearTimeout(timer);
	}
		
	
	return {
		show : function(component, callback)
		{	
			cleanTimers()

			offset = component.realWidth * 0.5;

			component.animating = true;
			let zindex = component.hasClass("disabled") ? 0 : component.css( "z-index");
			component.css({transition : "none", transform : "translateX(" + offset + "px)", opacity : 0, "visibility" : "hidden", "z-index" : 1});
			
			timers.push(setTimeout(function(){

				component.css({transition : "all " + showSpeed + "s cubic-bezier(0.5, 1, 0.89, 1)", opacity : 1, "visibility" : "visible", transform : "translateX(0px)"});
				
				timers.push(setTimeout( function(){

					component.css( {"transition" : "none", "z-index" : zindex});
					
					component.animating = false;
					component.enable();
					component.updateDisplay(true);

					if (callback)
						callback();

				}, showSpeed * 1000));


			}, defaultTimeout));
		
		},
		hide : function(component, callback)
		{
			cleanTimers()

			offset = component.realWidth * 0.50;

			component.animating = true;
            component.css({transition : "none", transform : "translateX(0px)", opacity : 1, "visibility" : "visible"});
			

			timers.push(setTimeout(function(){

					component.css({transition : "all " + hideSpeed + "s cubic-bezier(0.11, 0, 0.5, 0)", opacity : 0, transform : "translateX(" + offset + "px)"});
					
					timers.push(setTimeout( function(){
						
						component.css( {"transition" : "none", "visibility" : "hidden"});
						component.disable();
						component.animating = false;
						
						if (callback)
							callback();

					}, hideSpeed * 1000));

				}, defaultTimeout));
		}
	};

})();
// TODO : rewrite "scale" animation in order to make it update only scale property on transform
fx.animate.scale = (function(){

	let easing = "cubic-bezier(0.455, 0.03, 0.515, 0.955)",
		showSpeed = 0.25, // speed to show an element
		hideSpeed = 0.4,
		defaultTimeout = 40;
		
	
	return {
		show : function(component, callback){
			let childs = component.getChilds();

			component.animating = true;
			
			component.css({"transition": "none", opacity : 0, transform : "scale(0)", "transform-origin" : "center", "visibility" : "hidden"});
			
			setTimeout(function(){
				
				component.css({transition : "transform " + showSpeed + "s " + easing, opacity : 1, transform : "scale(1)", "visibility" : "visible"});
					
				setTimeout( function(){
					component.css( {"transition" : "none"});
					
					component.animating = false;
					component.enable();
					component.updateDisplay(true);
			
					if (callback)
						callback();

				}, showSpeed * 1000);


			}, defaultTimeout);
		},
		hide : function(component, callback){
			
			component.animating = true;
			
			component.css( {transition : "all " + showSpeed + "s " + easing, opacity : 1, transform : "scale(1)", "transform-origin" : "center", "visibility" : "visible"});
			
			setTimeout(function(){
				
				component.css( {transform : "scale(0)", opacity : 0});

				setTimeout(function(){

						component.css( {"transition" : "none", "visibility" : "hidden"});
						component.disable();
						component.animating = false;
						
						if (callback)
							callback();

					}, hideSpeed * 1000);

			}, defaultTimeout);
		}
	};

})();
fx.animate.scroll = (function(){

	let easing = "cubic-bezier(.24,.31,.58,.99)",
		showSpeed = 0.5, // speed to show an element
		hideSpeed = 0.4,  // speed to hide an element
		showDelayFactor = 1,
		hideDelayFactor = 1,
		timers = [],
		defaultTimeout = 10,
		dom = fx.get("dom");

	function getOppositePosition(child)
	{
		let viewport = child.viewport();
		let position = {top:viewport.top, bottom:viewport.bottom, left:viewport.left, right:viewport.right};
		if (viewport.top !== undefined)
		{
			if (typeof viewport.height == "string" && viewport.height == "100%" && (viewport.width + "").indexOf("%") == -1)
				position.left = -child.realWidth;
			else
				position.top = -child.realHeight;
		}
		else
		if (viewport.bottom)
			position.bottom = -child.realHeight;
		
		return position;
	}

	function addTransition(obj, speed, easing, delay)
	{
		delay = delay || 0;
		obj.transition  = "";
		let props = ["top","left", "bottom", "right"];
		for (let i = 0; i < props.length; i++)
		{
			obj.transition += props[i] + " " + speed + "s " + (easing || "") + " " + (delay || 0) + "s";
			if ( (i+1) < props.length)
				obj.transition += ",";
		}

		obj.transition += ", opacity " + (speed/2) + "s " + (easing || "") + " " + (speed/2) + "s"; 
		return obj;
	}


	return {
		show : function(component, callback){
			
			let childs = component.getChilds();

			component.animating = true;

			// let's disable transition
			let obj = {"transition": "none", opacity : 0, "visibility" : "visible"};
			dom.css(component.node, obj );

			setTimeout(function(){
			for (let index = 0; index < childs.length; index++)
			{
				if (!childs[index].visibleAtStart)
					continue;

				let props = Object.assign(getOppositePosition( childs[index]), obj);
				dom.css(childs[index].node, props);
			
			}

			setTimeout(function(){
				let delay = 0;
				dom.css(component.node, addTransition({opacity : 1}, showSpeed ,  easing) );
				for (let index = 0; index < childs.length; index++)
				{
					if (!childs[index].visibleAtStart)
						continue;

					//delay += showSpeed;
					let viewport = childs[index].realPosition;
					//let position = {top:viewport.top, bottom:viewport.bottom, left:viewport.left, right:viewport.right};
		
					let props = Object.assign(addTransition({opacity : 1}, showSpeed ,  easing, delay), viewport) ;
					dom.css(childs[index].node, props );
					if (childs[index].visibleAtStart /*&& childs[index].ready*/)
						childs[index].show();
                }
                delay += showSpeed;

				setTimeout( function(){
					dom.css(component.node, {"transition" : "none"});
					for (let index = 0; index < childs.length; index++)
					{
						if (!childs[index].visibleAtStart)
							continue;

						dom.css(childs[index].node, {"transition": "none"});
					}

					component.animating = false;
					component.enable();
					component.updateDisplay(true);
			

					if (callback)
						callback();
				}, 1 * delay * 1000 * showDelayFactor);

			}, defaultTimeout);

		}, defaultTimeout);
		
		},
		hide : function(component, callback){
			
			let childs = component.getChilds().slice().reverse();

			// let's disable transition
			let obj = {"transition": "none", opacity : 1, "visibility" : "visible"};
			dom.css(component.node, obj );

			setTimeout(function(){
			for (let index = 0; index < childs.length; index++)
			{
				if (!childs[index].visibleAtStart)
						continue;

				let viewport = childs[index].viewport();
				let position = {top:viewport.top, bottom:viewport.bottom, left:viewport.left, right:viewport.right};

				let props = Object.assign(position, obj);
				dom.css(childs[index].node, props);
			}

			setTimeout(function(){
				let delay = 0;
				for (let index = 0; index < childs.length; index++)
				{
					if (!childs[index].visibleAtStart)
						continue;

					dom.css(childs[index].node, addTransition({}, hideSpeed ,  easing, delay) );
					//childs[index].show();
					//delay += hideSpeed;
				}
                dom.css(component.node, addTransition({}, hideSpeed ,  easing, delay) );
                
                //delay += hideSpeed;

				setTimeout(function(){
					let delay = hideSpeed;
					dom.css(component.node, {opacity : 0} );
					for (let index = 0; index < childs.length; index++)
					{
						if (!childs[index].visibleAtStart)
							continue;

						//delay += hideSpeed;
						let props = Object.assign({opacity : 0}, getOppositePosition( childs[index]));
						dom.css(childs[index].node, props );
						//childs[index].show();
					}

					setTimeout( function(){
						dom.css(component.node, {"transition" : "none", "visibility" : "hidden"});
						for (let index = 0; index < childs.length; index++)
						{
							if (!childs[index].visibleAtStart)
								continue;

							dom.css(childs[index].node, {"transition": "none", "visibility" : "hidden"});
							component.disable();
						}
							

						if (callback)
							callback();
					}, delay * 1000 * showDelayFactor);

				}, defaultTimeout);

			}, defaultTimeout);

		}, defaultTimeout);
		}
	};

})();
fx.animate.scrollup = (function(){

	let showSpeed = 0.5, // speed to show an element
		defaultTimeout = 10;
		
	
	return {
		show : function(component, callback){
			
			component.animating = true;
            component.css({"transition" : "none", transform : "translate(0px," + fx.graphics.screenSize().height + "px)", "visibility" : "visible", opacity : 1, display:"block"});
			
			setTimeout(function(){

                component.css({transition : "all " + showSpeed + "s "});
				
				setTimeout( function(){

                    // let's enable transition
				    component.css({"transform" : "translate(0px,0px)"});
                
                    setTimeout( function(){

                        component.animating = false;
                        component.enable();
                        component.updateDisplay(true);

                        if (callback)
                            callback();

                    }, showSpeed * 500);

                }, defaultTimeout);
            }, defaultTimeout);
		},
		hide : function(component, callback){
		
			
			component.animating = true;
			
            component.css( {transition : "all " + showSpeed + "s ", "transform" : "translate(0px," + fx.graphics.screenSize().height + "px)"});

            setTimeout(function(){

                component.css( {"transition" : "none", "visibility" : "hidden", display :"none", opacity : 0 });
                component.disable();
                component.animating = false;
                
            }, showSpeed * 500);
			//}, defaultTimeout);
		}
	};

})();
fx.animate.transformer = (function(){

	let easing = "cubic-bezier(0.455, 0.03, 0.515, 0.955)",
		showSpeed = 0.25, // speed to show an element
		hideSpeed = 0.35,  // speed to hide an element
		showDelayFactor = 0.25,
		hideDelayFactor = 1,
		timers = [],
		defaultTimeout = 10,
		dom = fx.get("dom");

	function getOppositePosition(child)
	{
		let viewport = child.viewport();
		let position = {top:viewport.top, bottom:viewport.bottom, left:viewport.left, right:viewport.right};
		if (viewport.top)
		{
			if (viewport.height == "100%" && viewport.width.indexOf("%") == -1)
				position.left = -child.realWidth;
			else
				position.top = -child.realHeight;
		}
		else
		if (viewport.bottom)
			position.bottom = -child.realHeight;
		
		return position;
	}

	function addTransition(obj, speed, easing, delay)
	{
		delay = delay || 0;
		obj.transition  = "";
		let props = ["top","left", "bottom", "right", "opacity"];
		for (let i = 0; i < props.length; i++)
		{
			obj.transition += props[i] + " " + speed + "s " + (easing || "") + " " + (delay || 0) + "s";
			if ( (i+1) < props.length)
				obj.transition += ",";
		}
		return obj;
	}

	return {
		show : function(component, callback){
			
			let childs = component.getChilds();

			// let's disable transition
			let obj = {"transition": "none", opacity : 0, "visibility" : "visible"};
			dom.css(component.node, obj );
			for (let index = 0; index < childs.length; index++)
			{
				let props = Object.assign(getOppositePosition( childs[index]), obj);
				dom.css(childs[index].node, props);
			}

			setTimeout(function(){
				let delay = 0;
				dom.css(component.node, addTransition({opacity : 1}, showSpeed ,  easing) );
				for (let index = 0; index < childs.length; index++)
				{
					delay += showSpeed;
					let viewport = childs[index].viewport();
					let position = {top:viewport.top, bottom:viewport.bottom, left:viewport.left, right:viewport.right};
		
					let props = Object.assign(addTransition({opacity : 1}, showSpeed ,  easing, delay), position) ;
					dom.css(childs[index].node, props );
					if (childs[index].visibleAtStart)
						childs[index].show();
				}

				setTimeout( function(){
					dom.css(component.node, {"transition" : "none"});
					for (let index = 0; index < childs.length; index++)
						dom.css(childs[index].node, {"transition": "none"});

						component.animating = true;
						component.enable();
						component.updateDisplay(true);
						
					if (callback)
						callback();
				}, 1.5 * delay * 1000 * showDelayFactor);

			}, defaultTimeout);
		
		},
		hide : function(component, callback){
			
			let childs = component.getChilds().slice().reverse();

			// let's disable transition
			let obj = {"transition": "none", opacity : 1, "visibility" : "visible"};
			dom.css(component.node, obj );
			for (let index = 0; index < childs.length; index++)
			{
				let viewport = childs[index].viewport();
				let position = {top:viewport.top, bottom:viewport.bottom, left:viewport.left, right:viewport.right};

				let props = Object.assign(position, obj);
				dom.css(childs[index].node, props);
			}

			setTimeout(function(){
				let delay = 0;
				for (let index = 0; index < childs.length; index++)
				{
					dom.css(childs[index].node, addTransition({}, hideSpeed ,  easing, delay) );
					if (childs[index].visibleAtStart)
						childs[index].show();
					delay += hideSpeed;
				}
				dom.css(component.node, addTransition({}, hideSpeed ,  easing, delay) );

				setTimeout(function(){
					let delay = 0;
					dom.css(component.node, {opacity : 0} );
					for (let index = 0; index < childs.length; index++)
					{
						delay += hideSpeed;
						let props = Object.assign({opacity : 0}, getOppositePosition( childs[index]));
						dom.css(childs[index].node, props );
						if (childs[index].visibleAtStart)
							childs[index].show();
					}

					setTimeout( function(){
						dom.css(component.node, {"transition" : "none", "visibility" : "hidden"});
						for (let index = 0; index < childs.length; index++)
							dom.css(childs[index].node, {"transition": "none", "visibility" : "hidden"});

						component.disable();

						if (callback)
							callback();
					}, delay * 1000 * showDelayFactor);

				}, defaultTimeout);

			}, defaultTimeout);
		}
	};

})();
fx.animate.vslide = (function(){

	let easing = "cubic-bezier(0.455, 0.03, 0.515, 0.955)",
		showSpeed = 0.25, // speed to show an element
		defaultTimeout = 10;
		
	
	return {
		show : function(component, callback){
			
			component.animating = true;
			component.css({transform : "scaleY(0)"});
			
			setTimeout(function(){

				component.css({transition : "transform " + showSpeed + "s ","visibility" : "visible", opacity : 1});
				
				setTimeout(function(){
				// let's enable transition
				component.css({transform : "scaleY(1)"});
				
			
				setTimeout( function(){
					component.css( {"transition" : "none"});
					
					component.animating = false;
					component.enable();
					component.updateDisplay(true);

					if (callback)
						callback();

				}, showSpeed * 500);


			}, defaultTimeout);
		}, defaultTimeout);
		},
		hide : function(component, callback){
		
			
			component.animating = true;
			
			//component.css( {"transition": "none", opacity : 1, height : component.realHeight, "visibility" : "visible"});
			
			//setTimeout(function(){
				// let's enable transition
				component.css( {transition : "transform " + showSpeed + "s "});

				setTimeout(function(){

					component.css( { transform : "scaleY(0)"});
					
					setTimeout( function(){
						
						component.css( {"transition" : "none", "visibility" : "hidden", opacity : 0});
						component.disable();
						component.animating = false;
						
						if (callback)
							callback();

					}, showSpeed * 500);

				}, defaultTimeout);
			//}, defaultTimeout);
		}
	};

})();
fx.animate.vslidein = (function(){

    let showSpeed = 0.5, // speed to show an element
        hideSpeed = 0.25, // speed to show an element
        defaultTimeout = 10,
        offset = -400;
        //timers = [];
    
    function timers(component)
    {
        if (!component)
            return [];

        if (!component.__animationTimers)
            component.__animationTimers = [];

        return component.__animationTimers;
    }
    function cleanTimers(component)
    {
        let _timers = timers(component), timer;
        while(timer = _timers.pop())
            clearTimeout(timer);
    }
    
    return {
        show : function(component, callback)
        {   
            cleanTimers(component);

            offset = (component.realHeight * 0.25);

            component.animating = true;
            let zindex = component.css( "z-index");
            let transition = component.css( "transition");
            component.css({transition : "none", transform : "translateY(" + offset + "px)", opacity : 0, "visibility" : "visible", "z-index" : 10});
            component.updateDisplay(true); // put here to avoid some weird offest behaviour with PhotoChoices (desktop)

            timers(component).push(setTimeout(function(){

                component.css({transition : "all " + showSpeed + "s cubic-bezier(0.5, 1, 0.89, 1)", opacity : 1, transform : "translateY(0px)"});
                
                timers(component).push(setTimeout( function(){

                    component.css( {"transition" : transition, "z-index" : zindex == - 1 ? "auto" : zindex});
                    
                    component.animating = false;
                    component.enable();
                    //component.updateDisplay(true);

                    if (callback)
                        callback();

                }, showSpeed * 1000));


            }, defaultTimeout) );
        
        },
        hide : function(component, callback)
        {   
            cleanTimers(component);

            offset = (component.realHeight);

            let transition = component.css( "transition");

            component.animating = true;
            component.css({transition : "none", transform : "translateY(0px)", opacity : 1, "visibility" : "visible"});
            

                timers(component).push(setTimeout(function(){

                    component.css({transition : "all " + hideSpeed + "s cubic-bezier(0.11, 0, 0.5, 0)", opacity : 0, transform : "translateY(" + offset + "px)"});
                    
                    timers(component).push(setTimeout( function(){
                        
                        component.css( {"transition" : transition, "visibility" : "hidden"});
                        component.disable();
                        component.animating = false;
                        
                        if (callback)
                            callback();

                    }, hideSpeed * 500));

                }, defaultTimeout));
            //}, defaultTimeout);
        }
    };

})();
fx.animate.vslideout = (function(){

    let showSpeed = 0.5, // speed to show an element
        hideSpeed = 0.25, // speed to show an element
        defaultTimeout = 10,
        offset = -400;
        //timers = [];
    
    function timers(component)
    {
        if (!component)
            return [];

        if (!component.__animationTimers)
            component.__animationTimers = [];

        return component.__animationTimers;
    }
    function cleanTimers(component)
    {
        let _timers = timers(component), timer;
        while(timer = _timers.pop())
            clearTimeout(timer);
    }
    
    return {
        show : function(component, callback)
        {   
            cleanTimers(component);

            offset = -(component.realHeight * 0.25);

            component.animating = true;
            let zindex = component.css( "z-index");
            component.css({transition : "none", transform : "translateY(" + offset + "px)", opacity : 0, "visibility" : "visible", "z-index" : 10});
            component.updateDisplay(true); // put here to avoid some weird offest behaviour with PhotoChoices (desktop)

            timers(component).push(setTimeout(function(){

                component.css({transition : "all " + showSpeed + "s cubic-bezier(0.5, 1, 0.89, 1)", opacity : 1, transform : "translateY(0px)"});
                
                timers(component).push(setTimeout( function(){

                    component.css( {"transition" : "none", "z-index" : zindex == - 1 ? "auto" : zindex});
                    
                    component.animating = false;
                    component.enable();
                    //component.updateDisplay(true);

                    if (callback)
                        callback();

                }, showSpeed * 1000));


            }, defaultTimeout) );
        
        },
        hide : function(component, callback)
        {   
            cleanTimers(component);

            offset = -(component.realHeight * 0.15);

            component.animating = true;
            component.css({transition : "none", transform : "translateY(0px)", opacity : 1, "visibility" : "visible"});
            

                timers(component).push(setTimeout(function(){

                    component.css({transition : "all " + hideSpeed + "s cubic-bezier(0.11, 0, 0.5, 0)", opacity : 0, transform : "translateY(" + offset + "px)"});
                    
                    timers(component).push(setTimeout( function(){
                        
                        component.css( {"transition" : "none", "visibility" : "hidden"});
                        component.disable();
                        component.animating = false;
                        
                        if (callback)
                            callback();

                    }, hideSpeed * 1000));

                }, defaultTimeout));
            //}, defaultTimeout);
        }
    };

})();
fx.animate.vzigzag = (function(){

	let easing = "cubic-bezier(0.455, 0.03, 0.515, 0.955)",
		showSpeed = 0.5, // speed to show an element
		hideSpeed = 0.25, // speed to show an element
        defaultTimeout = 10,
        range = 150;
		dom = fx.get("dom");
		


	return {
		show : function(component, callback){
            
            component.animating = true;

            let top = (-range + Math.round(Math.random() * (range*2))) + "px";
            let left = (-range+ Math.round(Math.random() * (range*2))) + "px";
            // let's disable transition
            let position = dom.css(component.node, "position");
            position = position == "static" ? undefined : position;

            let viewport = component.viewport();

            component.viewport({top : top/*, left : left*/}, true);
            dom.css(component.node, {"transition": "none", opacity : 0, "visibility" : "visible", top:top/*, left : left*/, position:"relative"});
         
            setTimeout(function(){

                dom.css(component.node, {transition : "all " + (showSpeed) + "s " + easing});

			    setTimeout(function(){
                
                    dom.css(component.node, {opacity : 1, top:"0px", left : "0px"});
                    
                    setTimeout( function(){
                        dom.css(component.node, {"transition" : "none", position:position});
                        component.viewport(viewport, true);

                        component.animating = true;
                        component.enable();
                        component.updateDisplay(true);
			
                        if (callback)
                            callback();

                    }, showSpeed * 1000);


                }, defaultTimeout);
            }, defaultTimeout);
		},
		hide : function(component, callback){
			
			let top = (-range + Math.round(Math.random() * (range*2))) + "px";
            let left = (-range+ Math.round(Math.random() * (range*2))) + "px";
            // let's disable transition
            let position = dom.css(component.node, "position");
            position = position == "static" ? undefined : position;

            let viewport = component.viewport();

            dom.css(component.node, {transition : "all " + hideSpeed + "s " + easing, "visibility" : "visible", position:"relative", top:viewport.top, left:viewport.left});
         
            setTimeout(function(){

                component.viewport({top : top/*, left : left*/}, true);
                dom.css(component.node, {opacity : 0, top:top/*, left : left*/});

			    setTimeout(function(){
                
                    component.viewport(viewport, true);
                    dom.css(component.node, {"transition" : "none", position:position});
                    component.disable();

                        if (callback)
                            callback();

                    }, hideSpeed * 1000);

               
            }, defaultTimeout);
		}
	};

})();
fx.animate.zigzag = (function(){

	let easing = "cubic-bezier(0.455, 0.03, 0.515, 0.955)",
		showSpeed = 0.5, // speed to show an element
		hideSpeed = 0.25, // speed to show an element
        defaultTimeout = 10,
        range = 150;
		dom = fx.get("dom");
		


	return {
		show : function(component, callback){
            
            component.animating = true;

            let top = (-range + Math.round(Math.random() * (range*2))) + "px";
            let left = (-range+ Math.round(Math.random() * (range*2))) + "px";
            // let's disable transition
            let position = dom.css(component.node, "position");

            let viewport = component.viewport();

            component.viewport({top : top, left : left}, true);
            dom.css(component.node, {"transition": "none", opacity : 0, "visibility" : "visible", top:top, left : left, position:"relative"});
         
            setTimeout(function(){

                dom.css(component.node, {transition : "all " + (showSpeed) + "s " + easing});

			    setTimeout(function(){
                
                    dom.css(component.node, {opacity : 1, top:"0px", left : "0px"});
                    
                    setTimeout( function(){
                        dom.css(component.node, {"transition" : "none", position:position});
                        component.viewport(viewport, true);

                        component.animating = false;
                        component.enable();
                        component.updateDisplay(true);
			
                        if (callback)
                            callback();

                    }, showSpeed * 1000);


                }, defaultTimeout);
            }, defaultTimeout);
		},
		hide : function(component, callback){
			
			let top = (-range + Math.round(Math.random() * (range*2))) + "px";
            let left = (-range+ Math.round(Math.random() * (range*2))) + "px";
            // let's disable transition
            let position = dom.css(component.node, "position");

            let viewport = component.viewport();

            dom.css(component.node, {transition : "all " + hideSpeed + "s " + easing, "visibility" : "visible", position:"relative", top:viewport.top, left:viewport.left});
         
            setTimeout(function(){

                component.viewport({top : top, left : left}, true);
                dom.css(component.node, {opacity : 0, top:top, left : left});

			    setTimeout(function(){
                
                    component.viewport(viewport, true);
                    dom.css(component.node, {"transition" : "none", position:position});
                    component.disable();

                        if (callback)
                            callback();

                    }, hideSpeed * 1000);

               
            }, defaultTimeout);
		}
	};

})();
/**
 * Box
 * @constructor fx.components.Box
 * @param {object} dom DOM
 */
fx.ns("fx.components", class Box extends fx.Component {

	constructor(data, css)
	{
		super(data);
		
		this.classname = (data && typeof data == "string") ? data : (!data || !data.className) ? "" :data.className;
        
		if (typeof data == "string")
			this.classname = data;

		this._css = css
	}

	onReady()
	{
		super.onReady();

		if (this.classname)
			this.addClass(this.classname);

		if (this._css)
			this.css(this._css);
	}

});
fx.ns("fx.components", class HBox extends fx.components.Box {

    constructor(data){
        super(data);
        //this.align = (data && data.align) ? data.align : "left";

        this.dom = fx.get("dom");
    }

    get valign()
    {
        return this._valign;
    }

    // set vertical align
    set valign(val)
    {
        this._valign = val || "top";
        this._setAlign();
    }

    create()
    {
        super.create();
    }

    onReady()
    {
        super.onReady();
        this._setAlign();
        this.updateDisplay();
    }

    resize(){
        super.resize(true);

        let childs = this.getChilds();
        let viewport = this.viewport();
        
        if (!viewport.height) // --> highest child
        {
            let maxHeight = 0;
            for (let index = 0; index < childs.length; index++)
            {
                childs[index].resize();   
                let height = childs[index].realHeight;
                if (height > maxHeight)
                    maxHeight = height;
            }

            this.css({height : maxHeight} );
        }

        if (!viewport.width) // --> 100%
        {
            //this.width("100%");
            this.css({width : "100%"} );
        }

        //this.css("text-align" , this.align);
   
    }

    /*position() {
        super.position(true);

        // each child should be alignated to left
        let childs = this.getChilds();
        for (let index = 0; index < childs.length; index++)
        {
            if (childs[index].initialized)
            {
                this.css(childs[index].node, {position:"relative", display: (childs[index].node.style["display"] == "none" ? "none" : "inline-block") });
            }
        }   
    }*/

    _setAlign()
    {
        if (!this.initialized) return;

        if (this.valign != "bottom")
            this.removeClass("bottom");

        if (this.valign != "top")
            this.removeClass("top");

        if (this.valign != "middle")
            this.removeClass("middle");

        if (!this.hasClass(this.valign))
            this.addClass(this.valign);
    }
        
});
fx.ns("fx.components", class VBox extends fx.components.Box {

    constructor(data) {
        super(data);
    }
    
    onReady(){
        super.onReady();

        this.updateDisplay();
    }

    _initChildren() 
    {
        // childs should be displayed in one column
        let childs = this.getChilds();
        for (let index = 0; index < childs.length; index++)
            childs[index].css({position:"relative"});
            
        super._initChildren();
                
    }
});
fx.ns("fx.components", class Button extends fx.Component {

	constructor(parameters){

		super(parameters ? parameters.data : null);

		this._label = (typeof parameters == "string") ? parameters : ( (parameters && parameters.label) ? parameters.label : "" );
		this.classname = (parameters && parameters.className) ? parameters.className : "";
		this.clickCallback = parameters && parameters.click? parameters.click : null;
		this.type = parameters && parameters.type ? parameters.type : null; // borderOnly / filled
		this._icon = parameters && parameters.icon ? parameters.icon : false;
		this.iconPosition = parameters && parameters.iconPosition ? parameters.iconPosition : (this._label ? "left" : "center");
		this._disabled = (parameters ? parameters.disabled : false) || false;

		if (parameters && parameters.toolTip)
			this.toolTip = parameters.toolTip;
		
		if (parameters && parameters.title)
			this.title = parameters.title;
		
	}

	get label()
	{
		return this._label;
	}

	set label(val)
	{
		this._label = val;

		this.update(true);
	}

	get disabled()
	{
		return this._disabled;
	}

	set disabled(val)
	{
		this._disabled = val;
		
		this._updateDisabled();
	}

	get icon()
	{
		return this._icon;
	}

	set icon(val)
	{
		this._icon = val;
		if (this.initialized)
			this.update();
	}

	onReady()
	{
		super.onReady();

		if (this.classname)
			this.addClass(this.classname);

		if (this.type)
			this.addClass(this.type);

		this._updateDisabled();

		this.on("click", this.onClick, this.find(".shape"));

		this.on("click", this._onClick);
	}

	
	destroy(){
		super.destroy();
		this.clickCallback = null;
	}

	render()
	{
		let icon = (this.icon ? this.icon.render("button-icon " + this.iconPosition) : '');

		let html = '<div class="shape ' + (this.disabled ? "dsiabled" : "") + '">';

		if (this.iconPosition != "right" ) 
			html += icon;

		html += '<span class="text">' + this._label + '</span>';
		
		if (this.iconPosition == "right" ) 
			html += icon;

		html += '</div>';
		
		return html;
	}

	_onClick(e)
	{
		if (this.disabled)
			e.stopPropagation();
	}

	onClick(e)
	{
		if (this.disabled)
			e.stopPropagation();
		else
		if (this.clickCallback)
			this.clickCallback(e, this.data);
	}

	_updateDisabled()
	{
		this.toggleClass("disabled", this.disabled);
	}
});
fx.ns("fx.components", class CheckList extends fx.Component {

	constructor(parameters)
	{
		super();

		this._items = parameters ? (parameters.items || ( parameters || [] ) ) : [];
		this._className = parameters ? parameters.className : "";
		this._selectedIndex = parameters ? parameters.selectedIndex || 0 : 0;
		
	}

	get selectedIndex()
	{
		return this._selectedIndex;
	}

	set selectedIndex(val)
	{
		this._selectedIndex = val;

		if (this.initialized)
			this._selectItem( this._selectedIndex );
	}

	get items()
	{
		return this._items;
	}

	render(){

		let html = '';

		for (let i = 0; i < this._items.length; i++)
		{
			let item = this._items[i];
			item.__id = item.id || Utils.newID();

			html +='<div id="' + item.__id + '" class="select-item';
			html += (i == this.selectedIndex) ? ' active' : '';
			html +='">';
			html +='<div class="filter">';
			html += this._items.getItemAt(i).label;
			html +='</div>';
			html += fx.assets.checkmark.render();
			html +='</div>';
		}

		return html;
	}

	onReady (){
		
		if (this._classname)
			this.addClass(this._classname);

		this.filters = this.find(".select-item");

		this.on("click", this.onSelect, this.filters);
	}

	onSelect(e)
	{
		// if e.target contain active do nothing;
        if(fx.dom.parent(e.target, ".active"))
			return;
		
		// set current item
		let selectItem = fx.dom.parent(e.target, ".select-item");

		if (selectItem)
		{
			for (let i = 0; i < this._items.length; i++)
			{
				if (this._items[i].__id == selectItem.getAttribute("id"))
				{
					this._selectItem(i);
					break;
				}
			}
		}
	}

	_selectItem(index)
	{
		let item = this.items[index];

		if (item)
		{
			this.removeClass(this.find(".active"), "active");
			this.addClass( this.find("[id=" + item.__id +"]") , "active");
			this._selectedIndex = index;
			this.trigger("changed", this.selectedIndex);
		}
	}
	
});
fx.ns("fx.components", class ColorPickerButton extends fx.components.HBox {

    constructor(parameters)
    {
        super();
        this.pickerType = parameters ? parameters.pickerType : null; 
        this.noEffect = parameters ? parameters.noEffect : false;
        this.label = parameters ? parameters.label : null; 
        this.lastColor = ( parameters && parameters.lastColor ) ? parameters.lastColor : "#000";
        this.lastColors =  ( parameters && parameters.lastColors ) ? parameters.lastColors : ["#000000", "#7F7F7F", "#727272", "#515151", "#303030", "#0F0F0F"];
        this._showOpacity = parameters ? parameters.showOpacity : false; 
        this.direction = parameters && parameters.direction ? parameters.direction : "bottom"; 
    }


    get currentColor()
    {
        if (this.colorPicker)
            return this.colorPicker.currentColor;

        return null;
    }

    set currentColor(val)
    {
        if (this.colorPicker)
            this.colorPicker.currentColor = val;
    }

    get toolTip()
	{
		return "";
	}

	set toolTip(val)
	{
		this._toolTip = val;

        if (this.colorbox)
            this.colorbox.toolTip = this._toolTip;
	}

    onReady()
    {
        super.onReady();

        this.on("click", this.onClick, window);
        this.on("selected", this.onSelected, this.colorPicker);

        this.on("selected-all", this.onSelectedAll, this.colorPicker);

        this.updateButtonColor();
        this.colorbox.toolTip = this._toolTip;
    }

    create()
    {
        super.create();

        if (this.label)
        {
            this.labelText = new fx.components.Text( {text : this.label, className : "label"} )
            this.addChild(this.labelText, {width:"auto", height : 30});
        }

        this.colorbox = new fx.components.Image({data : fx.get("assets").paletteIcon, className :"colorbox"} );
        //this.colorbox = new fx.components.Box("colorbox");
        this.addChild(this.colorbox, {width : 30, height : 30});

        this.colorPicker = new fx.components.ColorPicker({lastColors:this.lastColors, currentColor : this.lastColor, showOpacity : this._showOpacity, pickerType: this.pickerType});
        this.colorPicker.visibleAtStart = false;
        if(!this.noEffect)
            this.colorPicker.effect = (this.direction =="bottom") ? "vslide" : "fade";
        this.addChild(this.colorPicker, {top : this.direction =="bottom" ? 4 : -254, left : 2/*, width : 315, height:200*/});
        
    }

    selectionChanged()
    {
        //this.css(this.colorIcon, {fill : this.component[this.command.field] } );  
    }

    destroy()
    {
        super.destroy();
        
        this.colorPicker = null;
    }

    onClick(e)
    {
        if (!this.visible)
            return;

        let colorbox = fx.dom.parent(e.target, ".colorbox");
        let colorPicker = fx.dom.parent(e.target, ".ColorPicker");
        if (colorbox == this.colorbox.node)
        {
            if (this.colorPicker.visible)
                this.colorPicker.hide();
            else
                this.colorPicker.show();
        }
        else
        if (this.colorPicker.visible && colorPicker != this.colorPicker.node && e.target.parentNode)
            this.colorPicker.hide();

       
    }


    onSelected(event)
    {
        this.updateButtonColor(event.detail);
    }

    onSelectedAll(event)
    {
        this.updateButtonColor(event.detail, true);
    }

    updateButtonColor(color, all)
    {
        this.lastColor = color || this.lastColor;
        
        //this.colorbox.css("background-color", this.lastColor);

        this.trigger(all ? "color-all" : "color", this.lastColor);
    }


});
fx.ns("fx.components", class DatePicker extends fx.Component 
{
    constructor(parameters)
    {
        super();

        this._pickLevel = parameters && parameters.pickLevel != undefined ? parameters.pickLevel : 0; 
        this._minDate = parameters && parameters.minDate != undefined ? parameters.minDate : undefined; 
        this._maxDate = parameters && parameters.maxDate != undefined ? parameters.maxDate : undefined; 
        this._maxView = parameters && parameters.maxView != undefined ? parameters.maxView : undefined; 
        this._defaultDate = parameters && parameters.defaultDate != undefined ? parameters.defaultDate : undefined; 
    }

    get selectedDate()
    {
        if (this._datepicker)
            return this._datepicker.getDate()
    }

    create()
    {
        super.create();
        
        this._datepicker = new Datepicker(this.node, {
            language : fx.currentLang(),
            nextArrow : ">",
            prevArrow : "<",
            pickLevel : this._pickLevel,
            minDate : this._minDate,
            maxDate : this._maxDate,
            maxView : this._maxView,
            defaultViewDate : this._defaultDate
        });    
    }

    onReady()
    {
        super.onReady();

        this.on("changeDate", this.onDateChanged, this.node); 
    }

    onDateChanged()
    {
        this.trigger("changed");
    }

});
fx.ns("fx.components", class DefaultRenderer extends fx.Component {

	constructor(data) {
		super(data);
    }
    
	static HEIGHT()
	{	
		return  45;
	}


	render(){
		return ( (this.data && this.data.text) ? this.data.text : this.data );
	}

	defaultHeight(){
		return 20;
	}
});
/**
 * FileSelector allow to select files from device.
 * Contructor allows to specify files types and multiple selection.
 * Wehn files are selected, this component trigger "files-selected" event with array of selected files in event.detail.
 * 
 * Call destroy function when finish using.
 */
fx.ns("fx.components", class FileSelector extends fx.EventDispatcher {

    /**
     * FileSelector optional parameters :
     * - fileTypes : array of files extensions. Example : new fx.components.FileSelector({fileTypes : [".jpeg", ".jpeg", ".png"]}). Default value : ["*"]
     * - multipleSelection : boolean. If true, user can select multiple files. Default value : false.
     * @param {Object} parameters 
     */
    constructor(parameters)
    {
        super();

        this._fileTypes = (parameters && parameters.fileTypes) ? parameters.fileTypes : ["*"];
        this._multipleSelection = (parameters && parameters.multipleSelection) ? parameters.multipleSelection : false;
    
        this._input = document.createElement('input');
        this._input.id = Utils.newID();
        this._input.setAttribute("id", Utils.newID());
        this._input.setAttribute("type", "file");
        this._input.setAttribute("accept", this._fileTypes.join(",") /*".jpg,.jpeg,.png"*/);
        if (this._multipleSelection)
            this._input.setAttribute("multiple", "multiple");
        this._input.style.display = "none";
       
        this.on("change", this._onFilesSelected, this._input);
        this.on("cancel", this._onFilesCanceled, this._input);

        document.body.appendChild( this._input );
    }

    get fileTypes()
    {
        return this._fileTypes;
    }

    set fileTypes(val)
    {
        this._fileTypes = val;
        this._input.setAttribute("accept", this._fileTypes.join(",") );
    }

    get multipleSelection()
    {
        return this._multipleSelection;
    }

    set multipleSelection(val)
    {
        this._multipleSelection = val;
        
        if (this._multipleSelection)
            this._input.setAttribute("multiple", "multiple");
        else
            this._input.removeAttribute("multiple");
    }

    /**
     * Call this function to open an explorer, so user can select files.
     */
    selectFiles()
    {
        this._input.click();
    }

    get files()
    {
        if(!this._files)
            this._files = [];
            
        return this._files;
    }

    _onFilesCanceled(event)
    {
        this.trigger("files-canceled");
    }

    _onFilesSelected(event)
    {
        this._files = [];
        var wrong_extension = true;

        // TODO : make this part work even for file like photo.2012.jpeg 
        // we filter here only valid image types
        for (let i = 0; i < event.target.files.length; i++)
        {
            let file = event.target.files[i];

            let ext = "." + file["name"].toLowerCase().split('.').pop();

            if ( this._fileTypes.indexOf(ext) > -1 )
            {
                wrong_extension = false;
                this._files.push(file);
            }
        }

        // no this._files, we do nothing
        if (this._files.length == 0)
        {
            if(wrong_extension)
                this.trigger("files-extension-error");
            return;
        }

        // clear input, so user can select again the same files
        this._input.value = "";

        //this.model.event("files-selected", files);
        this.trigger("files-selected", this._files);
    }

    destroy()
    {
        super.destroy();

        fx.dom.remove(this._input.id);
        this._files = null;
    }

});
/**
 * Display horizontal list by creating dynamically graphical components only when visible, and destroying them when hidden.
 * Parameters :
 * - scrollOnNew : scroll automatically on new element. Default value : false
 * - renderers : object of renderers for each data type. Example : { Sticker : renderers.StickerRendered, Background : renderers.BackgroundRenderer }]
 * - marginRight : after last element, add margin
 * - lastItem : if need to show a static componenent as last item, provide class
 * - labelPosition : "top" / "bottom", if label is displayed, this parameter sets its position
 * If list of data is given with groups, and each group has a label, label will be displayed graphically at the beggining of each group.
 */
fx.ns("fx.components", class HorizontalDynamicList extends fx.Component {

    constructor(parameters)
    {
        super(parameters && parameters.data);

        this._scrollOnNew = parameters && parameters.scrollOnNew;
        this._renderers = parameters && parameters.renderers;
        this._marginRight = (parameters && parameters.marginRight) || 10;
        this._marginLeft = (parameters && parameters.marginLeft) || 10;
        this._lastItem = parameters && parameters.lastItem;
        this._labelPosition = parameters && parameters.labelPosition;
        this._sharedData = (parameters && parameters.sharedData) ? parameters.sharedData : null;
        this._elementWidth = (parameters && parameters.elementWidth) ? parameters.elementWidth : 0;
        this._elementHeight = (parameters && parameters.elementHeight) ? parameters.elementHeight : 0;
        this._paddingElementRight = (parameters && parameters.paddingElementRight) ? parameters.paddingElementRight : 0;
        this._elementEffect = parameters && parameters.childEffect;

        this.filter = (parameters && parameters.filter) ? parameters.filter : null;

        this._visibleItems = [];
        this._newItems = {};
        this._currentRenderers = {};

        // we load items that are 100 pixels outside of view in order to improve experience
        this._OFFSET_DISPLAY = 100;

        this._structure = [];

        this._manageNewItemsHandler = this._manageNewItems.bind(this);
    }

    get data()
    {
        return super.data;
    }

    set data(val)
    {
        super.data = val;
    }

    create()
    {
        super.create();

        this.container = new fx.components.Box("container");
        this.addChild(this.container, {top:0, left : 0, width : "100%", height:"100%"});
    }

    onReady()
    {
        super.onReady();

        this.on("scroll", this.onScroll);
        this.on("click", this.onClick);
    }

    forceUpdate()
    {
        if (this.filter)
            this.filter.refresh();

        this.delay(this._update, 50);
    }

    getChildFromUI(element)
    {
        return this.container.getChildFromUI(element);
    }
    

    onDisplayUpdated()
    {
        this.delay(this._updateDisplay, 500);
    }

    _updateDisplay()
    {
        if (this._estimateStructure())
            this._calculateVisibleElements();
    }


    onScroll(e)
    {
        this._calculateVisibleElements();
    }

    onClick(e)
    {
        if (!this.enabled || fx.dom.parent(this.node, ".disabled"))
            return;

        let found = null;

        if (this._lastItem)
        {
            let elt = fx.dom.parent(e.target, "." + this._lastItem.name)    
            if (elt)
                found = elt;
        }

        if (!found)
        {
            for (let prop in this._renderers)
            {
                let renderer = this._renderers[prop];
                let elt = fx.dom.parent(e.target, "." + renderer.name)
                if (elt)
                {
                    found = elt;
                    break;
                }
            }
        }

        if (found)
        {
            let component = this.container.getChild(found.id);
            this.trigger("selected", (this._lastItem && (component instanceof this._lastItem)) ? "lastItem" : component.data);
        }
    }

    scrollToLeft()
    {
        if (this.node)
            this.node.scrollLeft = 0;
    }

    scrollToElement(item)
    {
        if (!this._structure) return;
        
        let obj;
        for (let i = 0; i < this._structure.length; i++)
        {
            let element = this._structure[i];
            
            if (element.item == item)
            {
                obj = { left : element.left, id : element.item.id };
                break;
            }
        }

        if (obj)
        {
            this.node.scrollLeft = obj.left;
            return obj.id;
        }
    }

    onChildUpdated(action)
    {
        if(action.impacts("id"))
        {
            let elements = this._structure.filter( element => element.id == action.previous.id);

            // let update structure
            for (let i = 0; i < elements.length; i++)
            {
                let obj = elements.getItemAt(i);
                obj.id = action.data.id;
            }
        }
    }
    
    onDataUpdated(action)
	{
        if (!this.initialized)
            return;

        // optimization for we add new items in a smooth way
        if (action.type == "addItem")
        {
            for(let i = 0; i < action.items.length; i++)
                this._newItems[action.items[i].id] = action.items[i];

            // let's store the first element, so we scroll to this element
            if (!this._newItems.first)
                this._newItems.first = action.items[0];

            this.delay( this._manageNewItems, 500);
        }
        else
        {
            if (action.type == "init")
                this.container.removeAllChild(true);
                
            this.delay(this._update, 50);
        }
    }

    _manageNewItems()
    {
        this._estimateStructure();
        if (this._canScroll && this._scrollOnNew)
            this.scrollToElement( this._newItems.first );
        else
            this._calculateVisibleElements();
    }

    _update()
    {
        if (this._estimateStructure())
            this._calculateVisibleElements();
    }
    
    _estimateStructure()
    {
        let structure = [];
        structure.signature = "";

        let data = this.data instanceof fx.ModelArray ? this.data.toArray() : this.data;
        let hasLabels = data.length > 0 && data[0].type == "label";
        let totalWidth = this._marginLeft;
        let left = this._marginLeft;
        let maxRowHeight = this.realHeight - (hasLabels ? 20 : 0);
        
        for(let i = 0; i < data.length; i++)
        {
            let element = data[i];
            if (element.deleted)
                continue;

            if (element.type == "label")
            {
                element.id = element.id || Utils.newID();
                structure.push( { id : element.id, item : element, height : 20, top : (this._labelPosition == "bottom") ? (this.realHeight - 15): 0, left : left} );
            }
            else
            {
                let newWidth = maxRowHeight * Number(this._elementWidth ? this._elementWidth : element.width) / Number(this._elementHeight ? this._elementHeight : element.height);
                
                structure.push( { id : element.id, item : element, top : hasLabels ? ((this._labelPosition == "bottom") ? 0 : 20) : 0, left : left, width : newWidth, height : maxRowHeight} );
                
                totalWidth += newWidth + this._paddingElementRight;
                left += newWidth + this._paddingElementRight;
            }

            structure.signature = structure.last().id + "|" + structure.signature;
        }

        if (this._lastItem)
        {
            let id = Utils.newID();
            structure.push( { id : id, item : "lastItem" , top : hasLabels ?  ((this._labelPosition == "bottom") ? 0 : 20) : 0, left : left, width : maxRowHeight, height : maxRowHeight} );
            totalWidth += maxRowHeight;
            left += maxRowHeight
        }

        structure.totalWidth = totalWidth + this._marginRight;

        // allow to know if structure changed
        //if (this._structure.signature != structure.signature)
        //{
            this._structure = structure;

            this._canScroll = this._structure.totalWidth > this.realWidth;

            this.container.width(this._canScroll ? this._structure.totalWidth : "100%");

            return true;
        //}
        //else
          //  return false;
    }

    _calculateVisibleElements()
    {
        if (!this._structure) return;

        let visibleItems = {};

        for (let i = 0; i < this._structure.length; i++)
        {
            let element = this._structure[i];

            if (element.left + (element.width || 150) >= this.node.scrollLeft - this._OFFSET_DISPLAY && element.left <= this.node.scrollLeft + this.node.clientWidth + this._OFFSET_DISPLAY)
                visibleItems[element.id] = element;
        }
   
        for (var id in this._currentRenderers)
        {
            if (!visibleItems[id])
            {
                this._currentRenderers[id].destroy();
                delete(this._currentRenderers[id]);
            }
        }
       
       for (var id in visibleItems)
       {
            let element = visibleItems[id];

            if (!this._currentRenderers[element.id])
            {
                let child, renderer;

                if (this._renderers && element.item)
                    renderer = (element.item == "lastItem") ? this._lastItem : this._renderers[Object.getPrototypeOf(element.item).constructor.name];
                
                if (!renderer)
                    renderer = fx.components.DefaultRenderer;

                child = new renderer( element.item, this._sharedData );
                child.addClass("Renderer");
                
                if (child instanceof fx.components.DefaultRenderer)
                    child.effect = "";
                else
                if (this._newItems[element.id])
                    child.effect = "scale";
                else
                    child.effect = this.elementEffect;
                
                this.container.addChild( child );
                this._currentRenderers[element.id] = child;
            }
            
            this._currentRenderers[element.id].viewport( {width : element.width || "auto", height: element.height, top : element.top, left : element.left} );
            
       }
       this._newItems = {};
    }

});
/**
 * Box
 * @constructor fx.components.Box
 * @param {object} dom DOM
 */
fx.ns("fx.components", class IFrame extends fx.Component {

	constructor(data)
	{
		super();

        this._tag = "iframe";
		
        if (data)
        {
            if (typeof data == "string")
                this._url = data;
            else
            {
                if(data.url)
                    this._url = data.url;

                if(data.className)
                    this.classname = data.className;
            }
        }
	}

    get url()
    {
        return this._url;
    }

    set url(val)
    {
        this._url = val;

        if (this.initialized)
            this._updateFrame();
    }

	onReady()
	{
		super.onReady();

		if (this.classname)
			this.addClass(this.classname);

        this._updateFrame(); 
    }

    _updateFrame()
    {
        this.attr("src", this.url);
    }
});

/**
 * IconButton constructor
 * @constructor fx.components.IconButton
 */

fx.ns("fx.components", class IconButton extends fx.components.Button {
	
	constructor(parameters){
		super(parameters);

		this._asset = parameters ? parameters.icon : null;
		
		if (Utils.typeEqual(this._asset, "string"))
			this._asset = new fx.Asset(this._asset);

		this.classname = parameters ? parameters.className : null;
		this.filled = parameters ? parameters.filled : null;
		this.iconRatio = parameters && parameters.iconRatio ? parameters.iconRatio : 0.50;

		this._textMargin = parameters && parameters.textMargin ? parameters.textMargin : 10;

		this._DEFAULT_SIZE = 100;
		
	}

	get icon()
	{
		return this._asset;
	}

	set icon(val)
	{
		this._asset = val;
		this.update();
	}

	get shapeComponent()
	{
		if (!this._shapeComponent)
			this._shapeComponent = this.find(".circle");

		return this._shapeComponent;
	}

	get iconComponent()
	{
		if (!this._iconComponent)
			this._iconComponent = this.find(".icon");

		return this._iconComponent;
	}

	get labelComponent()
	{
		if (!this._labelComponent)
			this._labelComponent = this.find(".label");

		return this._labelComponent;
	}

	onReady(){
		
		if (this.classname)
			this.addClass(this.classname);

		if (this.filled)
			this.addClass("filled");

		this.on("click", this.onClick);
	}

	resize()
	{
		if (!this.initialized)
			return;

		let height = parseInt(this._viewport.height);
		let width = parseInt(this._viewport.width);
		if (isNaN(height) && isNaN(width))
		{
			height = this._DEFAULT_SIZE;
			width = this._DEFAULT_SIZE;
		}
		else
		if (isNaN(height))
			height = width;
		else
		if (isNaN(width))
			width = height;

		this._viewport.height = height;
		this._viewport.width = width;

		super.resize();

		if (this.label)
		{
			height -= parseInt(fx.dom.css(this.labelComponent, "font-size")) /*fx.dom.outerHeight(this.labelComponent)*/ + this._textMargin;
			width -= parseInt(fx.dom.css(this.labelComponent, "font-size")) /*fx.dom.outerHeight(this.labelComponent)*/ + this._textMargin;
		}

		this._circleWidth = width;
		this._circleHeight = height;
		this._iconWidth = width * this.iconRatio;
		this._iconHeight = height * this.iconRatio;

		fx.dom.css(this.shapeComponent, {width : this._circleWidth, height : this._circleHeight});
		fx.dom.css(this.iconComponent, {width : this._iconWidth, height : this._iconHeight});
		fx.dom.css(this.labelComponent, {width : "100%"});
	}

	position()
	{
		super.position();

		if (!this.initialized)
			return;

		fx.dom.css(this.shapeComponent, {left : (this.realWidth - this._circleWidth) / 2, top : 0});

		fx.dom.css(this.iconComponent, {left : (this._circleWidth - this._iconWidth) / 2, 
										top : (this._circleHeight - this._iconHeight) / 2});
			
		if (this.labelComponent)
			fx.dom.css(this.labelComponent, {top : this._circleHeight + this._textMargin, left : 0});
		
	}

	render()
	{			
		let html = '';

		if (this._asset)
			html += '<div class="circle">' + this._asset.render("icon") + '</div>';
	
		if (this.label)
			html += '<div class="label">' + this.label + '</div>';

		return html;
	}

});
fx.ns("fx.components", class Image extends fx.Component {

  constructor(data)
  {
    super((data && data instanceof fx.Model ? data :  (data && data.data instanceof fx.Model) ? data.data : (data && data.url) ? data.url : (data && data.data ? data.data : data) ) );

    this.className = data && data.className ? data.className : "";
    this._cover = data && data.cover ? data.cover : false;
    this.assetClassName = (data && data.assetClassName) ? data.assetClassName : "photo";
    this.tooltip = (data && data.tooltip) ? data.tooltip : "";
  }

  
  get data()
  {
    return super.data;
  }

  set data(val)
  {
    super.data = val;
    this.cover = false;
    if (this.initialized)
      this.update();
  }

  get url()
  {
    let url;

    if (this.data)
    {
      if (typeof this.data == "string")
        url = this.data;
      else
      if(this.data && "thumb" in this.data)  
        url = this.data.thumb;
      else
      if(this.data && this.data.url)  
        url = this.data.url;
    }

    return url;
  }

  get src()
  {
    if (this._src)
      return this._src;
    else
      return this.url;

    /*if (this.cover)
      return this._src;
    
    let img = this.find(this.assetClassName ? ("." + this.assetClassName) : ".image");
    if (img)
        return img.src;*/
  }

  set src(val)
  {
    this._src = val;
    this.cover = true;
    
    if (this.initialized)
        this.update();

    /*if (this.cover)
    {
      let img = this.find(this.assetClassName ? ("." + this.assetClassName) : ".image");
      if (img)
      {
        img.src = "";
        fx.dom.css(img, {"display" : "none"});
      }

      this.css({"background-image" : "url(" + val + ')'});
      this._src = val;
    }
    else
    {
      let img = this.find(this.assetClassName ? ("." + this.assetClassName) : ".image");
      if (img)
          img.src = val;
    }

      fx.dom.toggleClass(this._image, "empty", !val);*/
  }

  get cover()
  {
    return this._cover
  }

  set cover(val) // TODO : create a real switch from Image to Cover Image
  {
      this._cover = val;

      if (this.initialized)
        this.update();
  }

  
  onReady()
  {
    super.onReady();

    this.addClass(this.className);

    if (this.data && this.data.id)
      this.attr('data-id', this.data.id);

    if (this.tooltip)
      this.attr("title", this.tooltip);

    //this._addImage();
    //this.render();
  }

  create()
  {
    this.update();
  }

  update()
  {
    if (!this.node) return;
    
      if (this.cover)
      {
        if (this._image && this.node.contains(this._image))
          this._image.remove();

          this.node.innerHTML = "<div class='cover' style='background-image: url(" + (this.src ? this.src : "") + ")'></div>";
      }
      else
      {
        if (this.data instanceof fx.Asset)
          this.node.innerHTML = this.data.render(this.assetClassName);   
        else
        {
          if (!this._image)
          {
            this._image = new window.Image();
            this.node.innerHTML = "";
            this.node.appendChild( this._image );
            fx.dom.addClass(this._image, "image");
          }
        
          if (this.url || this.src)
          {
            fx.dom.removeClass(this._image, "empty");

            this._addImageListeners(true);
                    
            this._image.src = this.url ? this.url : this.src;
          }
          else
          {
            
            if (this._image)
            {
              fx.dom.addClass(this._image, "empty");
              this._image.src = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs%3D"; // empty
            }
          }
        }

      }

      this._refreshHandlers();
		  this.updateDisplay();
      
  }


  onDataUpdated(action)
  {
    if (action.type == "update")
        this.update();

    /*if (action.impacts("thumb") )
      this.src = this.data.thumb;
    else
    if (action.impacts("url") )
      this.src = this.data.url;*/
  }


  _addImageListeners(add)
  {
    if (add)
    {
      this.on("load", this._onComplete, this._image);
      this.on("error", this._onError, this._image);
    }
    else
    {
      this.off("load", this._onComplete, this._image);
      this.off("error", this._onError, this._image);
    }
  }
      

  _onComplete()
  {
    this.trigger("complete");

    this._addImageListeners(false);
  }

  _onError()
  {
    this.trigger("error");
  }
  



});

fx.ns("fx.components", class ImageButton extends fx.components.Button {

    constructor(data)
    {
        super(data);

        this._image = data ? data.image : "";
    }

    get image()
    {
        return this._image;
    }

    set image(val)
    {
        this._image = val;
        this.update(true);
    }

    render()
    {
        return '<div class="shape">' + (this._image ? this._image.render("image") : "") + '<span class="label">' + this.label + '</span></div>';
    }
});
fx.ns("fx.components", class Input extends fx.Component {

    constructor(parameters)
    {
        super();
        
        this._value = (parameters && parameters.value !== undefined) ? parameters.value : "";
        this._placeHolder = (parameters && parameters.placeHolder) ? parameters.placeHolder : "";
        this._name = (parameters && parameters.name) ? parameters.name : "";
        this._type = (parameters && parameters.type) ? parameters.type : "text";
        this._maxlength = (parameters && parameters.maxlength) ? parameters.maxlength : 0;
    }

    /**************************** Parameters / Constants ******************************/

    get maxLength()
    {
        return this._maxlength;
    }
    
    get value()
    {
        if (this.initialized)
            return this._normalize(this.find(".input").value);

        return this._normalize(this._value);
    }

    set value(val)
    {
        this._value = val;

        if (this.initialized)
            this.find(".input").value = val;
    }

    get placeHolder()
    {
        return this._placeHolder;
    }

    set placeHolder(val)
    {
        this._placeHolder = val;

        if (this.initialized)
            this.find(".input").setAttribute("placeHolder", val);
    }


    get input()
    {
        return this.find(".input");
    }

    /**************************** Overrides ******************************/

    onReady()
    {
        super.onReady();

        //this.on("keyup", this.onKeyPress, this.find(".input"));
        this.on("keyup", this.onKeyPress, this.find(".input"));
    }


    render()
    {
		return '<input class="input" type="' + this._type + '" ' + (this._maxlength ? ('maxlength="' + this._maxlength + '"') : '') + ' value="' + this.value + '" placeholder="' + this.placeHolder + '" ' + (this._name ? ('name= "' + this._name + '"') : '') + '>';
    }
    
    enable()
    {
        super.enable();
        if (this.input)
            this.input.disabled = false;
    }

    disable()
    {
        super.disable();
        if (this.input)
            this.input.disabled = true;
    }

    focus(positionAtEnd)
    {
        this._focus(positionAtEnd);
            
    }

    /**************************** Events ******************************/
    onKeyPress(e)
    {
        let handled = false;

        if (e.keyCode == 13)
        {
            this.trigger("enter");
            handled = true;
        }
        else
        if (e.keyCode == 27)
        {
            this.trigger("escape");
            handled = true;
        }
        else
        {
            if (this._value != this.find(".input").value)
            {
                this._value = this.find(".input").value;
                this.trigger("updated", e);
                handled = true;
            }
        }

        if (handled)
        {
            e.preventDefault();
            e.stopPropagation();
        }
            
    }



    _focus(positionAtEnd) 
    {
        if (!this.input)
            return;

        if (positionAtEnd)
        {
            var elemLen = this.input.value.length;
            // For IE Only
            if (document.selection) {
                // Set focus
                this.input.focus();
                // Use IE Ranges
                var oSel = document.selection.createRange();
                // Reset position to 0 & then set at end
                oSel.moveStart('character', -elemLen);
                oSel.moveStart('character', elemLen);
                oSel.moveEnd('character', 0);
                oSel.select();
            }
            else if (this.input.selectionStart || this.input.selectionStart == '0') {
                // Firefox/Chrome
                this.input.selectionStart = elemLen;
                this.input.selectionEnd = elemLen;
                this.input.focus();
            } // if
        } 
        else
        {
            var savedTabIndex = this.input.getAttribute('tabindex')
            this.input.setAttribute('tabindex', '-1')
            this.input.focus()
            this.input.setAttribute('tabindex', savedTabIndex)
        }
    }

    _normalize(val)
    {
        return Utils.isNumber(val) ? Number(val) : (val ? val : "");
    }


});
/**
 * LinkButton constructor
 * @constructor fx.components.LinkButton
 */
fx.ns("fx.components", class LinkButton extends fx.components.Button {

    constructor(parameters){
        super(parameters);
    }
    
   
  
});
fx.ns("fx.components", class PopupPanel extends fx.Component {

    /**
     * 
     * @param {*} mode : allow to show this 
     */
    constructor(data) 
	{
		super(data);
		
        this.mode = "popup";

        if (typeof data == "string")
			this.classname = data;
	}

    get mode()
    {
        return this._mode;
    }

    set mode(val)
    {
        this._mode = val;

        this.showEffect = (val == "popup" || val == "") ? "scroll" : "hslideout";
		this.hideEffect = (val == "popup" || val == "") ? "scroll" : "hslidein"
    }

	create()
	{
        if (this.mode == "navigation")
        {
            this._backButton = new fx.components.Button({label: fx.text("Revenir"), icon : fx.get("assets").arrowBack, className : "exit"});
            this.addChild( this._backButton, {top : 0, left : 0});

        }
        else
        if (this.mode == "popup")
        {
            // Exit button
            this._exit = new fx.components.Box("exit");
            this._exit.effect = "fade";
            let exitButton = new fx.components.IconButton({ icon: fx.get("assets").ExitIcon, className: "exit" });
            this._exit.addChild(exitButton, { right: 10, top: 10, width: 40, height: 40 });

            if(fx.browser.isDesktop)
            {
                let exitLabel = new fx.components.Text({ text: fx.text("Fermer"), className: "button-label link left-label" });
                this._exit.addChild(exitLabel, { width: 100, height: 40, right: 60, top: 20 });

                this.addChild( this._exit, {top : 10, right : 10, width: 30, height: 30});
            }
            else
                this.addChild( this._exit, {top: 0, right: 0, width: 150, height: 60});
        }
	}

    onReady()
    {
        super.onReady();

        if (this._exit)
        {
            this.on(window.fx.browser.isMobile ? "tap" : "click", this.close, this._exit );
            this.on("ESCAPE", this.close, fx.keyboard);
        }
         
        if (this._backButton)
        {
            this.on("click", this.onBackClick, this._backButton);
            this.on("ESCAPE", this.onBackClick, fx.keyboard);
        }

		if (this.classname)
			this.addClass(this.classname);

        
	}

    onBackClick()
    {
        this.hideEffect = "hslideout";
        
        if (this.data)
            this.data.event("previous-step");
    }

	// exitToEditor => destroy views and go back to editor
	close()
	{
        // nothing to do, should be overrided
        this.hideDestroy();
	}

})
fx.ns("fx.components", class PopupPanelNavigation extends fx.components.PopupPanel {

    constructor() 
	{
		super();

        this._navigationData = [];
	}

    get currentView()
    {
        if (!this._navigationData[this._currentIndex])
            return;

        return this._navigationData[this._currentIndex].instance;
    }

    create()
    {
        super.create();

        // Back button
        this.back = new fx.components.Box("back");
        let backButton = new fx.components.IconButton( {icon: fx.get("assets").arrowBack} );
        let text = new fx.components.Text({text : fx.text("Revenir"), className : "button-label link"});
        this.back.addChild(backButton, {width:40, height:40, left : 0, top : 0})
        this.back.addChild(text, {width: 100, height : 20, top : 10, left : 40})    
        
        if(!window.fx.browser.isMobile)
            this.addChild(this.back, {top : 15, left : 15, width:150, height:40});
        else
        {
            this.back = new fx.components.IconButton({icon : fx.get("assets").orderArrow, className : "back"});
            this.addChild( this.back, {top : 10, left : 10, width: 30, height: 30});
        }
        this.back.visibleAtStart = false;
    }

    onReady()
    {
        super.onReady();
        this.on(window.fx.browser.isMobile ? "tap" : "click", this._onPreviousStep, this.back );
    }

    steps()
    {
        this._cleanNavigation();
        
        for(let i = 0; i < arguments.length; i++)
        {
            if(!Array.isArray(arguments[i]))
                this._navigationData.push({className : arguments[i]});
            else if(arguments[i].length > 0)
                this._navigationData.push({className : arguments[i][0], data : arguments[i][1]});
        }
        // add background for hiding first panel (and fixing transitions when opacity = 0)
        if(!this.background)
        {
            this.background = new fx.components.Box("background");
            this.addChild( this.background , {top:"0px", left:"0px", width:"100%", height:"100%"})
            this.background.visibleAtStart = false;
        }
        this._showStep( 0 );
    }


    _showStep(index, data)
    {      
        if (!this._navigationData[index])
            return;

        this._currentIndex = index;
        this.back.show();

        if (!this._navigationData[index].instance)
        {
            let constructor = Utils.getConstructor( this._navigationData[index].className ).fcn;
            this._navigationData[index].instance = new constructor();
            if(this._navigationData[index].data)
                this._navigationData[index].instance.data = this._navigationData[index].data;
            else if(data)
                this._navigationData[index].instance.data = data;
            else
                this._navigationData[index].instance.data = this.data;
            this._navigationData[index].instance.showEffect = "hslideout";
            this._navigationData[index].instance.hideEffect = "hslideout";
            this._navigationData[index].instance.addClass("navigation-panel");
            this.on("next-step", this._onNextStep, this._navigationData[index].instance );
            this.on("previous-step", this._onPreviousStep, this._navigationData[index].instance );
            this.on("reset-navigation", this._resetNavigation, this._navigationData[index].instance );
            this.on("close", this.close, this._navigationData[index].instance );
            
            this.addChild( this._navigationData[index].instance , {top:"0px", left:"0px", width:"100%", height:"100%"})
        }
        else
            this.currentView.show();
    }

    nextStep(event)
    {
        if (this._navigationData.length > 0)
        {
            if (this.currentView)
                this.currentView.hideEffect = "hslidein";
            if(this._currentIndex+1 < this._navigationData.length)
            {
                this.background.show();
                if (this.currentView)
                    this.currentView.hide();
                this._currentIndex++;
                if (this.currentView)
                    this.currentView.showEffect = "hslideout";
                this._showStep( this._currentIndex, event.detail );
            }
            else
                this._resetNavigation();
        }
        else
            this._resetNavigation();
    }

    previousStep(event)
    {
        if (this._navigationData.length > 0)
        {
            if (this.currentView)
                this.currentView.hideEffect = "hslideout";
            if(this._currentIndex>0)
            {
                if (this.currentView)
                    this.currentView.hide();
                this._currentIndex--;
                if (this.currentView)
                    this.currentView.showEffect = "hslidein";
                this._showStep( this._currentIndex, event.detail );
            }
            else
                this._resetNavigation();
        }
        else
            this._resetNavigation();            
    }

    _onNextStep(data)
    {
        this.nextStep(data);
    }
    
    _onPreviousStep(data)
    {
        this.previousStep(data);
    }

    // resetNavigation => go back to first view
    _resetNavigation(){
        if(this.background)
        {
            this.background.destroy();
            this.background = null;
        }
        if (this.currentView)
        {
            // the step destroys itself once hidden : it is forgotten right away, so that a later
            // steps() or destroy() does not destroy it a second time (its properties freed meanwhile)
            let instance = this.currentView;

            this.off("next-step", this._onNextStep, instance);
            this.off("previous-step", this._onPreviousStep, instance);
            this.off("reset-navigation", this._resetNavigation, instance);
            this._navigationData[this._currentIndex].instance = null;

            instance.hideDestroy();
        }
        this.back.hide();
    }

    destroy()
    {
        super.destroy();

        this._cleanNavigation();
    }

    _cleanNavigation()
    {
        for(let index = 0; index < this._navigationData.length; index++)
        {
            if (this._navigationData[index].instance)
            {
                this.off("next-step", this._onNextStep, this._navigationData[index].instance);
                this.off("previous-step", this._onPreviousStep, this._navigationData[index].instance);
                this.off("reset-navigation", this._resetNavigation, this._navigationData[index].instance);
                
                this._navigationData[index].instance.destroy();
                this._navigationData[index].instance = null;
            }
        }

        this._navigationData = [];
    }

})
fx.ns("fx.components", class ProgressBar extends fx.Component {

    constructor(parameters)
    {
      super();

      this.showLabel = parameters && parameters.showLabel;
    }

    get showLabel()
    {
        return this._showLabel;
    }

    set showLabel(val)
    {
        this._showLabel = val;
    }

    get label()
    {
        return this._label ? this._label.text : "";
    }

    set label(val)
    {
        if (this._label)
        {
            this._label.text = val;
            this.updateDisplay();
        }
    }

    onReady()
    {
        super.onReady();

        this.update(0);
    }

    /**
     * If only position is given, it's used as a percentage (0-100)
     * If total is given, if will be used to calculate what percentage position means.
     * @param {float} position 
     * @param {int} total 
     */
    update(position, total)
    {
        if (isNaN(position) || isNaN(total)) return;
        
        if (!this.initialized) return;
        
        let percentage = position;

        if (total !== undefined)
            percentage = (total == 0) ? 0 : (position * 100 / total);
        
        this.progressInner.width( Math.min(this.realWidth, this.realWidth * percentage/100) );

        if (this._showLabel)
        {
            if (!this._label)
            {
                this._label = new fx.components.Text({className:"label"});
                this.addChild(this._label, {top:"center", left:"center"});
            }

            this._label.text = parseInt(percentage) + " %";
        }
    }

  
    create()
    {
        super.create();
      
        this.progressInner = new fx.components.Box("inner");
        
        this.addChild(this.progressInner, {top:0, left:0, width:0, height:"100%"});
    
    }
  
  });
  
fx.ns("fx.components", class RadialProgress extends fx.Component {

    constructor(parameters)
    {
      super();
      
      this.showLabel = parameters && parameters.showLabel;
      this.progressColor = parameters && parameters.color ? parameters.color : '#ea67a2';
      this.progressBackgroundColor = parameters && parameters.backgroundColor ? parameters.backgroundColor : '#ffffff';
      this.progressColorThickness = parameters && parameters.thickness ? parameters.thickness : 5;
      this.progressStyle = parameters && parameters.style !== undefined ? parameters.style : 'round';

      this._progress = 0;
      this._updateProgressHandler = this._updateProgress.bind(this);
    }


    get canvas()
    {
        return this.find(".canvas");
    }

    get percentageLabel()
    {
        return this.find(".percentage");
    }

    get progress()
    {
        return this._progress;
    }

    set progress(val)
    {
        this._progress = val;
        this._updateProgress();
    }

    blink(value)
    {
        this.toggleClass("blink", value);
    }
    
    onReady()
    {
        super.onReady();

        if (!this.showLabel)
            this.css(this.percentageLabel, {"display" : "none"})

            this.canvas.width = this.realWidth;
            this.canvas.height = this.realHeight;
        
        this._updateProgress();
    }

    render()
    {
        let html = '';
      
        html +='<div class="canvas-wrap">';
        html += '<canvas class="canvas"></canvas>';
        html += '<span class="percentage"></span>';
        html += '</div>';

        return html;
    }

    _updateProgress()
    {
        let percentage = this._progress * 360 / 100;
        let context = this.canvas.getContext('2d');
   
        let posX = this.canvas.width / 2,
            posY = this.canvas.height / 2;
     
        context.lineCap = 'round';

        context.clearRect( 0, 0, this.canvas.width, this.canvas.height );
  
        context.beginPath();
        context.arc( posX, posY, this.realWidth/2 - this.progressColorThickness, (Math.PI/180) * 270, (Math.PI/180) * (270 + 360) );
        context.strokeStyle = this.progressBackgroundColor;
        context.lineWidth = this.progressColorThickness;
        context.stroke();
  
        context.beginPath();
        context.strokeStyle = this.progressColor;
        context.lineWidth = this.progressColorThickness;
        context.arc( posX, posY, this.realWidth/2 - this.progressColorThickness, (Math.PI/180) * 270, (Math.PI/180) * (270 + percentage) );
        context.stroke();

        this.percentageLabel.innerHTML = percentage.toFixed();
    }
      
   
});
fx.ns("fx.components", class ScanBox extends fx.Component {

    constructor(parameters)
    {
      super();
      this._text = parameters && parameters.text ? parameters.text : "";
    }

    create()
    {
        super.create();
        
        this.scanBox = new fx.components.Box("scan-box");
        this.addChild(this.scanBox, {width:"100%", height:"100%", top:0, left:0});

        this.scanLine = new fx.components.Box("scan-line");
        this.scanBox.addChild(this.scanLine, {width:"100%", height:2, top:0, left:0});

        if (this._text)
        {
            this.text = new fx.components.Text(this._text);
            this.addChild(this.text, {width:"auto", top:"center", left:"center"});
        }

    }

    
});
fx.ns("fx.components", class ScreenPopup extends fx.Component{

    constructor(data)
    {
        super(data);

        //this.effect = "scroll";
        this.effect = "vslidein";

        this._contentWidth = "100%";
        this._contentHeight = "100%";

        this._showClose = false;
        
        this._options = {top:0, left : 0};

        this._destroyHandler = this.destroy.bind(this);
    }


    /******************************** Parameters *****************************/

    get options()
    {
        return this._options;
    }

    set options(val)
    {
        if (val === undefined)
            return;

        for(let property in this._options)
        {
            if (val[property] !== undefined)
                this._options[property] = val[property];
        }
    }

    
    get showClose()
    {
        return this._showClose;
    }

    set showClose(val)
    {
        this._showClose = val;
        if (this.initialized)
            this._addClose();
    }

    get contentWidth()
    {
        return this._contentWidth;
    }

    set contentWidth(val)
    {
        this._contentWidth = val;

        if (this.initialized)
        {
            this._contentContainer.width(val);
            this.updateDisplay();
        }
    }

    get contentHeight()
    {
        return this._contentHeight;
    }

    set contentHeight(val)
    {
        this._contentHeight = val;

        if (this.initialized)
        {
            this._contentContainer.height(val);
            this.updateDisplay();
        }
    }


    get contentContainer()
    {
        return this._contentContainer;
    }

    /******************************** Actions *****************************/

    close()
    {
        this.hide( this._destroyHandler);
        this.trigger("closed");
    }

    /******************************** Overrides *****************************/

    onReady()
    {
        super.onReady();

        this.on("ESCAPE", this.onClose, fx.keyboard);
    }

    create()
    {
        super.create();

        
        this.overlay = new fx.components.Box("overlay");
        super.addChild(this.overlay, {width:"100%", height:"100%", top:0, left:0});
        
        this._contentContainer = new fx.components.Box("content");
        super.addChild(this._contentContainer, {width: this._contentWidth, height: this._contentHeight, top: this.options.top, left:this.options.left});

        /*if (this.options.leftArrow)
            this._contentContainer.addChild(new fx.components.Box("leftArrow"), {width:0, height:0, top:"center", left:-10});*/

        this._addClose();
    }

    _addClose()
    {
        if (!this.closeBtn && this.showClose)
        {
            this.closeBtn = new fx.components.IconButton({icon:fx.assets.ExitIcon, className : "close", filled : false});
            this._contentContainer.addChild(this.closeBtn, {width:50, height:50, right:10, top : 10});
            this.on("click", this.onClose, this.closeBtn);
        }
    }

    addChild(child, viewport)
    {
        if (this._contentContainer)
            this._contentContainer.addChild(child, viewport);
    }

    removeChild(child)
    {
        if (this._contentContainer)
            this._contentContainer.removeChild(child);
    }

    removeAllChild()
    {
        if (this._contentContainer)
            this._contentContainer.removeAllChild()
    }



    /******************************** Events *****************************/

    
    onClose()
    {
        this.close()
    }

    
});

fx.ns("fx.components", class Scrollable extends fx.Component 
{
    /**
     * Constructor
     * @param {*} data 
     * @param {*} direction : "horizontal" / "vertical"
     * @param {*} type : "absolute" / "relative" . if content of scrollable if composed of absolute positionned elements, scroll configuration is not the same
     */
    constructor(data, direction, type) 
    {
        super(data);

        this._childsToAdd = [];
        this._scrollDirection = ( (typeof data == "string") ? data : direction) || "vertical";
        this._scrollType = ((typeof data == "string" ) ? direction : type) || "absolute"; 
    }

    get scrollHeight()
    {
        return this.scrollableContent ? this.scrollableContent.scrollHeight : this.realHeight;
    }
  
    get canScrollTop()
    {
        return this.scrollPosition > 0;
    }

    get canScrollBottom()
    {
        return this.scrollPosition < this.scrollHeight;
    }


    get scrollWidth()
    {
        return this.scrollableContent ? this.scrollableContent.scrollWidth : this.realWidth;
    }

    get scrollTop()
    {
        return this.scrollableContent ? this.scrollableContent.scrollTop : 0;
    }

    set scrollTop(val)
    {
        if (this.scrollableContent)
            this.scrollableContent.scrollTop = val;
    }

    get scrollLeft()
    {
        return this.scrollableContent ? this.scrollableContent.scrollLeft : 0;
    }

    set scrollLeft(val)
    {
        if (this.scrollableContent)
            this.scrollableContent.scrollLeft = val;
    }

  
    get canScrollLeft()
    {
        return this.scrollPosition > 0;
    }

    get canScrollRight()
    {
        return this.scrollPosition < this.scrollWidth;
    }

    get scrollPosition()
    {
        return this.scrollableContent ? this.scrollableContent.scrollPosition : 0;
    }

    
    get scrollDirection()
    {
        return this._scrollDirection;
    }

    set scrollDirection(val)
    {
        this._scrollDirection = val;
        
        if (this.initialized)
            this.scrollableContent.scrollDirection = this.scrollDirection;
    }

    get scrollPercentage()
    {
        return Number((this.scrollTop / (this.scrollHeight - this.realHeight) * 100).toFixed(1));
    }

    onReady() 
    {
        super.onReady();

        this.on("scrollChanged", this.onScrollChanged, this.scrollableContent );     
           
        this._initScroll();

    }

     
    create() 
    {
        super.create();

        this.scrollableContent = new fx.components.ScrollableContent(this.scrollDirection, this._scrollType);

        super.addChild(this.scrollableContent, {top:0, left:0, width: (this._scrollType == "absolute") ? "100%" : "max-content", height:"100%"});

        for(let i = 0; i < this._childsToAdd.length; i++)
            this.scrollableContent.addChild(this._childsToAdd[i].child, this._childsToAdd[i].viewport, this._childsToAdd[i].effect, this._childsToAdd[i].position);
    }

    addChild(child, viewport, effect, position)
    {
        if (!this.scrollableContent)
             this._childsToAdd.push({child:child, viewport:viewport, effect:effect, position:position})
        else
            this.scrollableContent.addChild(child, viewport, effect, position);
    }

    
    removeChild(child, destroy)
    {
        if (this.scrollableContent)
            this.scrollableContent.removeChild(child, destroy);
    }

    removeAllChild(destroy)
    {
        if (this.scrollableContent)
            this.scrollableContent.removeAllChild(destroy);
    }

    moveChildBefore( child1, child2 )
	{
        if (this.scrollableContent)
        this.scrollableContent.moveChildBefore( child1, child2 );
	}

	moveChildAfter(child1, child2) 
	{
        if (this.scrollableContent)
        this.scrollableContent.moveChildAfter( child1, child2 );
	}

    getChild(id)
    {
        if (this.scrollableContent)
            return this.scrollableContent.getChild(id);
    }

    getChilds()
    {
        if (this.scrollableContent)
            return this.scrollableContent.getChilds();
        else
            return [];
    }

    getChildFromData(data)
    {
        if (this.scrollableContent)
            return this.scrollableContent.getChildFromData(data);
        else
            return [];
    }

    scroll(position, animate, direction)
    {
        if (this.scrollableContent)
            this.scrollableContent.scroll(position, animate, direction);

        this.delay(this.onScrollChanged, 500);
    }

    scrollToBottom(animate)
    {
        this.scrollableContent.scroll(this.scrollHeight, animate, "vertical");
        this.delay(this.onScrollChanged, 500);
    }

    scrollToTop(animate)
    {
        this.scrollableContent.scroll(0, animate, "vertical");
        this.delay(this.onScrollChanged, 500);
    }

    showScroll(val)
    {
        let cssProp = this.scrollDirection == "horizontal" ? "overflow-x" : "overflow-y";
        let scrollObject = (this._scrollType == "absolute") ? this.scrollableContent : this;
        
        if (val)
            scrollObject.css(cssProp, "scroll");
        else
            scrollObject.css(cssProp, "hidden");        
    }

    _initScroll()
    {
        if (this._scrollType == "relative")
        {
            let cssProp = (this.scrollDirection == "horizontal") ? "overflow-x" : "overflow-y";
            this.css(cssProp, "auto");

            if (this.scrollDirection == "horizontal" && this.scrollableContent.realWidth < this.realWidth)
                this.scrollableContent.left("center");
        }        
    }

    onScrollChanged(e)
    {
        this.trigger("scrollChanged");
    }
    
    destroy()
    {    
        super.destroy();
        this._childsToAdd = null;
    }
});
fx.ns("fx.components", class ScrollableContent extends fx.Component {

    constructor(direction, type) 
    {
        super();

        this.scrollDirection = direction;
        this.scrollType = type || "absolute";
    }

    onReady()
    {
        super.onReady();

        this.on("scroll", this.onScroll);

        this._updateDirection();
    }

    onScroll(e)
    {
        this.trigger("scrollChanged");
    }

    get scrollHeight()
    {
        return this.node ? this.node.scrollHeight : this.realHeight;
    }

    get scrollTop()
    {
        return this.node ? this.node.scrollTop : 0;
    }

    set scrollTop(val)
    {
        if (this.node)
            this.node.scrollTop = val;
    }

    get scrollWidth()
    {
        return this.node ? this.node.scrollWidth : this.realWidth;
    }
    
    get scrollLeft()
    {
        return this.node ? this.node.scrollLeft : 0;
    }

    set scrollLeft(val)
    {
        if (this.node)
            this.node.scrollLeft = val;
    }


    get scrollPosition()
    {
        return this.scrollDirection == "vertical" ? this.scrollTop : this.scrollLeft;
    }

    get scrollDirection()
    {
        return this._scrollDirection;
    }

    set scrollDirection(val)
    {
        this._scrollDirection = val;
     
        this._updateDirection();
    }

    _updateDirection()
    {
        if (!this.initialized)
            return;

        if (this.scrollType == "absolute")
        {
            if (this.scrollDirection == "both")
            {
                this.css("overflow-y", "scroll");
                this.css("overflow-x", "scroll");
            }
            else
            if (this.scrollDirection == "vertical")
            {
                this.css("overflow-y", "scroll");
                this.css("overflow-x", "hidden");
            }
            else
            if (this.scrollDirection == "horizontal")
            {
                this.css("overflow-x", "scroll");
                this.css("overflow-y", "hidden");
            }
            else
            {
                this.css("overflow-y", "hidden");
                this.css("overflow-x", "hidden");
            }
        }
    }
    
  
    scroll(position, animated, direction)
    {
        let newPosition = (typeof position == "string") ? (this.scrollPosition + parseInt(position)) : position;

        direction = direction || this.scrollDirection;

        if (!direction) return;
        
        let property = (direction == "vertical") ? "scrollTop" : "scrollLeft";
        
        if (newPosition == this.node[property])
            return;
        
        if (animated)
        {
            if (fx.browser.isTouchDevice)
            {
                this._SmoothHorizontalScrolling(this.node, newPosition, 250, property);
                return;
            }
            else
                this.css("scroll-behavior", "smooth");
        }
        else
            this.css("scroll-behavior", "auto");
            
        this.node[property] = newPosition;    
    }

    // Safari doesn't handle "scroll-behavior" : "smooth", so need javascript below to handle it
    _SmoothHorizontalScrolling(element, pos, time, property) {
        let currentPos = element[property],
            start = null;

        if(time == null) time = 500;

        pos = +pos, time = +time;

        window.requestAnimationFrame(function step(currentTime) 
        {
            start = !start ? currentTime : start;

            let progress = currentTime - start,
                progressivePos;

            if (currentPos < pos) 
            {
                progressivePos = ((pos - currentPos) * progress / time) + currentPos;
            } 
            else 
            {
                progressivePos = currentPos - ((currentPos - pos) * progress / time);                
            }

            if (property == "scrollTop")
                element.scrollTo(0,progressivePos);
            else
                element.scrollTo(progressivePos, 0);
            

            if (progress < time) 
            {
                window.requestAnimationFrame(step);
            } 
            else 
            {
                if (property == "scrollTop")
                    element.scrollTo(0, pos);
                else
                    element.scrollTo(pos, 0);
            }
        });
    }
    

    moveChildBefore( child1, child2 )
	{
        let index = this._childs.indexOf( child1 );
        this._childs.splice(index, 1);
        index = this._childs.indexOf( child2 );
        this._childs.splice(index, 0, child1);
		

		this.node.insertBefore( child1.node, child2.node);

	}

	moveChildAfter(child1, child2) 
	{
        let index = this._childs.indexOf( child1 );
        this._childs.splice(index, 1);
        index = this._childs.indexOf( child2 );
        index++;
        this._childs.splice(index, 0, child1);

		this.node.insertBefore( child1.node, child2.node.nextSibling);

	}

});

fx.ns("fx.components", class SearchInput extends fx.components.Input {

    constructor(parameters)
    {
        super(parameters);

        this._propositions = parameters && parameters.propositions ? parameters.propositions : [];
    }

    /********************** Constants / parameters *********************/

    get results()
    {
        return this._results;
    }

    set results(val)
    {
        this._results = val;
        if (this.initialized)
            this._updateResults();
    }

    get value()
    {
        return super.value;
    }

    set value(val)
    {
        super.value = val;

        this.toggleClass("filled", this.value != "");
    }

    get waiting()
    {
        return this._waiting;
    }

    set waiting(val)
    {
        this._waiting = val;

        if (val)
        {
            this.resultsContainer.innerHTML = "<ul class='list'><li>" + fx.assets.loader.render("waiting") + "</li></ul>";
            this.css(this.resultsContainer, {display:"block"});
        }
        else
        {
            this.resultsContainer.innerHTML = "";
            this.css(this.resultsContainer, {display:"none"});
        }
    }


    /************************ Overrides *******************/
    onReady()
    {
        super.onReady();

        this.on("escape", this.onEscape);
        this.on("click", this.onClick, window);
        this.on("keydown", this.onKeyDown);
        this.on("enter", this.onEnter);

        this.resultsContainer = this.find(".results");
    }

    render()
    {
        return super.render() + fx.assets.ExitIcon.render() + fx.assets.SearchIcon.render() + '<div class="results"></div>';
    }


    
    /************************ Events *******************/

    onEnter(e)
    {
        this.results = [];
    }

    onEscape(e)
    {
        if (this.results.length > 0)
            this.results = [];
        else
        if (this.value != "")
        {
            this.value = ""
            this.trigger("enter");
        }
    }

    onClick(e)
    {
        if (!this.enabled)
            return;

        if (!fx.dom.parent(e.target, this.node))
            this.results = [];
        else
        if (fx.dom.parent(e.target, ".ExitIcon"))
        {
            this.value = "";
            this.results = [];
            this.trigger("enter");
        }
        else
        if (fx.dom.parent(e.target, ".SearchIcon"))
        {
            this.results = [];
            this.trigger("enter");
        }
        else
        {
            let result = fx.dom.parent(e.target, ".result");
            if (result)
            {
                this.value = result.innerText;
                this.trigger("selected", this.value);

                this.results = [];
            }
            else
                this.results = this._propositions || [];
        }
        
    }


    onKeyPress(e)
    {
        super.onKeyPress(e);

        this.toggleClass("filled", this.value != "");
    }
    
    onKeyDown(e)
    {
        if (e.keyCode == 38) // up
        {
            let selectedItem = this.find(".selected");
            if (selectedItem) // previous
            {
                fx.dom.removeClass(selectedItem, "selected");
                let elements = this.find(".result");
                let index = elements.indexOf(selectedItem);
                index--;
                if (index >= 0)
                    fx.dom.addClass(elements[index], "selected");
            }
            else // last
            {
                let element = this.find(".result:last-child");
                fx.dom.addClass(element, "selected");
            }

            e.preventDefault();
            e.stopPropagation();

        }
        else
        if (e.keyCode == 40) // up
        {
            let selectedItem = this.find(".selected");
            if (selectedItem) // next
            {
                fx.dom.removeClass(selectedItem, "selected");
                let elements = this.find(".result");
                let index = elements.indexOf(selectedItem);
                index++;
                if (index < elements.length)
                    fx.dom.addClass(elements[index], "selected")
            }
            else // first
            {
                let element = this.find(".result:first-child");
                fx.dom.addClass(element, "selected");
            }

            e.preventDefault();
            e.stopPropagation();

            
        }
        else
        if (e.keyCode == 13)
        {
            let selectedItem = this.find(".selected");
            if (selectedItem)
            {
                this.value = selectedItem.innerText;
                this.trigger("selected", this.value);

                this.results = [];

                e.preventDefault();
                e.stopPropagation();
            }
        }

        
    }

    /******************************************************/
    _updateResults()
    {
        if (this._results.length == 0)
            this.css(this.resultsContainer, {display:"none"});
        else
        {
            let html = "<ul class='list'>";
            for(let i = 0; i < Math.min(10, this.results.length); i++) // Max 10 results
            {
                let label = this.results[i].label || "";
                let index = (this.value == "string" && typeof this.value.toLowerCase == "function") ? label.toLowerCase().indexOf(this.value.toLowerCase()) : -1; // fix trackjs crash (this.value.toLowerCase is not a function)
                if (index > -1) // underline search string in results
                    label = label.slice(0, index) + "<span class='bold underlined'>" + label.substring(index, index + this.value.length) + "</span>" + label.slice(index + this.value.length);
                
                html += "<li class='result' data-value='" + this.results[i].label + "'>" + label + "</li>";
            }

            html += "</ul>";

            this.resultsContainer.innerHTML = html;

            this.css(this.resultsContainer, {display:"block"});
        }
    }

});
fx.ns("fx.components", class SelectButtons extends fx.Component {

	constructor(parameters) 
	{
        super();

        this._items = parameters && parameters.items ? parameters.items : [];
        this._selectedIndex = parameters && parameters.selectedIndex ? parameters.selectedIndex : 0;
        this._className = parameters ? parameters.className : "";
    }
    
    get selectedItem()
	{
        if (this.items)
            return this.items[this._selectedIndex];
    }
    
    set selectedItem(val)
	{
        let index = this.items.indexOf( val );
        if (index != -1)
        {
            this._selectedIndex = index;
            this._selectButton(index);
        }
	}

    get selectedIndex()
    {
        return this._selectedIndex;
    }

    set selectedIndex(val)
    {
        if (val >= 0 && val < this.items.length)
        {
            this._selectedIndex = val;
            this._selectButton(val);
        }
            
    }

    get items()
    {
        return this._items;
    }

    set items(val) 
    {
        this._items = val;
        this._selectedIndex = 0;
        this._build();
        /*if (this.selectedItem)
            this.trigger("changed", this.selectedItem);*/
    }

    create()
	{
        super.create();

        this.container = new fx.components.HBox("buttons");

        this._build();
          
        this.addChild( this.container, {height:40, left:0, top : 0})
	}

    _build()
    {
        if (!this.container) return;

        this.container.removeAllChild();

        for (let i = 0; i < this.items.length; i++)
        {
            let btn = new fx.components.Button({className : i == this.selectedIndex ? "active" : "", label : this.items[i].label, type : "borderOnly"})
            this.items[i].__id = btn.id;
            this.container.addChild( btn );
        }

        if (this.initialized)
            this.container.updateDisplay();
    }


	onReady() 
	{
        super.onReady();

        this.addClass( this._className );

        this.on("click", this._onClick);
    }
    
    _onClick(e)
    {
        // if e.target contain active do nothing;
        if(fx.dom.parent(e.target, ".active"))
            return;
        
        let btn = fx.dom.parent(e.target, ".Button");

        if (btn)
        {
            for (let i = 0; i < this.items.length; i++)
            {
                if(this.items[i].__id == btn.getAttribute("id"))
                {
                    this._selectButton( i );
                    break;
                }
            }
        }
    }


    _selectButton(index)
    {
        if (!this.initialized)
            return;

        let buttons = this.container.getChilds();
        for (let i=0; i < buttons.length; i++)
            buttons[i].removeClass('active');

        let btn = this.container.getChild( this.items[index].__id);

        btn.addClass("active");

        this._selectedIndex = index;

        this.trigger("changed", this.selectedItem);
    }


});
fx.ns("fx.components", class SwitchButton extends fx.Component {

	constructor(parameters){

		super(parameters ? parameters.data : null);

		this.classname = (parameters && parameters.className) ? parameters.className : "";
		this._switched = parameters && parameters.value ? parameters.value : null;

	}

	get switched()
	{
		return this._switched;
	}

	set switched(val)
	{
		this._switched = val;
		this.toggleClass("switched", this._switched);
	}

	onReady()
	{
		super.onReady();

		if (this.classname)
			this.addClass(this.classname);
		
		if (this.switched)
			this.addClass('switched');

		// this.on("click", this.onClick, this.find(".shape"));
		this.on("click", this.onClick);
	}
	
	destroy(){
		super.destroy();
		this.clickCallback = null;
	}

	render(){
		return '<div class="container"><div class="switch"><div class="dot">' + fx.assets.checkmark.render() + '</div></div></div>';
	}

	onClick(e)
	{
		this.switched = !this.switched;

		this.trigger("changed", this.switched);
	}
});
fx.ns("fx.components", class TextArea extends fx.components.Input {

    constructor(parameters)
    {
        super(parameters);

        this._rows = (parameters && parameters.rows) ? parameters.rows : 0;
    }

    get rows()
    {
        return this._rows;
    }

    render()
    {
        return '<textarea class="input" ' + (this._rows ? ('rows="' + this._rows + '"') : '') + ' ' + (this._maxlength ? ('maxlength="' + this._maxlength + '"') : '') + ' ' + (this._name ? ('name= "' + this._name + '"') : '') + ' placeholder="' + this.placeHolder + '" >' + this.value + '</textarea>';
    }
    
});
/**
 * AdvancedTextArea is aimed to provide more flexibility than TextArea :
 * - resizing automatically according to it's number of lines
 */
fx.ns("fx.components", class TextAreaAdvanced extends fx.components.TextArea {

    constructor(parameters)
    {
        super(parameters);
    }

    get numRows()
    {
        return Math.max(1, Math.round(fx.dom.height(this.input) / fx.graphics.getLineHeight( this.input )) );
    }

     get value()
    {
        // String.isEmpty is used to avoid returning \n or empty space
        if (this.initialized)
            return (this.input.innerText && this.input.innerText.isEmpty()) ? "" : this.input.innerText;
        else
            return (this._value && this._value.isEmpty()) ? "" : this._value;
    }

    set value(val)
    {
        this._value = val;

        if (this.initialized)
            this.input.innerText = val;
    }

    onReady()
    {
        super.onReady();

        this.on("updated", this._onUpdated);

        this.on("keydown", this.onKeyDown, this.input);

        this._actualHeight = this.input.clientHeight;
    }

    _onUpdated()
    {
        if (this._actualHeight != this.input.clientHeight)
        {
            this._actualHeight = this.input.clientHeight;
            this.trigger("height-updated");
        }
    }

    onKeyDown(e)
    {
        if ( this.input.innerText.length > this.maxLength && !fx.keyboard.isSpecialKey(e))
        {
            e.preventDefault();
            e.stopPropagation();
        }
    }

    onKeyPress(e)
    {
        let handled = false;

        if (e.keyCode == 13)
        {
            this.trigger("enter");
            handled = true;
        }
        else
        if (e.keyCode == 27)
        {
            this.trigger("escape");
            handled = true;
        }
        else
        {
            if (this._value != this.find(".input").innerText)
            {
                this._value = this.find(".input").innerText;
                this.trigger("updated", e);
                handled = true;
            }
        }

        if (handled)
        {
            e.preventDefault();
            e.stopPropagation();
        }
            
    }

    render()
    {
        return '<div contenteditable="plaintext-only" ' +
                     ' class="input" ' +
                     (this._rows ? ('rows="' + this._rows + '"') : '') + ' ' + 
                     (this._maxlength ? ('maxlength="' + this._maxlength + '"') : '') + ' ' + 
                     (this._placeHolder ? ('name= "' + this._placeHolder + '"') : '') + ' ' + 
                     (this._name ? ('name= "' + this._name + '"') : '') + '>' + 
                     this.value + 
                '</div>';
    }
    
});
/**
 * Wrapper on Quilljs : https://github.com/quilljs/quill
 */
fx.ns("fx.components", class TextEditor extends fx.EventDispatcher {

    constructor(container, defaultStyle, fonts, extraScale)
    {
        super();

        this.fonts = fonts;

        this.MIN_FONT_SIZE = 2 * (extraScale ? extraScale : 1);
        this.MAX_FONT_SIZE = 100 * (extraScale ? extraScale : 1);

        if (!Quill._configured)
            this._configure();

        this._editor = new Quill(container, {  formats: ['bold','italic','size','font', 'align', 'color'], // we use a format white list for copy and paste
                                                modules: 
                                                { 
                                                    //lineheightfix: true ,
                                                    //maxlength : {value : 1000},
                                                    history: { delay: 100, maxStack: 100, userOnly: true },
                                                    // Override/disable default key bindings 
                                                    keyboard: {
                                                        bindings: {
                                                            bold: {
                                                                key: 'B', shortKey: true, handler: function() {}
                                                            },
                                                            tab: {
                                                                key: 9, handler: function() {}
                                                            },
                                                            italic: {
                                                                key: 'I',shortKey: true, handler: function() {}
                                                            }
                                                        }    
                                                    }
                                                },
                                            });

        // disable tab because it doesn't have same size on firefox / chrome
        //if (this._editor.keyboard && this._editor.keyboard.bindings && this._editor.keyboard.bindings[9])
        //    this._editor.keyboard.bindings[9].unshift({ key: 9, handler: function () {return false;}});

        this._active = false;

        this._onSelectionChangeHandler = this._onSelectionChange.bind(this);
        this._onTextChangeHandler = this._onTextChange.bind(this);
        this._onEditorChangeHandler = this._onEditorChange.bind(this);
        
        
        this._textChangedEnabled = true;
        this._lastSelectionStyle = {};

        this._editor.on("selection-change", this._onSelectionChangeHandler);
        this._editor.on("text-change", this._onTextChangeHandler);
        this._editor.on("editor-change", this._onEditorChangeHandler);
        
        this._editor.enable(false);

        this.setDefaultStyle(defaultStyle);

        // we set this._initialized to true only after some delay in order to avoid 
        // the first "text-change" event which is not usefull
        this.delay(this._editorInitialized, 250);

        this.Delta = Quill.import('delta');
     
    }

    _editorInitialized()
    {
        this._initialized = true;
    }

    get innerHTML()
    {
        return this._editor.root.innerHTML;
    }

    get active()
    {
        return this._active;
    }

    set active(val)
    {
        if (!this._editor)
            return;

        this._active = (val === true);

        this._disableTextChange(true);
        this._editor.enable( this._active );

        if (this._active)
            this._editor.focus();
        else
            this._editor.blur();
    }

    get content()
    {
        return this._editor.getContents();
    }

    set content(val)
    {
        this._editor.setContents(val);
    }

    get selection()
    {
        if (this._editor && !this.active)
            return { index : 0, length : this.textLength, noselection : true };
        else
        {
            let selection;
            try 
            {
                selection = this.currentSelection && this.currentSelection.length > 0 ? this.currentSelection : (this._editor ? this._editor.getSelection("silent") : null); //  this._editor.getSelection("silent") used everytime creates a problem for copy/paste
            } 
            catch(e) { } // Fix safari  "The index is not in the allowed range" on getBounds
            
            return selection ? selection : { index : 0, length : 0, noselection : true };
        }
            
    }

    css(properties)
    {
        fx.dom.css(this._editor.root, properties);
    }

    setHTML(val)
    {
        this._disableTextChange(true);

        this._editor.root.innerHTML = val;
    }
    
    _disableTextChange(disable)
    {
        if (disable)
        {
            this._textChangedEnabled = false;
            this.delay( this._disableTextChange, 100);
        }
        else
            this._textChangedEnabled = true;
    }
    
    get empty()
    {
        if (!this._editor)
            return;

        let text = (this._editor && this._editor.root) ? this._editor.root.innerText : this._editor.getText();

        return text.trim().length === 0 || (text.length == 1 && text == '\n');    
    }

    get textLength()
    {
        if (!this._editor)
            return;

        let text = (this._editor && this._editor.root) ? this._editor.root.innerText : this._editor.getText();

        return (text.length == 1 && text == '\n') ? 0 : text.length;  
    }

    /**
     * Each of getter/setter returns or update the current selection
     * If not current selection, the whole line is selected
     */
    get fontFamily()
    {
        let selection = this.selection;
        
        if (selection && this._editor)
        {
            let format = this._editor.getFormat( selection );
            if (format.font instanceof Array)
                return format.font[0];
            else
            if (format.font === undefined)
                return this._defaultStyle["font-family"];
            else
                return format.font;
        }
        else
            return "";
    }

    set fontFamily(val)
    {
        // TODO : check that val is part of listed fonts
        if (this.selection.noselection)
            this._editor.formatText( this.selection.index, this.selection.length, 'font' , val);
        else
            this._editor.format('font' , val);
    }

    get allFontFamilies()
    {
        let deltas = this._editor.getContents();
        let families = [];
        for (let i = 0; i < deltas.ops.length; i++)
        {
            let op = deltas.ops[i];
            if (op.attributes && op.attributes.font && !families.find(op.attributes.font))
                families.push(op.attributes.font);
        }
        
        return families;
    }

    get currentFontFamilies()
    {
        let families = [];
        let selection = this.selection;
        
        if (selection && this._editor)
        {
            let deltas = this._editor.getContents(selection);
            for (let i = 0; i < deltas.ops.length; i++)
            {
                let op = deltas.ops[i];
                if (op.attributes && op.attributes.font && !families.find(op.attributes.font))
                    families.push(op.attributes.font);
            }
        }

        if (families.length == 0 && this.fontFamily)
            families.push(this.fontFamily);

        return families;
    }

    get bold()
    {
        let selection = this.selection;

        if (selection && this._editor)
        {
            let format = this._editor.getFormat( selection );
            if (format.bold instanceof Array)
                return format.bold[0];
            else
            if (format.bold === undefined)
                return this._defaultStyle["bold"];
            else
            return format.bold;
        }
        else
            return false;
    }

    set bold(val)
    {
        if (val == "!")
            val = !this.bold;

        //this._editor.format('bold' , val === true);
        if (this.selection.noselection)
            this._editor.formatText(this.selection.index, this.selection.length, 'bold' , val === true);
        else
            this._editor.format('bold' , val === true);
    }

    get italic()
    {
        //let selection = this._editor.getSelection("silent");
        let selection = this.selection;

        if (selection && this._editor)
        {
            let format = this._editor.getFormat( selection );
            if (format.italic instanceof Array)
                return format.italic[0];
            else
            if (format.bold === undefined)
                return this._defaultStyle["italic"];
            else
                return format.italic;
        }
        else 
            return false;
    }

    set italic(val)
    {
        if (val == "!")
            val = !this.italic;

        if (this.selection.noselection)
            this._editor.formatText(this.selection.index, this.selection.length, 'italic' , val === true);
        else
            this._editor.format('italic' , val === true);
    }

    get align()
    {
        //let selection = this._editor.getSelection("silent");
        let selection = this.selection;

        if (selection && this._editor)
        {
            let format = this._editor.getFormat( selection );
            if (format.align)
                return format.align;
            else
                return this._defaultStyle["text-align"];
        }
        else
            return "";
    }

    set align(val)
    {
        if (this.selection.noselection)
            //this._editor.formatText(this.selection.index, this.selection.length, 'align' , val );
            this._editor.formatLine(this.selection.index, this.selection.length, 'align' , val );
        else
            this._editor.format('align' , val );
    }

    get size()
    {
        //let selection = this._editor.getSelection("silent");
        let selection = this.selection;

        if (selection && this._editor)
        {
            let format = this._editor.getFormat( selection );
            if (format.size instanceof Array)
                return format.size[0];
            else
            if (format.size === undefined)
                return this._defaultStyle["font-size"];
            else
                return format.size;
        }
        else
            return 0;
    }

    set size(val)
    {
        if (typeof val == 'string' && val.startsWith("+"))
        {
            this._increaseSize(val.substring(1));
        }
        else
        if (typeof val == 'string' && val.startsWith("-"))
        {
            this._decreaseSize(val.substring(1));
        }
        else
        {
            if (this.selection.noselection)
                this._editor.formatText(this.selection.index, this.selection.length, 'size' , parseInt(val) + "px" );
            else
                this._editor.format('size' , parseInt(val) + "px" );
        }
    }

    get color()
    {
        let selection = this.selection;

        if (selection && this._editor)
        {
            let format = this._editor.getFormat( selection );
            if (format.color instanceof Array)
                return format.color[0];

            return format.color;
        }
        else
            return "#000";
    }

    set color(val)
    {
        if (this.selection.noselection)
            this._editor.formatText(this.selection.index, this.selection.length, 'color', val );
        else
            this._editor.format('color', val );
    }

    /**
     * Set focus on editor
     */
    focus(options)
    {
        this._editor.focus(options);
    }

    /**
     * Selects the whole line and returns the selection
     */
    selectAll()
    {
        this._editor.setSelection(0, this._editor.getLength(), "silent");
    }

    unSelectAll()
    {
        this._editor.setSelection(null, "silent");
        
        //this.delay( this._removeSelection,250 );
        this._removeSelection();
    }

    undo()
    {
        this._editor.history.undo();
    }

    redo()
    {
        this._editor.history.redo();
    }

    _removeSelection()
    {
        if (document.selection)
            document.selection.empty()
        else
            window.getSelection().removeAllRanges();
    }
    
    /**
     * Applies default style to editor (font-size, text-color, etc...)
     * @param {object} defaultStyle 
     */
    setDefaultStyle(defaultStyle, force)
    {
        if (defaultStyle)
            this._defaultStyle = defaultStyle;
        
        if (this.empty && this._defaultStyle)
        {
            if (this._defaultStyle["font-family"] /*&& this._defaultStyle["font-family"] != this.fontFamily*/)
                this._editor.format('font' , this._defaultStyle["font-family"], "silent" );

            if (this._defaultStyle["font-size"] /*&& this._defaultStyle["font-size"] != this.size*/)
                this._editor.format('size' , parseInt(this._defaultStyle["font-size"]) + "px", "silent" );

            if (this._defaultStyle["color"] /*&& this._defaultStyle["color"] != this.color*/)
                this._editor.format('color', this._defaultStyle["color"] , "silent");

            if (this._defaultStyle["text-align"] /*&& this._defaultStyle["text-align"] != this.align*/)
                this._editor.format('align' , this._defaultStyle["text-align"], "silent" );

            if (this._defaultStyle["bold"] /*&& this._defaultStyle["bold"] != this.bold*/)
                this._editor.format('bold' , this._defaultStyle["bold"], "silent" );

            if (this._defaultStyle["italic"] /*&& this._defaultStyle["italic"] != this.align*/)
                this._editor.format('italic' , this._defaultStyle["italic"], "silent" );
        }
        

        let deltas = this._editor.getContents();
        let lowest = 4;
        for (let i = 0; i < deltas.ops.length; i++)
        {
            let op = deltas.ops[i];
            if (op.attributes && op.attributes.size)
                lowest = lowest ? Math.min(lowest, parseInt(op.attributes.size) ) : parseInt(op.attributes.size);
        }
        
        lowest = lowest < 4 ? lowest+1 : lowest;
        

        let defaults = {"font-family": !force && this._defaultStyle && this._defaultStyle["font-family"] ? this._defaultStyle["font-family"] : "Open Sans", 
                        "text-align": "left", //!force && this._defaultStyle && this._defaultStyle["text-align"]  ? this._defaultStyle["text-align"]  : "left", 
                        "font-size": !force && this._defaultStyle && this._defaultStyle["font-size"] ? Math.min(this._defaultStyle["font-size"], 4) : lowest + "px", 
                        "color": !force && this._defaultStyle && this._defaultStyle["color"] ? this._defaultStyle["color"] : "#000"};
        
        fx.dom.css(this._editor.root, defaults);
        
        return defaults;
    }


    // ------------------------- OVERRIDE ---------------------//
    destroy()
    {
        super.destroy();

        this._editor.off("selection-change", this._onSelectionChangeHandler);
        this._editor.off("text-change", this._onTextChangeHandler);
        this._editor.off("editor-change", this._onEditorChangeHandler);
        

        this._onSelectionChangeHandler = null;
        this._onTextChangeHandler = null;
        this._onEditorChangeHandler = null;
        

        this._editor.enable(false);

        this._editor = null;
    }
   

    // -------------------------- PRIVATE -----------------------//
    _configure()
    {
        // We set list of font sizes here
        let Size = Quill.import('attributors/style/size');
        Size.whitelist = [];

        for (let i = this.MIN_FONT_SIZE; i <=this.MAX_FONT_SIZE; i++)
            Size.whitelist.push(i + "px");

        Quill.register(Size, true);


        // We add fonts here
        let Font = Quill.import('attributors/style/font');
        let fonts = this.fonts;

        Font.whitelist = [];        

        for (let i = 0; i < fonts.length; i++)
            Font.whitelist.push(fonts.getItemAt(i).name);

        Quill.register(Font, true);

        Quill.register(Quill.import('attributors/style/align'), true);
        
    }

    // TODO : get each p and decrease it size instead of setting same size for all
    _increaseSize(value)
    {
        value = !value ? 1 : parseInt(value);

        // calculate the highest value and increments
        
        let selection = this.selection;

        if (selection)
        {
            // in case nothing is selected, we select pre
            if (selection.length == 0 && this._currentSize)
            {
                this._currentSize = Math.min(this.MAX_FONT_SIZE,(this._currentSize+value))
                if (this.selection.noselection)
                    this._editor.formatText(0, this.selection.length, 'size' , this._currentSize + "px" );
                else
                    this._editor.format('size' , this._currentSize + "px" );
                return;
            }
            
            let index = selection.length ? selection.index : (selection.index-1);
            let length = selection.length ? selection.length : 1;
            let highest = null;
            if (index == 0 && length == 0) // TODO : check next ?
                return;

            if (index > 0 || length > 0) 
            {
                // hack to get max font sizes because of  this._editor.getContents() bug
                if (selection.noselection)
                {
                    //let sizes = this._getFontSizes();
                    //highest = Math.max(...sizes);

                    // getContents provide wrong sizes
                    /*let deltas = this._editor.getContents(index, length);
                    for(let i = 0; i < deltas.length; i++)
                    {
                        let delta = deltas[i];
                        if (delta.attributes.size)
                        {
                            delta.attributes.size = (parseInt(delta.attributes.size) + value) + "px";
                        }
                        this._editor.setContents(deltas, "silent");
                    }*/

                    this._setFontSizes(value);
                    return;
                }
                else
                {
                    let deltas = this._editor.getContents(index, length);
                    
                    for (let i = 0; i < deltas.ops.length; i++)
                    {
                        let op = deltas.ops[i];
                        if (op.attributes && op.attributes.size)
                            highest = highest ? Math.max(highest, parseInt(op.attributes.size) ) : parseInt(op.attributes.size);
                    }
                }
            }

            if (!highest)
            {
                let defaultSize = this._getEditorDefaultValue("font-size");
                if (defaultSize)
                    highest = parseInt( defaultSize );
            }
            
            if (highest)
            {
                this._currentSize = Math.min(this.MAX_FONT_SIZE,(highest+value))
                if (this.selection.noselection)
                    this._editor.formatText(index, length, 'size' , this._currentSize + "px" );
                else
                    this._editor.format('size' , this._currentSize + "px" );
            }

            
        }
    }

    // TODO : get each p and decrease it size instead of setting same size for all
    _decreaseSize(value)
    {
        value = !value ? 1 : parseInt(value);

        // calculate the lowest value and increments

        let selection = this.selection;

        if (selection)
        {
            // in case nothing is selected, we select pre
            if (selection.length == 0 && this._currentSize)
            {
                this._currentSize = Math.min(this.MAX_FONT_SIZE,(this._currentSize-value))
                if (this.selection.noselection)
                    this._editor.formatText(0, this.selection.length, 'size' , this._currentSize + "px" );
                else
                    this._editor.format('size' , this._currentSize + "px" );
                return;
            }

            let index = selection.length ? selection.index : 0;
            let length = selection.length ? selection.length : this._editor.getLength();
            let lowest = null;

            if (index > 0 || length > 0) 
            {
                // hack to get min font sizes because of  this._editor.getContents() bug
                if (selection.noselection)
                {
                    //let sizes = this._getFontSizes();
                    //lowest = Math.min(...sizes);
                    this._setFontSizes(-value);
                    return;
                }
                else
                {
                    let deltas = this._editor.getContents(index, length);
                    
                    for (let i = 0; i < deltas.ops.length; i++)
                    {
                        let op = deltas.ops[i];
                        if (op.attributes && op.attributes.size)
                            lowest = lowest ? Math.min(lowest, parseInt(op.attributes.size) ) : parseInt(op.attributes.size);
                    }
                }
            }

            if (!lowest)
            {
                let defaultSize = this._getEditorDefaultValue("font-size");
                if (defaultSize)
                    lowest = parseInt( defaultSize );
            }

            this._currentSize = Math.max(this.MIN_FONT_SIZE,(lowest-value))
            if (this.selection.noselection)
                this._editor.formatText(index, length, 'size' , this._currentSize + "px" );
            else
                this._editor.format('size' , this._currentSize + "px" );
        }
    }

    // hack to get all font sizes because of  this._editor.getContents() bug
    /*_getFontSizes()
    {
        let sizes = [];
        for(let i = 0; i < this._editor.root.childNodes.length; i++)
        {
            let p = this._editor.root.childNodes[i];
            for(let j = 0; j < p.childNodes.length; j++)
            {   
                let span = p.childNodes[j];

                if (span instanceof Element && !span.querySelector(".ql-cursor"))
                {
                    var style = window.getComputedStyle(span, null).getPropertyValue('font-size');
                    sizes.push( parseFloat(style) ); 
                }
            }
        }
        
        return sizes;
    }*/

     _setFontSizes(value)
    {
        //let sizes = [];
        let style, edited = false;
        for(let i = 0; i < this._editor.root.childNodes.length; i++)
        {
            let p = this._editor.root.childNodes[i];

            //style = window.getComputedStyle(p, null).getPropertyValue('font-size');
            if (p.style.fontSize)
            {
                let newValue = (parseInt(p.style.fontSize) + value);
                if (newValue >= this.MIN_FONT_SIZE  && newValue <= this.MAX_FONT_SIZE)
                {
                    p.style.fontSize =  newValue + "px";
                    edited = true;
                }
                    
            }
            
            for(let j = 0; j < p.childNodes.length; j++)
            {   
                let span = p.childNodes[j];

                if (span instanceof Element)
                    style = window.getComputedStyle(span, null).getPropertyValue('font-size');
                else
                    style = span.style ? span.style.fontSize : '';

                if (style)
                {
                    let newValue = (parseInt(style) + value);
                    if (newValue >= this.MIN_FONT_SIZE  && newValue <= this.MAX_FONT_SIZE)
                    {
                        span.style.fontSize =  newValue + "px";
                        edited = true;
                    }
                        
                }
                    
            }
        }
        
        if (edited)
            this.trigger("text-change");
    }

    _getEditorDefaultValue(name)
    {
        // first we check inline styles on editor
        let value = fx.dom.css(this._editor.root, name);
        if (value)
            return value;

        // then we check style set on stylesheet
        let computStyle = window.getComputedStyle( this._editor.root );
        
        if (computStyle)
            return computStyle.getPropertyValue( name );
        
        return null;
    }


    _onSelectionChange(e)
    {
        if (!e) return;
        
        this.currentSelection = e;
        this.trigger("selection-change", e);
    }
    
    _onTextChange(e)
    {
        this.delay(this.__onTextChanged, 10); // trick to avoid too much recursion on firefox
    }
    
    _onEditorChange(e)
    {
        if (e == "text-change")
            this.delay(this.__onTextChanged, 10);  // trick to avoid too much recursion on firefox
        else
        {
            if (arguments[1] && arguments[3] == "user"){ // hack for when we click on another input on screen (color picker), in order to not have texteditor focused again
                    this._lastSelectionStyle = {
                    "font-family" : this.fontFamily ? this.fontFamily : this._lastSelectionStyle["font-family"], 
                    "bold" : this.bold || this._lastSelectionStyle["bold"], 
                    "italic" : this.italic || this._lastSelectionStyle["italic"], 
                    "text-align" : this.align ? this.align : this._lastSelectionStyle["text-align"], 
                    "font-size" : this.size ? this.size : this._lastSelectionStyle["font-size"],
                    "color" : this.color ? this.color : this._lastSelectionStyle["color"]
                };

                this.trigger("editor-change", e);
            }
        }
    }

    __onTextChanged()
    {
        if (this._initialized && this._textChangedEnabled)
            this.trigger("text-change");
        
        if (this.empty)
            this._defaultStyle = this._lastSelectionStyle;

        this.setDefaultStyle();
    }

    
    
});
fx.ns("fx.components", class ToolTip extends fx.EventDispatcher
{
    constructor()
    {
        super();

        this.on("blur", this.hide, window);
        this.on("mousemove", this.onMouseMove, window);
        this.on("mousedown", this.onMouseDown, window);
        this.on("mouseup", this.onMouseUp, window);
    }

    show(event, text, component)
    {
        if (text)
        {
            if (this._container)
            {
                if (this._container.text != text)
                    this._container.text = text;

                this._container.show();
                this._position(event, component);
            }
            else
            {
                this._container = new fx.components.Text({className : "ToolTip", text : text});
                this._container.init();
                this._position(event, component);
            }
        }
    }

    _position(e, component)
    {
        let style = component ? this._getToolTipStyle(component.id) : undefined;

        if (this._previousClass)
        {
            this._container.removeClass(this._previousClass);
            this._previousClass = "";
        }
        
        if (!style)
        {
            this._container._viewport = {};
            this._move(e.pageX + 10, e.pageY + 10);
        }
        else
        {
            if (style.class)
            {
                this._container.addClass(style.class);
                this._previousClass = style.class;
            }

            if (style.width)
                this._container._viewport.width = style.width;

            if (style.height)
                this._container._viewport.width = style.height;

            if (style.position)
            {
                let xPos, yPos;
                let position = fx.dom.offset(component.node);
                switch(style.position)
                {
                    case "left" : 
                        xPos = position.left - fx.dom.outerWidth(this._container.node) - (style.positionMargin || 10);
                        yPos = position.top + ( (fx.dom.outerHeight(component.node) - fx.dom.outerHeight(this._container.node)) / 2);
                        break;

                    case "top" : 
                        xPos = position.left + ( ( (fx.dom.outerWidth(component.node) * fx.graphics.getScale(component.node))  - fx.dom.outerWidth(this._container.node)) / 2);
                        yPos = position.top - (fx.dom.outerHeight(this._container.node) * fx.graphics.getScale(this._container.node)) - (style.positionMargin || 10);
                        

                        
                        break;
                }

                this._move(xPos, yPos);
            }
            else
            {
                this._move(e.pageX + 10, e.pageY + 10);
            }
        }
    }

    _move(xPos, yPos)
    {
        if (xPos + this._container.node.clientWidth > fx.graphics.screenSize().width)
        xPos = fx.graphics.screenSize().width - this._container.node.clientWidth - 10;

        if (yPos + this._container.node.clientHeight > fx.graphics.screenSize().height)
            yPos = fx.graphics.screenSize().height - this._container.node.clientHeight - 10;

        if (yPos < 5)
            yPos = 5;

        if (xPos < 5)
            xPos = 5;

        this._container.move(xPos, yPos);
    }

    hide()
    {
        if (this._container)
        {
            this._container.text = "";
            this._container.hide();
        }
    }

    onMouseMove(event)
    {
        if (this._mouseDown) return ;

        let component = fx.dom.parent(event.target, ".Component"),
            toolTip = component ? this._getToolTip(component.id) /*component.getAttribute("toolTip") */: "";

        while (component && component != document.body && (toolTip !== false && !toolTip))
        {
            component = component.parentNode;
            if (component)
                toolTip = this._getToolTip(component.id);//component.getAttribute("toolTip");
        }

        /*if (typeof toolTip == "function")
            toolTip = toolTip();*/
        
        if (component && (toolTip = this._getToolTip(component.id)))
            this.show(event, toolTip, fx.get("objects")[component.id] );
        else
            this.hide();
    }

    _getToolTip(id)
    {
        let toolTip = "";
        let component = fx.get("objects")[id];

        if (component)
            toolTip = component.toolTip;
        
        if (typeof toolTip == "function" && component)
            toolTip = toolTip();

        return toolTip
        // return fx.get("objects")[id] ? fx.get("objects")[id].toolTip : "";   
    }

    _getToolTipStyle(id)
    {
        return fx.get("objects")[id] ? fx.get("objects")[id].toolTypeStyle : undefined;
    }

    onMouseDown(event)
    {
        this._mouseDown = true;

        this.hide();
    }

    onMouseUp(event)
    {
        this._mouseDown = false;
    }

});
/**
 * Display list of component
 * Create only visible components
 * Destroy / create new components on scroll
 * Display one or more components per line
 * Adapt size and number of components with width of line
 * 
 * Parameters :
 * maxElementsPerRow : number of element per row. If set to "auto", set as many elements as possible. Default value : 4
 * maxRowHeight : maximum row height. Default value 150 pixels
 * elementWidth / elementHeight : size used for the ratio of every element instead of element.width / element.height
 * elementSize : function(element) returning {width, height} for the ratio of an element, or null to fall back on
 *               elementWidth / elementHeight then element.width / element.height. Lets a grid mixing data types give
 *               a ratio to a type that carries no size without forcing it on the others.
 * scrollOnNew : scroll automatically on new element. Default value : false
 * renderers : object of renderers for each data type. Example : { Sticker : renderers.StickerRendered, Background : renderers.BackgroundRenderer }]
 * hasOnlyUnique : if objects to display are unique, set this property true in order to gain performance.
 */
fx.ns("fx.components", class VerticalGridDynamic extends fx.Component {

    constructor(parameters)
    {
        super(parameters && parameters.data ? parameters.data : []);

        //parameters = (parameters instanceof Array || parameters instanceof fx.ModelArray) ? {} : parameters;
        
        this._className = (parameters && parameters.className) ? parameters.className : "";
        this._sharedData = (parameters && parameters.sharedData) ? parameters.sharedData : null;
        this.filter = (parameters && parameters.filter) ? parameters.filter : null;

        this._maxElementsPerRow = (parameters && parameters.maxElementsPerRow) ? parameters.maxElementsPerRow : null;
        this._elementWidth = (parameters && parameters.elementWidth) ? parameters.elementWidth : 0;
        this._elementHeight = (parameters && parameters.elementHeight) ? parameters.elementHeight : 0;
        this._elementSizeFn = (parameters && typeof parameters.elementSize == "function") ? parameters.elementSize : null;
        this._maxRowHeight = (parameters && parameters.maxRowHeight) ? parameters.maxRowHeight : 150;
        this._scrollOnNew = (parameters && parameters.scrollOnNew) ? parameters.scrollOnNew : false;
        this._scrollBarWidth = fx.graphics.scrollbarWidth();
        this._renderers = (parameters && parameters.renderers) ? parameters.renderers : [];
        this._childEffect = (parameters && parameters.childEffect !== undefined) ? parameters.childEffect : "";
        this._newChildEffect = (parameters && parameters.newChildEffect !== undefined) ? parameters.newChildEffect : "";
        this._marginBottom = (parameters && parameters.marginBottom !== undefined) ? parameters.marginBottom : 50;
        
        this._containerWidth = (parameters && parameters.containerWidth !== undefined) ? parameters.containerWidth : "100%";
        this._containerHeight = (parameters && parameters.containerHeight !== undefined) ? parameters.containerHeight : "100%";
        this._containerTop = (parameters && parameters.containerTop !== undefined) ? parameters.containerTop : 0;
        this._containerLeft = (parameters && parameters.containerLeft !== undefined) ? parameters.containerLeft : 0;

        this._selectable = (parameters && parameters.selectable !== undefined) ? parameters.selectable : false;
        this._selectable = (parameters && parameters.selectable !== undefined) ? parameters.selectable : false;

        this.headerComponent = (parameters && parameters.headerComponent !== undefined) ? parameters.headerComponent : null;

        // allow to have tiles with same size
        this._tilesSameSize = (parameters && parameters.tilesSameSize !== undefined) ? parameters.tilesSameSize : true;

        this._hasOnlyUnique = (parameters && parameters.hasOnlyUnique) ? parameters.hasOnlyUnique : false;

        this._onScrollHandler = this._onScroll.bind(this);
        this._manageNewItemsHandler = this._manageNewItems.bind(this);
        this._enableScrollHandler = this._enableScroll.bind(this);

        this._currentRenderers = {};

        this._labelIDS = {};

        this._newItems = {};

        this._scrollEnabled = true;

        this._selectedItems = [];
    }

    get maxElementsPerRow()
    {
        return this._maxElementsPerRow;
    }

    set maxElementsPerRow(val)
    {
        this._maxElementsPerRow = val;
        this._update();
    }

    get maxRowHeight()
    {
        return this._maxRowHeight;
    }

    set maxRowHeight(val)
    {
        this._maxRowHeight = val;
        this._update();
    }

    get renderers()
    {
        return this._renderers;
    }

    set renders(val)
    {
        this._renderers = val;
        if (this.initialized)
            this._update();
    }

    get childEffect()
    {
        return this._childEffect;
    }

    get newChildEffect()
    {
        return this._newChildEffect;
    }


    get headerComponent()
    {
        return this._headerComponent;
    }

    set headerComponent(val)
    {
        if (this._headerComponent)
        {
            this.off("resized", this.onHeaderComponentResized, this._headerComponent.component);
            this.off("component-initialized", this.onHeaderComponentResized, this._headerComponent.component);
        }
            
        this._headerComponent = val;

        if (this._headerComponent)
        {
            this.on("resized", this.onHeaderComponentResized, this._headerComponent.component);
            this.on("component-initialized", this.onHeaderComponentResized, this._headerComponent.component);
        }
            
    }

    get headerComponentHeight()
    {
        return this._headerComponent ? (this._headerComponent.component.initialized ? parseInt(this._headerComponent.component.realHeight) : ( isNaN(parseInt(this._headerComponent.viewport.height)) ? 0 : parseInt(this._headerComponent.viewport.height) ) ) : 0;
    }

    get headerComponentTop()
    {
        return this._headerComponent ? (this._headerComponent.component.initialized ? parseInt(this._headerComponent.component.realPosition.top) : ( isNaN(parseInt(this._headerComponent.viewport.top)) ? 0 : parseInt(this._headerComponent.viewport.top) ) ) : 0;
    }
    
    get selectedElement()
    {
        return this._selectedItem;
    }

    get selectedItems()
    {
        return this._selectedItems;
    }
    

    get data()
    {
        return super.data;
    }

    set data(val)
    {
        super.data = val;

        if (this.initialized)
            this._update();
    }

    scrollTop()
    {
        if (this.node)
            this.node.scrollTop = 0;
    }

    scrollToElement(element)
    {
        if (!this._structure) return;
        
        let obj;
        for (let i = 0; i < this._structure.length; i++)
        {
            let row = this._structure[i];
            if (row.items)
            {
                for (let j = 0; j < row.items.length; j++)
                {
                    let item = row.items[j];
                    if (item.element == element)
                    {
                        obj = { top : row.top, id : item.id };
                        break;
                    }
                }
                if (obj)
                    break;
            }
        }

        if (obj)
        {
            this.node.scrollTop = obj.top;
            return obj.id;
        }
    }

   
    
    /*************************** overrides ********************/

    onReady()
    {
        super.onReady();

        this.on("scroll", this.onScroll);
        this.on("click", this.onClick, window);
    }

    onDisplayUpdated()
    {
        /*if (fx.graphics.screenSize().width < this._containerWidth)
        {
            this.container.width("100%");
            this.container.left(0);
            this._structure = null;
        }
        else
        {
            this.container.width(this._containerWidth);
            this.container.left(this._containerLeft);
        }*/

        this.delay(this._updateDisplay, 500);
    }

    _updateDisplay()
    {
        if (!this._structure)
            this._estimateStructure();

        if (!this._structure || !this._canScroll)
            this.container.css("height", "100%");
        else
            this.container.css("height", this._structure.totalHeight + this._marginBottom);


        this._calculateVisibleRows();
        //this._updateVisibleRenderers();        
    }

    
    //
    onDataUpdated(action)
	{
        if (!this.initialized)
            return;

        /*if (this.filter && action.type != "init")
            this.filter.refresh();*/

        // When new Items are added one per one quickly, it could be very CPU intensive to recalculate everything, and not confortable for user to see all items replaced
        // so this code here allows to update grid every second, and scroll on first element of the wave (we set 5 secondes of each wave)
        if (action.type == "addItem" /*&& action.data.length === undefined*/)
        {
            // we store all new items here, so we can apply special effect when added
            //if (action.items.length > 0)
            //{
                for(let i = 0; i < action.items.length; i++)
                    this._newItems[action.items[i].id] = action.items[i];
            //}
            /*else
                this._newItems[action.data.id] = action.data;*/

            // let's store the first element, so we scroll to this element
            if (!this._newItems.first)
                this._newItems.first = action.items[0];//(action.data.length > 0) ? action.data[0] : action.data;
            
            // let's update grid in one second
            if (!this._newItemsTimer)
                this._newItemsTimer = setTimeout( this._manageNewItemsHandler, action.all ? 0 : 1000);

            this.delay(this._enableScroll, 5000);
        }
        else
        {
            if (action.type == "init")
                this.container.removeAllChild(true);
                
            this.delay(this._update, 50);
        }
            

    }

    onHeaderComponentResized()
    {
        this.container.top(this._containerTop + this.headerComponentTop + this.headerComponentHeight);
    }

    forceUpdate()
    {
        if (this.filter)
            this.filter.refresh();

        this.endMore();
        this.delay(this._update, 50);
    }

    endMore()
    {
        if (this.waiting)
        {
            this.waiting.destroy();
            this.waiting = null;
        }
    }

    _manageNewItems()
    {
        this._estimateStructure();
        
        if (this._canScroll && this._scrollOnNew && !this._scrollToNewElementDisabled)
        {
            this.scrollToElement( this._newItems.first );
            this._scrollToNewElementDisabled = true;
        }
        else
        {
            this._calculateVisibleRows();
            //this._updateVisibleRenderers(false);
        }

        this._newItemsTimer = null;

        this.endMore();
    }

    _enableScroll()
    {
        this._scrollToNewElementDisabled = false;
        this._newItems.first = null;
    }
   

    _clearScrollOnNewTimer()
    {
        this._scrollOnNewTimer = null;
    }

    create()
    {
        super.create();

        if (this._headerComponent)
        {
            this.addChild(this._headerComponent.component, this._headerComponent.viewport);
            if (this._headerComponent.position)
                this._headerComponent.component.css("position", this._headerComponent.position);
        }
            

        if (this._selectable)
            this.addClass("selectable");

        this.container = new fx.components.Box("container");
        this.addChild(this.container, {top:this._containerTop + this.headerComponentTop + this.headerComponentHeight, left : this._containerLeft, width : this._containerWidth, height:this._containerHeight});
    }

    getChildFromUI(element)
    {
        return this.container.getChildFromUI(element);
    }
    
    /***************************** PRIVATE *********************/
    _update()
    {
        /*if (fx.dom.parent(this.node, ".disabled"))
            return;*/
        //this._disableScroll();
        this._estimateStructure();
        this._calculateVisibleRows();
        //this._updateVisibleRenderers(false);

        if (this._selectedItem && !this.data.find({id : this._selectedItem.id}))
            this._selectedItem = null;
    }


    _estimateStructure()
    {
         this._structure = [];
         
         //this._previousData = [];
         let data = this.data instanceof fx.ModelArray ? this.data.toArray() : this.data;
         let hasOnlyUnique = this._hasOnlyUnique;//false;//true;//data.hasOnlyUnique();
         let top = 0;
         let totalHeight = 0;
         let newHeight;

         // Available width for a row. When the grid is not laid out yet (hidden panel, first display),
         // realWidth is 0 or empty and every row would get a 0 or negative height : leave the structure
         // null so _updateDisplay() computes it once the grid is displayed.
         let availableWidth = this.container.realWidth - this._scrollBarWidth;
         if (!isFinite(availableWidth) || availableWidth <= 0)
         {
            this._structure = null;
            this._canScroll = false;
            return;
         }

         for(let i = 0; i < data.length; i++)
         {
             let element = data[i];
             if (element.deleted)
                continue;

             if (element.type == "label")
             {
                element.id = element.id || Utils.newID();
                this._structure.push( { item : {id : element.id , element : element} , height : fx.components.DefaultRenderer.HEIGHT() , top : top} );
                top += Math.floor(fx.components.DefaultRenderer.HEIGHT() );
                totalHeight += fx.components.DefaultRenderer.HEIGHT();
             }
             else
             {
                let row = this._structure[this._structure.length-1];
                 
                let size = this._elementSize(element);
                let newWidth = this.maxRowHeight * size.width / size.height;
                newHeight = this.maxRowHeight;

                // check if last row is items row
                if (!row || !row.items || row.height < this.maxRowHeight * 0.8 || ((this.maxElementsPerRow == "auto" && newWidth > row.remainingWidth) || (row.items.length == this.maxElementsPerRow)))
                {
                    row = {items : [], sizes : [], remainingWidth : availableWidth, height : this.maxRowHeight, top : top};
                    top += Math.floor(row.height);
                    totalHeight += row.height;
                    
                    this._structure.push( row );
                }

                if (newWidth > row.remainingWidth)
                {
                    if (row.items.length == 0)  // Only one item 
                    {
                        newWidth = row.remainingWidth;
                        newHeight = size.height * row.remainingWidth / size.width;

                        row.items.push( {id :  (hasOnlyUnique && !row.items.find({id : element.id})) ? element.id : Utils.newID() , element : element} );
                        row.sizes.push(newWidth);

                        row.remainingWidth = 0;

                        top -= Math.floor(row.height);
                        totalHeight -= row.height;
                        row.height = newHeight;
                        top += Math.floor(row.height);
                        totalHeight += row.height;
                    }
                    else // resize other elements height
                    {
                        row.items.push( {id :  (hasOnlyUnique && !row.items.find({id : element.id})) ? element.id : Utils.newID() , element : element} );
                        
                        // calculate first totalWidth
                        let _totalWidth = 0;

                        for (let j = 0; j < row.items.length; j++)
                        {
                            let itemSize = this._elementSize(row.items[j].element);
                            _totalWidth += ( row.height * itemSize.width / itemSize.height );
                        }

                        newHeight = availableWidth * row.height / _totalWidth;

                        // calculate with for each element
                        for (let j = 0; j < row.items.length; j++)
                        {
                            let itemSize = this._elementSize(row.items[j].element);
                            row.sizes[j] = ( row.height * itemSize.width / itemSize.height ) / _totalWidth * availableWidth;
                        }
                     
                        row.remainingWidth = 0;
                        top -= Math.floor(row.height);
                        totalHeight -= row.height;
                        row.height = newHeight;
                        top += Math.floor(row.height);
                        totalHeight += row.height;

                        
                    }
                }
                else
                {
                    row.items.push( {id : (hasOnlyUnique && !row.items.find({id : element.id}))  ? element.id : Utils.newID() , element : element} );
                    row.sizes.push(newWidth);

                    top -= Math.floor(row.height);
                    totalHeight -= row.height;
                    row.height = newHeight;
                    top += Math.floor(row.height);
                    totalHeight += row.height;
                    row.remainingWidth = row.remainingWidth - newWidth;
                }
                
             }

             
         }

        //calculate total height
        this._structure.totalHeight = totalHeight;

        // rows start below the header / containerTop offset, so the content really spans offset + totalHeight
        let offset = this._containerTop + this.headerComponentTop + this.headerComponentHeight;
        this._canScroll = this._structure.totalHeight + offset > this.realHeight;

        if (this._canScroll)
            this.container.css("height", this._structure.totalHeight + this._marginBottom);
        else
            this.container.css("height", "100%");
    }


    /**
     * Width / height used to compute the tile ratio of an element.
     * An element with a missing, zero or non numeric dimension (photo still uploading, null image from an import)
     * would give NaN / Infinity ratios, which break the row layout for every following element : such an
     * element is laid out as a square tile instead.
     */
    _elementSize(element)
    {
        let custom = this._elementSizeFn ? this._elementSizeFn(element) : null;

        let width = Number(custom && custom.width ? custom.width : (this._elementWidth ? this._elementWidth : element.width));
        let height = Number(custom && custom.height ? custom.height : (this._elementHeight ? this._elementHeight : element.height));

        if (!(width > 0) || !(height > 0) || !isFinite(width) || !isFinite(height))
            return { width : 1, height : 1 };

        return { width : width, height : height };
    }

    _calculateVisibleRows()
    {
        if (!this._structure) return;

        this._visibleRows = { rows : [] /*, items : []*/};
        let visibleItems = {};
        let offset = this.headerComponentTop + this.headerComponentHeight;
        let bottom = offset;
        for (let i = 0; i < this._structure.length; i++)
        {
            let row = this._structure[i];
            
            if (row.top + offset >= (this.node.scrollTop - this.maxRowHeight ) && row.top + offset <= this.node.scrollTop  + this.node.clientHeight +  this.maxRowHeight  )
            {
                this._visibleRows.rows.push( row );
                
                let items = row.item ? [row.item] : row.items;
                for(let j = 0; j < items.length; j++)
                    visibleItems[items.getItemAt(j).id] = items.getItemAt(j);
            }
            
            bottom += row.height;
        }

        let vscrollBarVisible = (this.node.scrollHeight > this.node.clientHeight);
        
        if ( this.data.length > 0 && vscrollBarVisible && (this.data.more !== undefined && this.data.more !== false) && this.node.scrollTop + this.node.clientHeight >= (Math.floor(bottom) - 100) && !this.waiting)
        {
            this.delay(this._more, 500);
            
            if (!this.waiting)
            {
                if (fx.assets.loader)
                    this.waiting = new fx.components.Image({data : fx.assets.loader, className : "waiting"});
                else
                    this.waiting = new fx.components.Text({text : "Chargement ...", className : "waiting"});

                this.addChild( this.waiting, {top : bottom, left : 0, height : 50, width:"100%"});
            }
        }
    
        for (var id in this._currentRenderers)
        {
            if (!visibleItems[id])
            {
                this._currentRenderers[id].destroy();
                delete(this._currentRenderers[id]);
            }
        }

       // ajouter les nouveaux
       for (let i = 0; i < this._visibleRows.rows.length; i++)
       {
            let row = this._visibleRows.rows.getItemAt(i);
            let items = row.item ? [row.item] : row.items;
            let left = 0;
            for (let j = 0; j < items.length; j++)
            {
                let item = items.getItemAt(j);
                
                if (!this._currentRenderers[item.id])
                {
                    let child, renderer;

                    if (this._renderers && item.element)
                        renderer = this._renderers[Object.getPrototypeOf(item.element).constructor.name];
                    
                    if (!renderer)
                        renderer = fx.components.DefaultRenderer;
    
                    child = new renderer( item.element, this._sharedData );
                    child.addClass("Renderer");
                    
                    if (child instanceof fx.components.DefaultRenderer)
                        child.effect = "";
                    else
                    if (this._newItems[item.id])
                        child.effect = "scale";
                    else
                        child.effect = this.elementEffect;
                    
                    this.container.addChild( child );
                    this._currentRenderers[item.id] = child;
                }
                
                // if only one element per row, let's center it
                if (this.maxElementsPerRow == 1 && row.sizes)
                    left = (this.container.realWidth - row.sizes[j]) / 2;

                this._currentRenderers[item.id].viewport( {width : row.sizes ? row.sizes[j] : "auto", height: row.height, top : row.top, left : left} );

                if (row.sizes)
                    left += Math.floor(row.sizes[j]);
                
           }
           this._newItems = {};
        }
    }



    _more()
    {
        this.trigger("more");
    }

    _addChild(child)
    {
        this.container.addChild( child );
    }

    _removeChild(child, scoll)
    {
        if (scoll)
            child.destroy();
        else
            child.hideDestroy();
    }


    // We override this function, so grid is updated even when a component is updated and not only when list of components is updated
    /*_dataUpdated(e)
	{
	    this.onDataUpdated(e.action);
	}*/
    
    /********************* Events ********************/

    onScroll(e)
    {
        //if (this.globalyVisible)
        if (this._scrollEnabled)
            this._onScroll();
    }

    _onScroll()
    {
        this._calculateVisibleRows();
        //this._updateVisibleRenderers(true);
    }


    onClick(e)
    {
        if (!this.enabled || fx.dom.parent(this.node, ".disabled") || !fx.dom.parent(e.target, this.node))
            return;

        let found = null;
        for (let prop in this._renderers)
        {
            let renderer = this._renderers[prop];
            let elt = fx.dom.parent(e.target, "." + renderer.name)
            if (elt)
            {
                found = elt;
                break;
            }
        }

        if (!this._selectable)
        {
            if (found)
            {
                let component = this.data.find({id : found.getAttribute("data-id")});   
                this.trigger("selected", component);
            }
            return;
        }
        
        if (!found && fx.dom.parent(e.target, this) && !fx.dom.parent(e.target, this.container))
            return;

        /*if (found && fx.dom.hasClass(found, "selected"))
        {
            fx.dom.removeClass(found, "selected");
            this.trigger("selected", null);
            return;
        }*/
    
        if (this._selectable === true || this._selectable === "single")
        {
            let selectedElements = this.find(".selected");
            if (selectedElements)
            {
                if (!(selectedElements instanceof Array))
                    selectedElements = [selectedElements];

                for (let i = 0; i < selectedElements.length; i++)
                    fx.dom.removeClass(selectedElements.getItemAt(i), "selected");
            }

            if (found)
            {
                this._selectedItem = this.data.find({id : found.getAttribute("data-id")});
                fx.dom.addClass(found, "selected");
                this.trigger("selected", this._selectedItem);
            }
        }
        else
        if (this._selectable === "multiple")
        {
            if (found)
            {
                let selectedItem = this.data.find({id : found.getAttribute("data-id")});
                
                if (fx.dom.hasClass(found, "selected"))
                {
                    fx.dom.removeClass(found, "selected");
                    this.selectedItems.remove( selectedItem );
                }
                else
                {
                    fx.dom.addClass(found, "selected");
                    this.selectedItems.add( selectedItem );
                }
                
                this.trigger("selected", this.selectedItems);
            }
        }


        if (!found)
            this.trigger("selected", null);
    }

    
    _disableScroll()
    {
        this._scrollEnabled = false;
        this.delay(this._enableScrollUpdate, 1000);
    }

    _enableScrollUpdate()
    {
        this._scrollEnabled = true;
    }
});
fx.ns("fx.components", class AddPagesPanel extends fx.Component
{
    constructor(parameters)
    {
        super();
		this._maxPages = parameters ? parameters.maxPages : 0;
		this._pagePrice = parameters ? parameters.pagePrice : 0;
		this._remainingPages = parameters ? parameters.remainingPages : 0;
		this._pagesNumber;
		this._themes;
    }

	get maxPages()
	{
		return this._maxPages;
	}

	set maxPages(val)
	{
		this._maxPages = val;
		this.update();
	}

	get pagePrice()
	{
		return this._pagePrice;
	}

	set pagePrice(val)
	{
		this._pagePrice = val;
		this.update();
	}

	get remainingPages()
	{
		return this._remainingPages;
	}

	set remainingPages(val)
	{
		this._remainingPages = val;
		this.update();
	}

	onReady()
	{
		super.onReady();

		this.update();

		this.on("click", this._onClick, window);
		this.on("click", this._onPagesButtonClick, this.pageSelector);
		this.on("click", this._onThemesButtonClick, this.themeSelector);
		this.on("click", this._onAddPages, this.button);
        this.on("selected", this._onPageSelected, this.pageSelectorList);
		this.on("selected", this._onThemeSelected, this.themeSelectorList);
	}

	destroy(){
		super.destroy();
	}

	create(){

		/*** vertical list selectors ***/

		this.pageSelectorList = new fx.components.VerticalList({items: this._getPageSelectorItems(), selected : this._getPageSelectorItems()[0], className: "pageSelectorList", selectedAsset: fx.get("assets").checkmark});
		this.themeSelectorList = new fx.components.VerticalList({items: this._getThemeSelectorItems(), selected : this._getThemeSelectorItems()[0], className: "themeSelectorList", selectedAsset: fx.get("assets").checkmark});
		this.pageSelectorList.visibleAtStart = false;
		this.themeSelectorList.visibleAtStart = false;
		this.addChild(this.pageSelectorList, {left: 150, top: 65, width:"130", height:"150"});
		this.addChild(this.themeSelectorList, {left: 250, top: 65, width:"130", height:"85"});

		/*** selectors buttons ***/

		this.pageSelector = new fx.components.HBox({className : "pageSelector"});
		this.themeSelector = new fx.components.HBox({className : "themeSelector"});
		let label = this.pageSelectorList.items[0] ? this.pageSelectorList.items[0].name : "0 pages";
		this.pageSelectorLabel = new fx.components.Text(fx.text(label));
		this.pageSelector.addChild(this.pageSelectorLabel);
		this.pageSelector.addChild(new fx.components.Image({ data: fx.get("assets").DropdownArrow, className: "dropdown" }), {left: 10, width:"7", height:"7"});
		label = this.themeSelectorList.items[0] ? this.themeSelectorList.items[0].name : "Thématiques";
		this.themeSelectorLabel = new fx.components.Text(fx.text(label));
		this.themeSelector.addChild(this.themeSelectorLabel);
		this.themeSelector.addChild(new fx.components.Image({ data: fx.get("assets").DropdownArrow, className: "dropdown" }), {left: 10, width:"7", height:"7"});

		/*** panel content ***/

		this.content = new fx.components.Box("content");
		this.person = new shared.component.Person(fx.get("assets").personSure);
		this.personAdvice = new shared.component.Person(fx.get("assets").personAdvice);
		this.title = new fx.components.Text({text: fx.text("Ajouter des pages"), className: "bold"});
		this.text = new fx.components.Text({text: fx.text("jusqu'à $ pages ($€ par pages)", [ this.maxPages , this.pagePrice ]), className: "text"});
		this.textMaxPages = new fx.components.Text({text: fx.text("Vous avez atteint le nombre maximum de pages"), className: "warning bold"});
		this.button = new fx.components.Button({label : fx.text("Ajouter"), className : "button"});

		this.content.addChild(this.person, {width:"130", height:"130", top: 10, left: 10});
		this.content.addChild(this.personAdvice, {width:"130", height:"130", top: 10, left: 10});
		this.content.addChild(this.title, {left: 150, top: 15});
		this.content.addChild(this.text, {left: 150, top: 30});
		this.content.addChild(this.textMaxPages, {left: 145, top: 55, width: "200"});
		this.content.addChild(this.pageSelector, {left: 150, top: 65, width:"130", height:"20"});
		this.content.addChild(this.themeSelector, {left: 250, top: 65, width:"130", height:"20"});
		this.content.addChild(this.button, {left: 175, bottom: 10});
		this.personAdvice.visibleAtStart = false;
		this.textMaxPages.visibleAtStart = false;

		this.addChild(this.content, {width:"370", height:"150"});

	}

	/*** events ***/

	_onPagesButtonClick()
	{
		this.pageSelectorList.show();
	}

	_onThemesButtonClick()
	{
		this.themeSelectorList.show();
	}

	_onClick(e){
		if(!fx.dom.parent(e.target, this.themeSelector))
			this.themeSelectorList.hide();
		if(!fx.dom.parent(e.target, this.pageSelector))
			this.pageSelectorList.hide();
	}

	// triggered when a theme option is selected in the theme list
	_onThemeSelected(event)
    {
		this._themes = event.detail.id;
		this.themeSelectorLabel.text = event.detail.name;
    }

	// triggered when a page number option is selected in the pages list
    _onPageSelected(event)
    {
		this._pagesNumber = event.detail.id;
		this.pageSelectorLabel.text = event.detail.name;
    }

	// triggered when "Add" button is clicked
	_onAddPages(){
		this.hide();
		this.trigger("addPages", {pages: this._pagesNumber, themes: this._themes == 2 ? true : false});
	}

	/*** functions ***/

	// get elements to fill the page selector list
	_getPageSelectorItems()
	{
		let items = [];
		let pageStart = 4;
		if(this.remainingPages % 4 != 0)	// keep pages number multiple of 4
			pageStart = 2;
		for (var i = pageStart; i <= this.remainingPages; i+=4) {
			items.push({id: i, name: fx.text("$ pages", i)});
		}
		return items;
	}

	// get elements to fill the theme selector list
	_getThemeSelectorItems()
	{
		let items = [];
		items.push({id: 1, name: fx.text("Vierges")});
		items.push({id: 2, name: fx.text("Thématiques")});
		return items;
	}

	// update the panel content
	update(){
		this.pageSelectorList.items = this._getPageSelectorItems();
		this.text.text = fx.text("jusqu'à $ pages ($€ par pages)", [ this.maxPages , this.pagePrice ]);
		if (this.pageSelectorList.items.length <= 0)
		{
			this.title.hide();
			this.text.hide();
			this.pageSelector.hide();
			this.themeSelector.hide();
			this.button.hide();
			this.textMaxPages.show();
			this.person.hide();
			this.personAdvice.show();
		}
		else
		{
			this.pageSelectorList.selected = this.pageSelectorList.items[0];
			this.themeSelectorList.selected = this.themeSelectorList.items[0];
			this._pagesNumber = this.pageSelectorList.items[0].id;
			this._themes = this.themeSelectorList.items[0].id;
			this.themeSelectorLabel.text = this.themeSelectorList.items[0].name;
			this.pageSelectorLabel.text = this.pageSelectorList.items[0].name;
			this.title.show();
			this.text.show();
			this.pageSelector.show();
			this.themeSelector.show();
			this.button.show();
			this.textMaxPages.hide();
			this.person.show();
			this.personAdvice.hide();
			if(this.pageSelectorList.items.length <= 2)
				this.pageSelectorList.height(85);
			else
				this.pageSelectorList.height(150);
		}
	}

});
/**
 * Simple graphical component with a title, description and a button for executing a specific action (add photos ..).
 */
fx.ns("fx.components", class Card extends fx.Component {

    constructor({data, title, text, icon, buttonLabel, onButtonClick})
    {
        super(data);
        this.onButtonClick = onButtonClick;
        this.title = title;
        this.text = text;
        this.icon = icon;
        this.buttonLabel = buttonLabel;
        this.effect = "fade";
    }


    onReady()
    {
        super.onReady();
        this.on("click", this.onButtonClick, this._button);
    }

    create()
    {
        super.create();

        this._container = new fx.components.Box("cardContainer");

        this._person = new shared.component.Person(fx.get("assets").personAsset);
        this._title = new fx.components.Text({ text: this.title, className: "cardTitle" });
        this._text = new fx.components.Text({ text: this.text, className: "cardText" });
        this._button = new fx.components.Button({ icon: this.icon, label: this.buttonLabel, className: "cardButton" });

        this._container.addChild(this._person, {width:150, height : 150, top : -75, left : "center"});
        this._container.addChild( this._title, {width: "100%", height: 40, left: "center", top: 90});
        this._container.addChild( this._text, { width: "100%", height: 70, left: "center", top: 125});
        this._container.addChild( this._button, { left: "center", width: 250, height: 60, top: 160});
        this.addChild( this._container, { width : 400, height : 250});
        
        this.viewport({ width : 430, height : 340});    // width = container width + side margins (15) . height = container height + top margin (75) + bottom margin (15)
    }

});

fx.ns("fx.components", class Checkbox extends fx.Component {

    constructor(parameters)
    {
        super();

        this._label = parameters && parameters.label ? parameters.label : null;
        this._value = parameters && parameters.value ? parameters.value : null;
    }


    get value()
    {
        if (this.initialized)
            return this.find(".input").checked
        else
            return this._value;
    }

    set value(val)
    {
        this._value = val;

        if (this.initialized)
            this.find(".input").checked = this._value;
    }

    
    enable()
    {
        super.enable();
        this.find(".input").disabled = false;
    }

    disable()
    {
        super.disable();
        this.find(".input").disabled = true;
    }

    render()
    {
		return (this._label ? ('<div class="label">' + this._label + '</div>') : '') + '<input class="input" type="checkbox"' + (this.value ? "CHECKED" : "")+ '>';
    }

    onReady()
    {
        this.on("click", this._onClick);
        this.on("click", this._onInputClick, this.find(".input"));
    }


    _onClick(e)
    {
        if (fx.dom.parent(e.target, this.find(".label")))
        {
            this.value = !this.value;
            this.trigger("changed", this.value);
        }
            
    }

    _onInputClick(e)
    {
        this.trigger("changed", this.value);
    }
});
fx.ns("fx.components", class ColorPicker extends fx.Component {

	constructor(parameters){

        super();

        this.BOX_COLOR_HEIGHT = 25;
        this.BOX_COLOR_WIDTH = 29;

        this.customColorsVisible = false;

        this._lastColors = (parameters && parameters.lastColors) ? parameters.lastColors : ["#000"];
        this._currentColor = (parameters && parameters.currentColor) ? parameters.currentColor : (this._lastColors.length > 0 ? this._lastColors[this._lastColors.length - 1] : "ffffff");
        this._showOpacity = (parameters && parameters.showOpacity) ? parameters.showOpacity : false;
        this._pickerType = (parameters && parameters.pickerType) ? parameters.pickerType : null;

        this._pickerColor = "#000";

        this._opacity = 0;
        
        this._defaultColors = [  ["#FFFFFF", "#f4f4f4", "#dddddd", "#c7c7c6", "#b0b0af", "#999a99"],
                                ["#1d1e1b", "#838382", "#6c6c6b", "#575658", "#3f3f3e", "#292927"],
                                ["#f70000", "#ffbec3", "#ff8993", "#ff4054", "#cf0014", "#9f0028"],
                                ["#fc4e00", "#ffd5bf", "#ffaa7e", "#fd6b07", "#cf4100", "#973100"],
                                ["#844c18", "#e1d3c7", "#c2a68f", "#9d714a", "#613710", "#472814"],
                                ["#ffee00", "#fffbaf", "#fff987", "#fff542", "#cece00", "#939400"],
                                ["#009c28", "#bbe9d0", "#6cd09d", "#19bf79", "#00ab4e", "#00692d"],
                                ["#302b88", "#c6c7e0", "#9b9ac7", "#5d5aa4", "#4e4c9b", "#2c2160"],
                                ["#8d2c90", "#e3cae3", "#c693c6", "#b778b8", "#a04ea1", "#701988"],
                                ["#fb0880", "#ffcfe9", "#ff77c1", "#ff48ae", "#ff0d9a", "#b7045f"],
                                ["#00a1e9", "#b9e9fa", "#77d6f7", "#00bef1", "#0094ca", "#0071be"],
                                ["#00b05e", "#caeedc", "#90dcb8", "#59cc98", "#2c936a", "#28785d"]  ];

        this.on("updated", this.updateLastColors, this._lastColors);
    }
    
    get lastColors()
    {
        return this._lastColors;
    }

    set lastColors(val)
    {
        this._lastColors = val;
    }

    get defaultColors()
    {
        return this._defaultColors;
    }

    set defaultColors(val)
    {
        this._defaultColors = val;
    }

    get currentColor()
    {
        return this._currentColor;
    }

    set currentColor(val)
    {
        let color = tinycolor(val);

        this._currentColor = color.toRgbString();

        if (this._opacity > 0)
            color = color.setAlpha(1 - this._opacity).toRgbString();
        else
            color = this._currentColor;
        
        if (this.initialized)
        {
            this.trigger("selected", color);

            this.updateLastColors();
        }
    }

    get pickerColor()
    {
        if (!this._pickerColor)
            this._pickerColor = this.currentColor;

        return this._pickerColor;
    }

    set pickerColor(val)
    {
        this._pickerColor = tinycolor(val).toHexString();
        this.updateDisplayColor();
    }


    get opacityLabel()
    {
        return this.opacityValue + "%";
    }

    get opacityValue()
    {
        return parseInt((1 - this._opacity) * 100);
    }

   
    onReady()
    {
        super.onReady();

        this.on("click", this.onClick);

        this.on("mousedown", this.onMouseDown);
        this.on("mousemove", this.onMouseMove);
        this.on("mouseup", this.onMouseUp, window);
        this.on("keyup", this.onKeyUp, this.find(".input.hexaColor") );
        
        this.updateDisplayColor();
        this.updateGradientColorPicker();

        if (this._showOpacity)
            this.on("input", this._opacityUpdated, this.find(".opacityInput"));

        this._colorPicker = this.find(".colorPicker");
        this._colorPickerCursor = this.find(".colorPickerCursor");

        this._brightnessPicker = this.find(".brightnessPicker");
        this._brightnessPickerCursor = this.find(".brightnessPickerCursor");
    }

    _opacityUpdated()
    {
        this._opacity = 1 - (this.find(".opacityInput").valueAsNumber / 100);

        this.find(".opacityValue").innerHTML = this.opacityLabel;
     
        if (!this.customColorsVisible)
            this.currentColor = this._currentColor;
        
    }

    render()
    {
        let html = "";

        /// ------------ header 
        html += '<div class="header">';

        html += '<div class="colorPickerButton hover" title="Palette / Couleurs">';

        html += '<img class="custom" src="/app/assets/icons/colorpicker/custom-color.png" >';
        html += '<svg class="palette" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">',
        html += '<g transform="translate(-67 -19)">',
        html += '<g transform="translate(67 19)">',
        html += '<circle cx="10" cy="10" r="10" fill="#e2e7ee"/>',
        html += '</g>',
        html += '<g transform="translate(70.636 22.636)">',
        html += '<circle cx="2.5" cy="2.5" r="2.5" transform="translate(0.364 0.364)" fill="#ffc600"/>',
        html += '<circle cx="2.5" cy="2.5" r="2.5" transform="translate(0.364 7.364)" fill="#ea67a2"/>',
        html += '<circle cx="2.5" cy="2.5" r="2.5" transform="translate(7.364 0.364)" fill="#f29104"/>',
        html += '<circle cx="2.5" cy="2.5" r="2.5" transform="translate(7.364 7.364)" fill="#72b4c9"/>',
        html += '</g>',
        html += '</g>',
        html += '</svg>',

        html += '</div>';

        html += '<div class="noColorButton hover" title="Supprimer la couleur">';
        html += '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">',
        html += '<g fill="none" stroke="#f26b6b" stroke-width="1">',
        html += '<circle cx="10" cy="10" r="10" stroke="none"/>',
        html += '<circle cx="10" cy="10" r="9.5" fill="none"/>',
        html += '</g>',
        html += '<line x1="9" y2="9" transform="translate(5.5 5.5)" fill="none" stroke="#f26b6b" stroke-linecap="round" stroke-width="2"/>',
        html += '</svg>',
        html += '</div>';

        html += '<div class="lastColors">';
        html += this.updateLastColors(true);
        html +='</div>';

        html += '</div>';

        //----- Colors Panel START
        html += '<div class="colorsPanel">';

        //----- first panel : Default colors
        html += '<div class="defaultColors">';
        html += '<div class="colors">';

        let xPos = 7.5, yPos = 7.5;
        for(let i = 0; i < this.defaultColors.length; i++)
        {
            let row = this.defaultColors[i];

            for(let j = 0; j < row.length; j++)
            {
                let color = row[j];

                html += '<div class="color hover" data="' + color + '" style="background-color:' + color + ';top:' + yPos + 'px;left:' + xPos + 'px"></div>';

                yPos += 23;
            }

            xPos += 24.5;
            yPos = 7.5;
        }

        html += '</div>';
        html += '</div>';

        //----- second panel : custom color

        html += '<div class="customColors">';

        html += '<div class="input" maxlength="7">';
        html += '<input title="Entrez le code hexadécimal de votre couleur et appuyez sur Entrée" class="hexaColor" type="text">';
        html += '<button class="button">OK</button>';
        html += '</div>';
        
        html += '<div class="colorPickerContainer"><div class="colorPickerCursor"></div><canvas class="colorPicker" width="165" height="25"></canvas></div>'; // color
        html += '<div class="brightnessPickerContainer"><div class="brightnessPickerCursor"></div><canvas class="brightnessPicker" width="292" height="112.5" ></canvas></div>'; // brightness

        html += '<div class="colorDisplay"></div>'

        //html += '<div class="colorPickerButton">';
        //html += '<img src="/app/assets/icons/colorpicker/palette.png">';
        html += '</div>';

        html += '</div>';

        //----- Colors Panel END

        html += '</div>';

        // ------- opacity footer

        if (this._showOpacity)
        {
            html += '<div class="opacityControl">';
            html += '<span class="title">' + fx.text("Transparence") + '</span>';
            html += '<input type="range" class="opacityInput" min="0" max="100" value="' + this.opacityValue + '"/>'; 
            html += '<span class="opacityValue">' + this.opacityLabel + '</span>'
            html += '</div>';
        }

        return html;
    }

    resize()
    {
        this._realWidth = 315;
        this._realHeight = this._showOpacity ? 240 : 205;
        this.css({ width : this._realWidth, height : this._realHeight});
    }

    show()
    {
        super.show();

        if (this.node)
        {
            let childs = this.node.children;
            for(let i = 0; i < childs.length; i++)
                fx.dom.removeClass(childs[i], "hidden");
        }

        this.customColorsVisible = false;
        this.updateVisiblePanel()
    }

    hide()
    {
        super.hide();
        
        if (this.node)
        {
            let childs = this.node.children;
            for(let i = 0; i < childs.length; i++)
                fx.dom.addClass(childs[i], "hidden");
        }
    }

    destroy()
    {
        super.destroy();
    }


    contextMenu(e)
	{
        let menu = [];

        if(this._pickerType === "backgrounds")
        {
            if(e)
            {
                if(fx.dom.hasClass(e.target, "color"))
                {
                    let color = e.target.style.backgroundColor;
                    
                    menu.push( {label : fx.text("Appliquer"), code : "apply", color :  color} );

                    if (fx.get("app") != "frame")
                        menu.push( {label : fx.text("Appliquer à toutes les pages"), code : "applyall", color :  color} );
                }
            }
            return menu;
        }
    }
    
	onContextMenu(e)
	{
        if(this._pickerType === "backgrounds")
        {
            switch(e.detail.code)
            {
                case "apply":
                        this.currentColor = e.detail.color;
                    break;
                case "applyall":
                        this.trigger("selected-all", e.detail.color);
                    break;
            }
        }
	}

    onClick(event)
    {
        let colorElement = fx.dom.parent(event.target, ".color");
        
        if (colorElement)
        {
            this.currentColor = colorElement.getAttribute("data");
        }
        else
        if (fx.dom.parent(event.target, ".colorPickerButton"))
        {
            this.customColorsVisible = !this.customColorsVisible;
            this.updateVisiblePanel();
        }
        else
        if (fx.dom.parent(event.target, ".noColorButton"))
        {
            this.currentColor = "rgba(0,0,0,0)";
        }
        else
        if (fx.dom.parent(event.target, ".button"))
        {
            this.currentColor = this.pickerColor;
        }

        event.preventDefault();
    }

    updateVisiblePanel()
    {
        if (this.customColorsVisible)
        {
            fx.dom.addClass(this.find(".customColors"), "shown");
            fx.dom.addClass(this.find(".colorPickerButton"), "custom");
        }
        else
        {
            fx.dom.removeClass(this.find(".customColors"), "shown");
            fx.dom.removeClass(this.find(".colorPickerButton"), "custom");

            this.updateColorPickerPanel();
        }

    }

    updateDisplayColor()
    {
        this.css(this.find(".colorDisplay"), {"background-color": this.pickerColor});
        this.find("input.hexaColor").value = this.pickerColor;

        this.css(this.find("input.hexaColor"), {'background-color': this.pickerColor, 'color': tinycolor(this.pickerColor).isDark() ? "#fff" : "#000"});

    }

    updateLastColors(inject)
    {
        let html = '', xPos = 0, count = 0;
        for(let i = 0; i < this.lastColors.length && ++count < 9; i++)
        {
            let color = this.lastColors.getItemAt(i);

            if (color instanceof fx.Model)
                color = color.color;

            html += '<div class="color hover" data="' + color + '" style="background-color:' + color + ';top:' + 0 + 'px;left:' + xPos + 'px"></div>';
            xPos += this.BOX_COLOR_WIDTH;
        }

        if (inject === true)
            return html;
        else
        {
            let lastColors = this.find(".lastColors");
            if (lastColors)
                lastColors.innerHTML = html;
        }
    }

    updateColorPickerPanel()
    {
        if (!this.colorPickerDrawed)
        {
            let canvas = this.find(".colorPicker");
            
            if (!canvas) return;

            let ctx = canvas.getContext("2d");

            let img = new Image();
            img.onload = function(){
                ctx.drawImage( this, 0, 0, canvas.width, canvas.height);
            }
            img.src = "/app/assets/icons/colorpicker/gradient.jpg";
            
            this.colorPickerDrawed = true;
        }
    }

    updateGradientColorPicker()
    {
        let canvas = this.find(".brightnessPicker");
        let  ctx = canvas.getContext("2d");
        let my_gradient = ctx.createLinearGradient(0,0,canvas.width, 0);
        my_gradient.addColorStop(0,"rgb(0,0,0)");
        my_gradient.addColorStop(0.3,this.pickerColor);
        my_gradient.addColorStop(1,"#ffffff");
        ctx.fillStyle=my_gradient;
        ctx.fillRect(0,0,canvas.width,canvas.height);
    }

    onMouseDown(e)
    {
        if (fx.dom.parent(e.target, ".colorPickerContainer"))
        {
            //this.movetarget = "colorPickerContainer";
            this.movetarget = this._colorPicker;// this.find(".colorPicker");
        }
        else
        if (fx.dom.parent(e.target, ".brightnessPickerContainer"))
        {
            //this.movetarget = "brightnessPicker";
            this.movetarget = this._brightnessPicker;//this.find(".brightnessPicker");
        }

        this.onMouseMove(e);
    }
    
    onMouseMove(e)
    {
        if (!this.movetarget) return;

        if (fx.dom.parent(e.target, ".colorPickerContainer"))
        {
            let canvas = this.movetarget;//fx.dom.parent(e.target, ".colorPicker");
            let  mousePos = this.getMousePos(canvas, e);
            if(mousePos !== null && mousePos.x >= 0 && mousePos.x <= canvas.width)
            {
                let ctx = canvas.getContext("2d");
                let imageData = ctx.getImageData(mousePos.x, mousePos.y, 1,1);
                let color = 'rgb(' + imageData.data[0] + ',' + imageData.data[1] + ',' + imageData.data[2] + ')';
                
                this.pickerColor = color;

                this.updateGradientColorPicker();

                let pickerPos = mousePos.x - fx.dom.outerWidth(this._colorPickerCursor)/2;
                pickerPos = Math.min(Math.max(pickerPos, 0), canvas.width - fx.dom.outerWidth(this._colorPickerCursor));
                fx.dom.css(this._colorPickerCursor, { left : pickerPos });
            }
        }
        else
        if (fx.dom.parent(e.target, ".brightnessPickerContainer"))
        {
            let canvas = this.movetarget;//fx.dom.parent(e.target, ".brightnessPicker");
            let  mousePos = this.getMousePos(canvas, e);
            if(mousePos !== null && mousePos.x >= 0 && mousePos.x <= canvas.width && mousePos.y >= 0 && mousePos.y <= canvas.height)
            {
                let ctx = canvas.getContext("2d");
                let imageData = ctx.getImageData(mousePos.x, mousePos.y, 1,1);
                let color = 'rgb(' + imageData.data[0] + ',' + imageData.data[1] + ',' + imageData.data[2] + ')';
                
                this.pickerColor = color;

                let pickerPosX = mousePos.x - fx.dom.outerWidth(this._brightnessPickerCursor)/2;
                pickerPosX = Math.min(Math.max(pickerPosX, 0), canvas.width - fx.dom.outerWidth(this._brightnessPickerCursor));

                let pickerPosY = mousePos.y - fx.dom.outerHeight(this._brightnessPickerCursor)/2;
                pickerPosY = Math.min(Math.max(pickerPosY, 0), canvas.height - fx.dom.outerHeight(this._brightnessPickerCursor));

                fx.dom.css(this._brightnessPickerCursor, { left : pickerPosX, top : pickerPosY });
            }
        }
    }
    

    onMouseUp(e)
    {
        if (this.movetarget)
            this.movetarget = null;
    }

    onKeyUp(e)
    {
        if (e.keyCode == 13) // enter
        {
            this.currentColor = this.pickerColor;
            return;
        }

        let val = e.target.value;
        
        if (val.indexOf("#") != 0)
        {
            val.replace(new RegExp("#", 'g'), "");
            val = "#" + val;
        }
        
        while (val.length < 7)
            val += "0";
        
        this._pickerColor = tinycolor(val).toRgbString();

        this.updateGradientColorPicker();
        this.css(this.find(".colorDisplay"), {"background-color": this.pickerColor});        
    }

    getMousePos(canvas, evt)
    {
        let rect = canvas.getBoundingClientRect();
        return {
            x: evt.clientX - rect.left,
            y: evt.clientY - rect.top
        };
    }

  

});
fx.ns("fx.components", class ContextMenu extends fx.EventDispatcher{

    constructor()
    {
        super();

        this._registredComponents = [];

        this.on("mouseup", this._onMouseUp, window);
        this.on("contextmenu", this._onContextMenu, window);
    }

   
    register(component, menu)
    {
        this._registredComponents.push(component);
    }

    unregister(component)
    {
        this._registredComponents.remove(component);
    }


    _onMouseUp(e)
    {
        if (e.button != 0) return;
        
        this._removeMenu();
    }

    _onContextMenu(e)
    {
        this._removeMenu();

        if (!fx.components.Menu) return;

        // check for each registered component, if right click was on him
        let target;
        let components = this._sortComponentsByDepth();
        for (let i = 0; i < components.length; i++)
        {
            target = fx.dom.parent(e.target, "#" + components[i].id);

            if (target)
            {
                let contentMenu = components[i].contextMenu(e)
                if (contentMenu == false)
                    continue;

                if (contentMenu == "default")
                {
                    target = undefined;
                    break;
                }
                else
                {
                    this._menu = new fx.components.Menu(components[i], contentMenu);
                    this._menu.init();
                    this._menu.addClass("ContextMenu");
                    let xPos = e.pageX;
                    let yPos = e.pageY;

                    if (yPos + this._menu.realHeight > fx.graphics.screenSize().height)
                        yPos = fx.graphics.screenSize().height - this._menu.realHeight - 5;

                    if (xPos + this._menu.realWidth > fx.graphics.screenSize().width)
                        xPos = fx.graphics.screenSize().width - this._menu.realWidth - 5;

                    this._menu.move(xPos, yPos);
                    break;
                }
            }
        
        }   

        if (target !== undefined && target !== null)
            e.preventDefault();
    }

    _removeMenu()
    {
        if (this._menu)
        {
            this._menu.destroy();
            this._menu = null;
        }
    }

    _sortComponentsByDepth()
    {
        for (let i = 0; i < this._registredComponents.length; i++)
        {
            let component = this._registredComponents[i];
            component.__depth = this._getDepth(component.node);
        }

        return this._registredComponents.sort( this._sortByDepth);
    }

    _getDepth(element, depth)
    {
        if (depth === undefined) depth = 0;
        
        if (element.parentNode)
            return this._getDepth(element.parentNode, ++depth)
        else
            return depth;
    }

    _sortByDepth(a, b)
    {
        if (a.__depth > b.__depth)
            return -1;
        if (a.__depth < b.__depth)
            return 1;
        
        return 0;
    }

});

fx.ns("fx.components", class CountrySelect extends fx.Component {

    constructor(data) {
        super(data);
    }

    get countries() {
        let path = "";
        return [
            { "id": "AF", "name": fx.text("Afghanistan"), "thumb": path+"/app/assets/images/flags/af.png", "phone": "+93" },
            { "id": "AL", "name": fx.text("Albanie"), "thumb": path+"/app/assets/images/flags/al.png", "phone": "+355" },
            { "id": "DZ", "name": fx.text("Algérie"), "thumb": path+"/app/assets/images/flags/dz.png", "phone": "+213" },
            { "id": "AS", "name": fx.text("Samoa Américaines"), "thumb": path+"/app/assets/images/flags/as.png", "phone": "+1" },
            { "id": "AD", "name": fx.text("Andorre"), "thumb": path+"/app/assets/images/flags/ad.png", "phone": "+376" },
            { "id": "AO", "name": fx.text("Angola"), "thumb": path+"/app/assets/images/flags/ao.png", "phone": "+244" },
            { "id": "AI", "name": fx.text("Anguilla"), "thumb": path+"/app/assets/images/flags/ai.png", "phone": "+1" },
            { "id": "AQ", "name": fx.text("Antarctique"), "thumb": path+"/app/assets/images/flags/aq.png", "phone": "+672" },
            { "id": "AG", "name": fx.text("Antigua-et-Barbuda"), "thumb": path+"/app/assets/images/flags/ag.png", "phone": "+1" },
            { "id": "AR", "name": fx.text("Argentine"), "thumb": path+"/app/assets/images/flags/ar.png", "phone": "+54" },
            { "id": "AM", "name": fx.text("Arménie"), "thumb": path+"/app/assets/images/flags/am.png", "phone": "+374" },
            { "id": "AW", "name": fx.text("Aruba"), "thumb": path+"/app/assets/images/flags/aw.png", "phone": "+297" },
            { "id": "AU", "name": fx.text("Australie"), "thumb": path+"/app/assets/images/flags/au.png", "phone": "+61" },
            { "id": "AT", "name": fx.text("Autriche"), "thumb": path+"/app/assets/images/flags/at.png", "phone": "+43" },
            { "id": "AZ", "name": fx.text("Azerbaïdjan"), "thumb": path+"/app/assets/images/flags/az.png", "phone": "+994" },
            { "id": "BS", "name": fx.text("Bahamas"), "thumb": path+"/app/assets/images/flags/bs.png", "phone": "+1" },
            { "id": "BH", "name": fx.text("Bahreïn"), "thumb": path+"/app/assets/images/flags/bh.png", "phone": "+973" },
            { "id": "BD", "name": fx.text("Bangladesh"), "thumb": path+"/app/assets/images/flags/bd.png", "phone": "+880" },
            { "id": "BB", "name": fx.text("Barbade"), "thumb": path+"/app/assets/images/flags/bb.png", "phone": "+1" },
            { "id": "BY", "name": fx.text("Bélarus"), "thumb": path+"/app/assets/images/flags/by.png", "phone": "+375" },
            { "id": "BE", "name": fx.text("Belgique"), "thumb": path+"/app/assets/images/flags/be.png", "phone": "+32" },
            { "id": "BZ", "name": fx.text("Belize"), "thumb": path+"/app/assets/images/flags/bz.png", "phone": "+501" },
            { "id": "BJ", "name": fx.text("Bénin"), "thumb": path+"/app/assets/images/flags/bj.png", "phone": "+229" },
            { "id": "BM", "name": fx.text("Bermudes"), "thumb": path+"/app/assets/images/flags/bm.png", "phone": "+1" },
            { "id": "BT", "name": fx.text("Bhoutan"), "thumb": path+"/app/assets/images/flags/bt.png", "phone": "+975" },
            { "id": "BO", "name": fx.text("Bolivie"), "thumb": path+"/app/assets/images/flags/bo.png", "phone": "+591" },
            { "id": "BA", "name": fx.text("Bosnie-Herzégovine"), "thumb": path+"/app/assets/images/flags/ba.png", "phone": "+387" },
            { "id": "BW", "name": fx.text("Botswana"), "thumb": path+"/app/assets/images/flags/bw.png", "phone": "+267" },
            { "id": "BV", "name": fx.text("Île Bouvet"), "thumb": path+"/app/assets/images/flags/bv.png", "phone": "+47" },
            { "id": "BR", "name": fx.text("Brésil"), "thumb": path+"/app/assets/images/flags/br.png", "phone": "+55" },
            { "id": "IO", "name": fx.text("Territoire britannique de l'océan Indien"), "thumb": path+"/app/assets/images/flags/io.png", "phone": "+246" },
            { "id": "VG", "name": fx.text("Îles Vierges britanniques"), "thumb": path+"/app/assets/images/flags/vg.png", "phone": "+1" },
            { "id": "BN", "name": fx.text("Brunei Darussalam"), "thumb": path+"/app/assets/images/flags/bn.png", "phone": "+673" },
            { "id": "BG", "name": fx.text("Bulgarie"), "thumb": path+"/app/assets/images/flags/bg.png", "phone": "+359" },
            { "id": "BF", "name": fx.text("Burkina Faso"), "thumb": path+"/app/assets/images/flags/bf.png", "phone": "+226" },
            { "id": "BI", "name": fx.text("Burundi"), "thumb": path+"/app/assets/images/flags/bi.png", "phone": "+257" },
            { "id": "KH", "name": fx.text("Cambodge"), "thumb": path+"/app/assets/images/flags/kh.png", "phone": "+855" },
            { "id": "CM", "name": fx.text("Cameroun"), "thumb": path+"/app/assets/images/flags/cm.png", "phone": "+237" },
            { "id": "CA", "name": fx.text("Canada"), "thumb": path+"/app/assets/images/flags/ca.png", "phone": "+1" },
            { "id": "CV", "name": fx.text("Cap-Vert"), "thumb": path+"/app/assets/images/flags/cv.png", "phone": "+238" },
            { "id": "KY", "name": fx.text("Îles Caïmans"), "thumb": path+"/app/assets/images/flags/ky.png", "phone": "+1" },
            { "id": "CF", "name": fx.text("République centrafricaine"), "thumb": path+"/app/assets/images/flags/cf.png", "phone": "+236" },
            { "id": "TD", "name": fx.text("Tchad"), "thumb": path+"/app/assets/images/flags/td.png", "phone": "+235" },
            { "id": "CL", "name": fx.text("Chili"), "thumb": path+"/app/assets/images/flags/cl.png", "phone": "+56" },
            { "id": "CN", "name": fx.text("Chine"), "thumb": path+"/app/assets/images/flags/cn.png", "phone": "+86" },
            { "id": "CX", "name": fx.text("Île Christmas"), "thumb": path+"/app/assets/images/flags/cx.png", "phone": "+61" },
            { "id": "CC", "name": fx.text("Îles Cocos (Keeling)"), "thumb": path+"/app/assets/images/flags/cc.png", "phone": "+61" },
            { "id": "CO", "name": fx.text("Colombie"), "thumb": path+"/app/assets/images/flags/co.png", "phone": "+57" },
            { "id": "KM", "name": fx.text("Comores"), "thumb": path+"/app/assets/images/flags/km.png", "phone": "+269" },
            { "id": "CG", "name": fx.text("Congo"), "thumb": path+"/app/assets/images/flags/cg.png", "phone": "+242" },
            { "id": "CD", "name": fx.text("République démocratique du Congo"), "thumb": path+"/app/assets/images/flags/cd.png", "phone": "+243" },
            { "id": "CK", "name": fx.text("Îles Cook"), "thumb": path+"/app/assets/images/flags/ck.png", "phone": "+682" },
            { "id": "CR", "name": fx.text("Costa Rica"), "thumb": path+"/app/assets/images/flags/cr.png", "phone": "+506" },
            { "id": "HR", "name": fx.text("Croatie"), "thumb": path+"/app/assets/images/flags/hr.png", "phone": "+385" },
            { "id": "CU", "name": fx.text("Cuba"), "thumb": path+"/app/assets/images/flags/cu.png", "phone": "+53" },
            { "id": "CY", "name": fx.text("Chypre"), "thumb": path+"/app/assets/images/flags/cy.png", "phone": "+357" },
            { "id": "CZ", "name": fx.text("République tchèque"), "thumb": path+"/app/assets/images/flags/cz.png", "phone": "+420" },
            { "id": "DK", "name": fx.text("Danemark"), "thumb": path+"/app/assets/images/flags/dk.png", "phone": "+45" },
            { "id": "DJ", "name": fx.text("Djibouti"), "thumb": path+"/app/assets/images/flags/dj.png", "phone": "+253" },
            { "id": "DM", "name": fx.text("Dominique"), "thumb": path+"/app/assets/images/flags/dm.png", "phone": "+1" },
            { "id": "DO", "name": fx.text("République dominicaine"), "thumb": path+"/app/assets/images/flags/do.png", "phone": "+1" },
            { "id": "EC", "name": fx.text("Équateur"), "thumb": path+"/app/assets/images/flags/ec.png", "phone": "+593" },
            { "id": "EG", "name": fx.text("Égypte"), "thumb": path+"/app/assets/images/flags/eg.png", "phone": "+20" },
            { "id": "SV", "name": fx.text("Salvador"), "thumb": path+"/app/assets/images/flags/sv.png", "phone": "+503" },
            { "id": "GQ", "name": fx.text("Guinée équatoriale"), "thumb": path+"/app/assets/images/flags/gq.png", "phone": "+240" },
            { "id": "ER", "name": fx.text("Érythrée"), "thumb": path+"/app/assets/images/flags/er.png", "phone": "+291" },
            { "id": "EE", "name": fx.text("Estonie"), "thumb": path+"/app/assets/images/flags/ee.png", "phone": "+372" },
            { "id": "ET", "name": fx.text("Éthiopie"), "thumb": path+"/app/assets/images/flags/et.png", "phone": "+251" },
            { "id": "FK", "name": fx.text("Îles Malouines"), "thumb": path+"/app/assets/images/flags/fk.png", "phone": "+500" },
            { "id": "FO", "name": fx.text("Îles Féroé"), "thumb": path+"/app/assets/images/flags/fo.png", "phone": "+298" },
            { "id": "FJ", "name": fx.text("Fidji"), "thumb": path+"/app/assets/images/flags/fj.png", "phone": "+679" },
            { "id": "FI", "name": fx.text("Finlande"), "thumb": path+"/app/assets/images/flags/fi.png", "phone": "+358" },
            { "id": "FR", "name": fx.text("France"), "thumb": path+"/app/assets/images/flags/fr.png", "phone": "+33" },
            { "id": "GF", "name": fx.text("Guyane française"), "thumb": path+"/app/assets/images/flags/gf.png", "phone": "+594" },
            { "id": "PF", "name": fx.text("Polynésie française"), "thumb": path+"/app/assets/images/flags/pf.png", "phone": "+689" },
            { "id": "TF", "name": fx.text("Terres australes françaises"), "thumb": path+"/app/assets/images/flags/tf.png", "phone": "+262" },
            { "id": "GA", "name": fx.text("Gabon"), "thumb": path+"/app/assets/images/flags/ga.png", "phone": "+241" },
            { "id": "GM", "name": fx.text("Gambie"), "thumb": path+"/app/assets/images/flags/gm.png", "phone": "+220" },
            { "id": "GE", "name": fx.text("Géorgie"), "thumb": path+"/app/assets/images/flags/ge.png", "phone": "+995" },
            { "id": "DE", "name": fx.text("Allemagne"), "thumb": path+"/app/assets/images/flags/de.png", "phone": "+49" },
            { "id": "GH", "name": fx.text("Ghana"), "thumb": path+"/app/assets/images/flags/gh.png", "phone": "+233" },
            { "id": "GI", "name": fx.text("Gibraltar"), "thumb": path+"/app/assets/images/flags/gi.png", "phone": "+350" },
            { "id": "GR", "name": fx.text("Grèce"), "thumb": path+"/app/assets/images/flags/gr.png", "phone": "+30" },
            { "id": "GL", "name": fx.text("Groenland"), "thumb": path+"/app/assets/images/flags/gl.png", "phone": "+299" },
            { "id": "GD", "name": fx.text("Grenade"), "thumb": path+"/app/assets/images/flags/gd.png", "phone": "+1" },
            { "id": "GP", "name": fx.text("Guadeloupe"), "thumb": path+"/app/assets/images/flags/gp.png", "phone": "+590" },
            { "id": "GU", "name": fx.text("Guam"), "thumb": path+"/app/assets/images/flags/gu.png", "phone": "+1" },
            { "id": "GT", "name": fx.text("Guatemala"), "thumb": path+"/app/assets/images/flags/gt.png", "phone": "+502" },
            { "id": "GG", "name": fx.text("Guernesey"), "thumb": path+"/app/assets/images/flags/gg.png", "phone": "+44" },
            { "id": "GN", "name": fx.text("Guinée"), "thumb": path+"/app/assets/images/flags/gn.png", "phone": "+224" },
            { "id": "GW", "name": fx.text("Guinée-Bissau"), "thumb": path+"/app/assets/images/flags/gw.png", "phone": "+245" },
            { "id": "GY", "name": fx.text("Guyane"), "thumb": path+"/app/assets/images/flags/gy.png", "phone": "+592" },
            { "id": "HT", "name": fx.text("Haïti"), "thumb": path+"/app/assets/images/flags/ht.png", "phone": "+509" },
            { "id": "HM", "name": fx.text("Îles Heard-et-MacDonald"), "thumb": path+"/app/assets/images/flags/hm.png", "phone": "+672" },
            { "id": "VA", "name": fx.text("Saint-Siège (État de la Cité du Vatican)"), "thumb": path+"/app/assets/images/flags/va.png", "phone": "+379" },
            { "id": "HN", "name": fx.text("Honduras"), "thumb": path+"/app/assets/images/flags/hn.png", "phone": "+504" },
            { "id": "HK", "name": fx.text("Hong Kong"), "thumb": path+"/app/assets/images/flags/hk.png", "phone": "+852" },
            { "id": "HU", "name": fx.text("Hongrie"), "thumb": path+"/app/assets/images/flags/hu.png", "phone": "+36" },
            { "id": "IS", "name": fx.text("Islande"), "thumb": path+"/app/assets/images/flags/is.png", "phone": "+354" },
            { "id": "IN", "name": fx.text("Inde"), "thumb": path+"/app/assets/images/flags/in.png", "phone": "+91" },
            { "id": "ID", "name": fx.text("Indonésie"), "thumb": path+"/app/assets/images/flags/id.png", "phone": "+62" },
            { "id": "IR", "name": fx.text("Iran"), "thumb": path+"/app/assets/images/flags/ir.png", "phone": "+98" },
            { "id": "IQ", "name": fx.text("Iraq"), "thumb": path+"/app/assets/images/flags/iq.png", "phone": "+964" },
            { "id": "IE", "name": fx.text("Irlande"), "thumb": path+"/app/assets/images/flags/ie.png", "phone": "+353" },
            { "id": "IM", "name": fx.text("Île de Man"), "thumb": path+"/app/assets/images/flags/im.png", "phone": "+44" },
            { "id": "IL", "name": fx.text("Israël"), "thumb": path+"/app/assets/images/flags/il.png", "phone": "+972" },
            { "id": "IT", "name": fx.text("Italie"), "thumb": path+"/app/assets/images/flags/it.png", "phone": "+39" },
            { "id": "JM", "name": fx.text("Jamaïque"), "thumb": path+"/app/assets/images/flags/jm.png", "phone": "+1" },
            { "id": "JP", "name": fx.text("Japon"), "thumb": path+"/app/assets/images/flags/jp.png", "phone": "+81" },
            { "id": "JE", "name": fx.text("Jersey"), "thumb": path+"/app/assets/images/flags/je.png", "phone": "+44" },
            { "id": "JO", "name": fx.text("Jordanie"), "thumb": path+"/app/assets/images/flags/jo.png", "phone": "+962" },
            { "id": "KZ", "name": fx.text("Kazakhstan"), "thumb": path+"/app/assets/images/flags/kz.png", "phone": "+7" },
            { "id": "KE", "name": fx.text("Kenya"), "thumb": path+"/app/assets/images/flags/ke.png", "phone": "+254" },
            { "id": "KI", "name": fx.text("Kiribati"), "thumb": path+"/app/assets/images/flags/ki.png", "phone": "+686" },
            { "id": "KP", "name": fx.text("Corée du Nord"), "thumb": path+"/app/assets/images/flags/kp.png", "phone": "+850" },
            { "id": "KR", "name": fx.text("Corée du Sud"), "thumb": path+"/app/assets/images/flags/kr.png", "phone": "+82" },
            { "id": "KW", "name": fx.text("Koweït"), "thumb": path+"/app/assets/images/flags/kw.png", "phone": "+965" },
            { "id": "KG", "name": fx.text("Kirghizistan"), "thumb": path+"/app/assets/images/flags/kg.png", "phone": "+996" },
            { "id": "LA", "name": fx.text("Laos"), "thumb": path+"/app/assets/images/flags/la.png", "phone": "+856" },
            { "id": "LV", "name": fx.text("Lettonie"), "thumb": path+"/app/assets/images/flags/lv.png", "phone": "+371" },
            { "id": "LB", "name": fx.text("Liban"), "thumb": path+"/app/assets/images/flags/lb.png", "phone": "+961" },
            { "id": "LS", "name": fx.text("Lesotho"), "thumb": path+"/app/assets/images/flags/ls.png", "phone": "+266" },
            { "id": "LR", "name": fx.text("Libéria"), "thumb": path+"/app/assets/images/flags/lr.png", "phone": "+231" },
            { "id": "LY", "name": fx.text("Libye"), "thumb": path+"/app/assets/images/flags/ly.png", "phone": "+218" },
            { "id": "LI", "name": fx.text("Liechtenstein"), "thumb": path+"/app/assets/images/flags/li.png", "phone": "+423" },
            { "id": "LT", "name": fx.text("Lituanie"), "thumb": path+"/app/assets/images/flags/lt.png", "phone": "+370" },
            { "id": "LU", "name": fx.text("Luxembourg"), "thumb": path+"/app/assets/images/flags/lu.png", "phone": "+352" },
            { "id": "MO", "name": fx.text("Macao"), "thumb": path+"/app/assets/images/flags/mo.png", "phone": "+853" },
            { "id": "MK", "name": fx.text("Macédoine du Nord"), "thumb": path+"/app/assets/images/flags/mk.png", "phone": "+389" },
            { "id": "MG", "name": fx.text("Madagascar"), "thumb": path+"/app/assets/images/flags/mg.png", "phone": "+261" },
            { "id": "MW", "name": fx.text("Malawi"), "thumb": path+"/app/assets/images/flags/mw.png", "phone": "+265" },
            { "id": "MY", "name": fx.text("Malaisie"), "thumb": path+"/app/assets/images/flags/my.png", "phone": "+60" },
            { "id": "MV", "name": fx.text("Maldives"), "thumb": path+"/app/assets/images/flags/mv.png", "phone": "+960" },
            { "id": "ML", "name": fx.text("Mali"), "thumb": path+"/app/assets/images/flags/ml.png", "phone": "+223" },
            { "id": "MT", "name": fx.text("Malte"), "thumb": path+"/app/assets/images/flags/mt.png", "phone": "+356" },
            { "id": "MH", "name": fx.text("Îles Marshall"), "thumb": path+"/app/assets/images/flags/mh.png", "phone": "+692" },
            { "id": "MQ", "name": fx.text("Martinique"), "thumb": path+"/app/assets/images/flags/mq.png", "phone": "+596" },
            { "id": "MR", "name": fx.text("Mauritanie"), "thumb": path+"/app/assets/images/flags/mr.png", "phone": "+222" },
            { "id": "MU", "name": fx.text("Maurice"), "thumb": path+"/app/assets/images/flags/mu.png", "phone": "+230" },
            { "id": "YT", "name": fx.text("Mayotte"), "thumb": path+"/app/assets/images/flags/yt.png", "phone": "+262" },
            { "id": "MX", "name": fx.text("Mexique"), "thumb": path+"/app/assets/images/flags/mx.png", "phone": "+52" },
            { "id": "FM", "name": fx.text("Micronésie"), "thumb": path+"/app/assets/images/flags/fm.png", "phone": "+691" },
            { "id": "MD", "name": fx.text("Moldavie"), "thumb": path+"/app/assets/images/flags/md.png", "phone": "+373" },
            { "id": "MC", "name": fx.text("Monaco"), "thumb": path+"/app/assets/images/flags/mc.png", "phone": "+377" },
            { "id": "MN", "name": fx.text("Mongolie"), "thumb": path+"/app/assets/images/flags/mn.png", "phone": "+976" },
            { "id": "ME", "name": fx.text("Monténégro"), "thumb": path+"/app/assets/images/flags/me.png", "phone": "+382" },
            { "id": "MS", "name": fx.text("Montserrat"), "thumb": path+"/app/assets/images/flags/ms.png", "phone": "+1" },
            { "id": "MA", "name": fx.text("Maroc"), "thumb": path+"/app/assets/images/flags/ma.png", "phone": "+212" },
            { "id": "MZ", "name": fx.text("Mozambique"), "thumb": path+"/app/assets/images/flags/mz.png", "phone": "+258" },
            { "id": "MM", "name": fx.text("Myanmar"), "thumb": path+"/app/assets/images/flags/mm.png", "phone": "+95" },
            { "id": "NA", "name": fx.text("Namibie"), "thumb": path+"/app/assets/images/flags/na.png", "phone": "+264" },
            { "id": "NR", "name": fx.text("Nauru"), "thumb": path+"/app/assets/images/flags/nr.png", "phone": "+674" },
            { "id": "NP", "name": fx.text("Népal"), "thumb": path+"/app/assets/images/flags/np.png", "phone": "+977" },
            { "id": "NL", "name": fx.text("Pays-Bas"), "thumb": path+"/app/assets/images/flags/nl.png", "phone": "+31" },
            { "id": "NC", "name": fx.text("Nouvelle-Calédonie"), "thumb": path+"/app/assets/images/flags/nc.png", "phone": "+687" },
            { "id": "NZ", "name": fx.text("Nouvelle-Zélande"), "thumb": path+"/app/assets/images/flags/nz.png", "phone": "+64" },
            { "id": "NI", "name": fx.text("Nicaragua"), "thumb": path+"/app/assets/images/flags/ni.png", "phone": "+505" },
            { "id": "NE", "name": fx.text("Niger"), "thumb": path+"/app/assets/images/flags/ne.png", "phone": "+227" },
            { "id": "NG", "name": fx.text("Nigeria"), "thumb": path+"/app/assets/images/flags/ng.png", "phone": "+234" },
            { "id": "NU", "name": fx.text("Niue"), "thumb": path+"/app/assets/images/flags/nu.png", "phone": "+683" },
            { "id": "NF", "name": fx.text("Île Norfolk"), "thumb": path+"/app/assets/images/flags/nf.png", "phone": "+672" },
            { "id": "MP", "name": fx.text("Îles Mariannes du Nord"), "thumb": path+"/app/assets/images/flags/mp.png", "phone": "+1" },
            { "id": "NO", "name": fx.text("Norvège"), "thumb": path+"/app/assets/images/flags/no.png", "phone": "+47" },
            { "id": "OM", "name": fx.text("Oman"), "thumb": path+"/app/assets/images/flags/om.png", "phone": "+968" },
            { "id": "PK", "name": fx.text("Pakistan"), "thumb": path+"/app/assets/images/flags/pk.png", "phone": "+92" },
            { "id": "PW", "name": fx.text("Palaos"), "thumb": path+"/app/assets/images/flags/pw.png", "phone": "+680" },
            { "id": "PS", "name": fx.text("Palestine"), "thumb": path+"/app/assets/images/flags/ps.png", "phone": "+970" },
            { "id": "PA", "name": fx.text("Panama"), "thumb": path+"/app/assets/images/flags/pa.png", "phone": "+507" },
            { "id": "PG", "name": fx.text("Papouasie-Nouvelle-Guinée"), "thumb": path+"/app/assets/images/flags/pg.png", "phone": "+675" },
            { "id": "PY", "name": fx.text("Paraguay"), "thumb": path+"/app/assets/images/flags/py.png", "phone": "+595" },
            { "id": "PE", "name": fx.text("Pérou"), "thumb": path+"/app/assets/images/flags/pe.png", "phone": "+51" },
            { "id": "PH", "name": fx.text("Philippines"), "thumb": path+"/app/assets/images/flags/ph.png", "phone": "+63" },
            { "id": "PN", "name": fx.text("Îles Pitcairn"), "thumb": path+"/app/assets/images/flags/pn.png", "phone": "+64" },
            { "id": "PL", "name": fx.text("Pologne"), "thumb": path+"/app/assets/images/flags/pl.png", "phone": "+48" },
            { "id": "PT", "name": fx.text("Portugal"), "thumb": path+"/app/assets/images/flags/pt.png", "phone": "+351" },
            { "id": "PR", "name": fx.text("Porto Rico"), "thumb": path+"/app/assets/images/flags/pr.png", "phone": "+1" },
            { "id": "QA", "name": fx.text("Qatar"), "thumb": path+"/app/assets/images/flags/qa.png", "phone": "+974" },
            { "id": "RE", "name": fx.text("Réunion"), "thumb": path+"/app/assets/images/flags/re.png", "phone": "+262" },
            { "id": "RO", "name": fx.text("Roumanie"), "thumb": path+"/app/assets/images/flags/ro.png", "phone": "+40" },
            { "id": "RU", "name": fx.text("Russie"), "thumb": path+"/app/assets/images/flags/ru.png", "phone": "+7" },
            { "id": "RW", "name": fx.text("Rwanda"), "thumb": path+"/app/assets/images/flags/rw.png", "phone": "+250" },
            { "id": "BL", "name": fx.text("Saint-Barthélemy"), "thumb": path+"/app/assets/images/flags/bl.png", "phone": "+590" },
            { "id": "SH", "name": fx.text("Sainte-Hélène, Ascension et Tristan da Cunha"), "thumb": path+"/app/assets/images/flags/sh.png", "phone": "+290" },
            { "id": "KN", "name": fx.text("Saint-Christophe-et-Niévès"), "thumb": path+"/app/assets/images/flags/kn.png", "phone": "+1" },
            { "id": "LC", "name": fx.text("Sainte-Lucie"), "thumb": path+"/app/assets/images/flags/lc.png", "phone": "+1" },
            { "id": "MF", "name": fx.text("Saint-Martin (partie française)"), "thumb": path+"/app/assets/images/flags/mf.png", "phone": "+590" },
            { "id": "PM", "name": fx.text("Saint-Pierre-et-Miquelon"), "thumb": path+"/app/assets/images/flags/pm.png", "phone": "+508" },
            { "id": "VC", "name": fx.text("Saint-Vincent-et-les-Grenadines"), "thumb": path+"/app/assets/images/flags/vc.png", "phone": "+1" },
            { "id": "WS", "name": fx.text("Samoa"), "thumb": path+"/app/assets/images/flags/ws.png", "phone": "+685" },
            { "id": "SM", "name": fx.text("Saint-Marin"), "thumb": path+"/app/assets/images/flags/sm.png", "phone": "+378" },
            { "id": "ST", "name": fx.text("Sao Tomé-et-Principe"), "thumb": path+"/app/assets/images/flags/st.png", "phone": "+239" },
            { "id": "SA", "name": fx.text("Arabie saoudite"), "thumb": path+"/app/assets/images/flags/sa.png", "phone": "+966" },
            { "id": "SN", "name": fx.text("Sénégal"), "thumb": path+"/app/assets/images/flags/sn.png", "phone": "+221" },
            { "id": "RS", "name": fx.text("Serbie"), "thumb": path+"/app/assets/images/flags/rs.png", "phone": "+381" },
            { "id": "SC", "name": fx.text("Seychelles"), "thumb": path+"/app/assets/images/flags/sc.png", "phone": "+248" },
            { "id": "SL", "name": fx.text("Sierra Leone"), "thumb": path+"/app/assets/images/flags/sl.png", "phone": "+232" },
            { "id": "SG", "name": fx.text("Singapour"), "thumb": path+"/app/assets/images/flags/sg.png", "phone": "+65" },
            { "id": "SX", "name": fx.text("Saint-Martin (partie néerlandaise)"), "thumb": path+"/app/assets/images/flags/sx.png", "phone": "+1" },
            { "id": "SK", "name": fx.text("Slovaquie"), "thumb": path+"/app/assets/images/flags/sk.png", "phone": "+421" },
            { "id": "SI", "name": fx.text("Slovénie"), "thumb": path+"/app/assets/images/flags/si.png", "phone": "+386" },
            { "id": "SB", "name": fx.text("Îles Salomon"), "thumb": path+"/app/assets/images/flags/sb.png", "phone": "+677" },
            { "id": "SO", "name": fx.text("Somalie"), "thumb": path+"/app/assets/images/flags/so.png", "phone": "+252" },
            { "id": "ZA", "name": fx.text("Afrique du Sud"), "thumb": path+"/app/assets/images/flags/za.png", "phone": "+27" },
            { "id": "GS", "name": fx.text("Géorgie du Sud-et-les Îles Sandwich du Sud"), "thumb": path+"/app/assets/images/flags/gs.png", "phone": "+500" },
            { "id": "SS", "name": fx.text("Soudan du Sud"), "thumb": path+"/app/assets/images/flags/ss.png", "phone": "+211" },
            { "id": "ES", "name": fx.text("Espagne"), "thumb": path+"/app/assets/images/flags/es.png", "phone": "+34" },
            { "id": "LK", "name": fx.text("Sri Lanka"), "thumb": path+"/app/assets/images/flags/lk.png", "phone": "+94" },
            { "id": "SD", "name": fx.text("Soudan"), "thumb": path+"/app/assets/images/flags/sd.png", "phone": "+249" },
            { "id": "SR", "name": fx.text("Suriname"), "thumb": path+"/app/assets/images/flags/sr.png", "phone": "+597" },
            { "id": "SJ", "name": fx.text("Svalbard et Île Jan Mayen"), "thumb": path+"/app/assets/images/flags/sj.png", "phone": "+47" },
            { "id": "SZ", "name": fx.text("Eswatini"), "thumb": path+"/app/assets/images/flags/sz.png", "phone": "+268" },
            { "id": "SE", "name": fx.text("Suède"), "thumb": path+"/app/assets/images/flags/se.png", "phone": "+46" },
            { "id": "CH", "name": fx.text("Suisse"), "thumb": path+"/app/assets/images/flags/ch.png", "phone": "+41" },
            { "id": "SY", "name": fx.text("Syrie"), "thumb": path+"/app/assets/images/flags/sy.png", "phone": "+963" },
            { "id": "TW", "name": fx.text("Taïwan"), "thumb": path+"/app/assets/images/flags/tw.png", "phone": "+886" },
            { "id": "TJ", "name": fx.text("Tadjikistan"), "thumb": path+"/app/assets/images/flags/tj.png", "phone": "+992" },
            { "id": "TZ", "name": fx.text("Tanzanie"), "thumb": path+"/app/assets/images/flags/tz.png", "phone": "+255" },
            { "id": "TH", "name": fx.text("Thaïlande"), "thumb": path+"/app/assets/images/flags/th.png", "phone": "+66" },
            { "id": "TL", "name": fx.text("Timor oriental"), "thumb": path+"/app/assets/images/flags/tl.png", "phone": "+670" },
            { "id": "TG", "name": fx.text("Togo"), "thumb": path+"/app/assets/images/flags/tg.png", "phone": "+228" },
            { "id": "TK", "name": fx.text("Tokelau"), "thumb": path+"/app/assets/images/flags/tk.png", "phone": "+690" },
            { "id": "TO", "name": fx.text("Tonga"), "thumb": path+"/app/assets/images/flags/to.png", "phone": "+676" },
            { "id": "TT", "name": fx.text("Trinité-et-Tobago"), "thumb": path+"/app/assets/images/flags/tt.png", "phone": "+1" },
            { "id": "TN", "name": fx.text("Tunisie"), "thumb": path+"/app/assets/images/flags/tn.png", "phone": "+216" },
            { "id": "TR", "name": fx.text("Turquie"), "thumb": path+"/app/assets/images/flags/tr.png", "phone": "+90" },
            { "id": "TM", "name": fx.text("Turkménistan"), "thumb": path+"/app/assets/images/flags/tm.png", "phone": "+993" },
            { "id": "TC", "name": fx.text("Îles Turques-et-Caïques"), "thumb": path+"/app/assets/images/flags/tc.png", "phone": "+1" },
            { "id": "TV", "name": fx.text("Tuvalu"), "thumb": path+"/app/assets/images/flags/tv.png", "phone": "+688" },
            { "id": "UG", "name": fx.text("Ouganda"), "thumb": path+"/app/assets/images/flags/ug.png", "phone": "+256" },
            { "id": "UA", "name": fx.text("Ukraine"), "thumb": path+"/app/assets/images/flags/ua.png", "phone": "+380" },
            { "id": "AE", "name": fx.text("Émirats arabes unis"), "thumb": path+"/app/assets/images/flags/ae.png", "phone": "+971" },
            { "id": "GB", "name": fx.text("Royaume-Uni"), "thumb": path+"/app/assets/images/flags/gb.png", "phone": "+44" },
            { "id": "US", "name": fx.text("États-Unis"), "thumb": path+"/app/assets/images/flags/us.png", "phone": "+1" },
            { "id": "UM", "name": fx.text("Îles mineures éloignées des États-Unis"), "thumb": path+"/app/assets/images/flags/um.png", "phone": "+1" },
            { "id": "UY", "name": fx.text("Uruguay"), "thumb": path+"/app/assets/images/flags/uy.png", "phone": "+598" },
            { "id": "UZ", "name": fx.text("Ouzbékistan"), "thumb": path+"/app/assets/images/flags/uz.png", "phone": "+998" },
            { "id": "VU", "name": fx.text("Vanuatu"), "thumb": path+"/app/assets/images/flags/vu.png", "phone": "+678" },
            { "id": "VE", "name": fx.text("Venezuela"), "thumb": path+"/app/assets/images/flags/ve.png", "phone": "+58" },
            { "id": "VN", "name": fx.text("Viêt Nam"), "thumb": path+"/app/assets/images/flags/vn.png", "phone": "+84" },
            { "id": "VG", "name": fx.text("Îles Vierges britanniques"), "thumb": path+"/app/assets/images/flags/vg.png", "phone": "+1" },
            { "id": "VI", "name": fx.text("Îles Vierges des États-Unis"), "thumb": path+"/app/assets/images/flags/vi.png", "phone": "+1" },
            { "id": "WF", "name": fx.text("Wallis-et-Futuna"), "thumb": path+"/app/assets/images/flags/wf.png", "phone": "+681" },
            { "id": "EH", "name": fx.text("Sahara occidental"), "thumb": path+"/app/assets/images/flags/eh.png", "phone": "+212" },
            { "id": "YE", "name": fx.text("Yémen"), "thumb": path+"/app/assets/images/flags/ye.png", "phone": "+967" },
            { "id": "ZM", "name": fx.text("Zambie"), "thumb": path+"/app/assets/images/flags/zm.png", "phone": "+260" },
            { "id": "ZW", "name": fx.text("Zimbabwe"), "thumb": path+"/app/assets/images/flags/zw.png", "phone": "+263" }             
        ];
    }

    create() {
        super.create();
        let sortedCountries = this.countries.sort(function(a, b) {
            return this._compareStrings(a.name, b.name);
          }.bind(this));
        this.verticalList = new fx.components.CountryVerticalList({ items: sortedCountries, selected: this.countries[0] });
        this.verticalList.visibleAtStart = false;
        this.dropdownIcon = new fx.components.Image({ data: fx.get("assets").DropdownArrow, className: "dropdown" });
        this.updownIcon = new fx.components.Image({ data: fx.get("assets").UpdownArrow, className: "updown" });
        var height = this.countries.length < 5 ? 100 : 200;
        this.addChild(this.verticalList, { top: this.realHeight, left: 0, width: 200, height: height });
        this.addChild(this.dropdownIcon, { top: 15, left: 37 });
        this.addChild(this.updownIcon, { top: 15, left: 37 });
        this.updownIcon.visibleAtStart = false;
    }

    onReady() {
        super.onReady();
        this.on("click", this.onClick, window);
        this.on("selected", this.onSelected, this.verticalList);
    }

    onClick(e) {
        let select = fx.dom.parent(e.target, ".CountrySelect")
        if (select == this.node) {
            if (this.verticalList.visible)
                this._hideVerticalList();
            else
                this._showVerticalList();
        }
        else{
            if (this.verticalList.visible)
                this._hideVerticalList();
        }
    }

    onSelected(e) {
        this.find(".flag").src = e.detail.thumb;
        this.find(".flag").setAttribute("dialcode", e.detail.phone)
    }

    render() {
        let current = this.countries[0];
        this.countries.forEach(function (country) {
            if (country.id === fx.service("LangService").current.label)
                current = country;
        });
        return "<img class='flag' src='" + current.thumb + "' dialcode='" + current.phone + "'/>";
    }

    _showVerticalList(){
        this.dropdownIcon.hide();
        this.updownIcon.show();
        this.verticalList.show();
    }

    _hideVerticalList(){
        this.dropdownIcon.show();
        this.updownIcon.hide();
        this.verticalList.hide();
    }

    _compareStrings(a, b) {
        a = a.toLowerCase();
        b = b.toLowerCase();
        return (a < b) ? -1 : (a > b) ? 1 : 0;
    }
});

fx.ns("fx.components", class CountryVerticalList extends fx.Component {

    constructor(parameters) 
    {
        super();
        
        this.data = (parameters && parameters.items) ? parameters.items : [];
        this._selected = (parameters && parameters.selected !== undefined) ? parameters.selected : null;
        this._maxHeight = (parameters && parameters.maxHeight) ? parameters.maxHeight : 300;

        /*if (this.data instanceof fx.Model)
            this.listenUpdates( this.data );*/

        this._resized = true;
	}

    get items()
    {
        return this.data;
    }

    set items(val)
    {
        this.data = val;
        this.update();
    }

    onReady()
    {
        super.onReady();
        
        this.on("click", this.onClick);
        this.on("mousewheel", this.onMouseWheel, this);
    }

    get selected(){
        return this._selected;
    }

    set selected(val)
    {
        this._selected = val;

        if (this._selected)
        {
            let target = this.find('[data=' + (this._selected.id || this._selected) + ']');

            if (target)
            {
                this.removeClass(this.find(".selected"), "selected");
                this.addClass( target , "selected" );
            }
        }
        else
            this.removeClass(this.find(".selected"), "selected");
    }

    updateDisplay()
	{
		super.updateDisplay();
	}


    resize()
    {
        super.resize();
       
        if (this._resized)
            this._resize();
    }

    _resize()
    {
        let height = 0;
        let items = this.find(".item");
        if (items && items.length)
        {
            for (let i = 0; i < items.length; i++)
                height += fx.dom.outerHeight( items[i] );
        
            this._realHeight = Math.min(this._maxHeight, height);

            this.css({ height : this._realHeight});
        }

        this._resized = false;
    }

    render()
    {
        let html = "<ul class='items'>";

        for (let i = 0; i < this.data.length; i++)
        {
            if(this.data instanceof fx.ModelArray && this.data.getItemAt(i).empty)
            {
                html += "<li class='item empty";

                let item = this.data.getItemAt(i);

                html += "' data='" + item.id + "'><div class='overlay empty'></div>"
            }
            else
            {
                html += "<li class='item ";
                
                let item = (this.data instanceof fx.ModelArray) ? this.data.getItemAt(i) : this.data[i];
    
                if (this._selected == item)
                    html += " selected";
    
                html += "' data='" + (item.id || item) + "'><div class='overlay'></div>"
    
                if (item.thumb)
                    html += "<img src='" + item.thumb + "'>";
                if (item.phone)
                    html += "<span class='countryphone'>"+item.phone+"</span>";
                if (item.name)
                    html += "<span class='countryname'>"+item.name+"</span>";
                html += "</li>";
            }

        }

        html += "</ul>";

        return html;
    }

    onClick(event)
    {
        let target = fx.dom.parent(event.target, ".item");
        if (target)
        {
            this.removeClass(this.find(".selected"), "selected");
            this.addClass( target , "selected" );

            let item = this.data.find({id : target.getAttribute("data") });
            if (!item)
                item = target.innerText;

            this.trigger("selected", item);

            event.preventDefault();
        }
    }

    onMouseWheel(e)
    {
        e.stopPropagation();
    }


    onChildUpdated(action)
    {
        //this._needRender = true;
        //this.update();
    }

    onDataUpdated()
    {
        this._resized = true;
    }
    
});

/*fx.ns("fx.components", class HScrollable extends fx.Component 
{
    constructor(data) 
    {
        super(data);

        this._childsToAdd = [];
    }

    get scrollWidth()
    {
        return this.scrollableContent ? this.scrollableContent.scrollHeight : this.realHeight;
    }
  
    get canScrollLeft()
    {
        return this.scrollPosition > 0;
    }

    get canScrollRight()
    {
        return this.scrollPosition < this.scrollWidth;
    }

    get scrollPosition()
    {
        return this.scrollableContent.scrollLeft;
    }


    onReady() 
    {
        super.onReady();

        this.on("scrollChanged", this.onScrollChanged, this.scrollableContent );

        if (this._childsToAdd.length > 0)
            for (let i = 0; i < this._childsToAdd.length; i++)
                this.addChild(this._childsToAdd[i].child, this._childsToAdd[i].viewport, this._childsToAdd[i].effect, this._childsToAdd[i].position);
    }

     
    create() 
    {
        super.create();

        this.scrollableContent = new fx.components.HScrollableContent();

        super.addChild(this.scrollableContent, {top:0, left:0, width:"max-content", height:"100%"});      
    }

    
    addChild(child, viewport, effect, position){
        if (this.scrollableContent)
            this.scrollableContent.addChild(child, viewport, effect, position);
        else
            this._childsToAdd.push({child : child, viewport : viewport, effect : effect, position : position});
    }

    removeChild(child){
        this.scrollableContent.removeChild(child);
    }

    removeAllChild(destroy){
        this.scrollableContent.removeAllChild(destroy);
    }

    moveChildBefore( child1, child2 )
	{
        this.scrollableContent.moveChildBefore( child1, child2 );
	}

	moveChildAfter(child1, child2) 
	{
        this.scrollableContent.moveChildAfter( child1, child2 );
	}

    getChilds(){
        return this.scrollableContent.getChilds();
    }

    scroll(position, animate)
    {
        let newPosition;
        if (typeof position == "string")
            newPosition = this.scrollPosition + parseInt(position);
        else
            newPosition = position;

        this.scrollableContent.scroll(newPosition, animate);
    }

    showScroll(val)
    {
        if (val)
            this.scrollableContent.css("overflow-x", "scroll");
        else
            this.scrollableContent.css("overflow-x", "hidden");        
    }


    onScrollChanged(e)
    {
        this.trigger("scrollChanged");
    }
    
    destroy(){
        
        super.destroy();
        
    }
});*/
/*
fx.ns("fx.components", class HScrollableContent extends fx.Component {

    constructor(data) 
    {
        super(data);
    }


    onReady()
    {
        super.onReady();

        this.on("scroll", this.onScroll);
    }

    onScroll(e)
    {
        this.trigger("scrollChanged");
    }

    get scrollWidth()
    {
        return this.node ? this.node.scrollWidth : this.realWidth;
    }

    get scrollLeft()
    {
        return this.node ? this.node.scrollLeft : 0;
    }

    set scrollLeft(val)
    {
        if (this.node)
            this.node.scrollLeft = val;
    }
  
    scroll(position, animated)
    {
        if (position == this.node.scrollLeft)
            return;

        if (animated)
        {
            fx.dom.stop(this.node, true, false);
            fx.dom.animate(this.node, {scrollLeft : position}, 250);     
        }
        else
            this.node.scrollLeft = position;
            
    }

    moveChildBefore( child1, child2 )
	{
        let index = this._childs.indexOf( child1 );
        this._childs.splice(index, 1);
        index = this._childs.indexOf( child2 );
        this._childs.splice(index, 0, child1);
	
		this.node.insertBefore( child1.node, child2.node);
	}

	moveChildAfter(child1, child2) 
	{
        let index = this._childs.indexOf( child1 );
        this._childs.splice(index, 1);
        index = this._childs.indexOf( child2 );
        index++;
        this._childs.splice(index, 0, child1);

		this.node.insertBefore( child1.node, child2.node.nextSibling);

	}

});
*/
fx.ns("fx.components", class InputRange extends fx.components.Input {

    constructor(data)
    {
        super(data);

        this.min = data && data.min !== undefined ? data.min : 0;
        this.max = data && data.max !== undefined ? data.max : 10;
    }

    get value()
    {
        if (this.initialized)
            return this.find(".input").value;

        return 0;
    }

    set value(val)
    {
        this._value = Number(val);

        if (this.initialized)
            this.find(".input").value = this._value;
    }

    get min()
    {
        return this._min || 0;
    }

    set min(val)
    {
        this._min = val;

        this._update();
    }

    get max()
    {
        return this._max || 10;
    }

    set max(val)
    {
        this._max = val;

        this._update();
    }

    get step()
    {
        return this._step || 1;
    }

    set step(val)
    {
        this._step = val;

        this._update();
    }

    onReady()
    {
        let input = this.find("input");
        this.on("input", this.onChange, input);
        //this.on("change", this.onChange, input); // IE10 : but not supported on fx
    }

    onChange(e)
    {
        this.trigger("changed", this.value);
    }

    render()
    {
		return '<input class="input" type="range" min="' + this.min + '" max="' + this.max + '" value="' + this._value + '" ' + (this._name ? ('name= "' + this._name + '"') : '') + '>';
    }
});
fx.ns("fx.components", class Menu extends fx.Component {

    constructor(component, content) 
    {
        super();

        this._component = component;
        this._content = content;
    }

    get component()
    {
        return this._component;
    }
    
    get content()
    {
        return this._content;
    }


    /**
     * We override this function because the height has to be calculated depending on max width and total height of all elements
     */
    resize()
    {
        if (!this._initialized)
            return;

        let items = this.find(".item");
        if (!items.length)
            items = [items];

        if (!items)
            return;

        let height = 0;
        let width = 0;
        for (let i = 0; i < items.length; i++)
        {
            let item = items[i];

            if (fx.dom.hasClass(item, "separator"))
            {
                let margin = parseInt( fx.dom.css(item, "margin-top") ) + parseInt( fx.dom.css(item, "margin-bottom") );
                height += margin;
            }

            height += fx.dom.outerHeight( item );
            width = Math.max(width, fx.dom.outerWidth( item ) + 5 );
        }

        this._realWidth = width;
        this._realHeight = height;

        let container = this.find(".items");

        let padding = parseInt( fx.dom.css(container, "padding") );

        this._realWidth += 2*padding;
        this._realHeight += 2*padding;

        fx.dom.css(this.node, { width : this._realWidth, height : this._realHeight } );

        return this;
    }

    onReady()
    {
        super.onReady();
        this.on("mouseup", this._onClick);
    }

    render()
    {
        if (!this._content)
            return "";

        let html = "<ul class='items'>";

        for (let i = 0; i < this._content.length; i++)
         {
            let item = this._content[i];
            item.id = item.id || Utils.newID();

            if (item.label)
                html += "<li class='item' id='" + item.id + "'>" + item.label + "</li>";
            else
                html += "<li class='item separator'>";
        }

        html += "</ul>";

        return html;
    }

    
    _onClick(e)   
    {
        let uicomponent = fx.dom.parent(e.target, ".item");
        if (uicomponent)
        {
            let item = this._content.find({"id" : uicomponent.getAttribute("id")});
            if (item)
            {
                item.x = this.x;
                item.y = this.y;
                this._component.trigger("menu-action", item);
            }
        }
    }

});

fx.ns("fx.components", class PageContent extends fx.Component {

	constructor(parameters) {
		super(parameters);
	}

	create(){
		super.create();
		this.addChild(new fx.components.Content(), {top:"center", left:"center", width : 600, height:400} );
	}

	content(){
		return "";
	}

});


fx.ns("fx.components", class Content extends fx.Component {

	constructor(parameters) {
		super(parameters);
	}

	render (){
		return Utils.typeEqual( this.parent.content, "function") ? this.parent.content() : "";
	}
});
fx.ns("fx.components", class Popup extends fx.Component{

    constructor(data)
    {
        super(data);
        this.effect = "fade";

        this.destroyHandler = this.destroy.bind(this);

        this._contentWidth = 500;
        this._contentHeight = 500;
        this._showClose = false;
        this.closeOnClickBehind = true;
        this._modal = true;
        this._options = {modal : true, top:"center", left : "center", leftArrow : false};

        this._closeOnClickBehindActive = false;
    }


    /******************************** Parameters *****************************/

    get options()
    {
        return this._options;
    }

    set options(val)
    {
        if (val === undefined)
            return;

        for(let property in this._options)
        {
            if (val[property] !== undefined)
                this._options[property] = val[property];
        }
    }

    get modal()
    {
        return this._options.modal;
    }

    set modal(val)
    {
        this._options.modal = val;
    }

    get showClose()
    {
        return this._showClose;
    }

    set showClose(val)
    {
        this._showClose = val;
        if (this.initialized)
            this._addClose();
    }

    get contentWidth()
    {
        return this._contentWidth;
    }

    set contentWidth(val)
    {
        this._contentWidth = val;

        if (this.initialized)
        {
            this._contentContainer.width(val);
            this.updateDisplay();
        }
    }

    get contentHeight()
    {
        return this._contentHeight;
    }

    set contentHeight(val)
    {
        this._contentHeight = val;

        if (this.initialized)
        {
            this._contentContainer.height(val);
            this.updateDisplay();
        }
    }


    get contentContainer()
    {
        return this._contentContainer;
    }

    /******************************** Actions *****************************/

    close()
    {
        if (this._contentContainer)
        {
            this._contentContainer.addClass("up");
            this.hide( this.destroyHandler);
        }

        this.trigger("closed");
    }

    /******************************** Overrides *****************************/

    onReady()
    {
        super.onReady();

        //this.on("click", this.onClick);
        this.on("mousedown", this.onClick);
        this.on("ESCAPE", this.onClose, fx.keyboard);

        this.delay( this._setCloseOnClickBehindActive, 500);
    }

    create()
    {
        super.create();

        if (this.modal)
        {
            this.overlay = new fx.components.Box("overlay");
            super.addChild(this.overlay, {width:"100%", height:"100%", top:0, left:0});
        }

        
        this._contentContainer = new fx.components.Box("content");
        super.addChild(this._contentContainer, {width: this._contentWidth, height: this._contentHeight, top: this.options.top, left:this.options.left});

        if (this.options.leftArrow)
            this._contentContainer.addChild(new fx.components.Box("leftArrow"), {width:0, height:0, top:"center", left:-9});

        
        this._addClose();
    }

    _addClose()
    {
        if (!this.closeBtn && this.showClose)
        {
            this.closeBtn = new fx.components.IconButton({icon:fx.assets.ExitIcon, className : "close", filled : false});
            this._contentContainer.addChild(this.closeBtn, {width:30, height:30, right:10, top : 10});
        }
    }

    addChild(child, viewport)
    {
        if (this._contentContainer)
            this._contentContainer.addChild(child, viewport);
    }

    removeChild(child)
    {
        if (this._contentContainer)
            this._contentContainer.removeChild(child);
    }



    loading(val, text, style)
	{
		if (val)
        {
			if (this._loading)
				return;

			if (!this._loaderComponent)
			{
				if (fx.assets.loader)
				{
					this._loaderComponent = new fx.components.Box();

					if (text)
					{
						this._loaderComponent = new fx.components.Box();
						let vbox = new fx.components.VBox({className:"inner"});
						vbox.addChild(new fx.components.Image(fx.assets.loader), {width : 50, height : 50});
						vbox.addChild(new fx.components.Text(text) );
						this._loaderComponent.addChild(vbox, {width:"100%", height:80, top:"center", left:"center"});
					}
					else
					{
						this._loaderComponent.addChild(new fx.components.Image(fx.assets.loader), {width:50, height:50, top:"center", left:"center"} );
					}
						
				}
				else
					this._loaderComponent.addChild(new fx.components.Text(text ? text : "Chargement..."), {width:50, height:50, top:"center", left:"center"} );
					
				this.addClass("__loading");
				this._loaderComponent.addClass("loading");
				if (style)
					this._loaderComponent.addClass(style);
			}
                
			this._contentContainer.addClass("_loading");
			
            super.addChild(this._loaderComponent, {width:200, height:200, top : "center", left : "center"});
        }
        else
        {
			if (!this._loading)
				return;

			this._contentContainer.removeClass("_loading");
					
			this.delay(this._removeLoading, 1000);

            if (this._loaderComponent)
                super.removeChild(this._loaderComponent);
				
			this._loaderComponent.destroy();
			this._loaderComponent = null;
		}
		
		this._loading = val;

		this._updateLoadingScale();
	}


    /******************************** Events *****************************/

    onClick(e)
    {
        if (!this._closeOnClickBehindActive || !this.closeOnClickBehind) return;

        //e.target.parentNode : Fix for a strange bug occuring on ColorPicker throwing an event with event.target containing a div.color with no parent
        if ( e.target.parentNode && ( !fx.dom.parent(e.target, this._contentContainer) || fx.dom.parent(e.target, this.closeBtn) ))
        {
            e.stopImmediatePropagation();
            e.preventDefault();

            this.onClose(true);
        }
            
       
    }

    onClose(clickedOutSide)
    {
        this.close()
    }

    // ---- privates

    _setCloseOnClickBehindActive()
    {
        this._closeOnClickBehindActive = true;
    }

  
});

fx.ns("fx.components", class ScrollableTiles extends fx.components.Scrollable {
    
    constructor(parameters) {
        super("vertical");

        this.data = parameters && parameters.data ? parameters.data : null;
        this._renderers = parameters && parameters.renderers ? parameters.renderers : null;
        this._effect = parameters && parameters.effect ? parameters.effect : null;
        this._selectable = parameters && parameters.selectable ? parameters.selectable : false;

        this._elements = [];
        this._selectedElement;
    }

    get selectedElement()
    {
        return this._selectedElement;
    }


    get childUnselect()
    {
        if (!this._childUnselect)
            this._childUnselect = [];

        return this._childUnselect;
    }


    update()
    {
        this._buildTiles();
    }

    onReady()
    {
        this.on("click", this._onClick, window);
    }

    onDataUpdated(action)
    {
        if (this.initialized)
        {
            if (action.type == "removeItem"  && !(action.data instanceof Array))
            {
                // nothing to do
                let tile = this.getChildFromData(action.data);
                if (tile)
                    this.removeChild(tile, true);
            }
            else
            if (action.type == "addItem" && !(action.data instanceof Array))
            {
                for (let i = 0; i < action.items.length; i++)
                {
                    let item = action.items.getItemAt(i);
                    if (this.data.contains(item))
                        this._addTile( item );        
                }
                    
            }
            else
            {
                if (this.filter)
                    this.filter.refresh();

                this._buildTiles();
            }
        }
    }

    _onClick(e)
    {
        let clickInside = false;
        let allElements = this.childUnselect.concat([this]);
        for(let i = 0; i < allElements.length; i++)
            clickInside = clickInside || fx.dom.parent(e.target, allElements[i]);
        
        if (!clickInside)
        {
            if (this._selectedElement)
            {
                let child = this.getChildFromData(this._selectedElement);
                if (child)
                {
                    child.removeClass("selected");
                    this.trigger("clicked", null);
                }
                this._selectedElement = null;
            }
            return;
        }

        let clickOnChildUnselect = false;
        for(let i = 0; i < this.childUnselect.length; i++)
            clickOnChildUnselect = clickOnChildUnselect || fx.dom.parent(e.target, this.childUnselect[i]);

        if (clickOnChildUnselect)
            return;

        let childs = this.getChilds();
        for (let i = 0; i < childs.length; i++)
        {
            let element = fx.dom.parent(e.target, childs[i].node);
            if (element)
            {
                if (this._selectable)
                {
                    if (childs[i].hasClass("selected"))
                    {
                        childs[i].removeClass("selected");
                        this.trigger("clicked", null);
                    }
                    else
                    {
                        this._selectedElement = childs[i].data;
                        childs[i].addClass("selected");
                        this.trigger("clicked", childs[i].data);
                    }
                        
                }
                else
                {
                    this.trigger("clicked", childs[i].data);
                }
                break;
            }
            else
            {
                if (this._selectable)
                    childs[i].removeClass("selected");
            }

        }
    }

    _buildTiles()
    {
        // TODO : to optimize like VerticalGridDynamic
        this.removeAllChild(true);

        if (this.data)
            for (let i = 0; i < this.data.length; i++)
                this._addTile( this.data.getItemAt(i) );        
    }

    _addTile(item)
    {
        let renderer;
        if (this._renderers)
        {
            renderer = this._renderers[Object.getPrototypeOf(item).constructor.name];

            if (!renderer)
            {
                fx.log.error("Renderer for " + Object.getPrototypeOf(item).constructor.name + " not found");
                return;    
            }
        }
        else
            renderer = fx.components.DefaultRenderer;

        let tile = new renderer(item);
        this.addChild( tile );
    }

});
/**
 * Select
 * @constructor fx.components.Select
 * @param {object} this.dom DOM
 * @param {object} parameters Select parameters 
 */
fx.ns("fx.components", class Select extends fx.Component {

	constructor(parameters) 
	{
		super(parameters && parameters.data ? parameters.data : parameters);
	
		this.side = "right";
		
		this.items = parameters ? (parameters.items || ( parameters || [] ) ) : [];
		this._className = parameters ? parameters.className : "";
		this.changedHandler = parameters ? parameters.changed : null;
		this.selectedIndex = parameters ? parameters.selectedIndex || 0 : 0;
		this.selectedValue = parameters ? parameters.selectedValue || 0 : 0;

		if (parameters && !parameters.selectedIndex && parameters.selectedValue)
		{
			for(let i = 0; i < this.items.length; i++)
			{
				if (this.items.getItemAt(i) == this.selectedValue)
				{
					this.selectedIndex = i;
					break;
				}
			}
		}

		this.leftIcon = (parameters && parameters.leftIcon) ? parameters.leftIcon : '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="0 0 284.929 284.929" xml:space="preserve"><g><path class="inner" d="M282.082,76.511l-14.274-14.273c-1.902-1.906-4.093-2.856-6.57-2.856c-2.471,0-4.661,0.95-6.563,2.856L142.466,174.441   L30.262,62.241c-1.903-1.906-4.093-2.856-6.567-2.856c-2.475,0-4.665,0.95-6.567,2.856L2.856,76.515C0.95,78.417,0,80.607,0,83.082   c0,2.473,0.953,4.663,2.856,6.565l133.043,133.046c1.902,1.903,4.093,2.854,6.567,2.854s4.661-0.951,6.562-2.854L282.082,89.647   c1.902-1.903,2.847-4.093,2.847-6.565C284.929,80.607,283.984,78.417,282.082,76.511z"></path></g></svg>';
		this.rightIcon = (parameters && parameters.rightIcon) ? parameters.rightIcon : '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="0 0 284.929 284.929" xml:space="preserve"><g><path class="inner" d="M282.082,76.511l-14.274-14.273c-1.902-1.906-4.093-2.856-6.57-2.856c-2.471,0-4.661,0.95-6.563,2.856L142.466,174.441   L30.262,62.241c-1.903-1.906-4.093-2.856-6.567-2.856c-2.475,0-4.665,0.95-6.567,2.856L2.856,76.515C0.95,78.417,0,80.607,0,83.082   c0,2.473,0.953,4.663,2.856,6.565l133.043,133.046c1.902,1.903,4.093,2.854,6.567,2.854s4.661-0.951,6.562-2.854L282.082,89.647   c1.902-1.903,2.847-4.093,2.847-6.565C284.929,80.607,283.984,78.417,282.082,76.511z"></path></g></svg>';

		if (Utils.typeEqual(this.leftIcon, "string"))
			this.leftIcon = new fx.Asset(this.leftIcon);

		if (Utils.typeEqual(this.rightIcon, "string"))
			this.rightIcon = new fx.Asset(this.rightIcon);

		//this.updatePositionHandler;
	
		this.selectedItemContainer;
		this.selectedItemInner;
		this.itemWidth;

		this.dom = fx.get("dom");
	}

	get selectedItem()
	{
		if (this.items && this.selectedIndex >= 0)	
			return this.items.getItemAt(this.selectedIndex);
	}

	onReady() 
	{
		super.onReady();

		this.selectedItemContainer = this.find(".selected-item");
		this.selectedItemInner = this.find(".selected-item .inner");

		this.arrows = this.find(".select-arrow");
		this.item = this.find(".selected-item");

		this.updatePosition();

		this.on("click", this.updatePosition, this.arrows);
		this.on("click", this.updatePosition, this.item);

		this.addClass( this._className );
	}


	
	onDisplayUpdated()
	{
		super.onDisplayUpdated();
		
		this.toFinishResize = false;

		
		let elements = this.find(".label");
		if (!elements)
			elements = [];
		else
		if (!elements.length)
			elements = [elements];

		let containerMaxWidth = this.measuredWidth() - 4 - 2 * (30 /*this.measuredWidth(".select-arrow")*/ + 20 ); // 4 -> border, 20 -> margin
		this.itemWidth = containerMaxWidth;//(containerMaxWidth > this.itemWidth ? this.itemWidth : containerMaxWidth) + 20;

		this.dom.css(this.find(".selected-item"), {"width" : this.itemWidth + "px"});
		this.dom.css(this.find(".inner"), {"width" : (this.itemWidth * elements.length) + "px"});
		this.dom.css(elements, {"width" : this.itemWidth + "px"});
	}

	select(item)
	{
		if (!this.items)
			return;

		let index = this.items.indexOf(item);

		if (index == -1)
			return;
		
		this.updatePosition(index);
	}
	updatePosition(index)
	{
		if (parseInt(index) == index) // integer
		{
			if (this.selectedIndex == index)
				return;

			if (index < this.items.length - 1 && index >= 0)
				this.selectedIndex = index;
		}
		else 
		if (index)
		{	
			let event = index;
			if (this.dom.hasClass(event.currentTarget, "selected-item"))
			{
				let offset = fx.graphics.globalToLocal( this.node, event.pageX, event.pageY );
				if (offset.x < (this.realWidth / 2))
					this.side = "left";
				else
					this.side = "right";
			}
			else
				this.side = "";
			
			if (this.dom.hasClass(event.currentTarget, "left") || this.side == "left")
			{
				if (this.selectedIndex == 0)
				return;

				this.selectedIndex--;
			}
			else
			if (this.dom.hasClass(event.currentTarget, "right") || this.side == "right")
			{
				if (this.selectedIndex == this.items.length - 1)
				return;

				this.selectedIndex++;
			}
			
		}

		this.css(this.selectedItemInner, {"left" :  this.itemWidth * (-this.selectedIndex)});		

		if (this.selectedIndex == this.items.length - 1)
			this.addClass(this.find(".right"), "disabled");
		else
			this.removeClass(this.find(".right"), "disabled");

		if (this.selectedIndex == 0)
			this.addClass(this.find(".left"), "disabled");
		else
			this.removeClass(this.find(".left"), "disabled");

		this.trigger("changed", this.items.getItemAt(this.selectedIndex));

		if (this.changedHandler)
			this.changedHandler(this.items.getItemAt(this.selectedIndex));
	}

	render(){

		let html = '';
		
		html +='<div class="select-btn">';
		html +='<div class="select-arrow left">';
		html += this.leftIcon.render("icon");
		html +='</div>';
		
		html +='<div class="selected-item">';
		html +='<div class="inner">';
		
		for (let i = 0; i < this.items.length; i++)
			html +='<div class="label">' + this.items.getItemAt(i).label + '</div>';
		
		html +='</div>';
		html +='</div>';

		html +='<div class="select-arrow right">';
		html += this.rightIcon.render("icon");
		html +='</div>';
		
		html +='</div>';

		return html;
	}
});
fx.ns("fx.components", class TabBarHorizontal extends fx.Component {

	constructor(parameters) {
		super(parameters);

		this.currentTab;
		this.onTabClickHandler;
		this.defaultWidth = 50;
		this._tabWidth = this.defaultWidth;

		// style "underline" : a line under the active tab, style default : a background color under the active tab
		this.style = parameters.style ? parameters.style : "default"; 

		this.items = parameters.tabs ? parameters.tabs : parameters;
	}

	get selectedItem()
	{
		let selected = this.find(".active");
		if (selected)
		{
			let id = selected.getAttribute("id");
			return this._items.find({id:id});
		}
		return null;
	}

	get items()
	{
		return this._items;
	}

	set items(val)
	{
		this._items = val;

		if (this._items)
		{
			this.tabs = [];

			for (let index = 0; index < this._items.length; index++)
			{
				let obj = this._items[index];
				obj.id = obj.id ? obj.id : Utils.newID();

				let tab = { id : obj.id, 
							label : obj.label, 
							data : obj.data,
							asset : Utils.typeEqual(obj.image, "string") ? new fx.Asset(obj.image) : obj.image,
							showNumber : obj.showNumber}
				
				this.tabs.push( tab );
			}

			if (this.initialized)
				this.update();
		}
	}
	
	onReady()
	{
		super.onReady();

		if (this.style == "underline")
			this.addClass("style-underline");

		this.on("click", this.onTabClick, this.find(".tab"));

		if (this.tabs.length > 0)
			this.selectTab(this.tabs[0]);
	}

	onDataUpdated(action)
	{
		
	}

	destroy(){
		super.destroy();

		this.tabs = null;
		this.currentTab = null;
		this.onTabClickHandler = null;
	}

	render(){
		let html = '<div class="bar">';

		// this div is used to show which tab is active, and animate the active tab
		html += '<div class="selected_tab_background"><div class="inner"></div></div>';

		html += '<ul class="tabs">';

		for (let i = 0; i < this.tabs.length; i++){
			let tab = this.tabs[i];
			html += '<li class="tab" id="' + tab.id + '"><div class="inner">' + (tab.showNumber ? '<div class="number"></div>' : '') + ( tab.asset ? tab.asset.render('tab-image') : "" ) + '<div class="tab-label">' + tab.label+ '</div></div></li>';
		}

		html += '</ul></div>';
		return html;
	}

	selectTab(tab){

		if (!Utils.typeEqual(tab, "object"))
			tab = this.getTab(tab);

		if (tab && tab.id)
		{
			this.removeClass(this.find(".active"), "active");
			this.addClass(this.find(tab.id), "active");
			this.css(".selected_tab_background", {	left : this.childPosition(tab.id).left,
													width : this._tabWidth, 
													/*height : this.realHeight*/ });
			this.trigger("tabchanged", {tab : tab});
		}
		else	
		{
			fx.throwError("Can not select given tab");
		}
	}

	resize(){
		super.resize();

		let tabs = this.find(".tab");
		if (tabs)
		{
			this._tabWidth = Math.max( this.defaultWidth, this.measuredWidth() / tabs.length );
			for (let i = 0; i < tabs.length; i++)
				this.css(tabs[i], {width : this._tabWidth, left : this._tabWidth * i });
		}
	}

	position(){
		super.position();
	
	}

	getTab(id){
		let tab;
		for (let i = 0; i < this.tabs.length; i++)
		{
			if (this.tabs[i].id == id)
			{
				tab = this.tabs[i];
				break;
			}
		}
		return tab;
	}

	setNumber(id, number)
	{
		let numberElement = this.find("#" + id + " .number");
		(number > 999) ? number = "999+":"";	// avoid ugly display if photo number is too big.
		if (numberElement)
			numberElement.innerHTML = number;
	}

	onTabClick(event){
		let tab = fx.dom.parent(event.target, ".tab");
		if (tab)
			this.selectTab(tab.getAttribute("id"));
	}
});

fx.ns("fx.components", class TabBarVertical extends fx.Component {

	constructor(parameters) {
		super(parameters);

		this.tabs = [];
		this.currentTab;
		this.onTabClickHandler;
		this.defaultHeight = 70;

		let tabButtons = parameters.tabs ? parameters.tabs : parameters;

		if (tabButtons)
		{
			for (let index = 0; index < tabButtons.length; index++)
			{
				let obj = tabButtons[index];
				let tab = { id : (obj.id ?  obj.id : Utils.newID()), 
							label : obj.label, 
							data : obj.data,
							asset : Utils.typeEqual(obj.image, "string") ? new fx.Asset(obj.image) : obj.image }
				
				this.tabs.push( tab );
			}
		}

		this.dom = fx.get("dom");
	}
	
	onReady()
	{
		super.onReady();
		this.on("click", this.onTabClick, this.find(".tab"));
	}


	destroy(){
		super.destroy();

		this.tabs = null;
		this.currentTab = null;
		this.onTabClickHandler = null;
	}

	render(){
		let html = "";

		// this div is used to show which tab is active, and animate the active tab
		html += '<div class="selected_tab_background"></div>';

		html += '<ul class="tabs">';

		for (let i = 0; i < this.tabs.length; i++){
			let tab = this.tabs[i];
			html += '<li class="tab" id="' + tab.id + '">' + ( tab.asset ? tab.asset.render('tab-image') : "" ) + '<div class="tab-label">' + tab.label+ '</div></li>';
		}

		html += '</ul>';
		return html;
	}

	selectTab(tab){

		if (!Utils.typeEqual(tab, "object"))
			tab = this.getTab(tab);

		if (tab && tab.id)
		{
			this.removeClass(this.find(".active"), "active");
			this.addClass(tab.id, "active");
			this.css(".selected_tab_background", {	top : this.childPosition(tab.id).top,
													height : this.defaultHeight, 
													width : this.realWidth });
			this.trigger("tabchanged", {tab : tab})				
		}
		else	
		{
            //fx.throwError("Can not select given tab");
            fx.log.error("Can not select given tab");
		}
	}

	resize(){
		super.resize();

		let tabs = this.find(".tab");
        //let tabHeight = Math.max( this.defaultHeight, this.measuredHeight() / tabs.length );
        let tabHeight = this.defaultHeight;
		for (let i = 0; i < tabs.length; i++)
			this.css(tabs[i], {height : tabHeight, top : tabHeight * i });
		
	}

	position(){
		super.position();
	
	}

	getTab(id){
		let tab;
		for (let i = 0; i < this.tabs.length; i++)
		{
			if (this.tabs[i].id == id)
			{
				tab = this.tabs[i];
				break;
			}
		}
		return tab;
	}

	onTabClick(event){
		this.selectTab(event.currentTarget.getAttribute("id"));
	}
});

fx.ns("fx.components", class TabsHorizontal extends fx.Component {

	constructor(parameters) {
		super(parameters);
		this.panels = [], 
		this.onTabChangedHandler, 
		this.currentPanel,
		
		this.tabBarHeight = (parameters && parameters.tabbarheight) ? parameters.tabbarheight : 75;
		this.tabBarWidth = (parameters && parameters.tabbarwidth) ? parameters.tabbarwidth : "100%";
		this._horizontalAlign = (parameters && parameters.horizontalAlign) ? parameters.horizontalAlign : "left";
	}

	onReady()
	{
		super.onReady();

		this.onTabChangedHandler = this.onTabChanged.bind(this);

		this.on("tabchanged", this.onTabChanged, this.tabBar);

		this.tabBar.show(); // TODO : it's only to fix bug on calculating size

		if (!this.currentPanel)
			this.currentPanel = this.panels[0];

		if (this.currentPanel)
			//this.selectTab(this.currentPanel.id);
			this.delay(this._selectInitialTab, 250);
	}

	_selectInitialTab()
	{
		this.selectTab(this.currentPanel.id);
	}

	create(){
		super.create();

		this.tabBar = new fx.components.TabBarHorizontal({tabs : this.panels});
		
		let viewport = {top:0, width: this.tabBarWidth, height:this.tabBarHeight};

		if (this._horizontalAlign == "right")
			viewport.right = 0;
		else
		if (this._horizontalAlign == "center")
			viewport.left = "center";
		else
			viewport.left = 0;

		this.addChild(this.tabBar, viewport);

		return this;
	}

	

	destroy() {
		super.destroy();

		this.onTabChangedHandler = null;
		this.panels = null;
	}

	addTab(label, img, panel, showNumber){
		this.panels.push({id : Utils.newID(), label : label, image: img, panel : panel, showNumber : showNumber, index : this.panels.length});
	}
	
	selectTab(element){

		if (element instanceof fx.Component)
			element = this.getTab(element);

		if (this.initialized)
			this.tabBar.selectTab(element);
		else
			this.currentPanel = element;
	}

	getTab(panel)
	{
		let elt;
		for (let i = 0; i < this.panels.length; i++)
		{
			if (this.panels[i].panel == panel)
			{
				elt = this.panels[i];
				break;
			}
		}
		return elt;
	}

	setNumber(panel, number)
	{
		let tab = this.getTab(panel);
		this.tabBar.setNumber(tab.id, number);
	}

	onTabChanged(event){

		let selectedPanel = this.panels.find({"id" : event.detail.tab.id});
		
		if (!selectedPanel)
			return;

		if (!this.hasChild(selectedPanel.panel))
		{
			selectedPanel.panel.addClass("animate");
			selectedPanel.panel.addClass("hide-left");
			
			this.addChild(selectedPanel.panel, {top:this.tabBar.realHeight, left:0, width:"100%", height: "fill" });
		}
		
		if (this.currentPanel)
		{
			if (this.currentPanel.index < selectedPanel.index)
				this.currentPanel.panel.addClass("hide-left");
			else
				this.currentPanel.panel.addClass("hide-right");
				
			this.currentPanel.panel.hide();
				
		}

		selectedPanel.panel.removeClass("hide-left");
		selectedPanel.panel.removeClass("hide-right");

		selectedPanel.panel.show();

		//selectedPanel.panel.updateDisplay();
		
		this.currentPanel = selectedPanel;

		if (this.css("overflow") == "visible")
		{
			this.css({overflow : "hidden"});
			this.delay(this._setBackOverflow, 250);
		}
	}

	_setBackOverflow()
	{
		this.css({overflow : "visible"});
	}
	
});
fx.ns("fx.components", class TabsVertical extends fx.Component {

    constructor(data, tabbarwidth) 
    {
		super(data);
		this.panels = [], 
		this._currentPanel;
		
		this.tabBarwidth = tabbarwidth || 65;
	}

    get currentPanel()
    {
        return this._currentPanel;
    }

    onReady()
    {
		super.onReady();

		
		this.on("tabchanged", this.onTabChanged, this.tabBar);

		this.tabBar.show(); // TODO : it's only to fix bug on calculating size

		this._currentPanel = this.panels[0];
		this.selectTab(this._currentPanel.id);

	}

    create()
    {
		super.create();

		this.tabBar = new fx.components.TabBarVertical({tabs : this.panels});
		
		this.addChild(this.tabBar, {top:0, left:0, height:"100%", width:this.tabBarwidth});

		return this;
	}


    addTab(label, img, panel)
    {
		this.panels.push({id : Utils.newID(), label : label, image: img, class : panel, index : this.panels.length});
	}
	
    selectTab(id)
    {
		this.tabBar.selectTab(id);
	}

	onTabChanged(event){

		let selectedPanel = this.panels.find({"id" : event.detail.tab.id});
		
		if (!selectedPanel)
			return;

        if (!selectedPanel.instance)
            selectedPanel.instance = new selectedPanel.class(this.data);

		if (!this.hasChild(selectedPanel.instance))
		{
			selectedPanel.instance.addClass("animate");
			selectedPanel.instance.addClass("hide-left");
			
			this.addChild(selectedPanel.instance, {left:this.tabBar.realWidth, top:0, height:"100%", width: "fill" });
		}
		
		if (this._currentPanel)
		{
			if (this._currentPanel.index < selectedPanel.index)
				this._currentPanel.instance.addClass("hide-left");
			else
				this._currentPanel.instance.addClass("hide-right");
				
			this._currentPanel.instance.hide();
				
		}

		selectedPanel.instance.removeClass("hide-left");
		selectedPanel.instance.removeClass("hide-right");

		selectedPanel.instance.show();

		selectedPanel.instance.updateDisplay();
		
		this._currentPanel = selectedPanel;

        this.trigger("tabchanged", this._currentPanel.instance);
    }
    
    destroy() 
    {
		super.destroy();

		this.panels = null;
	}
	
});
fx.ns("fx.components", class Text extends fx.Component {

	constructor(parameters) {
		super();

		if (typeof parameters == "string")
			this._text = parameters;
		else
		{
			this._classname = parameters ? parameters.className : "";
			this._text = parameters ? parameters.text : "";
			this.toolTip = parameters ? parameters.toolTip : "";
		}
	}

	onReady (){
		
		if (this._classname)
			this.addClass(this._classname);
	}

	get text()
	{
		return this._text;
	}

	set text(val)
	{
		this._text = val;
		this.refresh();
	}

	refresh()
	{
		if (this.node)
			this.node.innerHTML = this.render();
	}

	render(){
		return this._text !== undefined ? (this._text instanceof fx.Asset ? this._text.content : this._text) : "";
	}
	
});
fx.ns("fx.components", class VScrollBar extends fx.Component {

    constructor(data) 
    {
        super(data);

    }

    onReady() 
    {
        super.onReady();
        
        this.on("mousedown", this.onMouseDown, window);
        this.on("mousemove", this.onMouseMove, window);
        this.on("mouseup", this.onMouseUp, window);
        this.on("blur", this.onMouseUp, window);
    }

    scrollPosition(val, animate, noevent)
    {
        if (val)
        {
            if (!this.thumb)
                return;

            this.thumb._viewport.top = Math.min(Math.max(val, 0), this.realHeight - this.thumb.realHeight);
            
            if (animate !== false)
                this.thumb.addClass("animated");

            this.thumb.css({top: this.thumb._viewport.top });
            
            if (!noevent)
                this.trigger("moved", {position:this.thumb._viewport.top, animated : animate !== false});

            
        }
        else
            return this.thumb ? this.thumb._viewport.top : 0;
    }

    create()
    {
        super.create();

        this.thumb = new fx.components.Box("thumb");
        this.addChild( this.thumb, {top:0, left:0, width:"100%", height:0})
    }

    /*refresh(height) {
        this.thumb.viewport({height:height, width:"100%", top: this.scrollPosition(), left : 0});
    }*/

   

    onMouseDown(event) 
    {
        if (event.target == this.node)
        {
            let top = event.pageY - this.thumb.realHeight/2;
            this.thumb._viewport.top = Math.min(Math.max(top, 0), this.realHeight - this.thumb.realHeight);

            this.thumb.addClass("animated");
            this.thumb.css({top: this.thumb._viewport.top });

            event.stopImmediatePropagation();
    
            this.trigger("moved", {position:this.thumb._viewport.top, animated : true});
            
        }
        else
        if (event.target != this.thumb.node)
            return;

        this.mouseDown = true;
        this.mouseUp = false;
        this.mouseMove = false;
        this.offset = event.pageY - this.thumb._viewport.top;
    }

    onMouseMove(event) {

        if (this.mouseDown)
        {
            this.mouseDown = false;
            this.mouseUp = false;
            this.mouseMove = true;
        }
        else
        {
            if (event.target == this.thumb.node || event.target == this.node)
                event.stopImmediatePropagation();
        }

        if (!this.mouseMove) return;

        let top = event.pageY - this.offset;

        this.thumb._viewport.top = Math.min(Math.max(top, 0), this.realHeight - this.thumb.realHeight);
        
        this.thumb.removeClass("animated");
        this.thumb.css({top: this.thumb._viewport.top });

        event.stopImmediatePropagation();

        this.trigger("moved", {position:this.thumb._viewport.top, animated : false});
    }

    onMouseUp(event) {
        this.mouseDown = false;
        this.mouseUp = true;
        this.mouseMove = false;
    }
    
});
/*fx.ns("fx.components", class VerticalContentButton extends fx.Component {
    
    constructor(parameters) {
        super(parameters);

        this.clickCallback = parameters.click;
        this.data = parameters.data;
        this.icon = parameters.icon;
        this.title = parameters.title;
        this.subtitle = parameters.subtitle

        this.dom = fx.get("dom");
    }

    onReady()
    {
        this.on("click", this.onClick);
    }


    onClick(){
        if (this.clickCallback)
            this.clickCallback(this.data || this);
    }

    render(){
        let html = this.icon.render("icon");
        html += "<div class='title'>" + this.title + "</div>";
        if (this.subtitle)
            html += "<div class='subtitle'>" + this.subtitle + "</div>";
        return html;
    }

});*/
/**
 * VerticalGridComponent
 * @constructor fx.components.VerticalGridComponent
 * @param {object} dom DOM
 * @param {object} parameters columns/cellrenderer
 */
/*
fx.ns("fx.components", class VerticalGridComponent extends fx.Component {

	constructor(parameters) {
		super(parameters);

		this.columns = (parameters && parameters.columns) ? parameters.columns : 2;
		this.renderer = (parameters && parameters.renderer) ? parameters.renderer : fx.components.DefaultRenderer;
		this.data = (parameters && parameters.data ? parameters.data : []);
	}

	
	create(){
		super.create();
		this.myLazyLoad = new LazyLoad({ container: this.node });     
	}

	enable(){
		super.enable();
	}

	refresh(){
		
		if (!this.initialized)
			return;

		//var data = this.data();

		this.removeAllChild(true);

		if (!this.data)
			return;

		let width =  (100 / this.columns) * 0.95, cellWidth, data = this.data;

		for (let index = 0; index < data.length; index++)
		{	
			let item = data[index],
				r;

			if (item.type == "label")
			{
				cellWidth = 100;
				r = new fx.components.DefaultRenderer(item);
			}
			else
			{
				cellWidth = width;
				r = new this.renderer(item);
			}

			this.addChild(r, {width : cellWidth + "%", height : r.defaultHeight() });


			r.addClass("Renderer");
			r.show();
		}

		this.myLazyLoad.update();
	
	}

	destroy(){
		super.destroy();
	}

	itemRender (r){
		this.renderer = r;
	}
});

*/
fx.ns("fx.components", class VerticalList extends fx.Component {

    constructor(parameters) 
    {
        super();
        
        this.data = (parameters && parameters.items) ? parameters.items : [];
        this._selected = (parameters && parameters.selected !== undefined) ? parameters.selected : null;
        this._renderer = (parameters && parameters.labelRenderer !== undefined) ? parameters.labelRenderer : null;
        this._maxHeight = (parameters && parameters.maxHeight) ? parameters.maxHeight : 300;

        this._selectedAsset = (parameters && parameters.selectedAsset) ? parameters.selectedAsset : false;
        this._selectedPosition = (parameters && parameters.selectedPosition) ? parameters.selectedPosition : "left";

        this._resized = true;
    }

    get items()
    {
        return this.data;
    }

    set items(val)
    {
        this.data = val;
        this.update();
    }

    get data()
    {
        return super.data;
    }

    set data(val)
    {
        if (this.data instanceof Array)
        {
            for(let i = 0; i < this.data.length; i++)
            {
                let data = this.data.getItemAt(i);
                if (data instanceof fx.Model)
                    this.listenUpdates( data, false )
            }
        }

        super.data = val;

        if (val instanceof Array)
        {
            for(let i = 0; i < val.length; i++)
            {
                let data = val.getItemAt(i);
                if (data instanceof fx.Model)
                    this.listenUpdates( data, true )
            }
        }
    }

    

    onReady()
    {
        super.onReady();
        
        this.on("click", this.onClick);
        this.on("mousewheel", this.onMouseWheel, this);
    }

    get selected(){
        return this._selected;
    }

    set selected(val)
    {
        this._selected = val;

        if (this._selected)
        {
            let target = this.find('[data=' + ( (this._selected.id == undefined) ? this._selected : this._selected.id) + ']');

            if (target)
            {
                this.removeClass(this.find(".selected"), "selected");
                this.addClass( target , "selected" );
            }
        }
        else
            this.removeClass(this.find(".selected"), "selected");
    }

    updateDisplay()
    {
        super.updateDisplay();
    }


    resize()
    {
        super.resize();
       
        if (this._resized)
            this._resize();
    }

    
    _resize()
    {
        let height = 0;
        let items = this.find(".item");
        if (items && items.length)
        {
            for (let i = 0; i < items.length; i++)
                height += fx.dom.outerHeight( items[i] );
        
            this._realHeight = Math.min(this._maxHeight, height);

            this.css({ height : this._realHeight});
        }

        this._resized = false;
    }

    render()
    {
        let html = "<ul class='items'>";

        for (let i = 0; i < this.data.length; i++)
        {
            if(this.data instanceof fx.ModelArray && this.data.getItemAt(i).empty)
            {
                html += "<li class='item empty";

                let item = this.data.getItemAt(i);

                html += "' data='" + item.id + "'><div class='overlay empty'></div>"
            }
            else
            {
                html += "<li class='item ";
                
                let item = (this.data instanceof fx.ModelArray) ? this.data.getItemAt(i) : this.data[i];
    
                if (this._selected == item)
                    html += " selected";
    
                html += "' data='" + ((item.id !== undefined) ? item.id : item) + "'><div class='overlay'></div>"
    

                if (this._selectedAsset && this._selectedPosition == "left")
                    html += this._selectedAsset.render("selected");
                
                if (this._renderer)
                    html += this._renderer(item);
                else
                if (item.thumb)
                    html += "<img src='" + item.thumb + "'>";
                else
                if (item.label)
                    html += item.label;
                else
                if (item.name)
                    html += item.name;
                else
                    html += item;

                if (this._selectedAsset && this._selectedPosition == "right")
                    html += this._selectedAsset.render("selected");

                html += "</li>"
            }

        }

        html += "</ul>";

        return html;
    }

    onClick(event)
    {
        let target = fx.dom.parent(event.target, ".item");
        if (target)
        {
            this.removeClass(this.find(".selected"), "selected");
            this.addClass( target , "selected" );

            let item = this.data.find({id : target.getAttribute("data") });
            if (!item)
                item = target.innerText;

            this.trigger("selected", item);

            event.preventDefault();
        }
    }

    onMouseWheel(e)
    {
        e.stopPropagation();
    }


    onChildUpdated(action)
    {
        //this._needRender = true;
        //this.update();
    }

    onDataUpdated(action)
    {
        this._resized = true;
        this.update(true);
    }
    
});
/**
 * Select
 * @constructor fx.components.Select
 * @param {object} this.dom DOM
 * @param {object} parameters Select parameters 
 */
fx.ns("fx.components", class VerticalSelect extends fx.Component {

	constructor(parameters) 
	{
        super();
        
        //if (!parameters)
            //return;

        this._items = parameters && parameters.items ? parameters.items : [];
        this._selectedItem = parameters && parameters.selectedItem ? parameters.selectedItem : null;
        this._notifyFirstSelect = parameters && parameters.notifyFirstSelect !== undefined ? parameters.notifyFirstSelect : true;
        this._hideIcon = parameters && parameters.hideIcon ? parameters.hideIcon : false;
        this._direction = parameters && parameters.direction ? parameters.direction : "bottom";
        this.classname = (parameters && parameters.className) ? parameters.className : "";

        this._labelRenderer = parameters && parameters.labelRenderer ? parameters.labelRenderer : null;
	
		this.upIcon = (parameters && parameters.upIcon) ? parameters.upIcon :       '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="0 0 284.929 284.929" xml:space="preserve"><g><path class="inner" d="M282.082,76.511l-14.274-14.273c-1.902-1.906-4.093-2.856-6.57-2.856c-2.471,0-4.661,0.95-6.563,2.856L142.466,174.441   L30.262,62.241c-1.903-1.906-4.093-2.856-6.567-2.856c-2.475,0-4.665,0.95-6.567,2.856L2.856,76.515C0.95,78.417,0,80.607,0,83.082   c0,2.473,0.953,4.663,2.856,6.565l133.043,133.046c1.902,1.903,4.093,2.854,6.567,2.854s4.661-0.951,6.562-2.854L282.082,89.647   c1.902-1.903,2.847-4.093,2.847-6.565C284.929,80.607,283.984,78.417,282.082,76.511z"></path></g></svg>';
        this.downIcon = (parameters && parameters.downIcon) ? parameters.downIcon : '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="0 0 284.929 284.929" xml:space="preserve"><g><path class="inner" d="M282.082,76.511l-14.274-14.273c-1.902-1.906-4.093-2.856-6.57-2.856c-2.471,0-4.661,0.95-6.563,2.856L142.466,174.441   L30.262,62.241c-1.903-1.906-4.093-2.856-6.567-2.856c-2.475,0-4.665,0.95-6.567,2.856L2.856,76.515C0.95,78.417,0,80.607,0,83.082   c0,2.473,0.953,4.663,2.856,6.565l133.043,133.046c1.902,1.903,4.093,2.854,6.567,2.854s4.661-0.951,6.562-2.854L282.082,89.647   c1.902-1.903,2.847-4.093,2.847-6.565C284.929,80.607,283.984,78.417,282.082,76.511z"></path></g></svg>';

        if (Utils.typeEqual(this.downIcon, "string"))
            this.downIcon = new fx.Asset(this.downIcon);
        
        if (this._items instanceof fx.Model)
        {
            this.data = this._items;
            this.listenUpdates( this._items );
        }
    }

    get items()
    {
        if (!this._items)
            this._items = [];
        
        return this._items;
    }

    set items(val)
    {
        this._items = val;
        this._selectedItem = null;
        this.verticalList.items = this._items;
        this.verticalList.selected = this.selectedItem;

        this._updateState();
        this._updateLabel();
    }

    get selectedItem()
	{
        if (!this._selectedItem && this.items.length > 0)
            return this.items.getItemAt(0);
        else
            return this._selectedItem;
    }

    set selectedItem(val)
    {
        this._selectedItem = val;
        this.verticalList.selected = this.selectedItem;
        this._updateLabel();
    }

    get selectedLabel()
    {
        return (this.selectedItem ? (this.selectedItem.label ? this.selectedItem.label : (this.selectedItem.toString ? this.selectedItem.toString() : this.selectedItem)) : "" )
    }
    

    create()
    {
        this.label = new fx.components.Text({className : "label"});

        this.addChild(this.label);

        if (!this._hideIcon)
        {
            this.icon = new fx.components.Image({data : this.downIcon, assetClassName : "icon"});
            this.addChild(this.icon, { width: 15, height: 15, right: 15, top: 11});
        }

        this.verticalList = new fx.components.VerticalList({items: this.items, selected : this.selectedItem, labelRenderer : this._labelRenderer });
        this.verticalList.visibleAtStart = false;
        this.verticalList.effect = "vslide";
        let margin = parseInt(this.css("margin")) / 2;
        if (isNaN(margin))
            margin = 0;

        if (this._direction == "bottom")
            this.addChild(this.verticalList, {top : this.measuredHeight(false) - margin, left : 0, width : "100%"});
        else
            this.addChild(this.verticalList, {bottom : this.measuredHeight(false), left : 0, width : "100%"});
    }
    
    onClick(e)
	{
        super.onClick(e);
    }

	onReady() 
	{
        super.onReady();

        if (this.classname)
			this.addClass(this.classname);

        this.on("click", this.onClick, window);
        this.on("selected", this.onSelected, this.verticalList);

        if (!this._hideIcon)
            this._downIcon = this.find(".icon");

        this._updateState();
        this._updateLabel();

        if (this._notifyFirstSelect)
            this.delay( this._notifySelect,10 );
    }

    _updateState()
    {
        if (!this._items || this._items.length == 0)
            this.disable();
        else
            this.enable();
    }

    _notifySelect()
    {
        if (this.selectedItem)
            this.trigger("selected", this.selectedItem);
    }
    
    onClick(e)
    {
        if (!this._items || this._items.length == 0)
            return;

        let list = fx.dom.parent(e.target, ".VerticalList") 
        if (list && list == this.verticalList.node)
            return;

        let select = fx.dom.parent(e.target, ".VerticalSelect") 
        if (select == this.node)
        {
            if (this.verticalList.visible)
                this.verticalList.hide();
            else
                this.verticalList.show();
        }
        else
        if (this.verticalList.visible)
            this.verticalList.hide();

        this._updateIcon();
    }

    onSelected(e)
    {
        this.find(".label").innerHTML = e.detail.toString ? e.detail.toString() : e.detail;
        this._selectedItem = e.detail;
        this.verticalList.hide();
        this._updateIcon();
        this._updateLabel();

        this.trigger("selected", this.selectedItem)
    }

    _updateIcon()
    {
        if (!this._hideIcon)
            this.toggleClass(this._downIcon, "rotate", this.verticalList.visible);
    }

    /*render()
    {
        return "<div class='label'>" +  (this.selectedItem ? (this.selectedItem.toString ? this.selectedItem.toString() : this.selectedItem) : "" ) + "</div>" + this.downIcon.render("icon");
    }*/


    onDataUpdated(action)
    {
        this._updateLabel();
        this._updateState();
    }

    onChildUpdated(action)
    {
        this._updateLabel();
        this._updateState();
    }


    _updateLabel()
    {
        this.label.text = this._labelRenderer ? this._labelRenderer(this.selectedItem) : this.selectedLabel;
    }


});
/*fx.ns("fx.components", class VerticalTabBar extends fx.components.TabBar {

	constructor(data) {
		super(data);

		this.defaultHeight = 20;
	}

	selectTab(tab){

		if (!Utils.typeEqual(tab, "object"))
			tab = this.getTab(tab);

		if (tab && tab.id)
		{
			this.removeClass(".active", "active");
			this.addClass(tab.id, "active");
			this.css(".selected_tab_background", {top : this.childPosition(tab.id).top });
			this.trigger("tabchanged", {tab : tab})				
		}
		else	
		{
			fx.throwError("Can not select given tab");
		}
	}

	resize(alone){
		super.resize(alone);

		let tabs = this.find(".tab"),
            top = 0, 
            tabHeight,
            
            maxWidth = 0,
            maxWidth2 = 0;

        for (let i = 0; i < tabs.length; i++)
        {
            tabHeight = fx.dom.outerHeight(tabs[i]);
            this.css(tabs[i], {top : top, left : 0});
            top += tabHeight + 5;

            maxWidth = Math.max( parseInt(fx.dom.css(tabs[i], "border-width"))*2  +  fx.dom.outerWidth(tabs[i]), maxWidth);
            maxWidth2 = Math.max( parseInt(fx.dom.width(tabs[i])) + parseInt(fx.dom.css(tabs[i], "border-width"))*2  , maxWidth2);
        }

        this.css(tabs, {width : maxWidth2 });
        
        this.css(this.find(".selected_tab_background"), {width : maxWidth, height : tabHeight});

        this.css({"height": top});
        
		
	}

});
*/
/*fx.ns("fx.components", class VerticalTabBarChoices extends fx.components.VerticalTabBar {

	constructor(data) {
		super(data);

        this.defaultHeight = 20;
        
        this.iconChecked = '<svg class="checked" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="0 0 30.59 24.352" xml:space="preserve"><path class="path" d="M29.421,1.952l-0.78-0.779C27.887,0.417,26.878,0,25.805,0c-1.074,0-2.082,0.417-2.838,1.174L11.031,13.109L7.623,9.703  C6.869,8.946,5.86,8.529,4.787,8.529c-1.075,0-2.083,0.418-2.839,1.176l-0.774,0.774c-1.564,1.565-1.564,4.11-0.002,5.674  l7.018,7.023c0.757,0.758,1.765,1.174,2.838,1.174c1.074,0,2.082-0.417,2.838-1.175L29.419,7.624  C30.98,6.059,30.98,3.515,29.421,1.952z M28.139,6.342L12.583,21.896c-0.428,0.428-0.991,0.642-1.556,0.642  c-0.563,0-1.128-0.214-1.556-0.642l-7.018-7.023c-0.854-0.854-0.854-2.255,0-3.11l0.777-0.777c0.427-0.428,0.992-0.644,1.556-0.644  s1.127,0.216,1.555,0.644l4.689,4.688L24.249,2.454c0.428-0.427,0.991-0.642,1.556-0.642c0.563,0,1.127,0.215,1.555,0.643  l0.779,0.777C28.992,4.086,28.992,5.487,28.139,6.342z"/></svg>';
    }
    
    render(){
		let html = "";
		
		html += '<div class="selected_tab_background"></div>';

		html += '<ul class="tabs">';

		for (let i = 0; i < this.tabs.length; i++){
			let tab = this.tabs[i];
			html += '<li class="tab" id="' + tab.id + '">' + ( tab.asset ? tab.asset.render('tab-image') : "" ) + '<div class="tab-label">' + tab.label+ '</div> ' + this.iconChecked + '</li>';
		}

		html += '</ul>';
		return html;
	}

	selectTab(tab){

		if (!Utils.typeEqual(tab, "object"))
			tab = this.getTab(tab);

		if (tab && tab.id)
		{
			this.removeClass(".active", "active");
            this.addClass(tab.id, "active");
			this.css(".selected_tab_background", {top : this.childPosition(tab.id).top });
            this.trigger("tabchanged", {tab : tab})				
            
		}
		else	
		{
			fx.throwError("Can not select given tab");
		}
	}

	resize(){
		super.resize();

		let tabs = this.find(".tab"),
            top = 0, 
            tabHeight,
            
            maxWidth = 0,
            maxWidth2 = 0;

        for (let i = 0; i < tabs.length; i++)
        {
            tabHeight = fx.dom.outerHeight(tabs[i]) - parseInt(fx.dom.css(tabs[i], "border-width"))*2 ;
            this.css(tabs[i], {top : top, left : 0});
            top += tabHeight + 10;

            maxWidth = Math.max(  fx.dom.outerWidth(tabs[i]), maxWidth);
            maxWidth2 = Math.max( parseInt(fx.dom.width(tabs[i])) + parseInt(fx.dom.css(tabs[i], "border-width"))*2  , maxWidth2);
        }

        maxWidth += 20;
        maxWidth2 += 20;

        this.css(tabs, {width : maxWidth2 });
        
        this.css(this.find(".selected_tab_background"), {width : maxWidth, height : tabHeight});

        this.css({"height": top});
        
		
    }
    

    

});
*/
//# sourceMappingURL=fx-desktop.min.js.map
